//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { Observable, of as _observableOf, throwError as _observableThrow } from 'rxjs';
import { catchError as _observableCatch, mergeMap as _observableMergeMap } from 'rxjs/operators';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class GstarClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    applicationnotificationsPOST(body: CreateApplicationNotificationRequest | undefined): Observable<ApplicationNotificationResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/applicationnotifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplicationnotificationsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplicationnotificationsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationNotificationResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationNotificationResponseAuditable>;
        }));
    }

    protected processApplicationnotificationsPOST(response: HttpResponseBase): Observable<ApplicationNotificationResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationNotificationResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    applicationnotificationsGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<ApplicationNotificationResponseAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/applicationnotifications?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplicationnotificationsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplicationnotificationsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationNotificationResponseAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationNotificationResponseAuditableODataWithMetadataResponse>;
        }));
    }

    protected processApplicationnotificationsGET(response: HttpResponseBase): Observable<ApplicationNotificationResponseAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationNotificationResponseAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    applicationnotificationsPUT(id: number, body: UpdateApplicationNotificationRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/applicationnotifications/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplicationnotificationsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplicationnotificationsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApplicationnotificationsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    applicationnotificationsGET2(id: number): Observable<ApplicationNotificationResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/applicationnotifications/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplicationnotificationsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplicationnotificationsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationNotificationResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationNotificationResponseAuditable>;
        }));
    }

    protected processApplicationnotificationsGET2(response: HttpResponseBase): Observable<ApplicationNotificationResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationNotificationResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    clientassignmentsGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<ClientAssignmentNestedObjectsResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/clientassignments?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientassignmentsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientassignmentsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientAssignmentNestedObjectsResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientAssignmentNestedObjectsResponseODataWithMetadataResponse>;
        }));
    }

    protected processClientassignmentsGET(response: HttpResponseBase): Observable<ClientAssignmentNestedObjectsResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientAssignmentNestedObjectsResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    clientassignmentsPOST(body: CreateClientAssignmentRequest | undefined): Observable<ClientAssignmentResponse> {
        let url_ = this.baseUrl + "/api/v1/clientassignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientassignmentsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientassignmentsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientAssignmentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientAssignmentResponse>;
        }));
    }

    protected processClientassignmentsPOST(response: HttpResponseBase): Observable<ClientAssignmentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientAssignmentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    clientassignmentsPUT(id: number, body: UpdateClientAssignmentRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/clientassignments/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientassignmentsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientassignmentsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClientassignmentsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    clientassignmentsDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/clientassignments/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientassignmentsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientassignmentsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClientassignmentsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    clientassignmentsGET2(id: number): Observable<ClientAssignmentNestedObjectsResponse> {
        let url_ = this.baseUrl + "/api/v1/clientassignments/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientassignmentsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientassignmentsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientAssignmentNestedObjectsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientAssignmentNestedObjectsResponse>;
        }));
    }

    protected processClientassignmentsGET2(response: HttpResponseBase): Observable<ClientAssignmentNestedObjectsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientAssignmentNestedObjectsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    clientconfigurationkey(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<ClientConfigurationKeyResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/clientconfigurationkey?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientconfigurationkey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientconfigurationkey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientConfigurationKeyResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientConfigurationKeyResponseODataWithMetadataResponse>;
        }));
    }

    protected processClientconfigurationkey(response: HttpResponseBase): Observable<ClientConfigurationKeyResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientConfigurationKeyResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Item by Id
     * @param id Id of item
     * @return Selected item
     */
    clientconfigurationkey2(id: number): Observable<ClientConfigurationKeyResponse> {
        let url_ = this.baseUrl + "/api/v1/clientconfigurationkey/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientconfigurationkey2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientconfigurationkey2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientConfigurationKeyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientConfigurationKeyResponse>;
        }));
    }

    protected processClientconfigurationkey2(response: HttpResponseBase): Observable<ClientConfigurationKeyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientConfigurationKeyResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Item not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    clientconfigurationsGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<ClientConfigurationResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/clientconfigurations?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientconfigurationsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientconfigurationsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientConfigurationResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientConfigurationResponseODataWithMetadataResponse>;
        }));
    }

    protected processClientconfigurationsGET(response: HttpResponseBase): Observable<ClientConfigurationResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientConfigurationResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates item
     * @param body (optional) 
     * @return Returns the newly created item
     */
    clientconfigurationsPOST(body: CreateClientConfigurationRequest | undefined): Observable<ClientConfigurationResponse> {
        let url_ = this.baseUrl + "/api/v1/clientconfigurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientconfigurationsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientconfigurationsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientConfigurationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientConfigurationResponse>;
        }));
    }

    protected processClientconfigurationsPOST(response: HttpResponseBase): Observable<ClientConfigurationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientConfigurationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("If the item is invalid", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete item by Id
     * @param id Id of item to delete
     * @return Item deleted successfully
     */
    clientconfigurationsDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/clientconfigurations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientconfigurationsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientconfigurationsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClientconfigurationsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Item not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update item
     * @param id Id of item to be updated
     * @param body (optional) New item
     * @return Item updated successfully
     */
    clientconfigurationsPUT(id: number, body: UpdateClientConfigurationRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/clientconfigurations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientconfigurationsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientconfigurationsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClientconfigurationsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Item invalid", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Item not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Item by Id
     * @param id Id of item
     * @return Selected item
     */
    clientconfigurationsGET2(id: number): Observable<ClientConfigurationResponse> {
        let url_ = this.baseUrl + "/api/v1/clientconfigurations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientconfigurationsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientconfigurationsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientConfigurationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientConfigurationResponse>;
        }));
    }

    protected processClientconfigurationsGET2(response: HttpResponseBase): Observable<ClientConfigurationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientConfigurationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Item not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create client
     * @param body (optional) 
     * @return OK
     */
    clientsPOST(body: CreateClientRequest | undefined): Observable<ClientResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/clients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientResponseAuditable>;
        }));
    }

    protected processClientsPOST(response: HttpResponseBase): Observable<ClientResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    clientsGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<ClientResponseAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/clients?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientResponseAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientResponseAuditableODataWithMetadataResponse>;
        }));
    }

    protected processClientsGET(response: HttpResponseBase): Observable<ClientResponseAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientResponseAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update client details
     * @param body (optional) 
     * @return No Content
     */
    clientsPUT(id: number, body: UpdateClientRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/clients/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClientsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Permanently deletes the client and all scoped data
     * @return No Content
     */
    clientsDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/clients/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClientsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Item by Id
     * @param id Id of item
     * @return Selected item
     */
    clientsGET2(id: number): Observable<ClientResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/clients/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientResponseAuditable>;
        }));
    }

    protected processClientsGET2(response: HttpResponseBase): Observable<ClientResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Item not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData - Gets list of active users for a specific client
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return Returns items list
     */
    users(clientId: number, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<UserResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/clients/{clientId}/users?";
        if (clientId === undefined || clientId === null)
            throw new globalThis.Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserResponseODataWithMetadataResponse>;
        }));
    }

    protected processUsers(response: HttpResponseBase): Observable<UserResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData - Get client specific configuration
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return Returns items list
     */
    configurations(clientId: number, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<ClientConfigurationResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/clients/{clientId}/configurations?";
        if (clientId === undefined || clientId === null)
            throw new globalThis.Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfigurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfigurations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientConfigurationResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientConfigurationResponseODataWithMetadataResponse>;
        }));
    }

    protected processConfigurations(response: HttpResponseBase): Observable<ClientConfigurationResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientConfigurationResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData - Get entities
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return Returns items list
     */
    entitiesGET(clientId: number, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<EntityResponseAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/clients/{clientId}/entities?";
        if (clientId === undefined || clientId === null)
            throw new globalThis.Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntitiesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntitiesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityResponseAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityResponseAuditableODataWithMetadataResponse>;
        }));
    }

    protected processEntitiesGET(response: HttpResponseBase): Observable<EntityResponseAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityResponseAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param body (optional) 
     * @return OK
     */
    countriesPOST(body: CreateCountryRequest | undefined): Observable<CountryResponse> {
        let url_ = this.baseUrl + "/api/v1/countries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountriesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountriesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryResponse>;
        }));
    }

    protected processCountriesPOST(response: HttpResponseBase): Observable<CountryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    countriesGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<CountryResponseWithNestedObjectsODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/countries?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountriesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountriesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryResponseWithNestedObjectsODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryResponseWithNestedObjectsODataWithMetadataResponse>;
        }));
    }

    protected processCountriesGET(response: HttpResponseBase): Observable<CountryResponseWithNestedObjectsODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryResponseWithNestedObjectsODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param body (optional) 
     * @return No Content
     */
    countriesPUT(id: number, body: UpdateCountryRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/countries/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountriesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountriesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCountriesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    countriesGET2(id: number): Observable<CountryResponseWithNestedObjects> {
        let url_ = this.baseUrl + "/api/v1/countries/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountriesGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountriesGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryResponseWithNestedObjects>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryResponseWithNestedObjects>;
        }));
    }

    protected processCountriesGET2(response: HttpResponseBase): Observable<CountryResponseWithNestedObjects> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryResponseWithNestedObjects.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param body (optional) 
     * @return OK
     */
    countrymaterialPOST(body: CreateCountryMaterialRequest | undefined): Observable<CountryMaterialResponse> {
        let url_ = this.baseUrl + "/api/v1/countrymaterial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountrymaterialPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountrymaterialPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryMaterialResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryMaterialResponse>;
        }));
    }

    protected processCountrymaterialPOST(response: HttpResponseBase): Observable<CountryMaterialResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryMaterialResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param body (optional) 
     * @return No Content
     */
    countrymaterialPUT(id: number, body: UpdateCountryMaterialRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/countrymaterial/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountrymaterialPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountrymaterialPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCountrymaterialPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get country material by client id
     * @param clientId (optional) 
     * @return OK
     */
    byclientAll(clientId: number | undefined): Observable<CountryMaterialWIthNestedObjectsResponse[]> {
        let url_ = this.baseUrl + "/api/v1/countrymaterial/byclient?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByclientAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByclientAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryMaterialWIthNestedObjectsResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryMaterialWIthNestedObjectsResponse[]>;
        }));
    }

    protected processByclientAll(response: HttpResponseBase): Observable<CountryMaterialWIthNestedObjectsResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryMaterialWIthNestedObjectsResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete country material by id
     * @param clientId (optional) 
     * @param body (optional) 
     * @return No Content
     */
    delete(clientId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/countrymaterial/delete?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param body (optional) 
     * @return OK
     */
    countrytaxnewsPOST(body: CreateCountryTaxNewsRequest | undefined): Observable<CountryTaxNewsResponse> {
        let url_ = this.baseUrl + "/api/v1/countrytaxnews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountrytaxnewsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountrytaxnewsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryTaxNewsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryTaxNewsResponse>;
        }));
    }

    protected processCountrytaxnewsPOST(response: HttpResponseBase): Observable<CountryTaxNewsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryTaxNewsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    countrytaxnewsGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<CountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/countrytaxnews?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountrytaxnewsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountrytaxnewsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse>;
        }));
    }

    protected processCountrytaxnewsGET(response: HttpResponseBase): Observable<CountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param body (optional) 
     * @return No Content
     */
    countrytaxnewsPUT(id: number, body: UpdateCountryTaxNewsRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/countrytaxnews/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountrytaxnewsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountrytaxnewsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCountrytaxnewsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    countrytaxnewsGET2(id: number): Observable<CountryTaxNewsWithNestedObjectsResponse> {
        let url_ = this.baseUrl + "/api/v1/countrytaxnews/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountrytaxnewsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountrytaxnewsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryTaxNewsWithNestedObjectsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryTaxNewsWithNestedObjectsResponse>;
        }));
    }

    protected processCountrytaxnewsGET2(response: HttpResponseBase): Observable<CountryTaxNewsWithNestedObjectsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryTaxNewsWithNestedObjectsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint by client id
     * @param clientId (optional) 
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    byclient(clientId: number | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<CountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/countrytaxnews/byclient?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByclient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByclient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse>;
        }));
    }

    protected processByclient(response: HttpResponseBase): Observable<CountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get country tax news by country id
     * @param clientId (optional) 
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    bycountry(countryId: number, clientId: number | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<CountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/countrytaxnews/{countryId}/bycountry?";
        if (countryId === undefined || countryId === null)
            throw new globalThis.Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBycountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBycountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse>;
        }));
    }

    protected processBycountry(response: HttpResponseBase): Observable<CountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete country tax news by news id
     * @param body (optional) 
     * @return No Content
     */
    delete2(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/countrytaxnews/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    countrytaxnewsfileimports(id: number): Observable<FileImportResponse> {
        let url_ = this.baseUrl + "/api/v1/countrytaxnewsfileimports/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountrytaxnewsfileimports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountrytaxnewsfileimports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileImportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileImportResponse>;
        }));
    }

    protected processCountrytaxnewsfileimports(response: HttpResponseBase): Observable<FileImportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileImportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    countrytaxnewsfileimports2(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<FileImportResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/countrytaxnewsfileimports?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountrytaxnewsfileimports2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountrytaxnewsfileimports2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileImportResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileImportResponseODataWithMetadataResponse>;
        }));
    }

    protected processCountrytaxnewsfileimports2(response: HttpResponseBase): Observable<FileImportResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileImportResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download a sample file
     * @return OK
     */
    download(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/countrytaxnewsfileimports/download";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("If the item is invalid", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Import Country tax news from excel (Max 1000 country tax news per file)
     * @param fileContent (optional) 
     * @return OK
     */
    upload(countryId: number, fileContent: FileParameter | undefined): Observable<FileImportResponse> {
        let url_ = this.baseUrl + "/api/v1/countrytaxnewsfileimports/{countryId}/upload";
        if (countryId === undefined || countryId === null)
            throw new globalThis.Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileContent === null || fileContent === undefined)
            throw new globalThis.Error("The parameter 'fileContent' cannot be null.");
        else
            content_.append("FileContent", fileContent.data, fileContent.fileName ? fileContent.fileName : "FileContent");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileImportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileImportResponse>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<FileImportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileImportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("If the item is invalid", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Entity
     * @param body (optional) 
     * @return OK
     */
    entitiesPOST(body: CreateEntityRequest | undefined): Observable<EntityResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/entities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntitiesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntitiesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityResponseAuditable>;
        }));
    }

    protected processEntitiesPOST(response: HttpResponseBase): Observable<EntityResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    entitiesGET2(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<EntityResponseWithNestedObjectsAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/entities?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntitiesGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntitiesGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityResponseWithNestedObjectsAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityResponseWithNestedObjectsAuditableODataWithMetadataResponse>;
        }));
    }

    protected processEntitiesGET2(response: HttpResponseBase): Observable<EntityResponseWithNestedObjectsAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityResponseWithNestedObjectsAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Entity details
     * @param body (optional) 
     * @return No Content
     */
    entitiesPUT(id: number, body: UpdateEntityRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/entities/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntitiesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntitiesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEntitiesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    entitiesGET3(id: number): Observable<EntityResponseWithNestedObjectsAuditable> {
        let url_ = this.baseUrl + "/api/v1/entities/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntitiesGET3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntitiesGET3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityResponseWithNestedObjectsAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityResponseWithNestedObjectsAuditable>;
        }));
    }

    protected processEntitiesGET3(response: HttpResponseBase): Observable<EntityResponseWithNestedObjectsAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityResponseWithNestedObjectsAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData - Get entities
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return Returns items list
     */
    securitiesGET(entityId: number, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/entities/{entityId}/securities?";
        if (entityId === undefined || entityId === null)
            throw new globalThis.Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecuritiesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecuritiesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse>;
        }));
    }

    protected processSecuritiesGET(response: HttpResponseBase): Observable<SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param body (optional) 
     * @return OK
     */
    entitytypesPOST(body: CreateEntityTypeRequest | undefined): Observable<EntityTypeResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/entitytypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntitytypesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntitytypesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityTypeResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityTypeResponseAuditable>;
        }));
    }

    protected processEntitytypesPOST(response: HttpResponseBase): Observable<EntityTypeResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityTypeResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    entitytypesGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<EntityTypeResponseWithNestedObjectsODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/entitytypes?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntitytypesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntitytypesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityTypeResponseWithNestedObjectsODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityTypeResponseWithNestedObjectsODataWithMetadataResponse>;
        }));
    }

    protected processEntitytypesGET(response: HttpResponseBase): Observable<EntityTypeResponseWithNestedObjectsODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityTypeResponseWithNestedObjectsODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param body (optional) 
     * @return No Content
     */
    entitytypesPUT(id: number, body: UpdateEntityTypeRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/entitytypes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntitytypesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntitytypesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEntitytypesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    entitytypesGET2(id: number): Observable<EntityTypeResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/entitytypes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntitytypesGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntitytypesGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityTypeResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityTypeResponseAuditable>;
        }));
    }

    protected processEntitytypesGET2(response: HttpResponseBase): Observable<EntityTypeResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityTypeResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    externalsystemsGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<ExternalSystemResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/externalsystems?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalsystemsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalsystemsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalSystemResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalSystemResponseODataWithMetadataResponse>;
        }));
    }

    protected processExternalsystemsGET(response: HttpResponseBase): Observable<ExternalSystemResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalSystemResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates item
     * @param body (optional) 
     * @return Returns the newly created item
     */
    externalsystemsPOST(body: CreateExternalSystemRequest | undefined): Observable<ExternalSystemResponse> {
        let url_ = this.baseUrl + "/api/v1/externalsystems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalsystemsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalsystemsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalSystemResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalSystemResponse>;
        }));
    }

    protected processExternalsystemsPOST(response: HttpResponseBase): Observable<ExternalSystemResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalSystemResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("If the item is invalid", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update item
     * @param id Id of item to be updated
     * @param body (optional) New item
     * @return Item updated successfully
     */
    externalsystemsPUT(id: number, body: UpdateExternalSystemRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/externalsystems/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalsystemsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalsystemsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExternalsystemsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Item invalid", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Item not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Item by Id
     * @param id Id of item
     * @return Selected item
     */
    externalsystemsGET2(id: number): Observable<ExternalSystemResponse> {
        let url_ = this.baseUrl + "/api/v1/externalsystems/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalsystemsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalsystemsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalSystemResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalSystemResponse>;
        }));
    }

    protected processExternalsystemsGET2(response: HttpResponseBase): Observable<ExternalSystemResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalSystemResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Item not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    externalusersGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<ExternalUserResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/externalusers?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalusersGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalusersGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalUserResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalUserResponseODataWithMetadataResponse>;
        }));
    }

    protected processExternalusersGET(response: HttpResponseBase): Observable<ExternalUserResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalUserResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    externalusersPOST(body: CreateExternalUserRequest | undefined): Observable<ExternalUserResponse> {
        let url_ = this.baseUrl + "/api/v1/externalusers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalusersPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalusersPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalUserResponse>;
        }));
    }

    protected processExternalusersPOST(response: HttpResponseBase): Observable<ExternalUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    externalusersGET2(id: string): Observable<ExternalUserResponse> {
        let url_ = this.baseUrl + "/api/v1/externalusers/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalusersGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalusersGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalUserResponse>;
        }));
    }

    protected processExternalusersGET2(response: HttpResponseBase): Observable<ExternalUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    externalusersPUT(id: string, body: UpdateExternalUserRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/externalusers/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalusersPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalusersPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExternalusersPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    externalusersDELETE(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/externalusers/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalusersDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalusersDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExternalusersDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DeleteUserResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = DeleteUserResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = DeleteUserResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    graph(email: string): Observable<GraphValidateUserResponse> {
        let url_ = this.baseUrl + "/api/v1/externalusers/graph/{email}";
        if (email === undefined || email === null)
            throw new globalThis.Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGraph(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGraph(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GraphValidateUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GraphValidateUserResponse>;
        }));
    }

    protected processGraph(response: HttpResponseBase): Observable<GraphValidateUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GraphValidateUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    resetpassword(id: string): Observable<GraphAccountActionResponse> {
        let url_ = this.baseUrl + "/api/v1/externalusers/graph/resetpassword/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetpassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetpassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GraphAccountActionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GraphAccountActionResponse>;
        }));
    }

    protected processResetpassword(response: HttpResponseBase): Observable<GraphAccountActionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GraphAccountActionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    currentuser(): Observable<ExternalUserResponse> {
        let url_ = this.baseUrl + "/api/v1/externalusers/currentuser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCurrentuser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCurrentuser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalUserResponse>;
        }));
    }

    protected processCurrentuser(response: HttpResponseBase): Observable<ExternalUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updatetermsandprivacyaccepted(): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/externalusers/currentuser/updatetermsandprivacyaccepted";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatetermsandprivacyaccepted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatetermsandprivacyaccepted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatetermsandprivacyaccepted(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    clientassignmentsGET3(id: string, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<ClientAssignmentNestedObjectsResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/externalusers/{id}/clientassignments?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientassignmentsGET3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientassignmentsGET3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientAssignmentNestedObjectsResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientAssignmentNestedObjectsResponseODataWithMetadataResponse>;
        }));
    }

    protected processClientassignmentsGET3(response: HttpResponseBase): Observable<ClientAssignmentNestedObjectsResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientAssignmentNestedObjectsResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param body (optional) 
     * @return OK
     */
    generalcountryinformationPOST(body: CreateGeneralCountryInformationRequest | undefined): Observable<GeneralCountryInformationResponse> {
        let url_ = this.baseUrl + "/api/v1/generalcountryinformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneralcountryinformationPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneralcountryinformationPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralCountryInformationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralCountryInformationResponse>;
        }));
    }

    protected processGeneralcountryinformationPOST(response: HttpResponseBase): Observable<GeneralCountryInformationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralCountryInformationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    generalcountryinformationGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<GeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/generalcountryinformation?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneralcountryinformationGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneralcountryinformationGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse>;
        }));
    }

    protected processGeneralcountryinformationGET(response: HttpResponseBase): Observable<GeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param body (optional) 
     * @return No Content
     */
    generalcountryinformationPUT(id: number, body: UpdateGeneralCountryInformationRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/generalcountryinformation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneralcountryinformationPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneralcountryinformationPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGeneralcountryinformationPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    generalcountryinformationGET2(id: number): Observable<GeneralCountryInformationWithNestedObjectsResponse> {
        let url_ = this.baseUrl + "/api/v1/generalcountryinformation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneralcountryinformationGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneralcountryinformationGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralCountryInformationWithNestedObjectsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralCountryInformationWithNestedObjectsResponse>;
        }));
    }

    protected processGeneralcountryinformationGET2(response: HttpResponseBase): Observable<GeneralCountryInformationWithNestedObjectsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralCountryInformationWithNestedObjectsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint by client id
     * @param clientId (optional) 
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    byclient2(clientId: number | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<GeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/generalcountryinformation/byclient?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByclient2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByclient2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse>;
        }));
    }

    protected processByclient2(response: HttpResponseBase): Observable<GeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isApproved (optional) 
     * @return No Content
     */
    approve(id: number, isApproved: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/generalcountryinformation/{id}/approve?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (isApproved === null)
            throw new globalThis.Error("The parameter 'isApproved' cannot be null.");
        else if (isApproved !== undefined)
            url_ += "isApproved=" + encodeURIComponent("" + isApproved) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Full-content search across all GeneralCountryInformation records accessible to the client.
    Returns up to maxResults results with a plain-text snippet (~snippetWords words) around each match.
     * @param q (optional) 
     * @param clientId (optional) 
     * @return OK
     */
    search(q: string | undefined, clientId: number | undefined): Observable<ContentSearchResponse> {
        let url_ = this.baseUrl + "/api/v1/generalcountryinformation/search?";
        if (q === null)
            throw new globalThis.Error("The parameter 'q' cannot be null.");
        else if (q !== undefined)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContentSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContentSearchResponse>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<ContentSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContentSearchResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    generalcountryinformationtype(id: number): Observable<GeneralCountryInformationTypeResponse> {
        let url_ = this.baseUrl + "/api/v1/generalcountryinformationtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneralcountryinformationtype(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneralcountryinformationtype(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralCountryInformationTypeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralCountryInformationTypeResponse>;
        }));
    }

    protected processGeneralcountryinformationtype(response: HttpResponseBase): Observable<GeneralCountryInformationTypeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralCountryInformationTypeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    generalcountryinformationtype2(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<GeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/generalcountryinformationtype?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneralcountryinformationtype2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneralcountryinformationtype2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse>;
        }));
    }

    protected processGeneralcountryinformationtype2(response: HttpResponseBase): Observable<GeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a general rate rules editor row.
     * @param body (optional) 
     * @return OK
     */
    generalrateruleseditorsPOST(body: CreateGeneralRateRulesEditorRequest | undefined): Observable<GeneralRateRulesEditorResponse> {
        let url_ = this.baseUrl + "/api/v1/generalrateruleseditors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneralrateruleseditorsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneralrateruleseditorsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralRateRulesEditorResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralRateRulesEditorResponse>;
        }));
    }

    protected processGeneralrateruleseditorsPOST(response: HttpResponseBase): Observable<GeneralRateRulesEditorResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralRateRulesEditorResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint for general rate rules editor grid rows.
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    generalrateruleseditorsGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<GeneralRateRulesEditorResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/generalrateruleseditors?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneralrateruleseditorsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneralrateruleseditorsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralRateRulesEditorResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralRateRulesEditorResponseODataWithMetadataResponse>;
        }));
    }

    protected processGeneralrateruleseditorsGET(response: HttpResponseBase): Observable<GeneralRateRulesEditorResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralRateRulesEditorResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update general rate rules editor data.
     * @param body (optional) 
     * @return No Content
     */
    generalrateruleseditorsPUT(id: number, body: UpdateGeneralRateRulesEditorRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/generalrateruleseditors/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneralrateruleseditorsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneralrateruleseditorsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGeneralrateruleseditorsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a general rate rules editor row.
     * @return No Content
     */
    generalrateruleseditorsDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/generalrateruleseditors/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneralrateruleseditorsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneralrateruleseditorsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGeneralrateruleseditorsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a general rate rules editor row by generated id.
     * @return OK
     */
    generalrateruleseditorsGET2(id: number): Observable<GeneralRateRulesEditorResponse> {
        let url_ = this.baseUrl + "/api/v1/generalrateruleseditors/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneralrateruleseditorsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneralrateruleseditorsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralRateRulesEditorResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralRateRulesEditorResponse>;
        }));
    }

    protected processGeneralrateruleseditorsGET2(response: HttpResponseBase): Observable<GeneralRateRulesEditorResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralRateRulesEditorResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Unique non-default entity types that have at least one active general rate rule
    in a country the client is subscribed to.
     * @param clientId (optional) 
     * @return OK
     */
    entitytypesAll(clientId: number | undefined): Observable<EntityTypeNestedObjectResponse[]> {
        let url_ = this.baseUrl + "/api/v1/generalrateruleseditors/entitytypes?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntitytypesAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntitytypesAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityTypeNestedObjectResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityTypeNestedObjectResponse[]>;
        }));
    }

    protected processEntitytypesAll(response: HttpResponseBase): Observable<EntityTypeNestedObjectResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityTypeNestedObjectResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Investment jurisdictions that have an active general rate rule for the selected general-rate entity type,
    limited to the countries the client is subscribed to.
     * @param generalRateEntityTypeId (optional) 
     * @param clientId (optional) 
     * @return OK
     */
    investmentjurisdictionsAll(generalRateEntityTypeId: number | undefined, clientId: number | undefined): Observable<NestedInvestmentJurisdictionShortResponse[]> {
        let url_ = this.baseUrl + "/api/v1/generalrateruleseditors/investmentjurisdictions?";
        if (generalRateEntityTypeId === null)
            throw new globalThis.Error("The parameter 'generalRateEntityTypeId' cannot be null.");
        else if (generalRateEntityTypeId !== undefined)
            url_ += "generalRateEntityTypeId=" + encodeURIComponent("" + generalRateEntityTypeId) + "&";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvestmentjurisdictionsAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvestmentjurisdictionsAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NestedInvestmentJurisdictionShortResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NestedInvestmentJurisdictionShortResponse[]>;
        }));
    }

    protected processInvestmentjurisdictionsAll(response: HttpResponseBase): Observable<NestedInvestmentJurisdictionShortResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NestedInvestmentJurisdictionShortResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Security types that have an active general rate rule for the selected general-rate entity type and jurisdiction.
     * @param generalRateEntityTypeId (optional) 
     * @param investmentJurisdictionId (optional) 
     * @param clientId (optional) 
     * @return OK
     */
    securitytypesAll(generalRateEntityTypeId: number | undefined, investmentJurisdictionId: number | undefined, clientId: number | undefined): Observable<SecurityTypeNestedObjectResponse[]> {
        let url_ = this.baseUrl + "/api/v1/generalrateruleseditors/securitytypes?";
        if (generalRateEntityTypeId === null)
            throw new globalThis.Error("The parameter 'generalRateEntityTypeId' cannot be null.");
        else if (generalRateEntityTypeId !== undefined)
            url_ += "generalRateEntityTypeId=" + encodeURIComponent("" + generalRateEntityTypeId) + "&";
        if (investmentJurisdictionId === null)
            throw new globalThis.Error("The parameter 'investmentJurisdictionId' cannot be null.");
        else if (investmentJurisdictionId !== undefined)
            url_ += "investmentJurisdictionId=" + encodeURIComponent("" + investmentJurisdictionId) + "&";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecuritytypesAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecuritytypesAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityTypeNestedObjectResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityTypeNestedObjectResponse[]>;
        }));
    }

    protected processSecuritytypesAll(response: HttpResponseBase): Observable<SecurityTypeNestedObjectResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SecurityTypeNestedObjectResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Active general rate rule rows (income types, rates, and descriptions) for the selected group.
     * @param generalRateEntityTypeId (optional) 
     * @param investmentJurisdictionId (optional) 
     * @param securityTypeId (optional) 
     * @param clientId (optional) 
     * @return OK
     */
    rules(generalRateEntityTypeId: number | undefined, investmentJurisdictionId: number | undefined, securityTypeId: number | undefined, clientId: number | undefined): Observable<GeneralRateRulesEditorResponse[]> {
        let url_ = this.baseUrl + "/api/v1/generalrateruleseditors/rules?";
        if (generalRateEntityTypeId === null)
            throw new globalThis.Error("The parameter 'generalRateEntityTypeId' cannot be null.");
        else if (generalRateEntityTypeId !== undefined)
            url_ += "generalRateEntityTypeId=" + encodeURIComponent("" + generalRateEntityTypeId) + "&";
        if (investmentJurisdictionId === null)
            throw new globalThis.Error("The parameter 'investmentJurisdictionId' cannot be null.");
        else if (investmentJurisdictionId !== undefined)
            url_ += "investmentJurisdictionId=" + encodeURIComponent("" + investmentJurisdictionId) + "&";
        if (securityTypeId === null)
            throw new globalThis.Error("The parameter 'securityTypeId' cannot be null.");
        else if (securityTypeId !== undefined)
            url_ += "securityTypeId=" + encodeURIComponent("" + securityTypeId) + "&";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralRateRulesEditorResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralRateRulesEditorResponse[]>;
        }));
    }

    protected processRules(response: HttpResponseBase): Observable<GeneralRateRulesEditorResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralRateRulesEditorResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    internalusersGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<InternalUserResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/internalusers?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInternalusersGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInternalusersGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalUserResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalUserResponseODataWithMetadataResponse>;
        }));
    }

    protected processInternalusersGET(response: HttpResponseBase): Observable<InternalUserResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalUserResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates new user
     * @param body (optional) 
     * @return Returns the newly created item
     */
    internalusersPOST(body: CreateInternalUserRequest | undefined): Observable<InternalUserResponse> {
        let url_ = this.baseUrl + "/api/v1/internalusers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInternalusersPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInternalusersPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalUserResponse>;
        }));
    }

    protected processInternalusersPOST(response: HttpResponseBase): Observable<InternalUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("If the item is invalid", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Item by Id
     * @param id Id of item
     * @return Selected item
     */
    internalusersGET2(id: string): Observable<InternalUserResponse> {
        let url_ = this.baseUrl + "/api/v1/internalusers/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInternalusersGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInternalusersGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalUserResponse>;
        }));
    }

    protected processInternalusersGET2(response: HttpResponseBase): Observable<InternalUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Item not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update item
     * @param id Id of item to be updated
     * @param body (optional) New values
     * @return Item updated successfully
     */
    internalusersPUT(id: string, body: UpdateInternalUserRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/internalusers/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInternalusersPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInternalusersPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInternalusersPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Item invalid", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Item not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * When the caller is a Gstar Admin (Gstar.Services.User.ICurrentUserService.IsGstarAdmin), permanently removes the user row and
    reassigns related data to the GSTAR system account via `dbo.sp_DeleteInactiveUser` (system user: `NormalizedEmail = N'NOREPLY@GSTARUSER.COM'`).
    Callers with elevated rights but not Gstar Admin receive 403; previously they could only deactivate a user, so frontends may need updates.
     * @param id Id of item to delete
     * @return User removed and data reassigned
     */
    internalusersDELETE(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/internalusers/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInternalusersDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInternalusersDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInternalusersDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DeleteUserResponse.fromJS(resultData400);
            return throwException("Delete rejected (e.g. system user)", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Not a Gstar Admin", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = DeleteUserResponse.fromJS(resultData404);
            return throwException("Item not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = DeleteUserResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    userrolesGET(id: string, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<UserRoleResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/internalusers/{id}/userroles?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserrolesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserrolesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleResponseODataWithMetadataResponse>;
        }));
    }

    protected processUserrolesGET(response: HttpResponseBase): Observable<UserRoleResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRoleResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData - Gets list of engagement assignments
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return Returns items list
     */
    clientassignmentsGET4(id: string, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<ClientAssignmentNestedObjectsResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/internalusers/{id}/clientassignments?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientassignmentsGET4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientassignmentsGET4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientAssignmentNestedObjectsResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientAssignmentNestedObjectsResponseODataWithMetadataResponse>;
        }));
    }

    protected processClientassignmentsGET4(response: HttpResponseBase): Observable<ClientAssignmentNestedObjectsResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientAssignmentNestedObjectsResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param body (optional) 
     * @return OK
     */
    investmentjurisdictionsPOST(body: CreateInvestmentJurisdictionRequest | undefined): Observable<InvestmentJurisdictionResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/investmentjurisdictions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvestmentjurisdictionsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvestmentjurisdictionsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestmentJurisdictionResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestmentJurisdictionResponseAuditable>;
        }));
    }

    protected processInvestmentjurisdictionsPOST(response: HttpResponseBase): Observable<InvestmentJurisdictionResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestmentJurisdictionResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    investmentjurisdictionsGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<InvestmentJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/investmentjurisdictions?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvestmentjurisdictionsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvestmentjurisdictionsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestmentJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestmentJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse>;
        }));
    }

    protected processInvestmentjurisdictionsGET(response: HttpResponseBase): Observable<InvestmentJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestmentJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param body (optional) 
     * @return No Content
     */
    investmentjurisdictionsPUT(id: number, body: UpdateInvestmentJurisdictionRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/investmentjurisdictions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvestmentjurisdictionsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvestmentjurisdictionsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInvestmentjurisdictionsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    investmentjurisdictionsGET2(id: number): Observable<InvestmentJurisdictionWithNestedObjectsResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/investmentjurisdictions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvestmentjurisdictionsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvestmentjurisdictionsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestmentJurisdictionWithNestedObjectsResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestmentJurisdictionWithNestedObjectsResponseAuditable>;
        }));
    }

    protected processInvestmentjurisdictionsGET2(response: HttpResponseBase): Observable<InvestmentJurisdictionWithNestedObjectsResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestmentJurisdictionWithNestedObjectsResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint by client
     * @param clientId (optional) 
     * @return OK
     */
    byclientAll2(clientId: number | undefined): Observable<InvestmentJurisdictionWithNestedObjectsResponseAuditable[]> {
        let url_ = this.baseUrl + "/api/v1/investmentjurisdictions/byclient?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByclientAll2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByclientAll2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestmentJurisdictionWithNestedObjectsResponseAuditable[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestmentJurisdictionWithNestedObjectsResponseAuditable[]>;
        }));
    }

    protected processByclientAll2(response: HttpResponseBase): Observable<InvestmentJurisdictionWithNestedObjectsResponseAuditable[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvestmentJurisdictionWithNestedObjectsResponseAuditable.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint by client (navigation – only where IsDisplay is true)
     * @param clientId (optional) 
     * @return OK
     */
    byclientnav(clientId: number | undefined): Observable<InvestmentJurisdictionWithNestedObjectsResponseAuditable[]> {
        let url_ = this.baseUrl + "/api/v1/investmentjurisdictions/byclientnav?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByclientnav(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByclientnav(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestmentJurisdictionWithNestedObjectsResponseAuditable[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestmentJurisdictionWithNestedObjectsResponseAuditable[]>;
        }));
    }

    protected processByclientnav(response: HttpResponseBase): Observable<InvestmentJurisdictionWithNestedObjectsResponseAuditable[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvestmentJurisdictionWithNestedObjectsResponseAuditable.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exports general country sections
     * @param body (optional) Include `countryIds` as a JSON array of country ids (same ids used by investment jurisdictions).
     * @return OK
     */
    exportcountryinformation(body: ExportCountryInformation | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/investmentjurisdictions/exportcountryinformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportcountryinformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportcountryinformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportcountryinformation(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Build authentication URL to authenticate users
     * @return OK
     */
    authenticationlink(): Observable<AuthenticationLinkResponse> {
        let url_ = this.baseUrl + "/api/v1/login/authenticationlink";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticationlink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticationlink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticationLinkResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticationLinkResponse>;
        }));
    }

    protected processAuthenticationlink(response: HttpResponseBase): Observable<AuthenticationLinkResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticationLinkResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get access token for the code
     * @param body (optional) 
     * @return OK
     */
    accesstoken(body: AccessTokenCodeRequest | undefined): Observable<AccessTokenCodeResponse> {
        let url_ = this.baseUrl + "/api/v1/login/accesstoken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccesstoken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccesstoken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessTokenCodeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessTokenCodeResponse>;
        }));
    }

    protected processAccesstoken(response: HttpResponseBase): Observable<AccessTokenCodeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessTokenCodeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OAuth 2.0 redirect target when using `response_mode=form_post` (e.g. Microsoft Entra ID). Accepts `code` and `state` in the form body, then redirects the browser to the app root with a short-lived `loginSessionId`.
     * @param body (optional) 
     */
    oauthCallback(body: Body | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/login/oauth-callback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = Object.keys(body as any).map((key) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent((body as any)[key]);
        }).join('&')

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/x-www-form-urlencoded",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOauthCallback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOauthCallback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOauthCallback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 302) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exchanges a `loginSessionId` from the client app (after M:Gstar.Api.Controllers.LoginController.OAuthFormPostCallback(System.String,System.String,System.String,System.String,Gstar.Authentication.Interfaces.Jwt.IJwtTokenBuilder,Microsoft.AspNetCore.Identity.UserManager{Gstar.Domain.Identity.Entities.ApplicationUser},Gstar.Graph.Services.IEntraGraphTokenStore)) for application tokens. The session id is one-time use.
     * @param body (optional) 
     * @return OK
     */
    oauthLoginsession(body: OAuthLoginSessionRequest | undefined): Observable<AccessTokenCodeResponse> {
        let url_ = this.baseUrl + "/api/v1/login/oauth-loginsession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOauthLoginsession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOauthLoginsession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessTokenCodeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessTokenCodeResponse>;
        }));
    }

    protected processOauthLoginsession(response: HttpResponseBase): Observable<AccessTokenCodeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessTokenCodeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get access token for client credentials
     * @param body (optional) 
     * @return OK
     */
    login(body: AccessTokenCredentialRequest | undefined): Observable<AccessTokenCredentialResponse> {
        let url_ = this.baseUrl + "/api/v1/login/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessTokenCredentialResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessTokenCredentialResponse>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<AccessTokenCredentialResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessTokenCredentialResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Renew tokens
     * @param body (optional) 
     * @return OK
     */
    refreshtoken(body: RefreshTokenRequest | undefined): Observable<RefreshTokenResponse> {
        let url_ = this.baseUrl + "/api/v1/login/refreshtoken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshtoken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshtoken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshTokenResponse>;
        }));
    }

    protected processRefreshtoken(response: HttpResponseBase): Observable<RefreshTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Revoke refresh token
     * @param body (optional) 
     * @return No Content
     */
    revoketoken(body: RevokeRefreshTokenRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/login/revoketoken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevoketoken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevoketoken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRevoketoken(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Build Component Monitoring API
     * @return OK
     */
    monitor(): Observable<ComponentMonitorResponse[]> {
        let url_ = this.baseUrl + "/api/v1/monitor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMonitor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMonitor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentMonitorResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentMonitorResponse[]>;
        }));
    }

    protected processMonitor(response: HttpResponseBase): Observable<ComponentMonitorResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComponentMonitorResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Portfolio
     * @param body (optional) 
     * @return OK
     */
    questionsPOST(body: CreateQuestionRequest | undefined): Observable<QuestionResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/questions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionResponseAuditable>;
        }));
    }

    protected processQuestionsPOST(response: HttpResponseBase): Observable<QuestionResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    questionsGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<QuestionResponseWithNestedObjectsResponseAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/questions?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionResponseWithNestedObjectsResponseAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionResponseWithNestedObjectsResponseAuditableODataWithMetadataResponse>;
        }));
    }

    protected processQuestionsGET(response: HttpResponseBase): Observable<QuestionResponseWithNestedObjectsResponseAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionResponseWithNestedObjectsResponseAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Portfolio details
     * @param body (optional) 
     * @return No Content
     */
    questionsPUT(id: number, body: UpdateQuestionRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/questions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuestionsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    questionsGET2(id: number): Observable<QuestionResponseWithNestedObjectsResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/questions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionResponseWithNestedObjectsResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionResponseWithNestedObjectsResponseAuditable>;
        }));
    }

    protected processQuestionsGET2(response: HttpResponseBase): Observable<QuestionResponseWithNestedObjectsResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionResponseWithNestedObjectsResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    history(questionId: number, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<QuestionHistoryResponseAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/questions/{questionId}/history?";
        if (questionId === undefined || questionId === null)
            throw new globalThis.Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionHistoryResponseAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionHistoryResponseAuditableODataWithMetadataResponse>;
        }));
    }

    protected processHistory(response: HttpResponseBase): Observable<QuestionHistoryResponseAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionHistoryResponseAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    questiontypes(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<QuestionTypeResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/questiontypes?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestiontypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestiontypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionTypeResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionTypeResponseODataWithMetadataResponse>;
        }));
    }

    protected processQuestiontypes(response: HttpResponseBase): Observable<QuestionTypeResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionTypeResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Item by Id
     * @param id Id of item
     * @return Selected item
     */
    questiontypes2(id: number): Observable<QuestionTypeResponse> {
        let url_ = this.baseUrl + "/api/v1/questiontypes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestiontypes2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestiontypes2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionTypeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionTypeResponse>;
        }));
    }

    protected processQuestiontypes2(response: HttpResponseBase): Observable<QuestionTypeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionTypeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Item not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    questionvaluetypes(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<QuestionValueTypeResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/questionvaluetypes?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionvaluetypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionvaluetypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionValueTypeResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionValueTypeResponseODataWithMetadataResponse>;
        }));
    }

    protected processQuestionvaluetypes(response: HttpResponseBase): Observable<QuestionValueTypeResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionValueTypeResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Item by Id
     * @param id Id of item
     * @return Selected item
     */
    questionvaluetypes2(id: number): Observable<QuestionValueTypeResponse> {
        let url_ = this.baseUrl + "/api/v1/questionvaluetypes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionvaluetypes2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionvaluetypes2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionValueTypeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionValueTypeResponse>;
        }));
    }

    protected processQuestionvaluetypes2(response: HttpResponseBase): Observable<QuestionValueTypeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionValueTypeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Item not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param body (optional) 
     * @return OK
     */
    regionsPOST(body: CreateRegionRequest | undefined): Observable<RegionResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/regions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegionsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegionsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegionResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegionResponseAuditable>;
        }));
    }

    protected processRegionsPOST(response: HttpResponseBase): Observable<RegionResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegionResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    regionsGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<RegionResponseAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/regions?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegionsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegionsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegionResponseAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegionResponseAuditableODataWithMetadataResponse>;
        }));
    }

    protected processRegionsGET(response: HttpResponseBase): Observable<RegionResponseAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegionResponseAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param body (optional) 
     * @return No Content
     */
    regionsPUT(id: number, body: UpdateRegionRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/regions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegionsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegionsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRegionsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    regionsGET2(id: number): Observable<RegionResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/regions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegionsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegionsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegionResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegionResponseAuditable>;
        }));
    }

    protected processRegionsGET2(response: HttpResponseBase): Observable<RegionResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegionResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param body (optional) 
     * @return OK
     */
    residencyjurisdictionsPOST(body: CreateResidencyJurisdictionRequest | undefined): Observable<ResidencyJurisdictionResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/residencyjurisdictions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResidencyjurisdictionsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResidencyjurisdictionsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResidencyJurisdictionResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResidencyJurisdictionResponseAuditable>;
        }));
    }

    protected processResidencyjurisdictionsPOST(response: HttpResponseBase): Observable<ResidencyJurisdictionResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResidencyJurisdictionResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    residencyjurisdictionsGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<ResidencyJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/residencyjurisdictions?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResidencyjurisdictionsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResidencyjurisdictionsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResidencyJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResidencyJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse>;
        }));
    }

    protected processResidencyjurisdictionsGET(response: HttpResponseBase): Observable<ResidencyJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResidencyJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param body (optional) 
     * @return No Content
     */
    residencyjurisdictionsPUT(id: number, body: UpdateResidencyJurisdictionRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/residencyjurisdictions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResidencyjurisdictionsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResidencyjurisdictionsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResidencyjurisdictionsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    residencyjurisdictionsGET2(id: number): Observable<ResidencyJurisdictionWithNestedObjectsResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/residencyjurisdictions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResidencyjurisdictionsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResidencyjurisdictionsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResidencyJurisdictionWithNestedObjectsResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResidencyJurisdictionWithNestedObjectsResponseAuditable>;
        }));
    }

    protected processResidencyjurisdictionsGET2(response: HttpResponseBase): Observable<ResidencyJurisdictionWithNestedObjectsResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResidencyJurisdictionWithNestedObjectsResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Portfolio
     * @param body (optional) 
     * @return OK
     */
    securitiesPOST(body: CreateSecurityRequest | undefined): Observable<SecurityResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/securities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecuritiesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecuritiesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityResponseAuditable>;
        }));
    }

    protected processSecuritiesPOST(response: HttpResponseBase): Observable<SecurityResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    securitiesGET2(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/securities?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecuritiesGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecuritiesGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse>;
        }));
    }

    protected processSecuritiesGET2(response: HttpResponseBase): Observable<SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Portfolio details
     * @param body (optional) 
     * @return No Content
     */
    securitiesPUT(id: number, body: UpdateSecurityRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/securities/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecuritiesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecuritiesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSecuritiesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    securitiesGET3(id: number): Observable<SecurityByIdResponseWithNestedObjectsAuditable> {
        let url_ = this.baseUrl + "/api/v1/securities/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecuritiesGET3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecuritiesGET3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityByIdResponseWithNestedObjectsAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityByIdResponseWithNestedObjectsAuditable>;
        }));
    }

    protected processSecuritiesGET3(response: HttpResponseBase): Observable<SecurityByIdResponseWithNestedObjectsAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityByIdResponseWithNestedObjectsAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint by client id
     * @param clientId (optional) 
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    byclient3(clientId: number | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/securities/byclient?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByclient3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByclient3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse>;
        }));
    }

    protected processByclient3(response: HttpResponseBase): Observable<SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Set IsActive False to a Security
     * @param body (optional) Id of item to set IsActive False
     * @return OK
     */
    deleteAll(body: number[] | undefined): Observable<SecurityActionResult[]> {
        let url_ = this.baseUrl + "/api/v1/securities/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityActionResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityActionResult[]>;
        }));
    }

    protected processDeleteAll(response: HttpResponseBase): Observable<SecurityActionResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SecurityActionResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Set Dispose Date to a Security
     * @param id Id of item to set Dispose Date
     * @param body (optional) 
     * @return Item updated successfully
     */
    dispose(id: number, body: UpdateDispositionDateSecurityRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/securities/{id}/dispose";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDispose(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDispose(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDispose(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Item invalid", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Item not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Change Transaction type to a Security
     * @param body (optional) 
     * @return Item updated successfully
     */
    transactiontype(id: number, body: UpdateSecurityTransactionTypeRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/securities/{id}/transactiontype";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactiontype(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactiontype(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTransactiontype(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Item invalid", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Item not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reevaluate security - it will set automatically the security for review - use this endpoint only if the input values somehow changes, otherwise use another endpoint or create a new one
     * @param body (optional) 
     * @return Item updated successfully
     */
    reevaluate(id: number, body: ReevaluateSecurityRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/securities/{id}/reevaluate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReevaluate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReevaluate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReevaluate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Item invalid", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Item not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Approve security with Approve status
     * @param body (optional) 
     * @return Item updated successfully
     */
    approveAll(body: ApproveSecurityRequest[] | undefined): Observable<SecurityActionResult[]> {
        let url_ = this.baseUrl + "/api/v1/securities/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityActionResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityActionResult[]>;
        }));
    }

    protected processApproveAll(response: HttpResponseBase): Observable<SecurityActionResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SecurityActionResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reject security with Review status
     * @param body (optional) 
     * @return Item updated successfully
     */
    reject(body: number[] | undefined): Observable<SecurityActionResult[]> {
        let url_ = this.baseUrl + "/api/v1/securities/reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityActionResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityActionResult[]>;
        }));
    }

    protected processReject(response: HttpResponseBase): Observable<SecurityActionResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SecurityActionResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Item invalid", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Item not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    download2(body: CreateFileExportRequest | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/securities/download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownload2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download with filter
     * @param body (optional) 
     * @return OK
     */
    download3(clientId: number, body: SecurityFilterRequest | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/securities/{clientId}/download";
        if (clientId === undefined || clientId === null)
            throw new globalThis.Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownload3(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    taxresulthistory(securityId: number, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<SecurityTaxResultItemHistoryResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/securities/{securityId}/taxresulthistory?";
        if (securityId === undefined || securityId === null)
            throw new globalThis.Error("The parameter 'securityId' must be defined.");
        url_ = url_.replace("{securityId}", encodeURIComponent("" + securityId));
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxresulthistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxresulthistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityTaxResultItemHistoryResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityTaxResultItemHistoryResponseODataWithMetadataResponse>;
        }));
    }

    protected processTaxresulthistory(response: HttpResponseBase): Observable<SecurityTaxResultItemHistoryResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityTaxResultItemHistoryResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    answers(securityId: number, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<SecurityQuestionAnswerWithNestedObjectsResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/securities/{securityId}/answers?";
        if (securityId === undefined || securityId === null)
            throw new globalThis.Error("The parameter 'securityId' must be defined.");
        url_ = url_.replace("{securityId}", encodeURIComponent("" + securityId));
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAnswers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAnswers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityQuestionAnswerWithNestedObjectsResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityQuestionAnswerWithNestedObjectsResponseODataWithMetadataResponse>;
        }));
    }

    protected processAnswers(response: HttpResponseBase): Observable<SecurityQuestionAnswerWithNestedObjectsResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityQuestionAnswerWithNestedObjectsResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    review(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<SecurityReviewResponseWithNestedObjectsAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/securities/review?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityReviewResponseWithNestedObjectsAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityReviewResponseWithNestedObjectsAuditableODataWithMetadataResponse>;
        }));
    }

    protected processReview(response: HttpResponseBase): Observable<SecurityReviewResponseWithNestedObjectsAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityReviewResponseWithNestedObjectsAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    reviewwithanswers(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<SecurityReviewResponseWithAnswersAndNestedObjectsODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/securities/reviewwithanswers?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReviewwithanswers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReviewwithanswers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityReviewResponseWithAnswersAndNestedObjectsODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityReviewResponseWithAnswersAndNestedObjectsODataWithMetadataResponse>;
        }));
    }

    protected processReviewwithanswers(response: HttpResponseBase): Observable<SecurityReviewResponseWithAnswersAndNestedObjectsODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityReviewResponseWithAnswersAndNestedObjectsODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    securitiesaudithistory(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<SecurityAuditHistoryResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/securitiesaudithistory?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecuritiesaudithistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecuritiesaudithistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityAuditHistoryResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityAuditHistoryResponseODataWithMetadataResponse>;
        }));
    }

    protected processSecuritiesaudithistory(response: HttpResponseBase): Observable<SecurityAuditHistoryResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityAuditHistoryResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    securitiesaudithistory2(id: number): Observable<SecurityAuditHistoryResponse> {
        let url_ = this.baseUrl + "/api/v1/securitiesaudithistory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecuritiesaudithistory2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecuritiesaudithistory2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityAuditHistoryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityAuditHistoryResponse>;
        }));
    }

    protected processSecuritiesaudithistory2(response: HttpResponseBase): Observable<SecurityAuditHistoryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityAuditHistoryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param clientId (optional) 
     * @param fileContent (optional) 
     * @return OK
     */
    securityfileimportsPOST(clientId: number | undefined, fileContent: FileParameter | undefined): Observable<SecurityFileImportResponse> {
        let url_ = this.baseUrl + "/api/v1/securityfileimports?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileContent === null || fileContent === undefined)
            throw new globalThis.Error("The parameter 'fileContent' cannot be null.");
        else
            content_.append("FileContent", fileContent.data, fileContent.fileName ? fileContent.fileName : "FileContent");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecurityfileimportsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecurityfileimportsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityFileImportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityFileImportResponse>;
        }));
    }

    protected processSecurityfileimportsPOST(response: HttpResponseBase): Observable<SecurityFileImportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityFileImportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    securityfileimportsGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<SecurityFileImportResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/securityfileimports?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecurityfileimportsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecurityfileimportsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityFileImportResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityFileImportResponseODataWithMetadataResponse>;
        }));
    }

    protected processSecurityfileimportsGET(response: HttpResponseBase): Observable<SecurityFileImportResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityFileImportResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param securityFileImportId (optional) 
     * @param clientId (optional) 
     * @param fileContent (optional) 
     * @return No Content
     */
    securityfileimportsPUT(id: number, securityFileImportId: number | undefined, clientId: number | undefined, fileContent: FileParameter | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/securityfileimports/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (securityFileImportId === null)
            throw new globalThis.Error("The parameter 'securityFileImportId' cannot be null.");
        else if (securityFileImportId !== undefined)
            url_ += "SecurityFileImportId=" + encodeURIComponent("" + securityFileImportId) + "&";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileContent === null || fileContent === undefined)
            throw new globalThis.Error("The parameter 'fileContent' cannot be null.");
        else
            content_.append("FileContent", fileContent.data, fileContent.fileName ? fileContent.fileName : "FileContent");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecurityfileimportsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecurityfileimportsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSecurityfileimportsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    securityfileimportsGET2(id: number): Observable<SecurityFileImportResponse> {
        let url_ = this.baseUrl + "/api/v1/securityfileimports/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecurityfileimportsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecurityfileimportsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityFileImportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityFileImportResponse>;
        }));
    }

    protected processSecurityfileimportsGET2(response: HttpResponseBase): Observable<SecurityFileImportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityFileImportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download a sample file
     * @return OK
     */
    download4(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/securityfileimports/download";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownload4(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("If the item is invalid", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Import Securities from excel (Max 1000 securities per file) - ClientId is required
     * @param clientId (optional) 
     * @param fileContent (optional) 
     * @return OK
     */
    upload2(clientId: number | undefined, fileContent: FileParameter | undefined): Observable<SecurityFileImportResponse> {
        let url_ = this.baseUrl + "/api/v1/securityfileimports/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (clientId === null || clientId === undefined)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else
            content_.append("ClientId", clientId.toString());
        if (fileContent === null || fileContent === undefined)
            throw new globalThis.Error("The parameter 'fileContent' cannot be null.");
        else
            content_.append("FileContent", fileContent.data, fileContent.fileName ? fileContent.fileName : "FileContent");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityFileImportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityFileImportResponse>;
        }));
    }

    protected processUpload2(response: HttpResponseBase): Observable<SecurityFileImportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityFileImportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("If the item is invalid", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param body (optional) 
     * @return OK
     */
    securitynotificationsPOST(body: CreateSecurityNotificationRequest | undefined): Observable<SecurityNotifictionResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/securitynotifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecuritynotificationsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecuritynotificationsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityNotifictionResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityNotifictionResponseAuditable>;
        }));
    }

    protected processSecuritynotificationsPOST(response: HttpResponseBase): Observable<SecurityNotifictionResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityNotifictionResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    securitynotificationsGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<SecurityNotifictionResponseAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/securitynotifications?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecuritynotificationsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecuritynotificationsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityNotifictionResponseAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityNotifictionResponseAuditableODataWithMetadataResponse>;
        }));
    }

    protected processSecuritynotificationsGET(response: HttpResponseBase): Observable<SecurityNotifictionResponseAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityNotifictionResponseAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param body (optional) 
     * @return No Content
     */
    securitynotificationsPUT(id: number, body: UpdateSecurityNotificationRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/securitynotifications/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecuritynotificationsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecuritynotificationsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSecuritynotificationsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    securitynotificationsGET2(id: number): Observable<SecurityNotifictionResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/securitynotifications/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecuritynotificationsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecuritynotificationsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityNotifictionResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityNotifictionResponseAuditable>;
        }));
    }

    protected processSecuritynotificationsGET2(response: HttpResponseBase): Observable<SecurityNotifictionResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityNotifictionResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Only to admin
     * @param body (optional) Id of item to set IsNotified as true
     * @return Item updated successfully
     */
    pendingsecurityasnotified(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/securitynotifications/pendingsecurityasnotified";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPendingsecurityasnotified(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPendingsecurityasnotified(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPendingsecurityasnotified(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Item invalid", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Item not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Set IsNotified true to mark as viewed a security
     * @param body (optional) Id of item to set IsNotified as true
     * @return Item updated successfully
     */
    notified(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/securitynotifications/notified";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotified(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotified(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotified(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Item invalid", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Item not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    securitystatuses(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/securitystatuses?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecuritystatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecuritystatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse>;
        }));
    }

    protected processSecuritystatuses(response: HttpResponseBase): Observable<SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Item by Id
     * @param id Id of item
     * @return Selected item
     */
    securitystatuses2(id: number): Observable<SecurityStatusResponse> {
        let url_ = this.baseUrl + "/api/v1/securitystatuses/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecuritystatuses2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecuritystatuses2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityStatusResponse>;
        }));
    }

    protected processSecuritystatuses2(response: HttpResponseBase): Observable<SecurityStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Item not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param body (optional) 
     * @return OK
     */
    securitytypesPOST(body: CreateSecurityTypeRequest | undefined): Observable<SecurityTypeResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/securitytypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecuritytypesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecuritytypesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityTypeResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityTypeResponseAuditable>;
        }));
    }

    protected processSecuritytypesPOST(response: HttpResponseBase): Observable<SecurityTypeResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityTypeResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    securitytypesGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<SecurityTypeResponseAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/securitytypes?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecuritytypesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecuritytypesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityTypeResponseAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityTypeResponseAuditableODataWithMetadataResponse>;
        }));
    }

    protected processSecuritytypesGET(response: HttpResponseBase): Observable<SecurityTypeResponseAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityTypeResponseAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param body (optional) 
     * @return No Content
     */
    securitytypesPUT(id: number, body: UpdateSecurityTypeRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/securitytypes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecuritytypesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecuritytypesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSecuritytypesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    securitytypesGET2(id: number): Observable<SecurityTypeResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/securitytypes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecuritytypesGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecuritytypesGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityTypeResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityTypeResponseAuditable>;
        }));
    }

    protected processSecuritytypesGET2(response: HttpResponseBase): Observable<SecurityTypeResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityTypeResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint to get Tax Result Types
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    taxresultitemtypesGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<SecurityTypeTaxResultItemTypeResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/securitytypes/taxresultitemtypes?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxresultitemtypesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxresultitemtypesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityTypeTaxResultItemTypeResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityTypeTaxResultItemTypeResponseODataWithMetadataResponse>;
        }));
    }

    protected processTaxresultitemtypesGET(response: HttpResponseBase): Observable<SecurityTypeTaxResultItemTypeResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityTypeTaxResultItemTypeResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    datageochart(body: TaxByJurisdictionRequest | undefined): Observable<TaxByJurisdictionResponse[]> {
        let url_ = this.baseUrl + "/api/v1/taxbyjurisdiction/datageochart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatageochart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatageochart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxByJurisdictionResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxByJurisdictionResponse[]>;
        }));
    }

    protected processDatageochart(response: HttpResponseBase): Observable<TaxByJurisdictionResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaxByJurisdictionResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param body (optional) 
     * @return OK
     */
    taxpoliciesPOST(body: CreateTaxPolicyRequest | undefined): Observable<TaxPolicyResponse> {
        let url_ = this.baseUrl + "/api/v1/taxpolicies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxpoliciesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxpoliciesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxPolicyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxPolicyResponse>;
        }));
    }

    protected processTaxpoliciesPOST(response: HttpResponseBase): Observable<TaxPolicyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxPolicyResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    taxpoliciesGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<TaxPolicyWithNestedObjectResponseAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/taxpolicies?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxpoliciesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxpoliciesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxPolicyWithNestedObjectResponseAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxPolicyWithNestedObjectResponseAuditableODataWithMetadataResponse>;
        }));
    }

    protected processTaxpoliciesGET(response: HttpResponseBase): Observable<TaxPolicyWithNestedObjectResponseAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxPolicyWithNestedObjectResponseAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param body (optional) 
     * @return No Content
     */
    taxpoliciesPUT(id: number, body: UpdateTaxPolicyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/taxpolicies/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxpoliciesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxpoliciesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTaxpoliciesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    taxpoliciesGET2(id: number): Observable<TaxPolicyWithNestedObjectResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/taxpolicies/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxpoliciesGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxpoliciesGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxPolicyWithNestedObjectResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxPolicyWithNestedObjectResponseAuditable>;
        }));
    }

    protected processTaxpoliciesGET2(response: HttpResponseBase): Observable<TaxPolicyWithNestedObjectResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxPolicyWithNestedObjectResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    history2(taxPolicyId: number, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<TaxPolicyHistoryResponseAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/taxpolicies/{taxPolicyId}/history?";
        if (taxPolicyId === undefined || taxPolicyId === null)
            throw new globalThis.Error("The parameter 'taxPolicyId' must be defined.");
        url_ = url_.replace("{taxPolicyId}", encodeURIComponent("" + taxPolicyId));
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHistory2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHistory2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxPolicyHistoryResponseAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxPolicyHistoryResponseAuditableODataWithMetadataResponse>;
        }));
    }

    protected processHistory2(response: HttpResponseBase): Observable<TaxPolicyHistoryResponseAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxPolicyHistoryResponseAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData - Get Tax Results
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return Returns items list
     */
    taxresultsGET(taxPolicyId: number, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<TaxResultWithNestedObjectsResponseAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/taxpolicies/{taxPolicyId}/taxresults?";
        if (taxPolicyId === undefined || taxPolicyId === null)
            throw new globalThis.Error("The parameter 'taxPolicyId' must be defined.");
        url_ = url_.replace("{taxPolicyId}", encodeURIComponent("" + taxPolicyId));
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxresultsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxresultsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxResultWithNestedObjectsResponseAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxResultWithNestedObjectsResponseAuditableODataWithMetadataResponse>;
        }));
    }

    protected processTaxresultsGET(response: HttpResponseBase): Observable<TaxResultWithNestedObjectsResponseAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxResultWithNestedObjectsResponseAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData - Get Questions
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return Returns items list
     */
    questionsGET3(taxPolicyId: number, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<QuestionResponseWithNestedObjectsResponseAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/taxpolicies/{taxPolicyId}/questions?";
        if (taxPolicyId === undefined || taxPolicyId === null)
            throw new globalThis.Error("The parameter 'taxPolicyId' must be defined.");
        url_ = url_.replace("{taxPolicyId}", encodeURIComponent("" + taxPolicyId));
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionsGET3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionsGET3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionResponseWithNestedObjectsResponseAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionResponseWithNestedObjectsResponseAuditableODataWithMetadataResponse>;
        }));
    }

    protected processQuestionsGET3(response: HttpResponseBase): Observable<QuestionResponseWithNestedObjectsResponseAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionResponseWithNestedObjectsResponseAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData - Get Tax Rules
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return Returns items list
     */
    taxrulesGET(taxPolicyId: number, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<TaxRuleWithNestedObjectResponseAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/taxpolicies/{taxPolicyId}/taxrules?";
        if (taxPolicyId === undefined || taxPolicyId === null)
            throw new globalThis.Error("The parameter 'taxPolicyId' must be defined.");
        url_ = url_.replace("{taxPolicyId}", encodeURIComponent("" + taxPolicyId));
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxrulesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxrulesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxRuleWithNestedObjectResponseAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxRuleWithNestedObjectResponseAuditableODataWithMetadataResponse>;
        }));
    }

    protected processTaxrulesGET(response: HttpResponseBase): Observable<TaxRuleWithNestedObjectResponseAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxRuleWithNestedObjectResponseAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    taxpolicystatuses(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<TaxPolicyStatusResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/taxpolicystatuses?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxpolicystatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxpolicystatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxPolicyStatusResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxPolicyStatusResponseODataWithMetadataResponse>;
        }));
    }

    protected processTaxpolicystatuses(response: HttpResponseBase): Observable<TaxPolicyStatusResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxPolicyStatusResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Item by Id
     * @param id Id of item
     * @return Selected item
     */
    taxpolicystatuses2(id: number): Observable<TaxPolicyStatusResponse> {
        let url_ = this.baseUrl + "/api/v1/taxpolicystatuses/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxpolicystatuses2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxpolicystatuses2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxPolicyStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxPolicyStatusResponse>;
        }));
    }

    protected processTaxpolicystatuses2(response: HttpResponseBase): Observable<TaxPolicyStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxPolicyStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Item not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param body (optional) 
     * @return OK
     */
    taxratesummaryPOST(body: CreateTaxRateSummaryRequest | undefined): Observable<TaxRateSummaryResponse> {
        let url_ = this.baseUrl + "/api/v1/taxratesummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxratesummaryPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxratesummaryPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxRateSummaryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxRateSummaryResponse>;
        }));
    }

    protected processTaxratesummaryPOST(response: HttpResponseBase): Observable<TaxRateSummaryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxRateSummaryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    taxratesummaryGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<TaxRateSummaryWithNestedObjectResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/taxratesummary?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxratesummaryGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxratesummaryGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxRateSummaryWithNestedObjectResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxRateSummaryWithNestedObjectResponseODataWithMetadataResponse>;
        }));
    }

    protected processTaxratesummaryGET(response: HttpResponseBase): Observable<TaxRateSummaryWithNestedObjectResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxRateSummaryWithNestedObjectResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param body (optional) 
     * @return No Content
     */
    taxratesummaryPUT(id: number, body: UpdateTaxRateSummaryRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/taxratesummary/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxratesummaryPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxratesummaryPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTaxratesummaryPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    taxratesummaryGET2(id: number): Observable<TaxRateSummaryWithNestedObjectResponse> {
        let url_ = this.baseUrl + "/api/v1/taxratesummary/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxratesummaryGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxratesummaryGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxRateSummaryWithNestedObjectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxRateSummaryWithNestedObjectResponse>;
        }));
    }

    protected processTaxratesummaryGET2(response: HttpResponseBase): Observable<TaxRateSummaryWithNestedObjectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxRateSummaryWithNestedObjectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param body (optional) 
     * @return OK
     */
    taxresultitemsPOST(body: CreateTaxResultItemRequest | undefined): Observable<TaxResultItemResponse> {
        let url_ = this.baseUrl + "/api/v1/taxresultitems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxresultitemsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxresultitemsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxResultItemResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxResultItemResponse>;
        }));
    }

    protected processTaxresultitemsPOST(response: HttpResponseBase): Observable<TaxResultItemResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxResultItemResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    taxresultitemsGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<TaxResultItemNestedObjectResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/taxresultitems?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxresultitemsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxresultitemsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxResultItemNestedObjectResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxResultItemNestedObjectResponseODataWithMetadataResponse>;
        }));
    }

    protected processTaxresultitemsGET(response: HttpResponseBase): Observable<TaxResultItemNestedObjectResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxResultItemNestedObjectResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param body (optional) 
     * @return No Content
     */
    taxresultitemsPUT(id: number, body: UpdateTaxResultItemRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/taxresultitems/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxresultitemsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxresultitemsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTaxresultitemsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    taxresultitemsGET2(id: number): Observable<TaxResultItemResponse> {
        let url_ = this.baseUrl + "/api/v1/taxresultitems/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxresultitemsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxresultitemsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxResultItemResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxResultItemResponse>;
        }));
    }

    protected processTaxresultitemsGET2(response: HttpResponseBase): Observable<TaxResultItemResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxResultItemResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Export rates as Excel
     * @param body (optional) 
     * @return OK
     */
    exportrates(body: number[] | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/taxresultitems/exportrates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportrates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportrates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportrates(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param body (optional) 
     * @return OK
     */
    taxresultitemtypesPOST(body: CreateTaxResultItemTypeRequest | undefined): Observable<TaxResultItemTypeResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/taxresultitemtypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxresultitemtypesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxresultitemtypesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxResultItemTypeResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxResultItemTypeResponseAuditable>;
        }));
    }

    protected processTaxresultitemtypesPOST(response: HttpResponseBase): Observable<TaxResultItemTypeResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxResultItemTypeResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    taxresultitemtypesGET2(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<TaxResultItemTypeNestedObjectResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/taxresultitemtypes?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxresultitemtypesGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxresultitemtypesGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxResultItemTypeNestedObjectResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxResultItemTypeNestedObjectResponseODataWithMetadataResponse>;
        }));
    }

    protected processTaxresultitemtypesGET2(response: HttpResponseBase): Observable<TaxResultItemTypeNestedObjectResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxResultItemTypeNestedObjectResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param body (optional) 
     * @return No Content
     */
    taxresultitemtypesPUT(id: number, body: UpdateTaxResultItemTypeRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/taxresultitemtypes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxresultitemtypesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxresultitemtypesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTaxresultitemtypesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    taxresultitemtypesGET3(id: number): Observable<TaxResultItemTypeResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/taxresultitemtypes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxresultitemtypesGET3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxresultitemtypesGET3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxResultItemTypeResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxResultItemTypeResponseAuditable>;
        }));
    }

    protected processTaxresultitemtypesGET3(response: HttpResponseBase): Observable<TaxResultItemTypeResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxResultItemTypeResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param body (optional) 
     * @return OK
     */
    taxresultsPOST(body: CreateTaxResultRequest | undefined): Observable<TaxResultResponse> {
        let url_ = this.baseUrl + "/api/v1/taxresults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxresultsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxresultsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxResultResponse>;
        }));
    }

    protected processTaxresultsPOST(response: HttpResponseBase): Observable<TaxResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    taxresultsGET2(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<TaxResultWithNestedObjectsResponseAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/taxresults?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxresultsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxresultsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxResultWithNestedObjectsResponseAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxResultWithNestedObjectsResponseAuditableODataWithMetadataResponse>;
        }));
    }

    protected processTaxresultsGET2(response: HttpResponseBase): Observable<TaxResultWithNestedObjectsResponseAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxResultWithNestedObjectsResponseAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param body (optional) 
     * @return No Content
     */
    taxresultsPUT(id: number, body: UpdateTaxResultRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/taxresults/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxresultsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxresultsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTaxresultsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    taxresultsGET3(id: number): Observable<TaxResultWithNestedObjectsResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/taxresults/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxresultsGET3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxresultsGET3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxResultWithNestedObjectsResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxResultWithNestedObjectsResponseAuditable>;
        }));
    }

    protected processTaxresultsGET3(response: HttpResponseBase): Observable<TaxResultWithNestedObjectsResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxResultWithNestedObjectsResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @return OK
     */
    history3(taxResultId: number): Observable<TaxResultHistoryResponseAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/taxresults/{taxResultId}/history";
        if (taxResultId === undefined || taxResultId === null)
            throw new globalThis.Error("The parameter 'taxResultId' must be defined.");
        url_ = url_.replace("{taxResultId}", encodeURIComponent("" + taxResultId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHistory3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHistory3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxResultHistoryResponseAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxResultHistoryResponseAuditableODataWithMetadataResponse>;
        }));
    }

    protected processHistory3(response: HttpResponseBase): Observable<TaxResultHistoryResponseAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxResultHistoryResponseAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    taxresulttypes(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<TaxResultTypeResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/taxresulttypes?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxresulttypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxresulttypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxResultTypeResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxResultTypeResponseODataWithMetadataResponse>;
        }));
    }

    protected processTaxresulttypes(response: HttpResponseBase): Observable<TaxResultTypeResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxResultTypeResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Item by Id
     * @param id Id of item
     * @return Selected item
     */
    taxresulttypes2(id: number): Observable<TaxResultTypeResponse> {
        let url_ = this.baseUrl + "/api/v1/taxresulttypes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxresulttypes2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxresulttypes2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxResultTypeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxResultTypeResponse>;
        }));
    }

    protected processTaxresulttypes2(response: HttpResponseBase): Observable<TaxResultTypeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxResultTypeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Item not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param body (optional) 
     * @return OK
     */
    taxrulesPOST(body: CreateTaxRuleRequest | undefined): Observable<TaxRuleResponse> {
        let url_ = this.baseUrl + "/api/v1/taxrules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxrulesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxrulesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxRuleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxRuleResponse>;
        }));
    }

    protected processTaxrulesPOST(response: HttpResponseBase): Observable<TaxRuleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxRuleResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    taxrulesGET2(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<TaxRuleWithNestedObjectResponseAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/taxrules?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxrulesGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxrulesGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxRuleWithNestedObjectResponseAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxRuleWithNestedObjectResponseAuditableODataWithMetadataResponse>;
        }));
    }

    protected processTaxrulesGET2(response: HttpResponseBase): Observable<TaxRuleWithNestedObjectResponseAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxRuleWithNestedObjectResponseAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param body (optional) 
     * @return No Content
     */
    taxrulesPUT(id: number, body: UpdateTaxRuleRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/taxrules/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxrulesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxrulesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTaxrulesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    taxrulesGET3(id: number): Observable<TaxRuleWithNestedObjectResponseAuditable> {
        let url_ = this.baseUrl + "/api/v1/taxrules/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxrulesGET3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxrulesGET3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxRuleWithNestedObjectResponseAuditable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxRuleWithNestedObjectResponseAuditable>;
        }));
    }

    protected processTaxrulesGET3(response: HttpResponseBase): Observable<TaxRuleWithNestedObjectResponseAuditable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxRuleWithNestedObjectResponseAuditable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    history4(taxRuleId: number, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<TaxRuleHistoryResponseAuditableODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/taxrules/{taxRuleId}/history?";
        if (taxRuleId === undefined || taxRuleId === null)
            throw new globalThis.Error("The parameter 'taxRuleId' must be defined.");
        url_ = url_.replace("{taxRuleId}", encodeURIComponent("" + taxRuleId));
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHistory4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHistory4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxRuleHistoryResponseAuditableODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxRuleHistoryResponseAuditableODataWithMetadataResponse>;
        }));
    }

    protected processHistory4(response: HttpResponseBase): Observable<TaxRuleHistoryResponseAuditableODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxRuleHistoryResponseAuditableODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Rule Engine Endpoint
     * @param body (optional) 
     * @return Returns evaluation result
     */
    execute(body: EvaluationRequest | undefined): Observable<EvaluationResponse> {
        let url_ = this.baseUrl + "/api/v1/taxrules/execute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EvaluationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EvaluationResponse>;
        }));
    }

    protected processExecute(response: HttpResponseBase): Observable<EvaluationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EvaluationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("If the request is invalid", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Tax Policies / Rules to execute - only active policies
     * @param body (optional) 
     * @return List of active rules/policies
     */
    activerules(body: ActiveRuleRequest | undefined): Observable<ActiveRuleResponse[]> {
        let url_ = this.baseUrl + "/api/v1/taxrules/activerules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActiverules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiverules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveRuleResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveRuleResponse[]>;
        }));
    }

    protected processActiverules(response: HttpResponseBase): Observable<ActiveRuleResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActiveRuleResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("If the request is invalid", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param body (optional) 
     * @return OK
     */
    taxsummaryPOST(body: CreateTaxSummaryRequest | undefined): Observable<TaxSummaryResponse> {
        let url_ = this.baseUrl + "/api/v1/taxsummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxsummaryPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxsummaryPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxSummaryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxSummaryResponse>;
        }));
    }

    protected processTaxsummaryPOST(response: HttpResponseBase): Observable<TaxSummaryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxSummaryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    taxsummaryGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<TaxSummaryWithNestedObjectsResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/taxsummary?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxsummaryGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxsummaryGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxSummaryWithNestedObjectsResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxSummaryWithNestedObjectsResponseODataWithMetadataResponse>;
        }));
    }

    protected processTaxsummaryGET(response: HttpResponseBase): Observable<TaxSummaryWithNestedObjectsResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxSummaryWithNestedObjectsResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param body (optional) 
     * @return No Content
     */
    taxsummaryPUT(id: number, body: UpdateTaxSummaryRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/taxsummary/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxsummaryPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxsummaryPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTaxsummaryPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    taxsummaryGET2(id: number): Observable<TaxSummaryWithNestedObjectsResponse> {
        let url_ = this.baseUrl + "/api/v1/taxsummary/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxsummaryGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxsummaryGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxSummaryWithNestedObjectsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxSummaryWithNestedObjectsResponse>;
        }));
    }

    protected processTaxsummaryGET2(response: HttpResponseBase): Observable<TaxSummaryWithNestedObjectsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxSummaryWithNestedObjectsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint by client id
     * @param clientId (optional) 
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    byclient4(clientId: number | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<TaxSummaryWithNestedObjectsResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/taxsummary/byclient?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByclient4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByclient4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxSummaryWithNestedObjectsResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxSummaryWithNestedObjectsResponseODataWithMetadataResponse>;
        }));
    }

    protected processByclient4(response: HttpResponseBase): Observable<TaxSummaryWithNestedObjectsResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxSummaryWithNestedObjectsResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param body (optional) 
     * @return OK
     */
    taxsummaryheadertypePOST(body: CreateTaxSummaryHeaderTypeRequest | undefined): Observable<TaxSummaryHeaderTypeResponse> {
        let url_ = this.baseUrl + "/api/v1/taxsummaryheadertype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxsummaryheadertypePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxsummaryheadertypePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxSummaryHeaderTypeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxSummaryHeaderTypeResponse>;
        }));
    }

    protected processTaxsummaryheadertypePOST(response: HttpResponseBase): Observable<TaxSummaryHeaderTypeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxSummaryHeaderTypeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    taxsummaryheadertypeGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<TaxSummaryHeaderTypeResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/taxsummaryheadertype?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxsummaryheadertypeGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxsummaryheadertypeGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxSummaryHeaderTypeResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxSummaryHeaderTypeResponseODataWithMetadataResponse>;
        }));
    }

    protected processTaxsummaryheadertypeGET(response: HttpResponseBase): Observable<TaxSummaryHeaderTypeResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxSummaryHeaderTypeResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param body (optional) 
     * @return No Content
     */
    taxsummaryheadertypePUT(id: number, body: UpdateTaxSummaryHeaderTypeRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/taxsummaryheadertype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxsummaryheadertypePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxsummaryheadertypePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTaxsummaryheadertypePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    taxsummaryheadertypeGET2(id: number): Observable<TaxSummaryHeaderTypeResponse> {
        let url_ = this.baseUrl + "/api/v1/taxsummaryheadertype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxsummaryheadertypeGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxsummaryheadertypeGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxSummaryHeaderTypeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxSummaryHeaderTypeResponse>;
        }));
    }

    protected processTaxsummaryheadertypeGET2(response: HttpResponseBase): Observable<TaxSummaryHeaderTypeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxSummaryHeaderTypeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param body (optional) 
     * @return OK
     */
    taxsummarytypePOST(body: CreateTaxSummaryTypeRequest | undefined): Observable<TaxSummaryTypeResponse> {
        let url_ = this.baseUrl + "/api/v1/taxsummarytype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxsummarytypePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxsummarytypePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxSummaryTypeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxSummaryTypeResponse>;
        }));
    }

    protected processTaxsummarytypePOST(response: HttpResponseBase): Observable<TaxSummaryTypeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxSummaryTypeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    taxsummarytypeGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<TaxSummaryTypeWithNestedObjectResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/taxsummarytype?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxsummarytypeGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxsummarytypeGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxSummaryTypeWithNestedObjectResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxSummaryTypeWithNestedObjectResponseODataWithMetadataResponse>;
        }));
    }

    protected processTaxsummarytypeGET(response: HttpResponseBase): Observable<TaxSummaryTypeWithNestedObjectResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxSummaryTypeWithNestedObjectResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param body (optional) 
     * @return No Content
     */
    taxsummarytypePUT(id: number, body: UpdateTaxSummaryTypeRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/taxsummarytype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxsummarytypePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxsummarytypePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTaxsummarytypePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    taxsummarytypeGET2(id: number): Observable<TaxSummaryTypeWithNestedObjectResponse> {
        let url_ = this.baseUrl + "/api/v1/taxsummarytype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaxsummarytypeGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaxsummarytypeGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxSummaryTypeWithNestedObjectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxSummaryTypeWithNestedObjectResponse>;
        }));
    }

    protected processTaxsummarytypeGET2(response: HttpResponseBase): Observable<TaxSummaryTypeWithNestedObjectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxSummaryTypeWithNestedObjectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     * @param body (optional) 
     * @return OK
     */
    transactiontypesPOST(body: CreateTransactionTypeRequest | undefined): Observable<TransactionTypeResponse> {
        let url_ = this.baseUrl + "/api/v1/transactiontypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactiontypesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactiontypesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionTypeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionTypeResponse>;
        }));
    }

    protected processTransactiontypesPOST(response: HttpResponseBase): Observable<TransactionTypeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionTypeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    transactiontypesGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<TransactionTypeResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/transactiontypes?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactiontypesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactiontypesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionTypeResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionTypeResponseODataWithMetadataResponse>;
        }));
    }

    protected processTransactiontypesGET(response: HttpResponseBase): Observable<TransactionTypeResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionTypeResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     * @param body (optional) 
     * @return No Content
     */
    transactiontypesPUT(id: number, body: UpdateTransactionTypeRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/transactiontypes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactiontypesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactiontypesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTransactiontypesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get By Id
     * @return OK
     */
    transactiontypesGET2(id: number): Observable<TransactionTypeResponse> {
        let url_ = this.baseUrl + "/api/v1/transactiontypes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactiontypesGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactiontypesGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionTypeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionTypeResponse>;
        }));
    }

    protected processTransactiontypesGET2(response: HttpResponseBase): Observable<TransactionTypeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionTypeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get OData endpoint
     * @return OK
     */
    usernotifications(id: number): Observable<UserNotificationResponse> {
        let url_ = this.baseUrl + "/api/v1/usernotifications/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsernotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsernotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserNotificationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserNotificationResponse>;
        }));
    }

    protected processUsernotifications(response: HttpResponseBase): Observable<UserNotificationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNotificationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    usernotifications2(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<UserNotificationResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/usernotifications?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsernotifications2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsernotifications2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserNotificationResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserNotificationResponseODataWithMetadataResponse>;
        }));
    }

    protected processUsernotifications2(response: HttpResponseBase): Observable<UserNotificationResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNotificationResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get User Notifications by UserId
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    currentuser2(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<UserNotificationResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/usernotifications/currentuser?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCurrentuser2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCurrentuser2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserNotificationResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserNotificationResponseODataWithMetadataResponse>;
        }));
    }

    protected processCurrentuser2(response: HttpResponseBase): Observable<UserNotificationResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNotificationResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update User Notification
     * @param body (optional) List of userNoticationIds
     * @return OK
     */
    readusernotification(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/usernotifications/readusernotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadusernotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadusernotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReadusernotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    userrolesGET2(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<RoleResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/userroles?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserrolesGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserrolesGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleResponseODataWithMetadataResponse>;
        }));
    }

    protected processUserrolesGET2(response: HttpResponseBase): Observable<RoleResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adding user to a role
     * @param body (optional) 
     * @return Returns the newly created item
     */
    userrolesPOST(body: CreateUserRoleRequest | undefined): Observable<UserRoleResponse> {
        let url_ = this.baseUrl + "/api/v1/userroles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserrolesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserrolesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleResponse>;
        }));
    }

    protected processUserrolesPOST(response: HttpResponseBase): Observable<UserRoleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRoleResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("If the item is invalid", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Remove user from a role
     * @param userId User Id
     * @param body (optional) Role id
     * @return Item deleted successfully
     */
    userrolesDELETE(userId: string, body: DeleteUserRoleRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/userroles/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserrolesDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserrolesDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserrolesDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Item not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    getusersbyrole(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<ApplicationUserODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/userroles/getusersbyrole?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetusersbyrole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetusersbyrole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationUserODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationUserODataWithMetadataResponse>;
        }));
    }

    protected processGetusersbyrole(response: HttpResponseBase): Observable<ApplicationUserODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationUserODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    users2(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<UserResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/users?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserResponseODataWithMetadataResponse>;
        }));
    }

    protected processUsers2(response: HttpResponseBase): Observable<UserResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData - Gets list of client assignments
     * @param userId (optional) 
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return Returns items list
     */
    clientassignmentsGET5(userId: string | undefined, id: string, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<ClientAssignmentNestedObjectsResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/users/{id}/clientassignments?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientassignmentsGET5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientassignmentsGET5(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientAssignmentNestedObjectsResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientAssignmentNestedObjectsResponseODataWithMetadataResponse>;
        }));
    }

    protected processClientassignmentsGET5(response: HttpResponseBase): Observable<ClientAssignmentNestedObjectsResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientAssignmentNestedObjectsResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a user only if inactive for at least 6 months. Reassignment to the GSTAR system account and deletion are handled in
    `dbo.sp_DeleteInactiveUser` (system user is resolved in the database).
     * @return OK
     */
    deleteuser(userId: string): Observable<DeleteUserResponse> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/deleteuser";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteuser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteuser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteUserResponse>;
        }));
    }

    protected processDeleteuser(response: HttpResponseBase): Observable<DeleteUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DeleteUserResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = DeleteUserResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OData endpoint
     * @param select (optional) Returns only the selected properties.
     * @param filter (optional) Filter the response with OData filter queries.
     * @param top (optional) Number of objects to return.
     * @param skip (optional) Number of objects to skip in the current order.
     * @param orderby (optional) Define the order by one or more fields.
     * @param count (optional) Returns number of items.
     * @param expand (optional) Expands nested objects.
     * @return OK
     */
    usersettingsGET(select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: string | undefined, expand: string | undefined): Observable<UserSettingResponseODataWithMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/usersettings?";
        if (select === null)
            throw new globalThis.Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new globalThis.Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new globalThis.Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsersettingsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsersettingsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSettingResponseODataWithMetadataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSettingResponseODataWithMetadataResponse>;
        }));
    }

    protected processUsersettingsGET(response: HttpResponseBase): Observable<UserSettingResponseODataWithMetadataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSettingResponseODataWithMetadataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update
     * @param body (optional) 
     * @return Returns the newly created item
     */
    usersettingsPOST(body: AddUserSettingRequest | undefined): Observable<UserSettingResponse> {
        let url_ = this.baseUrl + "/api/v1/usersettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsersettingsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsersettingsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSettingResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSettingResponse>;
        }));
    }

    protected processUsersettingsPOST(response: HttpResponseBase): Observable<UserSettingResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSettingResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("If the item is invalid", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Item by Id
     * @param key Id of item
     * @return Selected item
     */
    usersettingsGET2(key: string): Observable<UserSettingResponse> {
        let url_ = this.baseUrl + "/api/v1/usersettings/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsersettingsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsersettingsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSettingResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSettingResponse>;
        }));
    }

    protected processUsersettingsGET2(response: HttpResponseBase): Observable<UserSettingResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSettingResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Item not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get User Email settings by user id
     * @return OK
     */
    getuseremailsettings(id: string): Observable<UserEmailNotificationSettingsResponse> {
        let url_ = this.baseUrl + "/api/v1/usersettings/{id}/getuseremailsettings";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetuseremailsettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetuseremailsettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserEmailNotificationSettingsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserEmailNotificationSettingsResponse>;
        }));
    }

    protected processGetuseremailsettings(response: HttpResponseBase): Observable<UserEmailNotificationSettingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserEmailNotificationSettingsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Set true/false User Email settings
     * @param body (optional) 
     * @return OK
     */
    setuseremailsettings(id: string, body: UserEmailNotificationSettingsRequest | undefined): Observable<UserEmailNotificationSettingsResponse> {
        let url_ = this.baseUrl + "/api/v1/usersettings/{id}/setuseremailsettings";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetuseremailsettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetuseremailsettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserEmailNotificationSettingsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserEmailNotificationSettingsResponse>;
        }));
    }

    protected processSetuseremailsettings(response: HttpResponseBase): Observable<UserEmailNotificationSettingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserEmailNotificationSettingsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AccessTokenCodeRequest implements IAccessTokenCodeRequest {
    code!: string;
    state!: string;

    constructor(data?: IAccessTokenCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): AccessTokenCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccessTokenCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["state"] = this.state;
        return data;
    }
}

export interface IAccessTokenCodeRequest {
    code: string;
    state: string;
}

export class AccessTokenCodeResponse implements IAccessTokenCodeResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    sessionId?: string;
    accessTokenExpiresIn?: number;
    refreshTokenExpiresIn?: number;
    activeSessionIds?: string[] | undefined;

    constructor(data?: IAccessTokenCodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.sessionId = _data["sessionId"];
            this.accessTokenExpiresIn = _data["accessTokenExpiresIn"];
            this.refreshTokenExpiresIn = _data["refreshTokenExpiresIn"];
            if (Array.isArray(_data["activeSessionIds"])) {
                this.activeSessionIds = [] as any;
                for (let item of _data["activeSessionIds"])
                    this.activeSessionIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AccessTokenCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccessTokenCodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["sessionId"] = this.sessionId;
        data["accessTokenExpiresIn"] = this.accessTokenExpiresIn;
        data["refreshTokenExpiresIn"] = this.refreshTokenExpiresIn;
        if (Array.isArray(this.activeSessionIds)) {
            data["activeSessionIds"] = [];
            for (let item of this.activeSessionIds)
                data["activeSessionIds"].push(item);
        }
        return data;
    }
}

export interface IAccessTokenCodeResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    sessionId?: string;
    accessTokenExpiresIn?: number;
    refreshTokenExpiresIn?: number;
    activeSessionIds?: string[] | undefined;
}

export class AccessTokenCredentialRequest implements IAccessTokenCredentialRequest {
    clientId?: string | undefined;
    clientSecret?: string | undefined;

    constructor(data?: IAccessTokenCredentialRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
        }
    }

    static fromJS(data: any): AccessTokenCredentialRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccessTokenCredentialRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        return data;
    }
}

export interface IAccessTokenCredentialRequest {
    clientId?: string | undefined;
    clientSecret?: string | undefined;
}

export class AccessTokenCredentialResponse implements IAccessTokenCredentialResponse {
    accessToken?: string | undefined;
    accessTokenExpiresIn?: number;

    constructor(data?: IAccessTokenCredentialResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.accessTokenExpiresIn = _data["accessTokenExpiresIn"];
        }
    }

    static fromJS(data: any): AccessTokenCredentialResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccessTokenCredentialResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["accessTokenExpiresIn"] = this.accessTokenExpiresIn;
        return data;
    }
}

export interface IAccessTokenCredentialResponse {
    accessToken?: string | undefined;
    accessTokenExpiresIn?: number;
}

export class ActiveRuleRequest implements IActiveRuleRequest {
    investmentJurisdictionId?: number;
    residencyJurisdictionId?: number | undefined;
    securityTypeId?: number;
    entityTypeId?: number | undefined;
    generalRateEntityTypeId?: number | undefined;
    clientID?: number;
    generalRate?: boolean;

    constructor(data?: IActiveRuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
            this.residencyJurisdictionId = _data["residencyJurisdictionId"];
            this.securityTypeId = _data["securityTypeId"];
            this.entityTypeId = _data["entityTypeId"];
            this.generalRateEntityTypeId = _data["generalRateEntityTypeId"];
            this.clientID = _data["clientID"];
            this.generalRate = _data["generalRate"];
        }
    }

    static fromJS(data: any): ActiveRuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveRuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        data["residencyJurisdictionId"] = this.residencyJurisdictionId;
        data["securityTypeId"] = this.securityTypeId;
        data["entityTypeId"] = this.entityTypeId;
        data["generalRateEntityTypeId"] = this.generalRateEntityTypeId;
        data["clientID"] = this.clientID;
        data["generalRate"] = this.generalRate;
        return data;
    }
}

export interface IActiveRuleRequest {
    investmentJurisdictionId?: number;
    residencyJurisdictionId?: number | undefined;
    securityTypeId?: number;
    entityTypeId?: number | undefined;
    generalRateEntityTypeId?: number | undefined;
    clientID?: number;
    generalRate?: boolean;
}

export class ActiveRuleResponse implements IActiveRuleResponse {
    taxPolicyId?: number;
    taxPolicyName?: string | undefined;
    taxRuleId?: number;
    taxResultItemTypeId?: number;
    taxResultItemTypeName?: string | undefined;

    constructor(data?: IActiveRuleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxPolicyId = _data["taxPolicyId"];
            this.taxPolicyName = _data["taxPolicyName"];
            this.taxRuleId = _data["taxRuleId"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.taxResultItemTypeName = _data["taxResultItemTypeName"];
        }
    }

    static fromJS(data: any): ActiveRuleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveRuleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxPolicyId"] = this.taxPolicyId;
        data["taxPolicyName"] = this.taxPolicyName;
        data["taxRuleId"] = this.taxRuleId;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["taxResultItemTypeName"] = this.taxResultItemTypeName;
        return data;
    }
}

export interface IActiveRuleResponse {
    taxPolicyId?: number;
    taxPolicyName?: string | undefined;
    taxRuleId?: number;
    taxResultItemTypeId?: number;
    taxResultItemTypeName?: string | undefined;
}

export class AddUserSettingRequest implements IAddUserSettingRequest {
    key!: string;
    value?: string | undefined;

    constructor(data?: IAddUserSettingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AddUserSettingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserSettingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IAddUserSettingRequest {
    key: string;
    value?: string | undefined;
}

export class ApplicationNotificationResponseAuditable implements IApplicationNotificationResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    applicationNotificationId?: number;
    title?: string | undefined;
    description?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    isActive?: boolean;

    constructor(data?: IApplicationNotificationResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.applicationNotificationId = _data["applicationNotificationId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ApplicationNotificationResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationNotificationResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["applicationNotificationId"] = this.applicationNotificationId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IApplicationNotificationResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    applicationNotificationId?: number;
    title?: string | undefined;
    description?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    isActive?: boolean;
}

/** OData response message structure */
export class ApplicationNotificationResponseAuditableODataWithMetadataResponse implements IApplicationNotificationResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: ApplicationNotificationResponseAuditable[] | undefined;

    constructor(data?: IApplicationNotificationResponseAuditableODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(ApplicationNotificationResponseAuditable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApplicationNotificationResponseAuditableODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationNotificationResponseAuditableODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IApplicationNotificationResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: ApplicationNotificationResponseAuditable[] | undefined;
}

export class ApplicationUser implements IApplicationUser {
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    organization?: string | undefined;
    territory?: string | undefined;
    gumId?: string | undefined;
    isActive?: boolean;
    isExternal?: boolean;
    termsAndPrivacyAccepted?: boolean;
    lastLogin?: Date | undefined;
    created?: Date | undefined;
    modified?: Date | undefined;
    claims?: StringIdentityUserClaim[] | undefined;

    constructor(data?: IApplicationUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : undefined as any;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.organization = _data["organization"];
            this.territory = _data["territory"];
            this.gumId = _data["gumId"];
            this.isActive = _data["isActive"];
            this.isExternal = _data["isExternal"];
            this.termsAndPrivacyAccepted = _data["termsAndPrivacyAccepted"];
            this.lastLogin = _data["lastLogin"] ? new Date(_data["lastLogin"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(StringIdentityUserClaim.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApplicationUser {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : undefined as any;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["organization"] = this.organization;
        data["territory"] = this.territory;
        data["gumId"] = this.gumId;
        data["isActive"] = this.isActive;
        data["isExternal"] = this.isExternal;
        data["termsAndPrivacyAccepted"] = this.termsAndPrivacyAccepted;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IApplicationUser {
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    organization?: string | undefined;
    territory?: string | undefined;
    gumId?: string | undefined;
    isActive?: boolean;
    isExternal?: boolean;
    termsAndPrivacyAccepted?: boolean;
    lastLogin?: Date | undefined;
    created?: Date | undefined;
    modified?: Date | undefined;
    claims?: StringIdentityUserClaim[] | undefined;
}

/** OData response message structure */
export class ApplicationUserODataWithMetadataResponse implements IApplicationUserODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: ApplicationUser[] | undefined;

    constructor(data?: IApplicationUserODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(ApplicationUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApplicationUserODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUserODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IApplicationUserODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: ApplicationUser[] | undefined;
}

export class ApproveSecurityRequest implements IApproveSecurityRequest {
    securityId?: number;

    constructor(data?: IApproveSecurityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityId = _data["securityId"];
        }
    }

    static fromJS(data: any): ApproveSecurityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveSecurityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityId"] = this.securityId;
        return data;
    }
}

export interface IApproveSecurityRequest {
    securityId?: number;
}

export class AspNetUser implements IAspNetUser {
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    termsAndPrivacyAccepted?: boolean;
    isActive!: boolean;
    isExternal?: boolean;
    firstName!: string;
    lastName!: string;
    organization?: string | undefined;
    territory?: string | undefined;
    gumid?: string | undefined;
    lastLogin?: Date | undefined;
    created?: Date;
    modified?: Date;
    aspNetUserRefreshTokens?: AspNetUserRefreshToken[] | undefined;
    aspNetUserRevokedAccessTokens?: AspNetUserRevokedAccessToken[] | undefined;
    aspNetUserSettings?: AspNetUserSetting[] | undefined;
    clientAssignments?: ClientAssignment[] | undefined;
    countryTaxNews?: CountryTaxNews[] | undefined;
    generalCountryInformations?: GeneralCountryInformation[] | undefined;
    securities?: Security[] | undefined;
    securityNotifications?: SecurityNotification[] | undefined;
    userNotifications?: UserNotification[] | undefined;
    userSettings?: UserSetting[] | undefined;

    constructor(data?: IAspNetUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : undefined as any;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
            this.termsAndPrivacyAccepted = _data["termsAndPrivacyAccepted"];
            this.isActive = _data["isActive"];
            this.isExternal = _data["isExternal"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.organization = _data["organization"];
            this.territory = _data["territory"];
            this.gumid = _data["gumid"];
            this.lastLogin = _data["lastLogin"] ? new Date(_data["lastLogin"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            if (Array.isArray(_data["aspNetUserRefreshTokens"])) {
                this.aspNetUserRefreshTokens = [] as any;
                for (let item of _data["aspNetUserRefreshTokens"])
                    this.aspNetUserRefreshTokens!.push(AspNetUserRefreshToken.fromJS(item));
            }
            if (Array.isArray(_data["aspNetUserRevokedAccessTokens"])) {
                this.aspNetUserRevokedAccessTokens = [] as any;
                for (let item of _data["aspNetUserRevokedAccessTokens"])
                    this.aspNetUserRevokedAccessTokens!.push(AspNetUserRevokedAccessToken.fromJS(item));
            }
            if (Array.isArray(_data["aspNetUserSettings"])) {
                this.aspNetUserSettings = [] as any;
                for (let item of _data["aspNetUserSettings"])
                    this.aspNetUserSettings!.push(AspNetUserSetting.fromJS(item));
            }
            if (Array.isArray(_data["clientAssignments"])) {
                this.clientAssignments = [] as any;
                for (let item of _data["clientAssignments"])
                    this.clientAssignments!.push(ClientAssignment.fromJS(item));
            }
            if (Array.isArray(_data["countryTaxNews"])) {
                this.countryTaxNews = [] as any;
                for (let item of _data["countryTaxNews"])
                    this.countryTaxNews!.push(CountryTaxNews.fromJS(item));
            }
            if (Array.isArray(_data["generalCountryInformations"])) {
                this.generalCountryInformations = [] as any;
                for (let item of _data["generalCountryInformations"])
                    this.generalCountryInformations!.push(GeneralCountryInformation.fromJS(item));
            }
            if (Array.isArray(_data["securities"])) {
                this.securities = [] as any;
                for (let item of _data["securities"])
                    this.securities!.push(Security.fromJS(item));
            }
            if (Array.isArray(_data["securityNotifications"])) {
                this.securityNotifications = [] as any;
                for (let item of _data["securityNotifications"])
                    this.securityNotifications!.push(SecurityNotification.fromJS(item));
            }
            if (Array.isArray(_data["userNotifications"])) {
                this.userNotifications = [] as any;
                for (let item of _data["userNotifications"])
                    this.userNotifications!.push(UserNotification.fromJS(item));
            }
            if (Array.isArray(_data["userSettings"])) {
                this.userSettings = [] as any;
                for (let item of _data["userSettings"])
                    this.userSettings!.push(UserSetting.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AspNetUser {
        data = typeof data === 'object' ? data : {};
        let result = new AspNetUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : undefined as any;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        data["termsAndPrivacyAccepted"] = this.termsAndPrivacyAccepted;
        data["isActive"] = this.isActive;
        data["isExternal"] = this.isExternal;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["organization"] = this.organization;
        data["territory"] = this.territory;
        data["gumid"] = this.gumid;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        if (Array.isArray(this.aspNetUserRefreshTokens)) {
            data["aspNetUserRefreshTokens"] = [];
            for (let item of this.aspNetUserRefreshTokens)
                data["aspNetUserRefreshTokens"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aspNetUserRevokedAccessTokens)) {
            data["aspNetUserRevokedAccessTokens"] = [];
            for (let item of this.aspNetUserRevokedAccessTokens)
                data["aspNetUserRevokedAccessTokens"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aspNetUserSettings)) {
            data["aspNetUserSettings"] = [];
            for (let item of this.aspNetUserSettings)
                data["aspNetUserSettings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.clientAssignments)) {
            data["clientAssignments"] = [];
            for (let item of this.clientAssignments)
                data["clientAssignments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.countryTaxNews)) {
            data["countryTaxNews"] = [];
            for (let item of this.countryTaxNews)
                data["countryTaxNews"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generalCountryInformations)) {
            data["generalCountryInformations"] = [];
            for (let item of this.generalCountryInformations)
                data["generalCountryInformations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.securities)) {
            data["securities"] = [];
            for (let item of this.securities)
                data["securities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.securityNotifications)) {
            data["securityNotifications"] = [];
            for (let item of this.securityNotifications)
                data["securityNotifications"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userNotifications)) {
            data["userNotifications"] = [];
            for (let item of this.userNotifications)
                data["userNotifications"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userSettings)) {
            data["userSettings"] = [];
            for (let item of this.userSettings)
                data["userSettings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAspNetUser {
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    termsAndPrivacyAccepted?: boolean;
    isActive: boolean;
    isExternal?: boolean;
    firstName: string;
    lastName: string;
    organization?: string | undefined;
    territory?: string | undefined;
    gumid?: string | undefined;
    lastLogin?: Date | undefined;
    created?: Date;
    modified?: Date;
    aspNetUserRefreshTokens?: AspNetUserRefreshToken[] | undefined;
    aspNetUserRevokedAccessTokens?: AspNetUserRevokedAccessToken[] | undefined;
    aspNetUserSettings?: AspNetUserSetting[] | undefined;
    clientAssignments?: ClientAssignment[] | undefined;
    countryTaxNews?: CountryTaxNews[] | undefined;
    generalCountryInformations?: GeneralCountryInformation[] | undefined;
    securities?: Security[] | undefined;
    securityNotifications?: SecurityNotification[] | undefined;
    userNotifications?: UserNotification[] | undefined;
    userSettings?: UserSetting[] | undefined;
}

export class AspNetUserRefreshToken implements IAspNetUserRefreshToken {
    refreshTokenId?: number;
    userId!: string;
    refreshToken!: string;
    revoked?: boolean;
    expiration?: Date;
    accessTokenExpiration?: Date;
    sessionId?: string;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    user?: AspNetUser;

    constructor(data?: IAspNetUserRefreshToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshTokenId = _data["refreshTokenId"];
            this.userId = _data["userId"];
            this.refreshToken = _data["refreshToken"];
            this.revoked = _data["revoked"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : undefined as any;
            this.accessTokenExpiration = _data["accessTokenExpiration"] ? new Date(_data["accessTokenExpiration"].toString()) : undefined as any;
            this.sessionId = _data["sessionId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.user = _data["user"] ? AspNetUser.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): AspNetUserRefreshToken {
        data = typeof data === 'object' ? data : {};
        let result = new AspNetUserRefreshToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshTokenId"] = this.refreshTokenId;
        data["userId"] = this.userId;
        data["refreshToken"] = this.refreshToken;
        data["revoked"] = this.revoked;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : undefined as any;
        data["accessTokenExpiration"] = this.accessTokenExpiration ? this.accessTokenExpiration.toISOString() : undefined as any;
        data["sessionId"] = this.sessionId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IAspNetUserRefreshToken {
    refreshTokenId?: number;
    userId: string;
    refreshToken: string;
    revoked?: boolean;
    expiration?: Date;
    accessTokenExpiration?: Date;
    sessionId?: string;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    user?: AspNetUser;
}

export class AspNetUserRevokedAccessToken implements IAspNetUserRevokedAccessToken {
    revokedAccessTokenId?: number;
    userId!: string;
    accessToken!: string;
    expiration?: Date;
    sessionId?: string;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    user?: AspNetUser;

    constructor(data?: IAspNetUserRevokedAccessToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.revokedAccessTokenId = _data["revokedAccessTokenId"];
            this.userId = _data["userId"];
            this.accessToken = _data["accessToken"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : undefined as any;
            this.sessionId = _data["sessionId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.user = _data["user"] ? AspNetUser.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): AspNetUserRevokedAccessToken {
        data = typeof data === 'object' ? data : {};
        let result = new AspNetUserRevokedAccessToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["revokedAccessTokenId"] = this.revokedAccessTokenId;
        data["userId"] = this.userId;
        data["accessToken"] = this.accessToken;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : undefined as any;
        data["sessionId"] = this.sessionId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IAspNetUserRevokedAccessToken {
    revokedAccessTokenId?: number;
    userId: string;
    accessToken: string;
    expiration?: Date;
    sessionId?: string;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    user?: AspNetUser;
}

export class AspNetUserSetting implements IAspNetUserSetting {
    aspNetUserSettingId?: number;
    userId!: string;
    key!: string;
    value?: string | undefined;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    user?: AspNetUser;

    constructor(data?: IAspNetUserSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aspNetUserSettingId = _data["aspNetUserSettingId"];
            this.userId = _data["userId"];
            this.key = _data["key"];
            this.value = _data["value"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.user = _data["user"] ? AspNetUser.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): AspNetUserSetting {
        data = typeof data === 'object' ? data : {};
        let result = new AspNetUserSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aspNetUserSettingId"] = this.aspNetUserSettingId;
        data["userId"] = this.userId;
        data["key"] = this.key;
        data["value"] = this.value;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IAspNetUserSetting {
    aspNetUserSettingId?: number;
    userId: string;
    key: string;
    value?: string | undefined;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    user?: AspNetUser;
}

export class AuthenticationLinkResponse implements IAuthenticationLinkResponse {
    url?: string | undefined;

    constructor(data?: IAuthenticationLinkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): AuthenticationLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IAuthenticationLinkResponse {
    url?: string | undefined;
}

export class Client implements IClient {
    clientId?: number;
    name!: string;
    description?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    clientAssignments?: ClientAssignment[] | undefined;
    clientConfigurations?: ClientConfiguration[] | undefined;
    countryMaterials?: CountryMaterial[] | undefined;
    entities?: Entity[] | undefined;
    securityFileImports?: SecurityFileImport[] | undefined;

    constructor(data?: IClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["clientAssignments"])) {
                this.clientAssignments = [] as any;
                for (let item of _data["clientAssignments"])
                    this.clientAssignments!.push(ClientAssignment.fromJS(item));
            }
            if (Array.isArray(_data["clientConfigurations"])) {
                this.clientConfigurations = [] as any;
                for (let item of _data["clientConfigurations"])
                    this.clientConfigurations!.push(ClientConfiguration.fromJS(item));
            }
            if (Array.isArray(_data["countryMaterials"])) {
                this.countryMaterials = [] as any;
                for (let item of _data["countryMaterials"])
                    this.countryMaterials!.push(CountryMaterial.fromJS(item));
            }
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(Entity.fromJS(item));
            }
            if (Array.isArray(_data["securityFileImports"])) {
                this.securityFileImports = [] as any;
                for (let item of _data["securityFileImports"])
                    this.securityFileImports!.push(SecurityFileImport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Client {
        data = typeof data === 'object' ? data : {};
        let result = new Client();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.clientAssignments)) {
            data["clientAssignments"] = [];
            for (let item of this.clientAssignments)
                data["clientAssignments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.clientConfigurations)) {
            data["clientConfigurations"] = [];
            for (let item of this.clientConfigurations)
                data["clientConfigurations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.countryMaterials)) {
            data["countryMaterials"] = [];
            for (let item of this.countryMaterials)
                data["countryMaterials"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.securityFileImports)) {
            data["securityFileImports"] = [];
            for (let item of this.securityFileImports)
                data["securityFileImports"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IClient {
    clientId?: number;
    name: string;
    description?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    clientAssignments?: ClientAssignment[] | undefined;
    clientConfigurations?: ClientConfiguration[] | undefined;
    countryMaterials?: CountryMaterial[] | undefined;
    entities?: Entity[] | undefined;
    securityFileImports?: SecurityFileImport[] | undefined;
}

export class ClientAssignment implements IClientAssignment {
    clientAssignmentId?: number;
    clientId?: number;
    userId!: string;
    isActive!: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    client?: Client;
    user?: AspNetUser;

    constructor(data?: IClientAssignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientAssignmentId = _data["clientAssignmentId"];
            this.clientId = _data["clientId"];
            this.userId = _data["userId"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : undefined as any;
            this.user = _data["user"] ? AspNetUser.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): ClientAssignment {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAssignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientAssignmentId"] = this.clientAssignmentId;
        data["clientId"] = this.clientId;
        data["userId"] = this.userId;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IClientAssignment {
    clientAssignmentId?: number;
    clientId?: number;
    userId: string;
    isActive: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    client?: Client;
    user?: AspNetUser;
}

export class ClientAssignmentNestedObjectsResponse implements IClientAssignmentNestedObjectsResponse {
    clientAssignmentId?: number;
    clientId?: number;
    user?: NestedUserResponse;
    isActive?: boolean;

    constructor(data?: IClientAssignmentNestedObjectsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientAssignmentId = _data["clientAssignmentId"];
            this.clientId = _data["clientId"];
            this.user = _data["user"] ? NestedUserResponse.fromJS(_data["user"]) : undefined as any;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ClientAssignmentNestedObjectsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAssignmentNestedObjectsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientAssignmentId"] = this.clientAssignmentId;
        data["clientId"] = this.clientId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IClientAssignmentNestedObjectsResponse {
    clientAssignmentId?: number;
    clientId?: number;
    user?: NestedUserResponse;
    isActive?: boolean;
}

/** OData response message structure */
export class ClientAssignmentNestedObjectsResponseODataWithMetadataResponse implements IClientAssignmentNestedObjectsResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: ClientAssignmentNestedObjectsResponse[] | undefined;

    constructor(data?: IClientAssignmentNestedObjectsResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(ClientAssignmentNestedObjectsResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientAssignmentNestedObjectsResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAssignmentNestedObjectsResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IClientAssignmentNestedObjectsResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: ClientAssignmentNestedObjectsResponse[] | undefined;
}

export class ClientAssignmentResponse implements IClientAssignmentResponse {
    clientAssignmentId?: number;
    clientId?: number;
    userId?: string | undefined;
    isActive?: boolean;

    constructor(data?: IClientAssignmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientAssignmentId = _data["clientAssignmentId"];
            this.clientId = _data["clientId"];
            this.userId = _data["userId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ClientAssignmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAssignmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientAssignmentId"] = this.clientAssignmentId;
        data["clientId"] = this.clientId;
        data["userId"] = this.userId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IClientAssignmentResponse {
    clientAssignmentId?: number;
    clientId?: number;
    userId?: string | undefined;
    isActive?: boolean;
}

export class ClientConfiguration implements IClientConfiguration {
    clientConfigurationId?: number;
    clientId?: number;
    key!: string;
    value?: string | undefined;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    client?: Client;
    keyNavigation?: ClientConfigurationKey;

    constructor(data?: IClientConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientConfigurationId = _data["clientConfigurationId"];
            this.clientId = _data["clientId"];
            this.key = _data["key"];
            this.value = _data["value"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : undefined as any;
            this.keyNavigation = _data["keyNavigation"] ? ClientConfigurationKey.fromJS(_data["keyNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): ClientConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new ClientConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientConfigurationId"] = this.clientConfigurationId;
        data["clientId"] = this.clientId;
        data["key"] = this.key;
        data["value"] = this.value;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["keyNavigation"] = this.keyNavigation ? this.keyNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IClientConfiguration {
    clientConfigurationId?: number;
    clientId?: number;
    key: string;
    value?: string | undefined;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    client?: Client;
    keyNavigation?: ClientConfigurationKey;
}

export class ClientConfigurationKey implements IClientConfigurationKey {
    clientConfigurationKeyId?: number;
    key!: string;
    description?: string | undefined;
    title?: string | undefined;
    availableValues?: string | undefined;
    configurationKeyTypeId?: number;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    clientConfigurations?: ClientConfiguration[] | undefined;
    configurationKeyType?: ConfigurationKeyType;

    constructor(data?: IClientConfigurationKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientConfigurationKeyId = _data["clientConfigurationKeyId"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.title = _data["title"];
            this.availableValues = _data["availableValues"];
            this.configurationKeyTypeId = _data["configurationKeyTypeId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["clientConfigurations"])) {
                this.clientConfigurations = [] as any;
                for (let item of _data["clientConfigurations"])
                    this.clientConfigurations!.push(ClientConfiguration.fromJS(item));
            }
            this.configurationKeyType = _data["configurationKeyType"] ? ConfigurationKeyType.fromJS(_data["configurationKeyType"]) : undefined as any;
        }
    }

    static fromJS(data: any): ClientConfigurationKey {
        data = typeof data === 'object' ? data : {};
        let result = new ClientConfigurationKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientConfigurationKeyId"] = this.clientConfigurationKeyId;
        data["key"] = this.key;
        data["description"] = this.description;
        data["title"] = this.title;
        data["availableValues"] = this.availableValues;
        data["configurationKeyTypeId"] = this.configurationKeyTypeId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.clientConfigurations)) {
            data["clientConfigurations"] = [];
            for (let item of this.clientConfigurations)
                data["clientConfigurations"].push(item ? item.toJSON() : undefined as any);
        }
        data["configurationKeyType"] = this.configurationKeyType ? this.configurationKeyType.toJSON() : undefined as any;
        return data;
    }
}

export interface IClientConfigurationKey {
    clientConfigurationKeyId?: number;
    key: string;
    description?: string | undefined;
    title?: string | undefined;
    availableValues?: string | undefined;
    configurationKeyTypeId?: number;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    clientConfigurations?: ClientConfiguration[] | undefined;
    configurationKeyType?: ConfigurationKeyType;
}

export class ClientConfigurationKeyResponse implements IClientConfigurationKeyResponse {
    clientConfigurationKeyId?: number;
    key?: string | undefined;
    description?: string | undefined;
    title?: string | undefined;

    constructor(data?: IClientConfigurationKeyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientConfigurationKeyId = _data["clientConfigurationKeyId"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): ClientConfigurationKeyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClientConfigurationKeyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientConfigurationKeyId"] = this.clientConfigurationKeyId;
        data["key"] = this.key;
        data["description"] = this.description;
        data["title"] = this.title;
        return data;
    }
}

export interface IClientConfigurationKeyResponse {
    clientConfigurationKeyId?: number;
    key?: string | undefined;
    description?: string | undefined;
    title?: string | undefined;
}

/** OData response message structure */
export class ClientConfigurationKeyResponseODataWithMetadataResponse implements IClientConfigurationKeyResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: ClientConfigurationKeyResponse[] | undefined;

    constructor(data?: IClientConfigurationKeyResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(ClientConfigurationKeyResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientConfigurationKeyResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClientConfigurationKeyResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IClientConfigurationKeyResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: ClientConfigurationKeyResponse[] | undefined;
}

export class ClientConfigurationResponse implements IClientConfigurationResponse {
    clientConfigurationId?: number;
    clientId?: number;
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IClientConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientConfigurationId = _data["clientConfigurationId"];
            this.clientId = _data["clientId"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ClientConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClientConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientConfigurationId"] = this.clientConfigurationId;
        data["clientId"] = this.clientId;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IClientConfigurationResponse {
    clientConfigurationId?: number;
    clientId?: number;
    key?: string | undefined;
    value?: string | undefined;
}

/** OData response message structure */
export class ClientConfigurationResponseODataWithMetadataResponse implements IClientConfigurationResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: ClientConfigurationResponse[] | undefined;

    constructor(data?: IClientConfigurationResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(ClientConfigurationResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientConfigurationResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClientConfigurationResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IClientConfigurationResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: ClientConfigurationResponse[] | undefined;
}

export class ClientNestedObjectResponse implements IClientNestedObjectResponse {
    clientId?: number;
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: IClientNestedObjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ClientNestedObjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClientNestedObjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IClientNestedObjectResponse {
    clientId?: number;
    name?: string | undefined;
    isActive?: boolean;
}

export class ClientResponseAuditable implements IClientResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    clientId?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;

    constructor(data?: IClientResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ClientResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new ClientResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IClientResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    clientId?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
}

/** OData response message structure */
export class ClientResponseAuditableODataWithMetadataResponse implements IClientResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: ClientResponseAuditable[] | undefined;

    constructor(data?: IClientResponseAuditableODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(ClientResponseAuditable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientResponseAuditableODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClientResponseAuditableODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IClientResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: ClientResponseAuditable[] | undefined;
}

export class ComponentMonitorResponse implements IComponentMonitorResponse {
    success?: boolean;
    component?: string | undefined;
    alias?: string | undefined;
    details?: string | undefined;
    readonly status?: string | undefined;

    constructor(data?: IComponentMonitorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.component = _data["component"];
            this.alias = _data["alias"];
            this.details = _data["details"];
            (this as any).status = _data["status"];
        }
    }

    static fromJS(data: any): ComponentMonitorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentMonitorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["component"] = this.component;
        data["alias"] = this.alias;
        data["details"] = this.details;
        data["status"] = this.status;
        return data;
    }
}

export interface IComponentMonitorResponse {
    success?: boolean;
    component?: string | undefined;
    alias?: string | undefined;
    details?: string | undefined;
    status?: string | undefined;
}

export class ConfigurationKeyType implements IConfigurationKeyType {
    configurationKeyTypeId?: number;
    name!: string;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    clientConfigurationKeys?: ClientConfigurationKey[] | undefined;

    constructor(data?: IConfigurationKeyType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationKeyTypeId = _data["configurationKeyTypeId"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["clientConfigurationKeys"])) {
                this.clientConfigurationKeys = [] as any;
                for (let item of _data["clientConfigurationKeys"])
                    this.clientConfigurationKeys!.push(ClientConfigurationKey.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConfigurationKeyType {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationKeyType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationKeyTypeId"] = this.configurationKeyTypeId;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.clientConfigurationKeys)) {
            data["clientConfigurationKeys"] = [];
            for (let item of this.clientConfigurationKeys)
                data["clientConfigurationKeys"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConfigurationKeyType {
    configurationKeyTypeId?: number;
    name: string;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    clientConfigurationKeys?: ClientConfigurationKey[] | undefined;
}

export class ContentSearchResponse implements IContentSearchResponse {
    total?: number;
    items?: ContentSearchResultItem[] | undefined;

    constructor(data?: IContentSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ContentSearchResultItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContentSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContentSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IContentSearchResponse {
    total?: number;
    items?: ContentSearchResultItem[] | undefined;
}

export class ContentSearchResultItem implements IContentSearchResultItem {
    generalCountryInformationId?: number;
    countryId?: number;
    countryName?: string | undefined;
    generalCountryInformationTypeId?: number;
    generalCountryInformationTypeName?: string | undefined;
    snippet?: string | undefined;
    modified?: Date;

    constructor(data?: IContentSearchResultItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generalCountryInformationId = _data["generalCountryInformationId"];
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
            this.generalCountryInformationTypeId = _data["generalCountryInformationTypeId"];
            this.generalCountryInformationTypeName = _data["generalCountryInformationTypeName"];
            this.snippet = _data["snippet"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ContentSearchResultItem {
        data = typeof data === 'object' ? data : {};
        let result = new ContentSearchResultItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalCountryInformationId"] = this.generalCountryInformationId;
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        data["generalCountryInformationTypeId"] = this.generalCountryInformationTypeId;
        data["generalCountryInformationTypeName"] = this.generalCountryInformationTypeName;
        data["snippet"] = this.snippet;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        return data;
    }
}

export interface IContentSearchResultItem {
    generalCountryInformationId?: number;
    countryId?: number;
    countryName?: string | undefined;
    generalCountryInformationTypeId?: number;
    generalCountryInformationTypeName?: string | undefined;
    snippet?: string | undefined;
    modified?: Date;
}

export class Country implements ICountry {
    countryId?: number;
    regionId?: number;
    code!: string;
    name!: string;
    isActive!: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    countryMaterials?: CountryMaterial[] | undefined;
    countryTaxNewsCountries?: CountryTaxNews[] | undefined;
    countryTaxNewsCountry2s?: CountryTaxNews[] | undefined;
    countryTaxNewsLinks?: CountryTaxNewsLink[] | undefined;
    entityTypes?: EntityType[] | undefined;
    generalCountryInformations?: GeneralCountryInformation[] | undefined;
    investmentJurisdictions?: InvestmentJurisdiction[] | undefined;
    region?: Region;
    residencyJurisdictions?: ResidencyJurisdiction[] | undefined;
    taxSummaries?: TaxSummary[] | undefined;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.regionId = _data["regionId"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["countryMaterials"])) {
                this.countryMaterials = [] as any;
                for (let item of _data["countryMaterials"])
                    this.countryMaterials!.push(CountryMaterial.fromJS(item));
            }
            if (Array.isArray(_data["countryTaxNewsCountries"])) {
                this.countryTaxNewsCountries = [] as any;
                for (let item of _data["countryTaxNewsCountries"])
                    this.countryTaxNewsCountries!.push(CountryTaxNews.fromJS(item));
            }
            if (Array.isArray(_data["countryTaxNewsCountry2s"])) {
                this.countryTaxNewsCountry2s = [] as any;
                for (let item of _data["countryTaxNewsCountry2s"])
                    this.countryTaxNewsCountry2s!.push(CountryTaxNews.fromJS(item));
            }
            if (Array.isArray(_data["countryTaxNewsLinks"])) {
                this.countryTaxNewsLinks = [] as any;
                for (let item of _data["countryTaxNewsLinks"])
                    this.countryTaxNewsLinks!.push(CountryTaxNewsLink.fromJS(item));
            }
            if (Array.isArray(_data["entityTypes"])) {
                this.entityTypes = [] as any;
                for (let item of _data["entityTypes"])
                    this.entityTypes!.push(EntityType.fromJS(item));
            }
            if (Array.isArray(_data["generalCountryInformations"])) {
                this.generalCountryInformations = [] as any;
                for (let item of _data["generalCountryInformations"])
                    this.generalCountryInformations!.push(GeneralCountryInformation.fromJS(item));
            }
            if (Array.isArray(_data["investmentJurisdictions"])) {
                this.investmentJurisdictions = [] as any;
                for (let item of _data["investmentJurisdictions"])
                    this.investmentJurisdictions!.push(InvestmentJurisdiction.fromJS(item));
            }
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined as any;
            if (Array.isArray(_data["residencyJurisdictions"])) {
                this.residencyJurisdictions = [] as any;
                for (let item of _data["residencyJurisdictions"])
                    this.residencyJurisdictions!.push(ResidencyJurisdiction.fromJS(item));
            }
            if (Array.isArray(_data["taxSummaries"])) {
                this.taxSummaries = [] as any;
                for (let item of _data["taxSummaries"])
                    this.taxSummaries!.push(TaxSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["regionId"] = this.regionId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.countryMaterials)) {
            data["countryMaterials"] = [];
            for (let item of this.countryMaterials)
                data["countryMaterials"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.countryTaxNewsCountries)) {
            data["countryTaxNewsCountries"] = [];
            for (let item of this.countryTaxNewsCountries)
                data["countryTaxNewsCountries"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.countryTaxNewsCountry2s)) {
            data["countryTaxNewsCountry2s"] = [];
            for (let item of this.countryTaxNewsCountry2s)
                data["countryTaxNewsCountry2s"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.countryTaxNewsLinks)) {
            data["countryTaxNewsLinks"] = [];
            for (let item of this.countryTaxNewsLinks)
                data["countryTaxNewsLinks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.entityTypes)) {
            data["entityTypes"] = [];
            for (let item of this.entityTypes)
                data["entityTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generalCountryInformations)) {
            data["generalCountryInformations"] = [];
            for (let item of this.generalCountryInformations)
                data["generalCountryInformations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.investmentJurisdictions)) {
            data["investmentJurisdictions"] = [];
            for (let item of this.investmentJurisdictions)
                data["investmentJurisdictions"].push(item ? item.toJSON() : undefined as any);
        }
        data["region"] = this.region ? this.region.toJSON() : undefined as any;
        if (Array.isArray(this.residencyJurisdictions)) {
            data["residencyJurisdictions"] = [];
            for (let item of this.residencyJurisdictions)
                data["residencyJurisdictions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.taxSummaries)) {
            data["taxSummaries"] = [];
            for (let item of this.taxSummaries)
                data["taxSummaries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICountry {
    countryId?: number;
    regionId?: number;
    code: string;
    name: string;
    isActive: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    countryMaterials?: CountryMaterial[] | undefined;
    countryTaxNewsCountries?: CountryTaxNews[] | undefined;
    countryTaxNewsCountry2s?: CountryTaxNews[] | undefined;
    countryTaxNewsLinks?: CountryTaxNewsLink[] | undefined;
    entityTypes?: EntityType[] | undefined;
    generalCountryInformations?: GeneralCountryInformation[] | undefined;
    investmentJurisdictions?: InvestmentJurisdiction[] | undefined;
    region?: Region;
    residencyJurisdictions?: ResidencyJurisdiction[] | undefined;
    taxSummaries?: TaxSummary[] | undefined;
}

export class CountryMaterial implements ICountryMaterial {
    countryMaterialId!: number;
    clientId!: number;
    countryId!: number;
    isActive!: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    client?: Client;
    country?: Country;

    constructor(data?: ICountryMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryMaterialId = _data["countryMaterialId"];
            this.clientId = _data["clientId"];
            this.countryId = _data["countryId"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : undefined as any;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : undefined as any;
        }
    }

    static fromJS(data: any): CountryMaterial {
        data = typeof data === 'object' ? data : {};
        let result = new CountryMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryMaterialId"] = this.countryMaterialId;
        data["clientId"] = this.clientId;
        data["countryId"] = this.countryId;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        return data;
    }
}

export interface ICountryMaterial {
    countryMaterialId: number;
    clientId: number;
    countryId: number;
    isActive: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    client?: Client;
    country?: Country;
}

export class CountryMaterialResponse implements ICountryMaterialResponse {
    countryMaterialId?: number;
    clientId?: number;
    countryId?: number;
    isActive?: boolean;

    constructor(data?: ICountryMaterialResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryMaterialId = _data["countryMaterialId"];
            this.clientId = _data["clientId"];
            this.countryId = _data["countryId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CountryMaterialResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CountryMaterialResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryMaterialId"] = this.countryMaterialId;
        data["clientId"] = this.clientId;
        data["countryId"] = this.countryId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICountryMaterialResponse {
    countryMaterialId?: number;
    clientId?: number;
    countryId?: number;
    isActive?: boolean;
}

export class CountryMaterialWIthNestedObjectsResponse implements ICountryMaterialWIthNestedObjectsResponse {
    countryMaterialId?: number;
    client?: Client;
    country?: Country;
    isActive?: boolean;

    constructor(data?: ICountryMaterialWIthNestedObjectsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryMaterialId = _data["countryMaterialId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : undefined as any;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : undefined as any;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CountryMaterialWIthNestedObjectsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CountryMaterialWIthNestedObjectsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryMaterialId"] = this.countryMaterialId;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICountryMaterialWIthNestedObjectsResponse {
    countryMaterialId?: number;
    client?: Client;
    country?: Country;
    isActive?: boolean;
}

export class CountryNestedResponse implements ICountryNestedResponse {
    countryId?: number;
    regionId?: number;
    code?: string | undefined;
    name?: string | undefined;

    constructor(data?: ICountryNestedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.regionId = _data["regionId"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CountryNestedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CountryNestedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["regionId"] = this.regionId;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface ICountryNestedResponse {
    countryId?: number;
    regionId?: number;
    code?: string | undefined;
    name?: string | undefined;
}

export class CountryResponse implements ICountryResponse {
    countryId?: number;
    regionId?: number;
    code?: string | undefined;
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: ICountryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.regionId = _data["regionId"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CountryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CountryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["regionId"] = this.regionId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICountryResponse {
    countryId?: number;
    regionId?: number;
    code?: string | undefined;
    name?: string | undefined;
    isActive?: boolean;
}

export class CountryResponseWithNestedObjects implements ICountryResponseWithNestedObjects {
    countryId?: number;
    region?: RegionNestedResponse;
    name?: string | undefined;
    code?: string | undefined;
    isActive?: boolean;

    constructor(data?: ICountryResponseWithNestedObjects) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.region = _data["region"] ? RegionNestedResponse.fromJS(_data["region"]) : undefined as any;
            this.name = _data["name"];
            this.code = _data["code"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CountryResponseWithNestedObjects {
        data = typeof data === 'object' ? data : {};
        let result = new CountryResponseWithNestedObjects();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["region"] = this.region ? this.region.toJSON() : undefined as any;
        data["name"] = this.name;
        data["code"] = this.code;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICountryResponseWithNestedObjects {
    countryId?: number;
    region?: RegionNestedResponse;
    name?: string | undefined;
    code?: string | undefined;
    isActive?: boolean;
}

/** OData response message structure */
export class CountryResponseWithNestedObjectsODataWithMetadataResponse implements ICountryResponseWithNestedObjectsODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: CountryResponseWithNestedObjects[] | undefined;

    constructor(data?: ICountryResponseWithNestedObjectsODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(CountryResponseWithNestedObjects.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryResponseWithNestedObjectsODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CountryResponseWithNestedObjectsODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ICountryResponseWithNestedObjectsODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: CountryResponseWithNestedObjects[] | undefined;
}

export class CountryTaxNews implements ICountryTaxNews {
    countryTaxNewsId?: number;
    name!: string;
    description?: string | undefined;
    countryId?: number | undefined;
    country2Id?: number | undefined;
    newsDate?: Date | undefined;
    isActive?: boolean;
    isApproved?: boolean;
    approvedBy?: string | undefined;
    approvedOn?: Date | undefined;
    actualFrom?: Date;
    reviewDate?: Date | undefined;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    approvedByNavigation?: AspNetUser;
    country?: Country;
    country2?: Country;
    countryTaxNewsLinks?: CountryTaxNewsLink[] | undefined;

    constructor(data?: ICountryTaxNews) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryTaxNewsId = _data["countryTaxNewsId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.countryId = _data["countryId"];
            this.country2Id = _data["country2Id"];
            this.newsDate = _data["newsDate"] ? new Date(_data["newsDate"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.isApproved = _data["isApproved"];
            this.approvedBy = _data["approvedBy"];
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : undefined as any;
            this.actualFrom = _data["actualFrom"] ? new Date(_data["actualFrom"].toString()) : undefined as any;
            this.reviewDate = _data["reviewDate"] ? new Date(_data["reviewDate"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.approvedByNavigation = _data["approvedByNavigation"] ? AspNetUser.fromJS(_data["approvedByNavigation"]) : undefined as any;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : undefined as any;
            this.country2 = _data["country2"] ? Country.fromJS(_data["country2"]) : undefined as any;
            if (Array.isArray(_data["countryTaxNewsLinks"])) {
                this.countryTaxNewsLinks = [] as any;
                for (let item of _data["countryTaxNewsLinks"])
                    this.countryTaxNewsLinks!.push(CountryTaxNewsLink.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryTaxNews {
        data = typeof data === 'object' ? data : {};
        let result = new CountryTaxNews();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryTaxNewsId"] = this.countryTaxNewsId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["countryId"] = this.countryId;
        data["country2Id"] = this.country2Id;
        data["newsDate"] = this.newsDate ? this.newsDate.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["isApproved"] = this.isApproved;
        data["approvedBy"] = this.approvedBy;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : undefined as any;
        data["actualFrom"] = this.actualFrom ? this.actualFrom.toISOString() : undefined as any;
        data["reviewDate"] = this.reviewDate ? this.reviewDate.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["approvedByNavigation"] = this.approvedByNavigation ? this.approvedByNavigation.toJSON() : undefined as any;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        data["country2"] = this.country2 ? this.country2.toJSON() : undefined as any;
        if (Array.isArray(this.countryTaxNewsLinks)) {
            data["countryTaxNewsLinks"] = [];
            for (let item of this.countryTaxNewsLinks)
                data["countryTaxNewsLinks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICountryTaxNews {
    countryTaxNewsId?: number;
    name: string;
    description?: string | undefined;
    countryId?: number | undefined;
    country2Id?: number | undefined;
    newsDate?: Date | undefined;
    isActive?: boolean;
    isApproved?: boolean;
    approvedBy?: string | undefined;
    approvedOn?: Date | undefined;
    actualFrom?: Date;
    reviewDate?: Date | undefined;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    approvedByNavigation?: AspNetUser;
    country?: Country;
    country2?: Country;
    countryTaxNewsLinks?: CountryTaxNewsLink[] | undefined;
}

export class CountryTaxNewsLink implements ICountryTaxNewsLink {
    countryTaxNewsLinkId?: number;
    countryTaxNewsId?: number;
    countryId?: number;
    isActive?: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    country?: Country;
    countryTaxNews?: CountryTaxNews;

    constructor(data?: ICountryTaxNewsLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryTaxNewsLinkId = _data["countryTaxNewsLinkId"];
            this.countryTaxNewsId = _data["countryTaxNewsId"];
            this.countryId = _data["countryId"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : undefined as any;
            this.countryTaxNews = _data["countryTaxNews"] ? CountryTaxNews.fromJS(_data["countryTaxNews"]) : undefined as any;
        }
    }

    static fromJS(data: any): CountryTaxNewsLink {
        data = typeof data === 'object' ? data : {};
        let result = new CountryTaxNewsLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryTaxNewsLinkId"] = this.countryTaxNewsLinkId;
        data["countryTaxNewsId"] = this.countryTaxNewsId;
        data["countryId"] = this.countryId;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        data["countryTaxNews"] = this.countryTaxNews ? this.countryTaxNews.toJSON() : undefined as any;
        return data;
    }
}

export interface ICountryTaxNewsLink {
    countryTaxNewsLinkId?: number;
    countryTaxNewsId?: number;
    countryId?: number;
    isActive?: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    country?: Country;
    countryTaxNews?: CountryTaxNews;
}

export class CountryTaxNewsLinkResponse implements ICountryTaxNewsLinkResponse {
    countryTaxNewsLinkId?: number;
    country?: CountryResponse;

    constructor(data?: ICountryTaxNewsLinkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryTaxNewsLinkId = _data["countryTaxNewsLinkId"];
            this.country = _data["country"] ? CountryResponse.fromJS(_data["country"]) : undefined as any;
        }
    }

    static fromJS(data: any): CountryTaxNewsLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CountryTaxNewsLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryTaxNewsLinkId"] = this.countryTaxNewsLinkId;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        return data;
    }
}

export interface ICountryTaxNewsLinkResponse {
    countryTaxNewsLinkId?: number;
    country?: CountryResponse;
}

export class CountryTaxNewsResponse implements ICountryTaxNewsResponse {
    countryTaxNewsId?: number;
    name?: string | undefined;
    description?: string | undefined;
    newsDate?: Date;
    isActive?: boolean;
    isApproved?: boolean;
    approvedBy?: string | undefined;
    approvedOn?: Date;
    actualFrom?: Date;
    reviewDate?: Date;

    constructor(data?: ICountryTaxNewsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryTaxNewsId = _data["countryTaxNewsId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.newsDate = _data["newsDate"] ? new Date(_data["newsDate"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.isApproved = _data["isApproved"];
            this.approvedBy = _data["approvedBy"];
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : undefined as any;
            this.actualFrom = _data["actualFrom"] ? new Date(_data["actualFrom"].toString()) : undefined as any;
            this.reviewDate = _data["reviewDate"] ? new Date(_data["reviewDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CountryTaxNewsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CountryTaxNewsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryTaxNewsId"] = this.countryTaxNewsId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["newsDate"] = this.newsDate ? this.newsDate.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["isApproved"] = this.isApproved;
        data["approvedBy"] = this.approvedBy;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : undefined as any;
        data["actualFrom"] = this.actualFrom ? this.actualFrom.toISOString() : undefined as any;
        data["reviewDate"] = this.reviewDate ? this.reviewDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ICountryTaxNewsResponse {
    countryTaxNewsId?: number;
    name?: string | undefined;
    description?: string | undefined;
    newsDate?: Date;
    isActive?: boolean;
    isApproved?: boolean;
    approvedBy?: string | undefined;
    approvedOn?: Date;
    actualFrom?: Date;
    reviewDate?: Date;
}

export class CountryTaxNewsWithNestedObjectsResponse implements ICountryTaxNewsWithNestedObjectsResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    countryTaxNewsId?: number;
    name?: string | undefined;
    description?: string | undefined;
    newsDate?: Date;
    isActive?: boolean;
    countryTaxNewsLinks?: CountryTaxNewsLinkResponse[] | undefined;

    constructor(data?: ICountryTaxNewsWithNestedObjectsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.countryTaxNewsId = _data["countryTaxNewsId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.newsDate = _data["newsDate"] ? new Date(_data["newsDate"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["countryTaxNewsLinks"])) {
                this.countryTaxNewsLinks = [] as any;
                for (let item of _data["countryTaxNewsLinks"])
                    this.countryTaxNewsLinks!.push(CountryTaxNewsLinkResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryTaxNewsWithNestedObjectsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CountryTaxNewsWithNestedObjectsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["countryTaxNewsId"] = this.countryTaxNewsId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["newsDate"] = this.newsDate ? this.newsDate.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.countryTaxNewsLinks)) {
            data["countryTaxNewsLinks"] = [];
            for (let item of this.countryTaxNewsLinks)
                data["countryTaxNewsLinks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICountryTaxNewsWithNestedObjectsResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    countryTaxNewsId?: number;
    name?: string | undefined;
    description?: string | undefined;
    newsDate?: Date;
    isActive?: boolean;
    countryTaxNewsLinks?: CountryTaxNewsLinkResponse[] | undefined;
}

/** OData response message structure */
export class CountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse implements ICountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: CountryTaxNewsWithNestedObjectsResponse[] | undefined;

    constructor(data?: ICountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(CountryTaxNewsWithNestedObjectsResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ICountryTaxNewsWithNestedObjectsResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: CountryTaxNewsWithNestedObjectsResponse[] | undefined;
}

export class CreateApplicationNotificationRequest implements ICreateApplicationNotificationRequest {
    title!: string;
    description?: string | undefined;
    validFrom?: Date;
    validTo?: Date;

    constructor(data?: ICreateApplicationNotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateApplicationNotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApplicationNotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreateApplicationNotificationRequest {
    title: string;
    description?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
}

export class CreateClientAssignmentRequest implements ICreateClientAssignmentRequest {
    clientId!: number;
    userId!: string;
    isActive!: boolean;

    constructor(data?: ICreateClientAssignmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.userId = _data["userId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateClientAssignmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientAssignmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["userId"] = this.userId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateClientAssignmentRequest {
    clientId: number;
    userId: string;
    isActive: boolean;
}

export class CreateClientConfigurationRequest implements ICreateClientConfigurationRequest {
    clientId!: number;
    key!: string;
    value?: string | undefined;

    constructor(data?: ICreateClientConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CreateClientConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ICreateClientConfigurationRequest {
    clientId: number;
    key: string;
    value?: string | undefined;
}

export class CreateClientRequest implements ICreateClientRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;

    constructor(data?: ICreateClientRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateClientRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateClientRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
}

export class CreateCountryMaterialRequest implements ICreateCountryMaterialRequest {
    clientId?: number;
    countryId?: number;
    isActive?: boolean;

    constructor(data?: ICreateCountryMaterialRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.countryId = _data["countryId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateCountryMaterialRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCountryMaterialRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["countryId"] = this.countryId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateCountryMaterialRequest {
    clientId?: number;
    countryId?: number;
    isActive?: boolean;
}

export class CreateCountryRequest implements ICreateCountryRequest {
    regionId!: number;
    name!: string;
    isActive!: boolean;

    constructor(data?: ICreateCountryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regionId = _data["regionId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateCountryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCountryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateCountryRequest {
    regionId: number;
    name: string;
    isActive: boolean;
}

export class CreateCountryTaxNewsRequest implements ICreateCountryTaxNewsRequest {
    name!: string;
    description!: string;
    newsDate!: Date;
    countryIds!: number[];
    isActive?: boolean;

    constructor(data?: ICreateCountryTaxNewsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.countryIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.newsDate = _data["newsDate"] ? new Date(_data["newsDate"].toString()) : undefined as any;
            if (Array.isArray(_data["countryIds"])) {
                this.countryIds = [] as any;
                for (let item of _data["countryIds"])
                    this.countryIds!.push(item);
            }
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateCountryTaxNewsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCountryTaxNewsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["newsDate"] = this.newsDate ? this.newsDate.toISOString() : undefined as any;
        if (Array.isArray(this.countryIds)) {
            data["countryIds"] = [];
            for (let item of this.countryIds)
                data["countryIds"].push(item);
        }
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateCountryTaxNewsRequest {
    name: string;
    description: string;
    newsDate: Date;
    countryIds: number[];
    isActive?: boolean;
}

export class CreateEntityRequest implements ICreateEntityRequest {
    clientId?: number;
    residencyJurisdictionId?: number;
    entityTypeId?: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;

    constructor(data?: ICreateEntityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.residencyJurisdictionId = _data["residencyJurisdictionId"];
            this.entityTypeId = _data["entityTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateEntityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEntityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["residencyJurisdictionId"] = this.residencyJurisdictionId;
        data["entityTypeId"] = this.entityTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateEntityRequest {
    clientId?: number;
    residencyJurisdictionId?: number;
    entityTypeId?: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
}

export class CreateEntityTypeRequest implements ICreateEntityTypeRequest {
    countryId?: number | undefined;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    entityTypeInvestmentJurisdiction?: CreateEntityTypeTargetInvestmentJurisdictionRequest[] | undefined;

    constructor(data?: ICreateEntityTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["entityTypeInvestmentJurisdiction"])) {
                this.entityTypeInvestmentJurisdiction = [] as any;
                for (let item of _data["entityTypeInvestmentJurisdiction"])
                    this.entityTypeInvestmentJurisdiction!.push(CreateEntityTypeTargetInvestmentJurisdictionRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateEntityTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEntityTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.entityTypeInvestmentJurisdiction)) {
            data["entityTypeInvestmentJurisdiction"] = [];
            for (let item of this.entityTypeInvestmentJurisdiction)
                data["entityTypeInvestmentJurisdiction"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateEntityTypeRequest {
    countryId?: number | undefined;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    entityTypeInvestmentJurisdiction?: CreateEntityTypeTargetInvestmentJurisdictionRequest[] | undefined;
}

export class CreateEntityTypeTargetInvestmentJurisdictionRequest implements ICreateEntityTypeTargetInvestmentJurisdictionRequest {
    investmentJurisdictionId?: number;
    targetEntityTypeId?: number;

    constructor(data?: ICreateEntityTypeTargetInvestmentJurisdictionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
            this.targetEntityTypeId = _data["targetEntityTypeId"];
        }
    }

    static fromJS(data: any): CreateEntityTypeTargetInvestmentJurisdictionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEntityTypeTargetInvestmentJurisdictionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        data["targetEntityTypeId"] = this.targetEntityTypeId;
        return data;
    }
}

export interface ICreateEntityTypeTargetInvestmentJurisdictionRequest {
    investmentJurisdictionId?: number;
    targetEntityTypeId?: number;
}

export class CreateExternalSystemRequest implements ICreateExternalSystemRequest {
    name!: string;

    constructor(data?: ICreateExternalSystemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateExternalSystemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExternalSystemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateExternalSystemRequest {
    name: string;
}

export class CreateExternalUserRequest implements ICreateExternalUserRequest {
    email!: string;
    firstName!: string;
    lastName!: string;
    organization!: string;
    territory!: string;
    isActive!: boolean;

    constructor(data?: ICreateExternalUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.organization = _data["organization"];
            this.territory = _data["territory"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateExternalUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExternalUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["organization"] = this.organization;
        data["territory"] = this.territory;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateExternalUserRequest {
    email: string;
    firstName: string;
    lastName: string;
    organization: string;
    territory: string;
    isActive: boolean;
}

export class CreateFileExportRequest implements ICreateFileExportRequest {
    securityIds?: number[] | undefined;
    clientId?: number | undefined;
    transactionType?: TransactionTypeEnum;

    constructor(data?: ICreateFileExportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["securityIds"])) {
                this.securityIds = [] as any;
                for (let item of _data["securityIds"])
                    this.securityIds!.push(item);
            }
            this.clientId = _data["clientId"];
            this.transactionType = _data["transactionType"];
        }
    }

    static fromJS(data: any): CreateFileExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFileExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.securityIds)) {
            data["securityIds"] = [];
            for (let item of this.securityIds)
                data["securityIds"].push(item);
        }
        data["clientId"] = this.clientId;
        data["transactionType"] = this.transactionType;
        return data;
    }
}

export interface ICreateFileExportRequest {
    securityIds?: number[] | undefined;
    clientId?: number | undefined;
    transactionType?: TransactionTypeEnum;
}

export class CreateGeneralCountryInformationRequest implements ICreateGeneralCountryInformationRequest {
    countryId!: number;
    generalCountryInformationTypeId!: number;
    description!: string;
    isActive!: boolean;
    isApproved?: boolean;
    approvedBy?: string | undefined;
    approvedOn?: Date;
    actualFrom!: Date;
    reviewDate?: Date;

    constructor(data?: ICreateGeneralCountryInformationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.generalCountryInformationTypeId = _data["generalCountryInformationTypeId"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isApproved = _data["isApproved"];
            this.approvedBy = _data["approvedBy"];
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : undefined as any;
            this.actualFrom = _data["actualFrom"] ? new Date(_data["actualFrom"].toString()) : undefined as any;
            this.reviewDate = _data["reviewDate"] ? new Date(_data["reviewDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateGeneralCountryInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeneralCountryInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["generalCountryInformationTypeId"] = this.generalCountryInformationTypeId;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isApproved"] = this.isApproved;
        data["approvedBy"] = this.approvedBy;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : undefined as any;
        data["actualFrom"] = this.actualFrom ? this.actualFrom.toISOString() : undefined as any;
        data["reviewDate"] = this.reviewDate ? this.reviewDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreateGeneralCountryInformationRequest {
    countryId: number;
    generalCountryInformationTypeId: number;
    description: string;
    isActive: boolean;
    isApproved?: boolean;
    approvedBy?: string | undefined;
    approvedOn?: Date;
    actualFrom: Date;
    reviewDate?: Date;
}

export class CreateGeneralRateRulesEditorRateRequest implements ICreateGeneralRateRulesEditorRateRequest {
    rate?: number;

    constructor(data?: ICreateGeneralRateRulesEditorRateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): CreateGeneralRateRulesEditorRateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeneralRateRulesEditorRateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate;
        return data;
    }
}

export interface ICreateGeneralRateRulesEditorRateRequest {
    rate?: number;
}

export class CreateGeneralRateRulesEditorRequest implements ICreateGeneralRateRulesEditorRequest {
    entityTypeId?: number;
    investmentJurisdictionId?: number;
    securityTypeId?: number;
    taxResultItemTypeId?: number;
    description?: string | undefined;
    generalRateRulesEditorRates!: CreateGeneralRateRulesEditorRateRequest[];

    constructor(data?: ICreateGeneralRateRulesEditorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.generalRateRulesEditorRates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityTypeId = _data["entityTypeId"];
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
            this.securityTypeId = _data["securityTypeId"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.description = _data["description"];
            if (Array.isArray(_data["generalRateRulesEditorRates"])) {
                this.generalRateRulesEditorRates = [] as any;
                for (let item of _data["generalRateRulesEditorRates"])
                    this.generalRateRulesEditorRates!.push(CreateGeneralRateRulesEditorRateRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateGeneralRateRulesEditorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeneralRateRulesEditorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityTypeId"] = this.entityTypeId;
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        data["securityTypeId"] = this.securityTypeId;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["description"] = this.description;
        if (Array.isArray(this.generalRateRulesEditorRates)) {
            data["generalRateRulesEditorRates"] = [];
            for (let item of this.generalRateRulesEditorRates)
                data["generalRateRulesEditorRates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateGeneralRateRulesEditorRequest {
    entityTypeId?: number;
    investmentJurisdictionId?: number;
    securityTypeId?: number;
    taxResultItemTypeId?: number;
    description?: string | undefined;
    generalRateRulesEditorRates: CreateGeneralRateRulesEditorRateRequest[];
}

export class CreateInternalUserRequest implements ICreateInternalUserRequest {
    email!: string;
    firstName!: string;
    lastName!: string;
    isActive!: boolean;

    constructor(data?: ICreateInternalUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateInternalUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInternalUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateInternalUserRequest {
    email: string;
    firstName: string;
    lastName: string;
    isActive: boolean;
}

export class CreateInvestmentJurisdictionRequest implements ICreateInvestmentJurisdictionRequest {
    countryId!: number;
    isActive!: boolean;
    isDisplay!: boolean;

    constructor(data?: ICreateInvestmentJurisdictionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.isActive = _data["isActive"];
            this.isDisplay = _data["isDisplay"];
        }
    }

    static fromJS(data: any): CreateInvestmentJurisdictionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvestmentJurisdictionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["isActive"] = this.isActive;
        data["isDisplay"] = this.isDisplay;
        return data;
    }
}

export interface ICreateInvestmentJurisdictionRequest {
    countryId: number;
    isActive: boolean;
    isDisplay: boolean;
}

export class CreateQuestionRequest implements ICreateQuestionRequest {
    taxPolicyId?: number | undefined;
    questionTypeId?: number;
    questionValueTypeId?: number;
    name!: string;
    text?: string | undefined;
    countryList?: string | undefined;
    isActive!: boolean;

    constructor(data?: ICreateQuestionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxPolicyId = _data["taxPolicyId"];
            this.questionTypeId = _data["questionTypeId"];
            this.questionValueTypeId = _data["questionValueTypeId"];
            this.name = _data["name"];
            this.text = _data["text"];
            this.countryList = _data["countryList"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateQuestionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuestionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxPolicyId"] = this.taxPolicyId;
        data["questionTypeId"] = this.questionTypeId;
        data["questionValueTypeId"] = this.questionValueTypeId;
        data["name"] = this.name;
        data["text"] = this.text;
        data["countryList"] = this.countryList;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateQuestionRequest {
    taxPolicyId?: number | undefined;
    questionTypeId?: number;
    questionValueTypeId?: number;
    name: string;
    text?: string | undefined;
    countryList?: string | undefined;
    isActive: boolean;
}

export class CreateRegionRequest implements ICreateRegionRequest {
    name!: string;
    isActive!: boolean;

    constructor(data?: ICreateRegionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateRegionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateRegionRequest {
    name: string;
    isActive: boolean;
}

export class CreateResidencyJurisdictionRequest implements ICreateResidencyJurisdictionRequest {
    countryId!: number;
    isActive!: boolean;

    constructor(data?: ICreateResidencyJurisdictionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateResidencyJurisdictionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateResidencyJurisdictionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateResidencyJurisdictionRequest {
    countryId: number;
    isActive: boolean;
}

export class CreateSecurityNotificationRequest implements ICreateSecurityNotificationRequest {
    securityId!: number;
    userId!: string;
    securityNotificationTypeId?: number;
    isNotified!: boolean;
    description!: string;

    constructor(data?: ICreateSecurityNotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityId = _data["securityId"];
            this.userId = _data["userId"];
            this.securityNotificationTypeId = _data["securityNotificationTypeId"];
            this.isNotified = _data["isNotified"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateSecurityNotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSecurityNotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityId"] = this.securityId;
        data["userId"] = this.userId;
        data["securityNotificationTypeId"] = this.securityNotificationTypeId;
        data["isNotified"] = this.isNotified;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateSecurityNotificationRequest {
    securityId: number;
    userId: string;
    securityNotificationTypeId?: number;
    isNotified: boolean;
    description: string;
}

export class CreateSecurityQuestionAnswerRequest implements ICreateSecurityQuestionAnswerRequest {
    questionId?: number;
    answer?: string | undefined;
    comment?: string | undefined;
    unsureAnswer?: boolean;
    taxPolicyId?: number;
    taxRuleId?: number;
    isActive?: boolean;

    constructor(data?: ICreateSecurityQuestionAnswerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.answer = _data["answer"];
            this.comment = _data["comment"];
            this.unsureAnswer = _data["unsureAnswer"];
            this.taxPolicyId = _data["taxPolicyId"];
            this.taxRuleId = _data["taxRuleId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateSecurityQuestionAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSecurityQuestionAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["answer"] = this.answer;
        data["comment"] = this.comment;
        data["unsureAnswer"] = this.unsureAnswer;
        data["taxPolicyId"] = this.taxPolicyId;
        data["taxRuleId"] = this.taxRuleId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateSecurityQuestionAnswerRequest {
    questionId?: number;
    answer?: string | undefined;
    comment?: string | undefined;
    unsureAnswer?: boolean;
    taxPolicyId?: number;
    taxRuleId?: number;
    isActive?: boolean;
}

export class CreateSecurityRequest implements ICreateSecurityRequest {
    entityId?: number;
    clientId?: number | undefined;
    generalRateEntityTypeId?: number | undefined;
    investmentJurisdictionId?: number;
    transactionTypeId?: number;
    securityTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    ownership?: number | undefined;
    isinCusip?: string | undefined;
    acquisitionDate?: Date | undefined;
    dispositionDate?: Date | undefined;
    taxRates!: CreateSecurityTaxRateRequest[];
    questionAnswers!: CreateSecurityQuestionAnswerRequest[];

    constructor(data?: ICreateSecurityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.taxRates = [];
            this.questionAnswers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.clientId = _data["clientId"];
            this.generalRateEntityTypeId = _data["generalRateEntityTypeId"];
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
            this.transactionTypeId = _data["transactionTypeId"];
            this.securityTypeId = _data["securityTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.ownership = _data["ownership"];
            this.isinCusip = _data["isinCusip"];
            this.acquisitionDate = _data["acquisitionDate"] ? new Date(_data["acquisitionDate"].toString()) : undefined as any;
            this.dispositionDate = _data["dispositionDate"] ? new Date(_data["dispositionDate"].toString()) : undefined as any;
            if (Array.isArray(_data["taxRates"])) {
                this.taxRates = [] as any;
                for (let item of _data["taxRates"])
                    this.taxRates!.push(CreateSecurityTaxRateRequest.fromJS(item));
            }
            if (Array.isArray(_data["questionAnswers"])) {
                this.questionAnswers = [] as any;
                for (let item of _data["questionAnswers"])
                    this.questionAnswers!.push(CreateSecurityQuestionAnswerRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateSecurityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSecurityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["clientId"] = this.clientId;
        data["generalRateEntityTypeId"] = this.generalRateEntityTypeId;
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        data["transactionTypeId"] = this.transactionTypeId;
        data["securityTypeId"] = this.securityTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["ownership"] = this.ownership;
        data["isinCusip"] = this.isinCusip;
        data["acquisitionDate"] = this.acquisitionDate ? this.acquisitionDate.toISOString() : undefined as any;
        data["dispositionDate"] = this.dispositionDate ? this.dispositionDate.toISOString() : undefined as any;
        if (Array.isArray(this.taxRates)) {
            data["taxRates"] = [];
            for (let item of this.taxRates)
                data["taxRates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.questionAnswers)) {
            data["questionAnswers"] = [];
            for (let item of this.questionAnswers)
                data["questionAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateSecurityRequest {
    entityId?: number;
    clientId?: number | undefined;
    generalRateEntityTypeId?: number | undefined;
    investmentJurisdictionId?: number;
    transactionTypeId?: number;
    securityTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    ownership?: number | undefined;
    isinCusip?: string | undefined;
    acquisitionDate?: Date | undefined;
    dispositionDate?: Date | undefined;
    taxRates: CreateSecurityTaxRateRequest[];
    questionAnswers: CreateSecurityQuestionAnswerRequest[];
}

export class CreateSecurityTaxRateRequest implements ICreateSecurityTaxRateRequest {
    taxPolicyId?: number | undefined;
    taxRuleId?: number | undefined;
    taxResultItemId?: number | undefined;
    taxResultItemTypeId?: number;
    rate?: number | undefined;
    description?: string | undefined;
    isActive?: boolean;

    constructor(data?: ICreateSecurityTaxRateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxPolicyId = _data["taxPolicyId"];
            this.taxRuleId = _data["taxRuleId"];
            this.taxResultItemId = _data["taxResultItemId"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.rate = _data["rate"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateSecurityTaxRateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSecurityTaxRateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxPolicyId"] = this.taxPolicyId;
        data["taxRuleId"] = this.taxRuleId;
        data["taxResultItemId"] = this.taxResultItemId;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["rate"] = this.rate;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateSecurityTaxRateRequest {
    taxPolicyId?: number | undefined;
    taxRuleId?: number | undefined;
    taxResultItemId?: number | undefined;
    taxResultItemTypeId?: number;
    rate?: number | undefined;
    description?: string | undefined;
    isActive?: boolean;
}

export class CreateSecurityTypeRequest implements ICreateSecurityTypeRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    isVisible?: boolean;
    isDefault?: boolean;
    isParent?: boolean;
    parentSecurityTypeId?: number | undefined;

    constructor(data?: ICreateSecurityTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isVisible = _data["isVisible"];
            this.isDefault = _data["isDefault"];
            this.isParent = _data["isParent"];
            this.parentSecurityTypeId = _data["parentSecurityTypeId"];
        }
    }

    static fromJS(data: any): CreateSecurityTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSecurityTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isVisible"] = this.isVisible;
        data["isDefault"] = this.isDefault;
        data["isParent"] = this.isParent;
        data["parentSecurityTypeId"] = this.parentSecurityTypeId;
        return data;
    }
}

export interface ICreateSecurityTypeRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
    isVisible?: boolean;
    isDefault?: boolean;
    isParent?: boolean;
    parentSecurityTypeId?: number | undefined;
}

export class CreateTaxPolicyRequest implements ICreateTaxPolicyRequest {
    investmentJurisdictionId?: number;
    residencyJurisdictionId?: number | undefined;
    securityTypeId?: number;
    entityTypeId?: number | undefined;
    generalRateEntityTypeId?: number | undefined;
    generalRate?: boolean;
    taxRuleId?: number | undefined;
    taxPolicyStatusId?: number;
    taxResultItemTypeId?: number;
    name!: string;
    isActive!: boolean;

    constructor(data?: ICreateTaxPolicyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
            this.residencyJurisdictionId = _data["residencyJurisdictionId"];
            this.securityTypeId = _data["securityTypeId"];
            this.entityTypeId = _data["entityTypeId"];
            this.generalRateEntityTypeId = _data["generalRateEntityTypeId"];
            this.generalRate = _data["generalRate"];
            this.taxRuleId = _data["taxRuleId"];
            this.taxPolicyStatusId = _data["taxPolicyStatusId"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTaxPolicyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaxPolicyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        data["residencyJurisdictionId"] = this.residencyJurisdictionId;
        data["securityTypeId"] = this.securityTypeId;
        data["entityTypeId"] = this.entityTypeId;
        data["generalRateEntityTypeId"] = this.generalRateEntityTypeId;
        data["generalRate"] = this.generalRate;
        data["taxRuleId"] = this.taxRuleId;
        data["taxPolicyStatusId"] = this.taxPolicyStatusId;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateTaxPolicyRequest {
    investmentJurisdictionId?: number;
    residencyJurisdictionId?: number | undefined;
    securityTypeId?: number;
    entityTypeId?: number | undefined;
    generalRateEntityTypeId?: number | undefined;
    generalRate?: boolean;
    taxRuleId?: number | undefined;
    taxPolicyStatusId?: number;
    taxResultItemTypeId?: number;
    name: string;
    isActive: boolean;
}

export class CreateTaxRateSummaryRequest implements ICreateTaxRateSummaryRequest {
    taxSummaryId!: number;
    rate!: number;
    description!: string;

    constructor(data?: ICreateTaxRateSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxSummaryId = _data["taxSummaryId"];
            this.rate = _data["rate"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateTaxRateSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaxRateSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxSummaryId"] = this.taxSummaryId;
        data["rate"] = this.rate;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateTaxRateSummaryRequest {
    taxSummaryId: number;
    rate: number;
    description: string;
}

export class CreateTaxResultItemRequest implements ICreateTaxResultItemRequest {
    taxResultId?: number;
    taxResultItemTypeId?: number;
    rate?: number | undefined;
    description?: string | undefined;
    isActive?: boolean;

    constructor(data?: ICreateTaxResultItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxResultId = _data["taxResultId"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.rate = _data["rate"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTaxResultItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaxResultItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxResultId"] = this.taxResultId;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["rate"] = this.rate;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateTaxResultItemRequest {
    taxResultId?: number;
    taxResultItemTypeId?: number;
    rate?: number | undefined;
    description?: string | undefined;
    isActive?: boolean;
}

export class CreateTaxResultItemTypeRequest implements ICreateTaxResultItemTypeRequest {
    name!: string;

    constructor(data?: ICreateTaxResultItemTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateTaxResultItemTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaxResultItemTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateTaxResultItemTypeRequest {
    name: string;
}

export class CreateTaxResultRequest implements ICreateTaxResultRequest {
    taxPolicyId?: number | undefined;
    taxResultTypeId?: number;
    name!: string;
    isActive!: boolean;

    constructor(data?: ICreateTaxResultRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxPolicyId = _data["taxPolicyId"];
            this.taxResultTypeId = _data["taxResultTypeId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTaxResultRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaxResultRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxPolicyId"] = this.taxPolicyId;
        data["taxResultTypeId"] = this.taxResultTypeId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateTaxResultRequest {
    taxPolicyId?: number | undefined;
    taxResultTypeId?: number;
    name: string;
    isActive: boolean;
}

export class CreateTaxRuleRequest implements ICreateTaxRuleRequest {
    taxPolicyId?: number;
    name!: string;
    rule?: string | undefined;
    isActive!: boolean;
    obsolete?: boolean;

    constructor(data?: ICreateTaxRuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxPolicyId = _data["taxPolicyId"];
            this.name = _data["name"];
            this.rule = _data["rule"];
            this.isActive = _data["isActive"];
            this.obsolete = _data["obsolete"];
        }
    }

    static fromJS(data: any): CreateTaxRuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaxRuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxPolicyId"] = this.taxPolicyId;
        data["name"] = this.name;
        data["rule"] = this.rule;
        data["isActive"] = this.isActive;
        data["obsolete"] = this.obsolete;
        return data;
    }
}

export interface ICreateTaxRuleRequest {
    taxPolicyId?: number;
    name: string;
    rule?: string | undefined;
    isActive: boolean;
    obsolete?: boolean;
}

export class CreateTaxSummaryHeaderTypeRequest implements ICreateTaxSummaryHeaderTypeRequest {
    name!: string;

    constructor(data?: ICreateTaxSummaryHeaderTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateTaxSummaryHeaderTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaxSummaryHeaderTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateTaxSummaryHeaderTypeRequest {
    name: string;
}

export class CreateTaxSummaryRequest implements ICreateTaxSummaryRequest {
    countryId!: number;
    taxSummaryTypeId!: number;
    description!: string;
    isActive!: boolean;
    isApproved!: boolean;
    actualFrom!: Date;
    reviewDate?: Date | undefined;
    approvedOn?: Date | undefined;
    approvedBy!: string;

    constructor(data?: ICreateTaxSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.taxSummaryTypeId = _data["taxSummaryTypeId"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isApproved = _data["isApproved"];
            this.actualFrom = _data["actualFrom"] ? new Date(_data["actualFrom"].toString()) : undefined as any;
            this.reviewDate = _data["reviewDate"] ? new Date(_data["reviewDate"].toString()) : undefined as any;
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : undefined as any;
            this.approvedBy = _data["approvedBy"];
        }
    }

    static fromJS(data: any): CreateTaxSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaxSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["taxSummaryTypeId"] = this.taxSummaryTypeId;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isApproved"] = this.isApproved;
        data["actualFrom"] = this.actualFrom ? this.actualFrom.toISOString() : undefined as any;
        data["reviewDate"] = this.reviewDate ? this.reviewDate.toISOString() : undefined as any;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : undefined as any;
        data["approvedBy"] = this.approvedBy;
        return data;
    }
}

export interface ICreateTaxSummaryRequest {
    countryId: number;
    taxSummaryTypeId: number;
    description: string;
    isActive: boolean;
    isApproved: boolean;
    actualFrom: Date;
    reviewDate?: Date | undefined;
    approvedOn?: Date | undefined;
    approvedBy: string;
}

export class CreateTaxSummaryTypeRequest implements ICreateTaxSummaryTypeRequest {
    name!: string;
    taxSummaryHeaderTypeId?: number | undefined;

    constructor(data?: ICreateTaxSummaryTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.taxSummaryHeaderTypeId = _data["taxSummaryHeaderTypeId"];
        }
    }

    static fromJS(data: any): CreateTaxSummaryTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaxSummaryTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["taxSummaryHeaderTypeId"] = this.taxSummaryHeaderTypeId;
        return data;
    }
}

export interface ICreateTaxSummaryTypeRequest {
    name: string;
    taxSummaryHeaderTypeId?: number | undefined;
}

export class CreateTransactionTypeRequest implements ICreateTransactionTypeRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;

    constructor(data?: ICreateTransactionTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTransactionTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTransactionTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateTransactionTypeRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
}

export class CreateUserRoleRequest implements ICreateUserRoleRequest {
    userId!: string;
    roleId!: string;

    constructor(data?: ICreateUserRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): CreateUserRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface ICreateUserRoleRequest {
    userId: string;
    roleId: string;
}

export class DeleteUserResponse implements IDeleteUserResponse {
    success?: boolean;
    resultCode?: number;
    message?: string | undefined;

    constructor(data?: IDeleteUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.resultCode = _data["resultCode"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DeleteUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["resultCode"] = this.resultCode;
        data["message"] = this.message;
        return data;
    }
}

export interface IDeleteUserResponse {
    success?: boolean;
    resultCode?: number;
    message?: string | undefined;
}

export class DeleteUserRoleRequest implements IDeleteUserRoleRequest {
    roleId!: string;

    constructor(data?: IDeleteUserRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): DeleteUserRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUserRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IDeleteUserRoleRequest {
    roleId: string;
}

export class Entity implements IEntity {
    entityId?: number;
    clientId?: number;
    residencyJurisdictionId?: number;
    entityTypeId?: number;
    name!: string;
    description?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    client?: Client;
    entityType?: EntityType;
    portfolioFolders?: PortfolioFolder[] | undefined;
    residencyJurisdiction?: ResidencyJurisdiction;
    securities?: Security[] | undefined;

    constructor(data?: IEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.clientId = _data["clientId"];
            this.residencyJurisdictionId = _data["residencyJurisdictionId"];
            this.entityTypeId = _data["entityTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : undefined as any;
            this.entityType = _data["entityType"] ? EntityType.fromJS(_data["entityType"]) : undefined as any;
            if (Array.isArray(_data["portfolioFolders"])) {
                this.portfolioFolders = [] as any;
                for (let item of _data["portfolioFolders"])
                    this.portfolioFolders!.push(PortfolioFolder.fromJS(item));
            }
            this.residencyJurisdiction = _data["residencyJurisdiction"] ? ResidencyJurisdiction.fromJS(_data["residencyJurisdiction"]) : undefined as any;
            if (Array.isArray(_data["securities"])) {
                this.securities = [] as any;
                for (let item of _data["securities"])
                    this.securities!.push(Security.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Entity {
        data = typeof data === 'object' ? data : {};
        let result = new Entity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["clientId"] = this.clientId;
        data["residencyJurisdictionId"] = this.residencyJurisdictionId;
        data["entityTypeId"] = this.entityTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["entityType"] = this.entityType ? this.entityType.toJSON() : undefined as any;
        if (Array.isArray(this.portfolioFolders)) {
            data["portfolioFolders"] = [];
            for (let item of this.portfolioFolders)
                data["portfolioFolders"].push(item ? item.toJSON() : undefined as any);
        }
        data["residencyJurisdiction"] = this.residencyJurisdiction ? this.residencyJurisdiction.toJSON() : undefined as any;
        if (Array.isArray(this.securities)) {
            data["securities"] = [];
            for (let item of this.securities)
                data["securities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEntity {
    entityId?: number;
    clientId?: number;
    residencyJurisdictionId?: number;
    entityTypeId?: number;
    name: string;
    description?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    client?: Client;
    entityType?: EntityType;
    portfolioFolders?: PortfolioFolder[] | undefined;
    residencyJurisdiction?: ResidencyJurisdiction;
    securities?: Security[] | undefined;
}

export class EntityEvaluationRequest implements IEntityEvaluationRequest {
    entityId?: number;

    constructor(data?: IEntityEvaluationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
        }
    }

    static fromJS(data: any): EntityEvaluationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EntityEvaluationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        return data;
    }
}

export interface IEntityEvaluationRequest {
    entityId?: number;
}

export class EntityResponseAuditable implements IEntityResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    entityId?: number;
    client?: ClientNestedObjectResponse;
    residencyJurisdictionId?: number;
    entityTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;

    constructor(data?: IEntityResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.entityId = _data["entityId"];
            this.client = _data["client"] ? ClientNestedObjectResponse.fromJS(_data["client"]) : undefined as any;
            this.residencyJurisdictionId = _data["residencyJurisdictionId"];
            this.entityTypeId = _data["entityTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): EntityResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new EntityResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["entityId"] = this.entityId;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["residencyJurisdictionId"] = this.residencyJurisdictionId;
        data["entityTypeId"] = this.entityTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IEntityResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    entityId?: number;
    client?: ClientNestedObjectResponse;
    residencyJurisdictionId?: number;
    entityTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
}

/** OData response message structure */
export class EntityResponseAuditableODataWithMetadataResponse implements IEntityResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: EntityResponseAuditable[] | undefined;

    constructor(data?: IEntityResponseAuditableODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(EntityResponseAuditable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityResponseAuditableODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EntityResponseAuditableODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IEntityResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: EntityResponseAuditable[] | undefined;
}

export class EntityResponseWithNestedObjectsAuditable implements IEntityResponseWithNestedObjectsAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    entityId?: number;
    client?: ClientNestedObjectResponse;
    residencyJurisdiction?: NestedResidencyJurisdictionResponseAuditable;
    entityType?: EntityTypeNestedObjectResponse;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;

    constructor(data?: IEntityResponseWithNestedObjectsAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.entityId = _data["entityId"];
            this.client = _data["client"] ? ClientNestedObjectResponse.fromJS(_data["client"]) : undefined as any;
            this.residencyJurisdiction = _data["residencyJurisdiction"] ? NestedResidencyJurisdictionResponseAuditable.fromJS(_data["residencyJurisdiction"]) : undefined as any;
            this.entityType = _data["entityType"] ? EntityTypeNestedObjectResponse.fromJS(_data["entityType"]) : undefined as any;
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): EntityResponseWithNestedObjectsAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new EntityResponseWithNestedObjectsAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["entityId"] = this.entityId;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["residencyJurisdiction"] = this.residencyJurisdiction ? this.residencyJurisdiction.toJSON() : undefined as any;
        data["entityType"] = this.entityType ? this.entityType.toJSON() : undefined as any;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IEntityResponseWithNestedObjectsAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    entityId?: number;
    client?: ClientNestedObjectResponse;
    residencyJurisdiction?: NestedResidencyJurisdictionResponseAuditable;
    entityType?: EntityTypeNestedObjectResponse;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
}

/** OData response message structure */
export class EntityResponseWithNestedObjectsAuditableODataWithMetadataResponse implements IEntityResponseWithNestedObjectsAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: EntityResponseWithNestedObjectsAuditable[] | undefined;

    constructor(data?: IEntityResponseWithNestedObjectsAuditableODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(EntityResponseWithNestedObjectsAuditable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityResponseWithNestedObjectsAuditableODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EntityResponseWithNestedObjectsAuditableODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IEntityResponseWithNestedObjectsAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: EntityResponseWithNestedObjectsAuditable[] | undefined;
}

export class EntityType implements IEntityType {
    entityTypeId?: number;
    countryId?: number | undefined;
    name!: string;
    description?: string | undefined;
    isActive?: boolean;
    isDefault?: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    country?: Country;
    entities?: Entity[] | undefined;
    entityTypeInvestmentJurisdictionEntityTypes?: EntityTypeInvestmentJurisdiction[] | undefined;
    entityTypeInvestmentJurisdictionTargetEntityTypes?: EntityTypeInvestmentJurisdiction[] | undefined;
    generalRateRulesEditors?: GeneralRateRulesEditor[] | undefined;
    taxPolicies?: TaxPolicy[] | undefined;
    generalRateEntityTypeTaxPolicies?: TaxPolicy[] | undefined;
    generalRateEntityTypeSecurities?: Security[] | undefined;

    constructor(data?: IEntityType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityTypeId = _data["entityTypeId"];
            this.countryId = _data["countryId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isDefault = _data["isDefault"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : undefined as any;
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(Entity.fromJS(item));
            }
            if (Array.isArray(_data["entityTypeInvestmentJurisdictionEntityTypes"])) {
                this.entityTypeInvestmentJurisdictionEntityTypes = [] as any;
                for (let item of _data["entityTypeInvestmentJurisdictionEntityTypes"])
                    this.entityTypeInvestmentJurisdictionEntityTypes!.push(EntityTypeInvestmentJurisdiction.fromJS(item));
            }
            if (Array.isArray(_data["entityTypeInvestmentJurisdictionTargetEntityTypes"])) {
                this.entityTypeInvestmentJurisdictionTargetEntityTypes = [] as any;
                for (let item of _data["entityTypeInvestmentJurisdictionTargetEntityTypes"])
                    this.entityTypeInvestmentJurisdictionTargetEntityTypes!.push(EntityTypeInvestmentJurisdiction.fromJS(item));
            }
            if (Array.isArray(_data["generalRateRulesEditors"])) {
                this.generalRateRulesEditors = [] as any;
                for (let item of _data["generalRateRulesEditors"])
                    this.generalRateRulesEditors!.push(GeneralRateRulesEditor.fromJS(item));
            }
            if (Array.isArray(_data["taxPolicies"])) {
                this.taxPolicies = [] as any;
                for (let item of _data["taxPolicies"])
                    this.taxPolicies!.push(TaxPolicy.fromJS(item));
            }
            if (Array.isArray(_data["generalRateEntityTypeTaxPolicies"])) {
                this.generalRateEntityTypeTaxPolicies = [] as any;
                for (let item of _data["generalRateEntityTypeTaxPolicies"])
                    this.generalRateEntityTypeTaxPolicies!.push(TaxPolicy.fromJS(item));
            }
            if (Array.isArray(_data["generalRateEntityTypeSecurities"])) {
                this.generalRateEntityTypeSecurities = [] as any;
                for (let item of _data["generalRateEntityTypeSecurities"])
                    this.generalRateEntityTypeSecurities!.push(Security.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityType {
        data = typeof data === 'object' ? data : {};
        let result = new EntityType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityTypeId"] = this.entityTypeId;
        data["countryId"] = this.countryId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isDefault"] = this.isDefault;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.entityTypeInvestmentJurisdictionEntityTypes)) {
            data["entityTypeInvestmentJurisdictionEntityTypes"] = [];
            for (let item of this.entityTypeInvestmentJurisdictionEntityTypes)
                data["entityTypeInvestmentJurisdictionEntityTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.entityTypeInvestmentJurisdictionTargetEntityTypes)) {
            data["entityTypeInvestmentJurisdictionTargetEntityTypes"] = [];
            for (let item of this.entityTypeInvestmentJurisdictionTargetEntityTypes)
                data["entityTypeInvestmentJurisdictionTargetEntityTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generalRateRulesEditors)) {
            data["generalRateRulesEditors"] = [];
            for (let item of this.generalRateRulesEditors)
                data["generalRateRulesEditors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.taxPolicies)) {
            data["taxPolicies"] = [];
            for (let item of this.taxPolicies)
                data["taxPolicies"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generalRateEntityTypeTaxPolicies)) {
            data["generalRateEntityTypeTaxPolicies"] = [];
            for (let item of this.generalRateEntityTypeTaxPolicies)
                data["generalRateEntityTypeTaxPolicies"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generalRateEntityTypeSecurities)) {
            data["generalRateEntityTypeSecurities"] = [];
            for (let item of this.generalRateEntityTypeSecurities)
                data["generalRateEntityTypeSecurities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEntityType {
    entityTypeId?: number;
    countryId?: number | undefined;
    name: string;
    description?: string | undefined;
    isActive?: boolean;
    isDefault?: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    country?: Country;
    entities?: Entity[] | undefined;
    entityTypeInvestmentJurisdictionEntityTypes?: EntityTypeInvestmentJurisdiction[] | undefined;
    entityTypeInvestmentJurisdictionTargetEntityTypes?: EntityTypeInvestmentJurisdiction[] | undefined;
    generalRateRulesEditors?: GeneralRateRulesEditor[] | undefined;
    taxPolicies?: TaxPolicy[] | undefined;
    generalRateEntityTypeTaxPolicies?: TaxPolicy[] | undefined;
    generalRateEntityTypeSecurities?: Security[] | undefined;
}

export class EntityTypeInvestmentJurisdiction implements IEntityTypeInvestmentJurisdiction {
    entityTypeInvestmentJurisdictionId?: number;
    entityTypeId?: number;
    investmentJurisdictionId?: number;
    targetEntityTypeId?: number;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    entityType?: EntityType;
    investmentJurisdiction?: InvestmentJurisdiction;
    targetEntityType?: EntityType;

    constructor(data?: IEntityTypeInvestmentJurisdiction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityTypeInvestmentJurisdictionId = _data["entityTypeInvestmentJurisdictionId"];
            this.entityTypeId = _data["entityTypeId"];
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
            this.targetEntityTypeId = _data["targetEntityTypeId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.entityType = _data["entityType"] ? EntityType.fromJS(_data["entityType"]) : undefined as any;
            this.investmentJurisdiction = _data["investmentJurisdiction"] ? InvestmentJurisdiction.fromJS(_data["investmentJurisdiction"]) : undefined as any;
            this.targetEntityType = _data["targetEntityType"] ? EntityType.fromJS(_data["targetEntityType"]) : undefined as any;
        }
    }

    static fromJS(data: any): EntityTypeInvestmentJurisdiction {
        data = typeof data === 'object' ? data : {};
        let result = new EntityTypeInvestmentJurisdiction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityTypeInvestmentJurisdictionId"] = this.entityTypeInvestmentJurisdictionId;
        data["entityTypeId"] = this.entityTypeId;
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        data["targetEntityTypeId"] = this.targetEntityTypeId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["entityType"] = this.entityType ? this.entityType.toJSON() : undefined as any;
        data["investmentJurisdiction"] = this.investmentJurisdiction ? this.investmentJurisdiction.toJSON() : undefined as any;
        data["targetEntityType"] = this.targetEntityType ? this.targetEntityType.toJSON() : undefined as any;
        return data;
    }
}

export interface IEntityTypeInvestmentJurisdiction {
    entityTypeInvestmentJurisdictionId?: number;
    entityTypeId?: number;
    investmentJurisdictionId?: number;
    targetEntityTypeId?: number;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    entityType?: EntityType;
    investmentJurisdiction?: InvestmentJurisdiction;
    targetEntityType?: EntityType;
}

export class EntityTypeInvestmentJurisdictionWithNestedObjectResponse implements IEntityTypeInvestmentJurisdictionWithNestedObjectResponse {
    entityTypeInvestmentJurisdictionId?: number;
    investmentJurisdiction?: NestedInvestmentJurisdictionShortResponse;
    targetEntityType?: TargetEntityTypeResponse;

    constructor(data?: IEntityTypeInvestmentJurisdictionWithNestedObjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityTypeInvestmentJurisdictionId = _data["entityTypeInvestmentJurisdictionId"];
            this.investmentJurisdiction = _data["investmentJurisdiction"] ? NestedInvestmentJurisdictionShortResponse.fromJS(_data["investmentJurisdiction"]) : undefined as any;
            this.targetEntityType = _data["targetEntityType"] ? TargetEntityTypeResponse.fromJS(_data["targetEntityType"]) : undefined as any;
        }
    }

    static fromJS(data: any): EntityTypeInvestmentJurisdictionWithNestedObjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EntityTypeInvestmentJurisdictionWithNestedObjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityTypeInvestmentJurisdictionId"] = this.entityTypeInvestmentJurisdictionId;
        data["investmentJurisdiction"] = this.investmentJurisdiction ? this.investmentJurisdiction.toJSON() : undefined as any;
        data["targetEntityType"] = this.targetEntityType ? this.targetEntityType.toJSON() : undefined as any;
        return data;
    }
}

export interface IEntityTypeInvestmentJurisdictionWithNestedObjectResponse {
    entityTypeInvestmentJurisdictionId?: number;
    investmentJurisdiction?: NestedInvestmentJurisdictionShortResponse;
    targetEntityType?: TargetEntityTypeResponse;
}

export class EntityTypeNestedObjectResponse implements IEntityTypeNestedObjectResponse {
    entityTypeId?: number;
    country?: CountryNestedResponse;
    name?: string | undefined;

    constructor(data?: IEntityTypeNestedObjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityTypeId = _data["entityTypeId"];
            this.country = _data["country"] ? CountryNestedResponse.fromJS(_data["country"]) : undefined as any;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EntityTypeNestedObjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EntityTypeNestedObjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityTypeId"] = this.entityTypeId;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        data["name"] = this.name;
        return data;
    }
}

export interface IEntityTypeNestedObjectResponse {
    entityTypeId?: number;
    country?: CountryNestedResponse;
    name?: string | undefined;
}

export class EntityTypeResponseAuditable implements IEntityTypeResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    entityTypeId?: number;
    countryId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    entityTypeInvestmentJurisdictionEntityTypes?: EntityTypeInvestmentJurisdictionWithNestedObjectResponse[] | undefined;

    constructor(data?: IEntityTypeResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.entityTypeId = _data["entityTypeId"];
            this.countryId = _data["countryId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["entityTypeInvestmentJurisdictionEntityTypes"])) {
                this.entityTypeInvestmentJurisdictionEntityTypes = [] as any;
                for (let item of _data["entityTypeInvestmentJurisdictionEntityTypes"])
                    this.entityTypeInvestmentJurisdictionEntityTypes!.push(EntityTypeInvestmentJurisdictionWithNestedObjectResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityTypeResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new EntityTypeResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["entityTypeId"] = this.entityTypeId;
        data["countryId"] = this.countryId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.entityTypeInvestmentJurisdictionEntityTypes)) {
            data["entityTypeInvestmentJurisdictionEntityTypes"] = [];
            for (let item of this.entityTypeInvestmentJurisdictionEntityTypes)
                data["entityTypeInvestmentJurisdictionEntityTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEntityTypeResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    entityTypeId?: number;
    countryId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    entityTypeInvestmentJurisdictionEntityTypes?: EntityTypeInvestmentJurisdictionWithNestedObjectResponse[] | undefined;
}

export class EntityTypeResponseWithNestedObjects implements IEntityTypeResponseWithNestedObjects {
    entityTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    isDefault?: boolean;
    isActive?: boolean;
    created?: Date;
    country?: CountryNestedResponse;
    entityTypeInvestmentJurisdictionEntityTypes?: EntityTypeInvestmentJurisdictionWithNestedObjectResponse[] | undefined;

    constructor(data?: IEntityTypeResponseWithNestedObjects) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityTypeId = _data["entityTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isDefault = _data["isDefault"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.country = _data["country"] ? CountryNestedResponse.fromJS(_data["country"]) : undefined as any;
            if (Array.isArray(_data["entityTypeInvestmentJurisdictionEntityTypes"])) {
                this.entityTypeInvestmentJurisdictionEntityTypes = [] as any;
                for (let item of _data["entityTypeInvestmentJurisdictionEntityTypes"])
                    this.entityTypeInvestmentJurisdictionEntityTypes!.push(EntityTypeInvestmentJurisdictionWithNestedObjectResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityTypeResponseWithNestedObjects {
        data = typeof data === 'object' ? data : {};
        let result = new EntityTypeResponseWithNestedObjects();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityTypeId"] = this.entityTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isDefault"] = this.isDefault;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        if (Array.isArray(this.entityTypeInvestmentJurisdictionEntityTypes)) {
            data["entityTypeInvestmentJurisdictionEntityTypes"] = [];
            for (let item of this.entityTypeInvestmentJurisdictionEntityTypes)
                data["entityTypeInvestmentJurisdictionEntityTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEntityTypeResponseWithNestedObjects {
    entityTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    isDefault?: boolean;
    isActive?: boolean;
    created?: Date;
    country?: CountryNestedResponse;
    entityTypeInvestmentJurisdictionEntityTypes?: EntityTypeInvestmentJurisdictionWithNestedObjectResponse[] | undefined;
}

/** OData response message structure */
export class EntityTypeResponseWithNestedObjectsODataWithMetadataResponse implements IEntityTypeResponseWithNestedObjectsODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: EntityTypeResponseWithNestedObjects[] | undefined;

    constructor(data?: IEntityTypeResponseWithNestedObjectsODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(EntityTypeResponseWithNestedObjects.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityTypeResponseWithNestedObjectsODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EntityTypeResponseWithNestedObjectsODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IEntityTypeResponseWithNestedObjectsODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: EntityTypeResponseWithNestedObjects[] | undefined;
}

export class EvaluationRequest implements IEvaluationRequest {
    generalRateEntityTypeId?: number | undefined;
    clientId?: number | undefined;
    taxPolicyId?: number;
    taxRuleId?: number;
    entity!: EntityEvaluationRequest;
    security!: SecurityEvaluationRequest;
    processedAnswers!: QuestionAnswerEvaluationRequest[];
    lastAnswer?: LastQuestionAnswerEvaluationRequest;

    constructor(data?: IEvaluationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.entity = new EntityEvaluationRequest();
            this.security = new SecurityEvaluationRequest();
            this.processedAnswers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generalRateEntityTypeId = _data["generalRateEntityTypeId"];
            this.clientId = _data["clientId"];
            this.taxPolicyId = _data["taxPolicyId"];
            this.taxRuleId = _data["taxRuleId"];
            this.entity = _data["entity"] ? EntityEvaluationRequest.fromJS(_data["entity"]) : new EntityEvaluationRequest();
            this.security = _data["security"] ? SecurityEvaluationRequest.fromJS(_data["security"]) : new SecurityEvaluationRequest();
            if (Array.isArray(_data["processedAnswers"])) {
                this.processedAnswers = [] as any;
                for (let item of _data["processedAnswers"])
                    this.processedAnswers!.push(QuestionAnswerEvaluationRequest.fromJS(item));
            }
            this.lastAnswer = _data["lastAnswer"] ? LastQuestionAnswerEvaluationRequest.fromJS(_data["lastAnswer"]) : undefined as any;
        }
    }

    static fromJS(data: any): EvaluationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalRateEntityTypeId"] = this.generalRateEntityTypeId;
        data["clientId"] = this.clientId;
        data["taxPolicyId"] = this.taxPolicyId;
        data["taxRuleId"] = this.taxRuleId;
        data["entity"] = this.entity ? this.entity.toJSON() : undefined as any;
        data["security"] = this.security ? this.security.toJSON() : undefined as any;
        if (Array.isArray(this.processedAnswers)) {
            data["processedAnswers"] = [];
            for (let item of this.processedAnswers)
                data["processedAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        data["lastAnswer"] = this.lastAnswer ? this.lastAnswer.toJSON() : undefined as any;
        return data;
    }
}

export interface IEvaluationRequest {
    generalRateEntityTypeId?: number | undefined;
    clientId?: number | undefined;
    taxPolicyId?: number;
    taxRuleId?: number;
    entity: EntityEvaluationRequest;
    security: SecurityEvaluationRequest;
    processedAnswers: QuestionAnswerEvaluationRequest[];
    lastAnswer?: LastQuestionAnswerEvaluationRequest;
}

export class EvaluationResponse implements IEvaluationResponse {
    taxPolicyId?: number;
    callTaxRuleId?: number;
    question?: QuestionEvaluationResponse;
    taxResult?: TaxResultEvaluationResponse[] | undefined;
    errorMessage?: string | undefined;
    usedUnsureAnswer?: string | undefined;

    constructor(data?: IEvaluationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxPolicyId = _data["taxPolicyId"];
            this.callTaxRuleId = _data["callTaxRuleId"];
            this.question = _data["question"] ? QuestionEvaluationResponse.fromJS(_data["question"]) : undefined as any;
            if (Array.isArray(_data["taxResult"])) {
                this.taxResult = [] as any;
                for (let item of _data["taxResult"])
                    this.taxResult!.push(TaxResultEvaluationResponse.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
            this.usedUnsureAnswer = _data["usedUnsureAnswer"];
        }
    }

    static fromJS(data: any): EvaluationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxPolicyId"] = this.taxPolicyId;
        data["callTaxRuleId"] = this.callTaxRuleId;
        data["question"] = this.question ? this.question.toJSON() : undefined as any;
        if (Array.isArray(this.taxResult)) {
            data["taxResult"] = [];
            for (let item of this.taxResult)
                data["taxResult"].push(item ? item.toJSON() : undefined as any);
        }
        data["errorMessage"] = this.errorMessage;
        data["usedUnsureAnswer"] = this.usedUnsureAnswer;
        return data;
    }
}

export interface IEvaluationResponse {
    taxPolicyId?: number;
    callTaxRuleId?: number;
    question?: QuestionEvaluationResponse;
    taxResult?: TaxResultEvaluationResponse[] | undefined;
    errorMessage?: string | undefined;
    usedUnsureAnswer?: string | undefined;
}

export class ExportCountryInformation implements IExportCountryInformation {
    countryIds?: number[] | undefined;

    constructor(data?: IExportCountryInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countryIds"])) {
                this.countryIds = [] as any;
                for (let item of _data["countryIds"])
                    this.countryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ExportCountryInformation {
        data = typeof data === 'object' ? data : {};
        let result = new ExportCountryInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countryIds)) {
            data["countryIds"] = [];
            for (let item of this.countryIds)
                data["countryIds"].push(item);
        }
        return data;
    }
}

export interface IExportCountryInformation {
    countryIds?: number[] | undefined;
}

export class ExternalSystemResponse implements IExternalSystemResponse {
    externalSystemId?: number;
    name?: string | undefined;

    constructor(data?: IExternalSystemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalSystemId = _data["externalSystemId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ExternalSystemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalSystemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalSystemId"] = this.externalSystemId;
        data["name"] = this.name;
        return data;
    }
}

export interface IExternalSystemResponse {
    externalSystemId?: number;
    name?: string | undefined;
}

/** OData response message structure */
export class ExternalSystemResponseODataWithMetadataResponse implements IExternalSystemResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: ExternalSystemResponse[] | undefined;

    constructor(data?: IExternalSystemResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(ExternalSystemResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalSystemResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalSystemResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IExternalSystemResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: ExternalSystemResponse[] | undefined;
}

export class ExternalUserResponse implements IExternalUserResponse {
    id?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    organization?: string | undefined;
    territory?: string | undefined;
    isActive?: boolean;
    termsAndPrivacyAccepted?: boolean;
    lastLogin?: Date | undefined;
    created?: Date | undefined;
    modified?: Date | undefined;

    constructor(data?: IExternalUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.organization = _data["organization"];
            this.territory = _data["territory"];
            this.isActive = _data["isActive"];
            this.termsAndPrivacyAccepted = _data["termsAndPrivacyAccepted"];
            this.lastLogin = _data["lastLogin"] ? new Date(_data["lastLogin"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ExternalUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["organization"] = this.organization;
        data["territory"] = this.territory;
        data["isActive"] = this.isActive;
        data["termsAndPrivacyAccepted"] = this.termsAndPrivacyAccepted;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        return data;
    }
}

export interface IExternalUserResponse {
    id?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    organization?: string | undefined;
    territory?: string | undefined;
    isActive?: boolean;
    termsAndPrivacyAccepted?: boolean;
    lastLogin?: Date | undefined;
    created?: Date | undefined;
    modified?: Date | undefined;
}

/** OData response message structure */
export class ExternalUserResponseODataWithMetadataResponse implements IExternalUserResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: ExternalUserResponse[] | undefined;

    constructor(data?: IExternalUserResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(ExternalUserResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalUserResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalUserResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IExternalUserResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: ExternalUserResponse[] | undefined;
}

export class FileImport implements IFileImport {
    fileImportId?: number;
    fileImportStatusId?: number;
    fileImportTypeId?: number | undefined;
    dueDate?: Date | undefined;
    fileName!: string;
    history?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    fileImportStatus?: FileImportStatus;
    fileImportType?: FileImportType;

    constructor(data?: IFileImport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileImportId = _data["fileImportId"];
            this.fileImportStatusId = _data["fileImportStatusId"];
            this.fileImportTypeId = _data["fileImportTypeId"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.fileName = _data["fileName"];
            this.history = _data["history"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.fileImportStatus = _data["fileImportStatus"] ? FileImportStatus.fromJS(_data["fileImportStatus"]) : undefined as any;
            this.fileImportType = _data["fileImportType"] ? FileImportType.fromJS(_data["fileImportType"]) : undefined as any;
        }
    }

    static fromJS(data: any): FileImport {
        data = typeof data === 'object' ? data : {};
        let result = new FileImport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileImportId"] = this.fileImportId;
        data["fileImportStatusId"] = this.fileImportStatusId;
        data["fileImportTypeId"] = this.fileImportTypeId;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["fileName"] = this.fileName;
        data["history"] = this.history;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["fileImportStatus"] = this.fileImportStatus ? this.fileImportStatus.toJSON() : undefined as any;
        data["fileImportType"] = this.fileImportType ? this.fileImportType.toJSON() : undefined as any;
        return data;
    }
}

export interface IFileImport {
    fileImportId?: number;
    fileImportStatusId?: number;
    fileImportTypeId?: number | undefined;
    dueDate?: Date | undefined;
    fileName: string;
    history?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    fileImportStatus?: FileImportStatus;
    fileImportType?: FileImportType;
}

export class FileImportResponse implements IFileImportResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    fileImportId?: number;
    fileName?: string | undefined;
    history?: string | undefined;
    fileImportStatus?: FileImportStatusResponse;

    constructor(data?: IFileImportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.fileImportId = _data["fileImportId"];
            this.fileName = _data["fileName"];
            this.history = _data["history"];
            this.fileImportStatus = _data["fileImportStatus"] ? FileImportStatusResponse.fromJS(_data["fileImportStatus"]) : undefined as any;
        }
    }

    static fromJS(data: any): FileImportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileImportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["fileImportId"] = this.fileImportId;
        data["fileName"] = this.fileName;
        data["history"] = this.history;
        data["fileImportStatus"] = this.fileImportStatus ? this.fileImportStatus.toJSON() : undefined as any;
        return data;
    }
}

export interface IFileImportResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    fileImportId?: number;
    fileName?: string | undefined;
    history?: string | undefined;
    fileImportStatus?: FileImportStatusResponse;
}

/** OData response message structure */
export class FileImportResponseODataWithMetadataResponse implements IFileImportResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: FileImportResponse[] | undefined;

    constructor(data?: IFileImportResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(FileImportResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileImportResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileImportResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IFileImportResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: FileImportResponse[] | undefined;
}

export class FileImportStatus implements IFileImportStatus {
    fileImportStatusId?: number;
    name!: string;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    fileImports?: FileImport[] | undefined;
    securityFileImports?: SecurityFileImport[] | undefined;

    constructor(data?: IFileImportStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileImportStatusId = _data["fileImportStatusId"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["fileImports"])) {
                this.fileImports = [] as any;
                for (let item of _data["fileImports"])
                    this.fileImports!.push(FileImport.fromJS(item));
            }
            if (Array.isArray(_data["securityFileImports"])) {
                this.securityFileImports = [] as any;
                for (let item of _data["securityFileImports"])
                    this.securityFileImports!.push(SecurityFileImport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileImportStatus {
        data = typeof data === 'object' ? data : {};
        let result = new FileImportStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileImportStatusId"] = this.fileImportStatusId;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.fileImports)) {
            data["fileImports"] = [];
            for (let item of this.fileImports)
                data["fileImports"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.securityFileImports)) {
            data["securityFileImports"] = [];
            for (let item of this.securityFileImports)
                data["securityFileImports"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFileImportStatus {
    fileImportStatusId?: number;
    name: string;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    fileImports?: FileImport[] | undefined;
    securityFileImports?: SecurityFileImport[] | undefined;
}

export class FileImportStatusResponse implements IFileImportStatusResponse {
    fileImportStatusId?: number;
    name?: string | undefined;

    constructor(data?: IFileImportStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileImportStatusId = _data["fileImportStatusId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FileImportStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileImportStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileImportStatusId"] = this.fileImportStatusId;
        data["name"] = this.name;
        return data;
    }
}

export interface IFileImportStatusResponse {
    fileImportStatusId?: number;
    name?: string | undefined;
}

export class FileImportType implements IFileImportType {
    fileImportTypeId?: number;
    name!: string;
    isActive?: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    fileImports?: FileImport[] | undefined;

    constructor(data?: IFileImportType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileImportTypeId = _data["fileImportTypeId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["fileImports"])) {
                this.fileImports = [] as any;
                for (let item of _data["fileImports"])
                    this.fileImports!.push(FileImport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileImportType {
        data = typeof data === 'object' ? data : {};
        let result = new FileImportType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileImportTypeId"] = this.fileImportTypeId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.fileImports)) {
            data["fileImports"] = [];
            for (let item of this.fileImports)
                data["fileImports"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFileImportType {
    fileImportTypeId?: number;
    name: string;
    isActive?: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    fileImports?: FileImport[] | undefined;
}

export class GeneralCountryInformation implements IGeneralCountryInformation {
    generalCountryInformationId?: number;
    countryId?: number;
    generalCountryInformationTypeId?: number;
    description?: string | undefined;
    isActive?: boolean;
    isApproved?: boolean | undefined;
    approvedBy?: string | undefined;
    approvedOn?: Date | undefined;
    actualFrom?: Date;
    reviewDate?: Date | undefined;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    approvedByNavigation?: AspNetUser;
    country?: Country;
    generalCountryInformationType?: GeneralCountryInformationType;

    constructor(data?: IGeneralCountryInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generalCountryInformationId = _data["generalCountryInformationId"];
            this.countryId = _data["countryId"];
            this.generalCountryInformationTypeId = _data["generalCountryInformationTypeId"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isApproved = _data["isApproved"];
            this.approvedBy = _data["approvedBy"];
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : undefined as any;
            this.actualFrom = _data["actualFrom"] ? new Date(_data["actualFrom"].toString()) : undefined as any;
            this.reviewDate = _data["reviewDate"] ? new Date(_data["reviewDate"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.approvedByNavigation = _data["approvedByNavigation"] ? AspNetUser.fromJS(_data["approvedByNavigation"]) : undefined as any;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : undefined as any;
            this.generalCountryInformationType = _data["generalCountryInformationType"] ? GeneralCountryInformationType.fromJS(_data["generalCountryInformationType"]) : undefined as any;
        }
    }

    static fromJS(data: any): GeneralCountryInformation {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralCountryInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalCountryInformationId"] = this.generalCountryInformationId;
        data["countryId"] = this.countryId;
        data["generalCountryInformationTypeId"] = this.generalCountryInformationTypeId;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isApproved"] = this.isApproved;
        data["approvedBy"] = this.approvedBy;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : undefined as any;
        data["actualFrom"] = this.actualFrom ? this.actualFrom.toISOString() : undefined as any;
        data["reviewDate"] = this.reviewDate ? this.reviewDate.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["approvedByNavigation"] = this.approvedByNavigation ? this.approvedByNavigation.toJSON() : undefined as any;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        data["generalCountryInformationType"] = this.generalCountryInformationType ? this.generalCountryInformationType.toJSON() : undefined as any;
        return data;
    }
}

export interface IGeneralCountryInformation {
    generalCountryInformationId?: number;
    countryId?: number;
    generalCountryInformationTypeId?: number;
    description?: string | undefined;
    isActive?: boolean;
    isApproved?: boolean | undefined;
    approvedBy?: string | undefined;
    approvedOn?: Date | undefined;
    actualFrom?: Date;
    reviewDate?: Date | undefined;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    approvedByNavigation?: AspNetUser;
    country?: Country;
    generalCountryInformationType?: GeneralCountryInformationType;
}

export class GeneralCountryInformationResponse implements IGeneralCountryInformationResponse {
    countryId?: number;
    generalCountryInformationTypeId?: number;
    description?: string | undefined;
    isActive?: boolean;
    isApproved?: boolean;
    approvedBy?: string | undefined;
    approvedOn?: Date;
    actualFrom?: Date;
    reviewDate?: Date;

    constructor(data?: IGeneralCountryInformationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.generalCountryInformationTypeId = _data["generalCountryInformationTypeId"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isApproved = _data["isApproved"];
            this.approvedBy = _data["approvedBy"];
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : undefined as any;
            this.actualFrom = _data["actualFrom"] ? new Date(_data["actualFrom"].toString()) : undefined as any;
            this.reviewDate = _data["reviewDate"] ? new Date(_data["reviewDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GeneralCountryInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralCountryInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["generalCountryInformationTypeId"] = this.generalCountryInformationTypeId;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isApproved"] = this.isApproved;
        data["approvedBy"] = this.approvedBy;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : undefined as any;
        data["actualFrom"] = this.actualFrom ? this.actualFrom.toISOString() : undefined as any;
        data["reviewDate"] = this.reviewDate ? this.reviewDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IGeneralCountryInformationResponse {
    countryId?: number;
    generalCountryInformationTypeId?: number;
    description?: string | undefined;
    isActive?: boolean;
    isApproved?: boolean;
    approvedBy?: string | undefined;
    approvedOn?: Date;
    actualFrom?: Date;
    reviewDate?: Date;
}

export class GeneralCountryInformationType implements IGeneralCountryInformationType {
    generalCountryInformationTypeId?: number;
    name!: string;
    isActive?: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    generalCountryInformations?: GeneralCountryInformation[] | undefined;

    constructor(data?: IGeneralCountryInformationType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generalCountryInformationTypeId = _data["generalCountryInformationTypeId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["generalCountryInformations"])) {
                this.generalCountryInformations = [] as any;
                for (let item of _data["generalCountryInformations"])
                    this.generalCountryInformations!.push(GeneralCountryInformation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeneralCountryInformationType {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralCountryInformationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalCountryInformationTypeId"] = this.generalCountryInformationTypeId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.generalCountryInformations)) {
            data["generalCountryInformations"] = [];
            for (let item of this.generalCountryInformations)
                data["generalCountryInformations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGeneralCountryInformationType {
    generalCountryInformationTypeId?: number;
    name: string;
    isActive?: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    generalCountryInformations?: GeneralCountryInformation[] | undefined;
}

export class GeneralCountryInformationTypeResponse implements IGeneralCountryInformationTypeResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    generalCountryInformationTypeId?: number;
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: IGeneralCountryInformationTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.generalCountryInformationTypeId = _data["generalCountryInformationTypeId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): GeneralCountryInformationTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralCountryInformationTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["generalCountryInformationTypeId"] = this.generalCountryInformationTypeId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IGeneralCountryInformationTypeResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    generalCountryInformationTypeId?: number;
    name?: string | undefined;
    isActive?: boolean;
}

export class GeneralCountryInformationWithNestedObjectsResponse implements IGeneralCountryInformationWithNestedObjectsResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    generalCountryInformationId?: number;
    country?: Country;
    generalCountryInformationType?: GeneralCountryInformationType;
    description?: string | undefined;
    isActive?: boolean;
    isApproved?: boolean;
    approvedByNavigation?: AspNetUser;
    approvedOn?: Date;
    actualFrom?: Date;
    reviewDate?: Date;

    constructor(data?: IGeneralCountryInformationWithNestedObjectsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.generalCountryInformationId = _data["generalCountryInformationId"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : undefined as any;
            this.generalCountryInformationType = _data["generalCountryInformationType"] ? GeneralCountryInformationType.fromJS(_data["generalCountryInformationType"]) : undefined as any;
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isApproved = _data["isApproved"];
            this.approvedByNavigation = _data["approvedByNavigation"] ? AspNetUser.fromJS(_data["approvedByNavigation"]) : undefined as any;
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : undefined as any;
            this.actualFrom = _data["actualFrom"] ? new Date(_data["actualFrom"].toString()) : undefined as any;
            this.reviewDate = _data["reviewDate"] ? new Date(_data["reviewDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GeneralCountryInformationWithNestedObjectsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralCountryInformationWithNestedObjectsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["generalCountryInformationId"] = this.generalCountryInformationId;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        data["generalCountryInformationType"] = this.generalCountryInformationType ? this.generalCountryInformationType.toJSON() : undefined as any;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isApproved"] = this.isApproved;
        data["approvedByNavigation"] = this.approvedByNavigation ? this.approvedByNavigation.toJSON() : undefined as any;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : undefined as any;
        data["actualFrom"] = this.actualFrom ? this.actualFrom.toISOString() : undefined as any;
        data["reviewDate"] = this.reviewDate ? this.reviewDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IGeneralCountryInformationWithNestedObjectsResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    generalCountryInformationId?: number;
    country?: Country;
    generalCountryInformationType?: GeneralCountryInformationType;
    description?: string | undefined;
    isActive?: boolean;
    isApproved?: boolean;
    approvedByNavigation?: AspNetUser;
    approvedOn?: Date;
    actualFrom?: Date;
    reviewDate?: Date;
}

/** OData response message structure */
export class GeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse implements IGeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: GeneralCountryInformationWithNestedObjectsResponse[] | undefined;

    constructor(data?: IGeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(GeneralCountryInformationWithNestedObjectsResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IGeneralCountryInformationWithNestedObjectsResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: GeneralCountryInformationWithNestedObjectsResponse[] | undefined;
}

export class GeneralRateRulesEditor implements IGeneralRateRulesEditor {
    generalRateRulesEditorId?: number;
    entityTypeId?: number;
    investmentJurisdictionId?: number;
    securityTypeId?: number;
    taxResultItemTypeId?: number;
    description?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    entityType?: EntityType;
    generalRateRulesEditorRates?: GeneralRateRulesEditorRate[] | undefined;
    investmentJurisdiction?: InvestmentJurisdiction;
    securityType?: SecurityType;
    taxResultItemType?: TaxResultItemType;

    constructor(data?: IGeneralRateRulesEditor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generalRateRulesEditorId = _data["generalRateRulesEditorId"];
            this.entityTypeId = _data["entityTypeId"];
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
            this.securityTypeId = _data["securityTypeId"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.entityType = _data["entityType"] ? EntityType.fromJS(_data["entityType"]) : undefined as any;
            if (Array.isArray(_data["generalRateRulesEditorRates"])) {
                this.generalRateRulesEditorRates = [] as any;
                for (let item of _data["generalRateRulesEditorRates"])
                    this.generalRateRulesEditorRates!.push(GeneralRateRulesEditorRate.fromJS(item));
            }
            this.investmentJurisdiction = _data["investmentJurisdiction"] ? InvestmentJurisdiction.fromJS(_data["investmentJurisdiction"]) : undefined as any;
            this.securityType = _data["securityType"] ? SecurityType.fromJS(_data["securityType"]) : undefined as any;
            this.taxResultItemType = _data["taxResultItemType"] ? TaxResultItemType.fromJS(_data["taxResultItemType"]) : undefined as any;
        }
    }

    static fromJS(data: any): GeneralRateRulesEditor {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralRateRulesEditor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalRateRulesEditorId"] = this.generalRateRulesEditorId;
        data["entityTypeId"] = this.entityTypeId;
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        data["securityTypeId"] = this.securityTypeId;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["entityType"] = this.entityType ? this.entityType.toJSON() : undefined as any;
        if (Array.isArray(this.generalRateRulesEditorRates)) {
            data["generalRateRulesEditorRates"] = [];
            for (let item of this.generalRateRulesEditorRates)
                data["generalRateRulesEditorRates"].push(item ? item.toJSON() : undefined as any);
        }
        data["investmentJurisdiction"] = this.investmentJurisdiction ? this.investmentJurisdiction.toJSON() : undefined as any;
        data["securityType"] = this.securityType ? this.securityType.toJSON() : undefined as any;
        data["taxResultItemType"] = this.taxResultItemType ? this.taxResultItemType.toJSON() : undefined as any;
        return data;
    }
}

export interface IGeneralRateRulesEditor {
    generalRateRulesEditorId?: number;
    entityTypeId?: number;
    investmentJurisdictionId?: number;
    securityTypeId?: number;
    taxResultItemTypeId?: number;
    description?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    entityType?: EntityType;
    generalRateRulesEditorRates?: GeneralRateRulesEditorRate[] | undefined;
    investmentJurisdiction?: InvestmentJurisdiction;
    securityType?: SecurityType;
    taxResultItemType?: TaxResultItemType;
}

export class GeneralRateRulesEditorRate implements IGeneralRateRulesEditorRate {
    generalRateRulesEditorRateId?: number;
    generalRateRulesEditorId?: number;
    rate?: number | undefined;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    generalRateRulesEditor?: GeneralRateRulesEditor;

    constructor(data?: IGeneralRateRulesEditorRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generalRateRulesEditorRateId = _data["generalRateRulesEditorRateId"];
            this.generalRateRulesEditorId = _data["generalRateRulesEditorId"];
            this.rate = _data["rate"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.generalRateRulesEditor = _data["generalRateRulesEditor"] ? GeneralRateRulesEditor.fromJS(_data["generalRateRulesEditor"]) : undefined as any;
        }
    }

    static fromJS(data: any): GeneralRateRulesEditorRate {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralRateRulesEditorRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalRateRulesEditorRateId"] = this.generalRateRulesEditorRateId;
        data["generalRateRulesEditorId"] = this.generalRateRulesEditorId;
        data["rate"] = this.rate;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["generalRateRulesEditor"] = this.generalRateRulesEditor ? this.generalRateRulesEditor.toJSON() : undefined as any;
        return data;
    }
}

export interface IGeneralRateRulesEditorRate {
    generalRateRulesEditorRateId?: number;
    generalRateRulesEditorId?: number;
    rate?: number | undefined;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    generalRateRulesEditor?: GeneralRateRulesEditor;
}

export class GeneralRateRulesEditorRateResponse implements IGeneralRateRulesEditorRateResponse {
    generalRateRulesEditorRateId?: number;
    rate?: number | undefined;

    constructor(data?: IGeneralRateRulesEditorRateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generalRateRulesEditorRateId = _data["generalRateRulesEditorRateId"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): GeneralRateRulesEditorRateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralRateRulesEditorRateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalRateRulesEditorRateId"] = this.generalRateRulesEditorRateId;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IGeneralRateRulesEditorRateResponse {
    generalRateRulesEditorRateId?: number;
    rate?: number | undefined;
}

export class GeneralRateRulesEditorResponse implements IGeneralRateRulesEditorResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    generalRateRulesEditorId?: number;
    entityTypeId?: number;
    investmentJurisdictionId?: number;
    securityTypeId?: number;
    taxResultItemTypeId?: number;
    description?: string | undefined;
    isActive?: boolean;
    entityType?: EntityTypeNestedObjectResponse;
    investmentJurisdiction?: NestedInvestmentJurisdictionShortResponse;
    securityType?: SecurityTypeNestedObjectResponse;
    taxResultItemType?: TaxResultItemTypeNestedObjectResponse;
    generalRateRulesEditorRates?: GeneralRateRulesEditorRateResponse[] | undefined;

    constructor(data?: IGeneralRateRulesEditorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.generalRateRulesEditorId = _data["generalRateRulesEditorId"];
            this.entityTypeId = _data["entityTypeId"];
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
            this.securityTypeId = _data["securityTypeId"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.entityType = _data["entityType"] ? EntityTypeNestedObjectResponse.fromJS(_data["entityType"]) : undefined as any;
            this.investmentJurisdiction = _data["investmentJurisdiction"] ? NestedInvestmentJurisdictionShortResponse.fromJS(_data["investmentJurisdiction"]) : undefined as any;
            this.securityType = _data["securityType"] ? SecurityTypeNestedObjectResponse.fromJS(_data["securityType"]) : undefined as any;
            this.taxResultItemType = _data["taxResultItemType"] ? TaxResultItemTypeNestedObjectResponse.fromJS(_data["taxResultItemType"]) : undefined as any;
            if (Array.isArray(_data["generalRateRulesEditorRates"])) {
                this.generalRateRulesEditorRates = [] as any;
                for (let item of _data["generalRateRulesEditorRates"])
                    this.generalRateRulesEditorRates!.push(GeneralRateRulesEditorRateResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeneralRateRulesEditorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralRateRulesEditorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["generalRateRulesEditorId"] = this.generalRateRulesEditorId;
        data["entityTypeId"] = this.entityTypeId;
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        data["securityTypeId"] = this.securityTypeId;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["entityType"] = this.entityType ? this.entityType.toJSON() : undefined as any;
        data["investmentJurisdiction"] = this.investmentJurisdiction ? this.investmentJurisdiction.toJSON() : undefined as any;
        data["securityType"] = this.securityType ? this.securityType.toJSON() : undefined as any;
        data["taxResultItemType"] = this.taxResultItemType ? this.taxResultItemType.toJSON() : undefined as any;
        if (Array.isArray(this.generalRateRulesEditorRates)) {
            data["generalRateRulesEditorRates"] = [];
            for (let item of this.generalRateRulesEditorRates)
                data["generalRateRulesEditorRates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGeneralRateRulesEditorResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    generalRateRulesEditorId?: number;
    entityTypeId?: number;
    investmentJurisdictionId?: number;
    securityTypeId?: number;
    taxResultItemTypeId?: number;
    description?: string | undefined;
    isActive?: boolean;
    entityType?: EntityTypeNestedObjectResponse;
    investmentJurisdiction?: NestedInvestmentJurisdictionShortResponse;
    securityType?: SecurityTypeNestedObjectResponse;
    taxResultItemType?: TaxResultItemTypeNestedObjectResponse;
    generalRateRulesEditorRates?: GeneralRateRulesEditorRateResponse[] | undefined;
}

/** OData response message structure */
export class GeneralRateRulesEditorResponseODataWithMetadataResponse implements IGeneralRateRulesEditorResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: GeneralRateRulesEditorResponse[] | undefined;

    constructor(data?: IGeneralRateRulesEditorResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(GeneralRateRulesEditorResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeneralRateRulesEditorResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralRateRulesEditorResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IGeneralRateRulesEditorResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: GeneralRateRulesEditorResponse[] | undefined;
}

export class GraphAccountActionResponse implements IGraphAccountActionResponse {
    hasSucceeded?: boolean;
    errorMessage?: string | undefined;
    responseCode?: string | undefined;
    responseCodeExplanation?: string | undefined;

    constructor(data?: IGraphAccountActionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasSucceeded = _data["hasSucceeded"];
            this.errorMessage = _data["errorMessage"];
            this.responseCode = _data["responseCode"];
            this.responseCodeExplanation = _data["responseCodeExplanation"];
        }
    }

    static fromJS(data: any): GraphAccountActionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GraphAccountActionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasSucceeded"] = this.hasSucceeded;
        data["errorMessage"] = this.errorMessage;
        data["responseCode"] = this.responseCode;
        data["responseCodeExplanation"] = this.responseCodeExplanation;
        return data;
    }
}

export interface IGraphAccountActionResponse {
    hasSucceeded?: boolean;
    errorMessage?: string | undefined;
    responseCode?: string | undefined;
    responseCodeExplanation?: string | undefined;
}

export class GraphExternalUser implements IGraphExternalUser {
    accountName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    displayName?: string | undefined;
    accountEnabled?: boolean;

    constructor(data?: IGraphExternalUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.displayName = _data["displayName"];
            this.accountEnabled = _data["accountEnabled"];
        }
    }

    static fromJS(data: any): GraphExternalUser {
        data = typeof data === 'object' ? data : {};
        let result = new GraphExternalUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["displayName"] = this.displayName;
        data["accountEnabled"] = this.accountEnabled;
        return data;
    }
}

export interface IGraphExternalUser {
    accountName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    displayName?: string | undefined;
    accountEnabled?: boolean;
}

export class GraphValidateUserResponse implements IGraphValidateUserResponse {
    hasSucceeded?: boolean;
    errorMessage?: string | undefined;
    responseCode?: string | undefined;
    responseCodeExplanation?: string | undefined;
    externalUser?: GraphExternalUser;

    constructor(data?: IGraphValidateUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasSucceeded = _data["hasSucceeded"];
            this.errorMessage = _data["errorMessage"];
            this.responseCode = _data["responseCode"];
            this.responseCodeExplanation = _data["responseCodeExplanation"];
            this.externalUser = _data["externalUser"] ? GraphExternalUser.fromJS(_data["externalUser"]) : undefined as any;
        }
    }

    static fromJS(data: any): GraphValidateUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GraphValidateUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasSucceeded"] = this.hasSucceeded;
        data["errorMessage"] = this.errorMessage;
        data["responseCode"] = this.responseCode;
        data["responseCodeExplanation"] = this.responseCodeExplanation;
        data["externalUser"] = this.externalUser ? this.externalUser.toJSON() : undefined as any;
        return data;
    }
}

export interface IGraphValidateUserResponse {
    hasSucceeded?: boolean;
    errorMessage?: string | undefined;
    responseCode?: string | undefined;
    responseCodeExplanation?: string | undefined;
    externalUser?: GraphExternalUser;
}

export class InternalUserResponse implements IInternalUserResponse {
    id?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isActive?: boolean;
    termsAndPrivacyAccepted?: boolean;
    lastLogin?: Date | undefined;
    created?: Date | undefined;
    modified?: Date | undefined;

    constructor(data?: IInternalUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isActive = _data["isActive"];
            this.termsAndPrivacyAccepted = _data["termsAndPrivacyAccepted"];
            this.lastLogin = _data["lastLogin"] ? new Date(_data["lastLogin"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): InternalUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InternalUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isActive"] = this.isActive;
        data["termsAndPrivacyAccepted"] = this.termsAndPrivacyAccepted;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        return data;
    }
}

export interface IInternalUserResponse {
    id?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isActive?: boolean;
    termsAndPrivacyAccepted?: boolean;
    lastLogin?: Date | undefined;
    created?: Date | undefined;
    modified?: Date | undefined;
}

/** OData response message structure */
export class InternalUserResponseODataWithMetadataResponse implements IInternalUserResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: InternalUserResponse[] | undefined;

    constructor(data?: IInternalUserResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(InternalUserResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InternalUserResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InternalUserResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IInternalUserResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: InternalUserResponse[] | undefined;
}

export class InvestmentJurisdiction implements IInvestmentJurisdiction {
    investmentJurisdictionId?: number;
    countryId?: number;
    isActive?: boolean;
    isDisplay?: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    country?: Country;
    entityTypeInvestmentJurisdictions?: EntityTypeInvestmentJurisdiction[] | undefined;
    generalRateRulesEditors?: GeneralRateRulesEditor[] | undefined;
    securities?: Security[] | undefined;
    taxPolicies?: TaxPolicy[] | undefined;

    constructor(data?: IInvestmentJurisdiction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
            this.countryId = _data["countryId"];
            this.isActive = _data["isActive"];
            this.isDisplay = _data["isDisplay"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : undefined as any;
            if (Array.isArray(_data["entityTypeInvestmentJurisdictions"])) {
                this.entityTypeInvestmentJurisdictions = [] as any;
                for (let item of _data["entityTypeInvestmentJurisdictions"])
                    this.entityTypeInvestmentJurisdictions!.push(EntityTypeInvestmentJurisdiction.fromJS(item));
            }
            if (Array.isArray(_data["generalRateRulesEditors"])) {
                this.generalRateRulesEditors = [] as any;
                for (let item of _data["generalRateRulesEditors"])
                    this.generalRateRulesEditors!.push(GeneralRateRulesEditor.fromJS(item));
            }
            if (Array.isArray(_data["securities"])) {
                this.securities = [] as any;
                for (let item of _data["securities"])
                    this.securities!.push(Security.fromJS(item));
            }
            if (Array.isArray(_data["taxPolicies"])) {
                this.taxPolicies = [] as any;
                for (let item of _data["taxPolicies"])
                    this.taxPolicies!.push(TaxPolicy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvestmentJurisdiction {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentJurisdiction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        data["countryId"] = this.countryId;
        data["isActive"] = this.isActive;
        data["isDisplay"] = this.isDisplay;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        if (Array.isArray(this.entityTypeInvestmentJurisdictions)) {
            data["entityTypeInvestmentJurisdictions"] = [];
            for (let item of this.entityTypeInvestmentJurisdictions)
                data["entityTypeInvestmentJurisdictions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generalRateRulesEditors)) {
            data["generalRateRulesEditors"] = [];
            for (let item of this.generalRateRulesEditors)
                data["generalRateRulesEditors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.securities)) {
            data["securities"] = [];
            for (let item of this.securities)
                data["securities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.taxPolicies)) {
            data["taxPolicies"] = [];
            for (let item of this.taxPolicies)
                data["taxPolicies"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInvestmentJurisdiction {
    investmentJurisdictionId?: number;
    countryId?: number;
    isActive?: boolean;
    isDisplay?: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    country?: Country;
    entityTypeInvestmentJurisdictions?: EntityTypeInvestmentJurisdiction[] | undefined;
    generalRateRulesEditors?: GeneralRateRulesEditor[] | undefined;
    securities?: Security[] | undefined;
    taxPolicies?: TaxPolicy[] | undefined;
}

export class InvestmentJurisdictionResponseAuditable implements IInvestmentJurisdictionResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    investmentJurisdictionId?: number;
    countryId?: number;
    isActive?: boolean;

    constructor(data?: IInvestmentJurisdictionResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
            this.countryId = _data["countryId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): InvestmentJurisdictionResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentJurisdictionResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        data["countryId"] = this.countryId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IInvestmentJurisdictionResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    investmentJurisdictionId?: number;
    countryId?: number;
    isActive?: boolean;
}

export class InvestmentJurisdictionWithNestedObjectsResponseAuditable implements IInvestmentJurisdictionWithNestedObjectsResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    investmentJurisdictionId?: number;
    country?: CountryResponseWithNestedObjects;
    isActive?: boolean;
    isDisplay?: boolean;

    constructor(data?: IInvestmentJurisdictionWithNestedObjectsResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
            this.country = _data["country"] ? CountryResponseWithNestedObjects.fromJS(_data["country"]) : undefined as any;
            this.isActive = _data["isActive"];
            this.isDisplay = _data["isDisplay"];
        }
    }

    static fromJS(data: any): InvestmentJurisdictionWithNestedObjectsResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentJurisdictionWithNestedObjectsResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        data["isActive"] = this.isActive;
        data["isDisplay"] = this.isDisplay;
        return data;
    }
}

export interface IInvestmentJurisdictionWithNestedObjectsResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    investmentJurisdictionId?: number;
    country?: CountryResponseWithNestedObjects;
    isActive?: boolean;
    isDisplay?: boolean;
}

/** OData response message structure */
export class InvestmentJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse implements IInvestmentJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: InvestmentJurisdictionWithNestedObjectsResponseAuditable[] | undefined;

    constructor(data?: IInvestmentJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(InvestmentJurisdictionWithNestedObjectsResponseAuditable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvestmentJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IInvestmentJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: InvestmentJurisdictionWithNestedObjectsResponseAuditable[] | undefined;
}

export class LastQuestionAnswerEvaluationRequest implements ILastQuestionAnswerEvaluationRequest {
    name?: string | undefined;
    answer?: string | undefined;
    unsureAnswer?: boolean;

    constructor(data?: ILastQuestionAnswerEvaluationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.answer = _data["answer"];
            this.unsureAnswer = _data["unsureAnswer"];
        }
    }

    static fromJS(data: any): LastQuestionAnswerEvaluationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LastQuestionAnswerEvaluationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["answer"] = this.answer;
        data["unsureAnswer"] = this.unsureAnswer;
        return data;
    }
}

export interface ILastQuestionAnswerEvaluationRequest {
    name?: string | undefined;
    answer?: string | undefined;
    unsureAnswer?: boolean;
}

export class NestedInvestmentJurisdictionShortResponse implements INestedInvestmentJurisdictionShortResponse {
    investmentJurisdictionId?: number;
    country?: CountryResponseWithNestedObjects;

    constructor(data?: INestedInvestmentJurisdictionShortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
            this.country = _data["country"] ? CountryResponseWithNestedObjects.fromJS(_data["country"]) : undefined as any;
        }
    }

    static fromJS(data: any): NestedInvestmentJurisdictionShortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NestedInvestmentJurisdictionShortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        return data;
    }
}

export interface INestedInvestmentJurisdictionShortResponse {
    investmentJurisdictionId?: number;
    country?: CountryResponseWithNestedObjects;
}

export class NestedResidencyJurisdictionResponseAuditable implements INestedResidencyJurisdictionResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    residencyJurisdictionId?: number;
    country?: CountryResponseWithNestedObjects;

    constructor(data?: INestedResidencyJurisdictionResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.residencyJurisdictionId = _data["residencyJurisdictionId"];
            this.country = _data["country"] ? CountryResponseWithNestedObjects.fromJS(_data["country"]) : undefined as any;
        }
    }

    static fromJS(data: any): NestedResidencyJurisdictionResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new NestedResidencyJurisdictionResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["residencyJurisdictionId"] = this.residencyJurisdictionId;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        return data;
    }
}

export interface INestedResidencyJurisdictionResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    residencyJurisdictionId?: number;
    country?: CountryResponseWithNestedObjects;
}

export class NestedResidencyJurisdictionShortResponse implements INestedResidencyJurisdictionShortResponse {
    residencyJurisdictionId?: number;
    country?: CountryResponseWithNestedObjects;
    isActive?: boolean;

    constructor(data?: INestedResidencyJurisdictionShortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residencyJurisdictionId = _data["residencyJurisdictionId"];
            this.country = _data["country"] ? CountryResponseWithNestedObjects.fromJS(_data["country"]) : undefined as any;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): NestedResidencyJurisdictionShortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NestedResidencyJurisdictionShortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residencyJurisdictionId"] = this.residencyJurisdictionId;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface INestedResidencyJurisdictionShortResponse {
    residencyJurisdictionId?: number;
    country?: CountryResponseWithNestedObjects;
    isActive?: boolean;
}

export class NestedUserResponse implements INestedUserResponse {
    id?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isExternal?: boolean;

    constructor(data?: INestedUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isExternal = _data["isExternal"];
        }
    }

    static fromJS(data: any): NestedUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NestedUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isExternal"] = this.isExternal;
        return data;
    }
}

export interface INestedUserResponse {
    id?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isExternal?: boolean;
}

export class OAuthLoginSessionRequest implements IOAuthLoginSessionRequest {
    loginSessionId?: string | undefined;

    constructor(data?: IOAuthLoginSessionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginSessionId = _data["loginSessionId"];
        }
    }

    static fromJS(data: any): OAuthLoginSessionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OAuthLoginSessionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginSessionId"] = this.loginSessionId;
        return data;
    }
}

export interface IOAuthLoginSessionRequest {
    loginSessionId?: string | undefined;
}

export class PortfolioFolder implements IPortfolioFolder {
    portfolioFolderId?: number;
    entityId?: number;
    name!: string;
    description?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    entity?: Entity;
    securities?: Security[] | undefined;

    constructor(data?: IPortfolioFolder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.portfolioFolderId = _data["portfolioFolderId"];
            this.entityId = _data["entityId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.entity = _data["entity"] ? Entity.fromJS(_data["entity"]) : undefined as any;
            if (Array.isArray(_data["securities"])) {
                this.securities = [] as any;
                for (let item of _data["securities"])
                    this.securities!.push(Security.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PortfolioFolder {
        data = typeof data === 'object' ? data : {};
        let result = new PortfolioFolder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portfolioFolderId"] = this.portfolioFolderId;
        data["entityId"] = this.entityId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["entity"] = this.entity ? this.entity.toJSON() : undefined as any;
        if (Array.isArray(this.securities)) {
            data["securities"] = [];
            for (let item of this.securities)
                data["securities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPortfolioFolder {
    portfolioFolderId?: number;
    entityId?: number;
    name: string;
    description?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    entity?: Entity;
    securities?: Security[] | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class Question implements IQuestion {
    questionId?: number;
    taxPolicyId?: number | undefined;
    questionTypeId?: number;
    questionValueTypeId?: number;
    name!: string;
    text!: string;
    countryList?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    questionType?: QuestionType;
    questionValueType?: QuestionValueType;
    securityQuestionAnswers?: SecurityQuestionAnswer[] | undefined;
    taxPolicy?: TaxPolicy;

    constructor(data?: IQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.taxPolicyId = _data["taxPolicyId"];
            this.questionTypeId = _data["questionTypeId"];
            this.questionValueTypeId = _data["questionValueTypeId"];
            this.name = _data["name"];
            this.text = _data["text"];
            this.countryList = _data["countryList"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.questionType = _data["questionType"] ? QuestionType.fromJS(_data["questionType"]) : undefined as any;
            this.questionValueType = _data["questionValueType"] ? QuestionValueType.fromJS(_data["questionValueType"]) : undefined as any;
            if (Array.isArray(_data["securityQuestionAnswers"])) {
                this.securityQuestionAnswers = [] as any;
                for (let item of _data["securityQuestionAnswers"])
                    this.securityQuestionAnswers!.push(SecurityQuestionAnswer.fromJS(item));
            }
            this.taxPolicy = _data["taxPolicy"] ? TaxPolicy.fromJS(_data["taxPolicy"]) : undefined as any;
        }
    }

    static fromJS(data: any): Question {
        data = typeof data === 'object' ? data : {};
        let result = new Question();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["taxPolicyId"] = this.taxPolicyId;
        data["questionTypeId"] = this.questionTypeId;
        data["questionValueTypeId"] = this.questionValueTypeId;
        data["name"] = this.name;
        data["text"] = this.text;
        data["countryList"] = this.countryList;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["questionType"] = this.questionType ? this.questionType.toJSON() : undefined as any;
        data["questionValueType"] = this.questionValueType ? this.questionValueType.toJSON() : undefined as any;
        if (Array.isArray(this.securityQuestionAnswers)) {
            data["securityQuestionAnswers"] = [];
            for (let item of this.securityQuestionAnswers)
                data["securityQuestionAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        data["taxPolicy"] = this.taxPolicy ? this.taxPolicy.toJSON() : undefined as any;
        return data;
    }
}

export interface IQuestion {
    questionId?: number;
    taxPolicyId?: number | undefined;
    questionTypeId?: number;
    questionValueTypeId?: number;
    name: string;
    text: string;
    countryList?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    questionType?: QuestionType;
    questionValueType?: QuestionValueType;
    securityQuestionAnswers?: SecurityQuestionAnswer[] | undefined;
    taxPolicy?: TaxPolicy;
}

export class QuestionAnswerEvaluationRequest implements IQuestionAnswerEvaluationRequest {
    name!: string;
    answer!: string;

    constructor(data?: IQuestionAnswerEvaluationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.answer = _data["answer"];
        }
    }

    static fromJS(data: any): QuestionAnswerEvaluationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionAnswerEvaluationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["answer"] = this.answer;
        return data;
    }
}

export interface IQuestionAnswerEvaluationRequest {
    name: string;
    answer: string;
}

export class QuestionEvaluationResponse implements IQuestionEvaluationResponse {
    questionId?: number;
    name?: string | undefined;
    question?: string | undefined;
    type?: number;

    constructor(data?: IQuestionEvaluationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.name = _data["name"];
            this.question = _data["question"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): QuestionEvaluationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionEvaluationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["name"] = this.name;
        data["question"] = this.question;
        data["type"] = this.type;
        return data;
    }
}

export interface IQuestionEvaluationResponse {
    questionId?: number;
    name?: string | undefined;
    question?: string | undefined;
    type?: number;
}

export class QuestionForSecurityReviewResponse implements IQuestionForSecurityReviewResponse {
    questionId?: number;
    questionValueType?: QuestionValueTypeNestedObjectResponse;
    name?: string | undefined;
    text?: string | undefined;
    isActive?: boolean;

    constructor(data?: IQuestionForSecurityReviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.questionValueType = _data["questionValueType"] ? QuestionValueTypeNestedObjectResponse.fromJS(_data["questionValueType"]) : undefined as any;
            this.name = _data["name"];
            this.text = _data["text"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): QuestionForSecurityReviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionForSecurityReviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["questionValueType"] = this.questionValueType ? this.questionValueType.toJSON() : undefined as any;
        data["name"] = this.name;
        data["text"] = this.text;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IQuestionForSecurityReviewResponse {
    questionId?: number;
    questionValueType?: QuestionValueTypeNestedObjectResponse;
    name?: string | undefined;
    text?: string | undefined;
    isActive?: boolean;
}

export class QuestionHistoryResponseAuditable implements IQuestionHistoryResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    questionId?: number;
    taxPolicyId?: number | undefined;
    questionTypeId?: number;
    questionValueTypeId?: number;
    name?: string | undefined;
    text?: string | undefined;
    countryList?: string | undefined;
    isActive?: boolean;

    constructor(data?: IQuestionHistoryResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.questionId = _data["questionId"];
            this.taxPolicyId = _data["taxPolicyId"];
            this.questionTypeId = _data["questionTypeId"];
            this.questionValueTypeId = _data["questionValueTypeId"];
            this.name = _data["name"];
            this.text = _data["text"];
            this.countryList = _data["countryList"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): QuestionHistoryResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionHistoryResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["questionId"] = this.questionId;
        data["taxPolicyId"] = this.taxPolicyId;
        data["questionTypeId"] = this.questionTypeId;
        data["questionValueTypeId"] = this.questionValueTypeId;
        data["name"] = this.name;
        data["text"] = this.text;
        data["countryList"] = this.countryList;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IQuestionHistoryResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    questionId?: number;
    taxPolicyId?: number | undefined;
    questionTypeId?: number;
    questionValueTypeId?: number;
    name?: string | undefined;
    text?: string | undefined;
    countryList?: string | undefined;
    isActive?: boolean;
}

/** OData response message structure */
export class QuestionHistoryResponseAuditableODataWithMetadataResponse implements IQuestionHistoryResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: QuestionHistoryResponseAuditable[] | undefined;

    constructor(data?: IQuestionHistoryResponseAuditableODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(QuestionHistoryResponseAuditable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionHistoryResponseAuditableODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionHistoryResponseAuditableODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IQuestionHistoryResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: QuestionHistoryResponseAuditable[] | undefined;
}

export class QuestionResponseAuditable implements IQuestionResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    questionId?: number;
    taxPolicyId?: number | undefined;
    questionTypeId?: number;
    questionValueTypeId?: number;
    name?: string | undefined;
    text?: string | undefined;
    countryList?: string | undefined;
    isActive?: boolean;

    constructor(data?: IQuestionResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.questionId = _data["questionId"];
            this.taxPolicyId = _data["taxPolicyId"];
            this.questionTypeId = _data["questionTypeId"];
            this.questionValueTypeId = _data["questionValueTypeId"];
            this.name = _data["name"];
            this.text = _data["text"];
            this.countryList = _data["countryList"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): QuestionResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["questionId"] = this.questionId;
        data["taxPolicyId"] = this.taxPolicyId;
        data["questionTypeId"] = this.questionTypeId;
        data["questionValueTypeId"] = this.questionValueTypeId;
        data["name"] = this.name;
        data["text"] = this.text;
        data["countryList"] = this.countryList;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IQuestionResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    questionId?: number;
    taxPolicyId?: number | undefined;
    questionTypeId?: number;
    questionValueTypeId?: number;
    name?: string | undefined;
    text?: string | undefined;
    countryList?: string | undefined;
    isActive?: boolean;
}

export class QuestionResponseWithNestedObjectsResponseAuditable implements IQuestionResponseWithNestedObjectsResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    questionId?: number;
    taxPolicy?: TaxPolicyWithNestedObjectShortResponse;
    questionType?: QuestionTypeNestedObjectResponse;
    questionValueType?: QuestionValueTypeNestedObjectResponse;
    name?: string | undefined;
    text?: string | undefined;
    countryList?: string | undefined;
    isActive?: boolean;

    constructor(data?: IQuestionResponseWithNestedObjectsResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.questionId = _data["questionId"];
            this.taxPolicy = _data["taxPolicy"] ? TaxPolicyWithNestedObjectShortResponse.fromJS(_data["taxPolicy"]) : undefined as any;
            this.questionType = _data["questionType"] ? QuestionTypeNestedObjectResponse.fromJS(_data["questionType"]) : undefined as any;
            this.questionValueType = _data["questionValueType"] ? QuestionValueTypeNestedObjectResponse.fromJS(_data["questionValueType"]) : undefined as any;
            this.name = _data["name"];
            this.text = _data["text"];
            this.countryList = _data["countryList"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): QuestionResponseWithNestedObjectsResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionResponseWithNestedObjectsResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["questionId"] = this.questionId;
        data["taxPolicy"] = this.taxPolicy ? this.taxPolicy.toJSON() : undefined as any;
        data["questionType"] = this.questionType ? this.questionType.toJSON() : undefined as any;
        data["questionValueType"] = this.questionValueType ? this.questionValueType.toJSON() : undefined as any;
        data["name"] = this.name;
        data["text"] = this.text;
        data["countryList"] = this.countryList;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IQuestionResponseWithNestedObjectsResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    questionId?: number;
    taxPolicy?: TaxPolicyWithNestedObjectShortResponse;
    questionType?: QuestionTypeNestedObjectResponse;
    questionValueType?: QuestionValueTypeNestedObjectResponse;
    name?: string | undefined;
    text?: string | undefined;
    countryList?: string | undefined;
    isActive?: boolean;
}

/** OData response message structure */
export class QuestionResponseWithNestedObjectsResponseAuditableODataWithMetadataResponse implements IQuestionResponseWithNestedObjectsResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: QuestionResponseWithNestedObjectsResponseAuditable[] | undefined;

    constructor(data?: IQuestionResponseWithNestedObjectsResponseAuditableODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(QuestionResponseWithNestedObjectsResponseAuditable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionResponseWithNestedObjectsResponseAuditableODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionResponseWithNestedObjectsResponseAuditableODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IQuestionResponseWithNestedObjectsResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: QuestionResponseWithNestedObjectsResponseAuditable[] | undefined;
}

export class QuestionType implements IQuestionType {
    questionTypeId?: number;
    name!: string;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    questions?: Question[] | undefined;

    constructor(data?: IQuestionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionTypeId = _data["questionTypeId"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(Question.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionType {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionTypeId"] = this.questionTypeId;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IQuestionType {
    questionTypeId?: number;
    name: string;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    questions?: Question[] | undefined;
}

export class QuestionTypeNestedObjectResponse implements IQuestionTypeNestedObjectResponse {
    questionTypeId?: number;
    name?: string | undefined;

    constructor(data?: IQuestionTypeNestedObjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionTypeId = _data["questionTypeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): QuestionTypeNestedObjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionTypeNestedObjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionTypeId"] = this.questionTypeId;
        data["name"] = this.name;
        return data;
    }
}

export interface IQuestionTypeNestedObjectResponse {
    questionTypeId?: number;
    name?: string | undefined;
}

export class QuestionTypeResponse implements IQuestionTypeResponse {
    questionTypeId?: number;
    name?: string | undefined;

    constructor(data?: IQuestionTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionTypeId = _data["questionTypeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): QuestionTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionTypeId"] = this.questionTypeId;
        data["name"] = this.name;
        return data;
    }
}

export interface IQuestionTypeResponse {
    questionTypeId?: number;
    name?: string | undefined;
}

/** OData response message structure */
export class QuestionTypeResponseODataWithMetadataResponse implements IQuestionTypeResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: QuestionTypeResponse[] | undefined;

    constructor(data?: IQuestionTypeResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(QuestionTypeResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionTypeResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionTypeResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IQuestionTypeResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: QuestionTypeResponse[] | undefined;
}

export class QuestionValueType implements IQuestionValueType {
    questionValueTypeId?: number;
    name!: string;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    questions?: Question[] | undefined;

    constructor(data?: IQuestionValueType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionValueTypeId = _data["questionValueTypeId"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(Question.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionValueType {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionValueType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionValueTypeId"] = this.questionValueTypeId;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IQuestionValueType {
    questionValueTypeId?: number;
    name: string;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    questions?: Question[] | undefined;
}

export class QuestionValueTypeNestedObjectResponse implements IQuestionValueTypeNestedObjectResponse {
    questionValueTypeId?: number;
    name?: string | undefined;

    constructor(data?: IQuestionValueTypeNestedObjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionValueTypeId = _data["questionValueTypeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): QuestionValueTypeNestedObjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionValueTypeNestedObjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionValueTypeId"] = this.questionValueTypeId;
        data["name"] = this.name;
        return data;
    }
}

export interface IQuestionValueTypeNestedObjectResponse {
    questionValueTypeId?: number;
    name?: string | undefined;
}

export class QuestionValueTypeResponse implements IQuestionValueTypeResponse {
    questionValueTypeId?: number;
    name?: string | undefined;

    constructor(data?: IQuestionValueTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionValueTypeId = _data["questionValueTypeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): QuestionValueTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionValueTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionValueTypeId"] = this.questionValueTypeId;
        data["name"] = this.name;
        return data;
    }
}

export interface IQuestionValueTypeResponse {
    questionValueTypeId?: number;
    name?: string | undefined;
}

/** OData response message structure */
export class QuestionValueTypeResponseODataWithMetadataResponse implements IQuestionValueTypeResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: QuestionValueTypeResponse[] | undefined;

    constructor(data?: IQuestionValueTypeResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(QuestionValueTypeResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionValueTypeResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionValueTypeResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IQuestionValueTypeResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: QuestionValueTypeResponse[] | undefined;
}

export class ReevaluateSecurityRequest implements IReevaluateSecurityRequest {
    entityId?: number;
    clientId?: number | undefined;
    generalRateEntityTypeId?: number | undefined;
    investmentJurisdictionId?: number;
    transactionTypeId?: number;
    securityTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    ownership?: number | undefined;
    isinCusip?: string | undefined;
    acquisitionDate?: Date | undefined;
    dispositionDate?: Date | undefined;
    taxRates!: UpdateSecurityTaxRateRequest[];
    questionAnswers!: UpdateSecurityQuestionAnswerRequest[];
    securityId!: number;
    comment?: string | undefined;
    adminComment?: string | undefined;
    skipNotification?: boolean;

    constructor(data?: IReevaluateSecurityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.taxRates = [];
            this.questionAnswers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.clientId = _data["clientId"];
            this.generalRateEntityTypeId = _data["generalRateEntityTypeId"];
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
            this.transactionTypeId = _data["transactionTypeId"];
            this.securityTypeId = _data["securityTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.ownership = _data["ownership"];
            this.isinCusip = _data["isinCusip"];
            this.acquisitionDate = _data["acquisitionDate"] ? new Date(_data["acquisitionDate"].toString()) : undefined as any;
            this.dispositionDate = _data["dispositionDate"] ? new Date(_data["dispositionDate"].toString()) : undefined as any;
            if (Array.isArray(_data["taxRates"])) {
                this.taxRates = [] as any;
                for (let item of _data["taxRates"])
                    this.taxRates!.push(UpdateSecurityTaxRateRequest.fromJS(item));
            }
            if (Array.isArray(_data["questionAnswers"])) {
                this.questionAnswers = [] as any;
                for (let item of _data["questionAnswers"])
                    this.questionAnswers!.push(UpdateSecurityQuestionAnswerRequest.fromJS(item));
            }
            this.securityId = _data["securityId"];
            this.comment = _data["comment"];
            this.adminComment = _data["adminComment"];
            this.skipNotification = _data["skipNotification"];
        }
    }

    static fromJS(data: any): ReevaluateSecurityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReevaluateSecurityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["clientId"] = this.clientId;
        data["generalRateEntityTypeId"] = this.generalRateEntityTypeId;
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        data["transactionTypeId"] = this.transactionTypeId;
        data["securityTypeId"] = this.securityTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["ownership"] = this.ownership;
        data["isinCusip"] = this.isinCusip;
        data["acquisitionDate"] = this.acquisitionDate ? this.acquisitionDate.toISOString() : undefined as any;
        data["dispositionDate"] = this.dispositionDate ? this.dispositionDate.toISOString() : undefined as any;
        if (Array.isArray(this.taxRates)) {
            data["taxRates"] = [];
            for (let item of this.taxRates)
                data["taxRates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.questionAnswers)) {
            data["questionAnswers"] = [];
            for (let item of this.questionAnswers)
                data["questionAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        data["securityId"] = this.securityId;
        data["comment"] = this.comment;
        data["adminComment"] = this.adminComment;
        data["skipNotification"] = this.skipNotification;
        return data;
    }
}

export interface IReevaluateSecurityRequest {
    entityId?: number;
    clientId?: number | undefined;
    generalRateEntityTypeId?: number | undefined;
    investmentJurisdictionId?: number;
    transactionTypeId?: number;
    securityTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    ownership?: number | undefined;
    isinCusip?: string | undefined;
    acquisitionDate?: Date | undefined;
    dispositionDate?: Date | undefined;
    taxRates: UpdateSecurityTaxRateRequest[];
    questionAnswers: UpdateSecurityQuestionAnswerRequest[];
    securityId: number;
    comment?: string | undefined;
    adminComment?: string | undefined;
    skipNotification?: boolean;
}

export class RefreshTokenRequest implements IRefreshTokenRequest {
    refreshToken!: string;
    sessionId!: string;

    constructor(data?: IRefreshTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshToken = _data["refreshToken"];
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): RefreshTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken;
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface IRefreshTokenRequest {
    refreshToken: string;
    sessionId: string;
}

export class RefreshTokenResponse implements IRefreshTokenResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    sessionId?: string;
    accessTokenExpiresIn?: number;
    refreshTokenExpiresIn?: number;

    constructor(data?: IRefreshTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.sessionId = _data["sessionId"];
            this.accessTokenExpiresIn = _data["accessTokenExpiresIn"];
            this.refreshTokenExpiresIn = _data["refreshTokenExpiresIn"];
        }
    }

    static fromJS(data: any): RefreshTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["sessionId"] = this.sessionId;
        data["accessTokenExpiresIn"] = this.accessTokenExpiresIn;
        data["refreshTokenExpiresIn"] = this.refreshTokenExpiresIn;
        return data;
    }
}

export interface IRefreshTokenResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    sessionId?: string;
    accessTokenExpiresIn?: number;
    refreshTokenExpiresIn?: number;
}

export class Region implements IRegion {
    regionId?: number;
    name!: string;
    isActive!: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    countries?: Country[] | undefined;

    constructor(data?: IRegion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regionId = _data["regionId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(Country.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Region {
        data = typeof data === 'object' ? data : {};
        let result = new Region();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRegion {
    regionId?: number;
    name: string;
    isActive: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    countries?: Country[] | undefined;
}

export class RegionNestedResponse implements IRegionNestedResponse {
    regionId?: number;
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: IRegionNestedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regionId = _data["regionId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): RegionNestedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegionNestedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IRegionNestedResponse {
    regionId?: number;
    name?: string | undefined;
    isActive?: boolean;
}

export class RegionResponseAuditable implements IRegionResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    regionId?: number;
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: IRegionResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.regionId = _data["regionId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): RegionResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new RegionResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["regionId"] = this.regionId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IRegionResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    regionId?: number;
    name?: string | undefined;
    isActive?: boolean;
}

/** OData response message structure */
export class RegionResponseAuditableODataWithMetadataResponse implements IRegionResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: RegionResponseAuditable[] | undefined;

    constructor(data?: IRegionResponseAuditableODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(RegionResponseAuditable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegionResponseAuditableODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegionResponseAuditableODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IRegionResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: RegionResponseAuditable[] | undefined;
}

export class ResidencyJurisdiction implements IResidencyJurisdiction {
    residencyJurisdictionId?: number;
    countryId?: number;
    isActive!: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    country?: Country;
    entities?: Entity[] | undefined;
    taxPolicies?: TaxPolicy[] | undefined;

    constructor(data?: IResidencyJurisdiction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residencyJurisdictionId = _data["residencyJurisdictionId"];
            this.countryId = _data["countryId"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : undefined as any;
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(Entity.fromJS(item));
            }
            if (Array.isArray(_data["taxPolicies"])) {
                this.taxPolicies = [] as any;
                for (let item of _data["taxPolicies"])
                    this.taxPolicies!.push(TaxPolicy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResidencyJurisdiction {
        data = typeof data === 'object' ? data : {};
        let result = new ResidencyJurisdiction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residencyJurisdictionId"] = this.residencyJurisdictionId;
        data["countryId"] = this.countryId;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.taxPolicies)) {
            data["taxPolicies"] = [];
            for (let item of this.taxPolicies)
                data["taxPolicies"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResidencyJurisdiction {
    residencyJurisdictionId?: number;
    countryId?: number;
    isActive: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    country?: Country;
    entities?: Entity[] | undefined;
    taxPolicies?: TaxPolicy[] | undefined;
}

export class ResidencyJurisdictionResponseAuditable implements IResidencyJurisdictionResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    residencyJurisdictionId?: number;
    countryId?: number;
    isActive?: boolean;

    constructor(data?: IResidencyJurisdictionResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.residencyJurisdictionId = _data["residencyJurisdictionId"];
            this.countryId = _data["countryId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ResidencyJurisdictionResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new ResidencyJurisdictionResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["residencyJurisdictionId"] = this.residencyJurisdictionId;
        data["countryId"] = this.countryId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IResidencyJurisdictionResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    residencyJurisdictionId?: number;
    countryId?: number;
    isActive?: boolean;
}

export class ResidencyJurisdictionWithNestedObjectsResponseAuditable implements IResidencyJurisdictionWithNestedObjectsResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    residencyJurisdictionId?: number;
    country?: CountryResponseWithNestedObjects;
    isActive?: boolean;

    constructor(data?: IResidencyJurisdictionWithNestedObjectsResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.residencyJurisdictionId = _data["residencyJurisdictionId"];
            this.country = _data["country"] ? CountryResponseWithNestedObjects.fromJS(_data["country"]) : undefined as any;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ResidencyJurisdictionWithNestedObjectsResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new ResidencyJurisdictionWithNestedObjectsResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["residencyJurisdictionId"] = this.residencyJurisdictionId;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IResidencyJurisdictionWithNestedObjectsResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    residencyJurisdictionId?: number;
    country?: CountryResponseWithNestedObjects;
    isActive?: boolean;
}

/** OData response message structure */
export class ResidencyJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse implements IResidencyJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: ResidencyJurisdictionWithNestedObjectsResponseAuditable[] | undefined;

    constructor(data?: IResidencyJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(ResidencyJurisdictionWithNestedObjectsResponseAuditable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResidencyJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResidencyJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IResidencyJurisdictionWithNestedObjectsResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: ResidencyJurisdictionWithNestedObjectsResponseAuditable[] | undefined;
}

export class RevokeRefreshTokenRequest implements IRevokeRefreshTokenRequest {
    refreshToken!: string;
    sessionId!: string;

    constructor(data?: IRevokeRefreshTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshToken = _data["refreshToken"];
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): RevokeRefreshTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RevokeRefreshTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken;
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface IRevokeRefreshTokenRequest {
    refreshToken: string;
    sessionId: string;
}

export class RoleResponse implements IRoleResponse {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IRoleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RoleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RoleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRoleResponse {
    id?: string | undefined;
    name?: string | undefined;
}

/** OData response message structure */
export class RoleResponseODataWithMetadataResponse implements IRoleResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: RoleResponse[] | undefined;

    constructor(data?: IRoleResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(RoleResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RoleResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IRoleResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: RoleResponse[] | undefined;
}

export class Security implements ISecurity {
    securityId?: number;
    entityId?: number;
    generalRateEntityTypeId?: number | undefined;
    portfolioFolderId?: number | undefined;
    investmentJurisdictionId?: number;
    transactionTypeId?: number;
    securityTypeId?: number;
    securityStatusId?: number;
    name?: string | undefined;
    description?: string | undefined;
    ownership?: number | undefined;
    acquisitionDate?: Date | undefined;
    dispositionDate?: Date | undefined;
    isinCusip?: string | undefined;
    isActive?: boolean;
    approved?: Date | undefined;
    approvedBy?: string | undefined;
    comment?: string | undefined;
    adminComment?: string | undefined;
    adminCommentModifiedBy?: string | undefined;
    adminCommentModifiedDate?: Date | undefined;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    approvedByNavigation?: AspNetUser;
    entity?: Entity;
    generalRateEntityType?: EntityType;
    investmentJurisdiction?: InvestmentJurisdiction;
    portfolioFolder?: PortfolioFolder;
    securityAudits?: SecurityAudit[] | undefined;
    securityNotifications?: SecurityNotification[] | undefined;
    securityQuestionAnswers?: SecurityQuestionAnswer[] | undefined;
    securityStatus?: SecurityStatus;
    securityTaxResultItems?: SecurityTaxResultItem[] | undefined;
    securityType?: SecurityType;
    transactionType?: TransactionType;

    constructor(data?: ISecurity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityId = _data["securityId"];
            this.entityId = _data["entityId"];
            this.generalRateEntityTypeId = _data["generalRateEntityTypeId"];
            this.portfolioFolderId = _data["portfolioFolderId"];
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
            this.transactionTypeId = _data["transactionTypeId"];
            this.securityTypeId = _data["securityTypeId"];
            this.securityStatusId = _data["securityStatusId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.ownership = _data["ownership"];
            this.acquisitionDate = _data["acquisitionDate"] ? new Date(_data["acquisitionDate"].toString()) : undefined as any;
            this.dispositionDate = _data["dispositionDate"] ? new Date(_data["dispositionDate"].toString()) : undefined as any;
            this.isinCusip = _data["isinCusip"];
            this.isActive = _data["isActive"];
            this.approved = _data["approved"] ? new Date(_data["approved"].toString()) : undefined as any;
            this.approvedBy = _data["approvedBy"];
            this.comment = _data["comment"];
            this.adminComment = _data["adminComment"];
            this.adminCommentModifiedBy = _data["adminCommentModifiedBy"];
            this.adminCommentModifiedDate = _data["adminCommentModifiedDate"] ? new Date(_data["adminCommentModifiedDate"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.approvedByNavigation = _data["approvedByNavigation"] ? AspNetUser.fromJS(_data["approvedByNavigation"]) : undefined as any;
            this.entity = _data["entity"] ? Entity.fromJS(_data["entity"]) : undefined as any;
            this.generalRateEntityType = _data["generalRateEntityType"] ? EntityType.fromJS(_data["generalRateEntityType"]) : undefined as any;
            this.investmentJurisdiction = _data["investmentJurisdiction"] ? InvestmentJurisdiction.fromJS(_data["investmentJurisdiction"]) : undefined as any;
            this.portfolioFolder = _data["portfolioFolder"] ? PortfolioFolder.fromJS(_data["portfolioFolder"]) : undefined as any;
            if (Array.isArray(_data["securityAudits"])) {
                this.securityAudits = [] as any;
                for (let item of _data["securityAudits"])
                    this.securityAudits!.push(SecurityAudit.fromJS(item));
            }
            if (Array.isArray(_data["securityNotifications"])) {
                this.securityNotifications = [] as any;
                for (let item of _data["securityNotifications"])
                    this.securityNotifications!.push(SecurityNotification.fromJS(item));
            }
            if (Array.isArray(_data["securityQuestionAnswers"])) {
                this.securityQuestionAnswers = [] as any;
                for (let item of _data["securityQuestionAnswers"])
                    this.securityQuestionAnswers!.push(SecurityQuestionAnswer.fromJS(item));
            }
            this.securityStatus = _data["securityStatus"] ? SecurityStatus.fromJS(_data["securityStatus"]) : undefined as any;
            if (Array.isArray(_data["securityTaxResultItems"])) {
                this.securityTaxResultItems = [] as any;
                for (let item of _data["securityTaxResultItems"])
                    this.securityTaxResultItems!.push(SecurityTaxResultItem.fromJS(item));
            }
            this.securityType = _data["securityType"] ? SecurityType.fromJS(_data["securityType"]) : undefined as any;
            this.transactionType = _data["transactionType"] ? TransactionType.fromJS(_data["transactionType"]) : undefined as any;
        }
    }

    static fromJS(data: any): Security {
        data = typeof data === 'object' ? data : {};
        let result = new Security();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityId"] = this.securityId;
        data["entityId"] = this.entityId;
        data["generalRateEntityTypeId"] = this.generalRateEntityTypeId;
        data["portfolioFolderId"] = this.portfolioFolderId;
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        data["transactionTypeId"] = this.transactionTypeId;
        data["securityTypeId"] = this.securityTypeId;
        data["securityStatusId"] = this.securityStatusId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["ownership"] = this.ownership;
        data["acquisitionDate"] = this.acquisitionDate ? this.acquisitionDate.toISOString() : undefined as any;
        data["dispositionDate"] = this.dispositionDate ? this.dispositionDate.toISOString() : undefined as any;
        data["isinCusip"] = this.isinCusip;
        data["isActive"] = this.isActive;
        data["approved"] = this.approved ? this.approved.toISOString() : undefined as any;
        data["approvedBy"] = this.approvedBy;
        data["comment"] = this.comment;
        data["adminComment"] = this.adminComment;
        data["adminCommentModifiedBy"] = this.adminCommentModifiedBy;
        data["adminCommentModifiedDate"] = this.adminCommentModifiedDate ? this.adminCommentModifiedDate.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["approvedByNavigation"] = this.approvedByNavigation ? this.approvedByNavigation.toJSON() : undefined as any;
        data["entity"] = this.entity ? this.entity.toJSON() : undefined as any;
        data["generalRateEntityType"] = this.generalRateEntityType ? this.generalRateEntityType.toJSON() : undefined as any;
        data["investmentJurisdiction"] = this.investmentJurisdiction ? this.investmentJurisdiction.toJSON() : undefined as any;
        data["portfolioFolder"] = this.portfolioFolder ? this.portfolioFolder.toJSON() : undefined as any;
        if (Array.isArray(this.securityAudits)) {
            data["securityAudits"] = [];
            for (let item of this.securityAudits)
                data["securityAudits"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.securityNotifications)) {
            data["securityNotifications"] = [];
            for (let item of this.securityNotifications)
                data["securityNotifications"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.securityQuestionAnswers)) {
            data["securityQuestionAnswers"] = [];
            for (let item of this.securityQuestionAnswers)
                data["securityQuestionAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        data["securityStatus"] = this.securityStatus ? this.securityStatus.toJSON() : undefined as any;
        if (Array.isArray(this.securityTaxResultItems)) {
            data["securityTaxResultItems"] = [];
            for (let item of this.securityTaxResultItems)
                data["securityTaxResultItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["securityType"] = this.securityType ? this.securityType.toJSON() : undefined as any;
        data["transactionType"] = this.transactionType ? this.transactionType.toJSON() : undefined as any;
        return data;
    }
}

export interface ISecurity {
    securityId?: number;
    entityId?: number;
    generalRateEntityTypeId?: number | undefined;
    portfolioFolderId?: number | undefined;
    investmentJurisdictionId?: number;
    transactionTypeId?: number;
    securityTypeId?: number;
    securityStatusId?: number;
    name?: string | undefined;
    description?: string | undefined;
    ownership?: number | undefined;
    acquisitionDate?: Date | undefined;
    dispositionDate?: Date | undefined;
    isinCusip?: string | undefined;
    isActive?: boolean;
    approved?: Date | undefined;
    approvedBy?: string | undefined;
    comment?: string | undefined;
    adminComment?: string | undefined;
    adminCommentModifiedBy?: string | undefined;
    adminCommentModifiedDate?: Date | undefined;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    approvedByNavigation?: AspNetUser;
    entity?: Entity;
    generalRateEntityType?: EntityType;
    investmentJurisdiction?: InvestmentJurisdiction;
    portfolioFolder?: PortfolioFolder;
    securityAudits?: SecurityAudit[] | undefined;
    securityNotifications?: SecurityNotification[] | undefined;
    securityQuestionAnswers?: SecurityQuestionAnswer[] | undefined;
    securityStatus?: SecurityStatus;
    securityTaxResultItems?: SecurityTaxResultItem[] | undefined;
    securityType?: SecurityType;
    transactionType?: TransactionType;
}

export class SecurityActionResult implements ISecurityActionResult {
    status?: string | undefined;
    message?: string | undefined;
    securityId?: number;

    constructor(data?: ISecurityActionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.securityId = _data["securityId"];
        }
    }

    static fromJS(data: any): SecurityActionResult {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityActionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["securityId"] = this.securityId;
        return data;
    }
}

export interface ISecurityActionResult {
    status?: string | undefined;
    message?: string | undefined;
    securityId?: number;
}

export class SecurityAudit implements ISecurityAudit {
    securityAuditId?: number;
    securityId?: number;
    description!: string;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    security?: Security;

    constructor(data?: ISecurityAudit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityAuditId = _data["securityAuditId"];
            this.securityId = _data["securityId"];
            this.description = _data["description"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.security = _data["security"] ? Security.fromJS(_data["security"]) : undefined as any;
        }
    }

    static fromJS(data: any): SecurityAudit {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityAudit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityAuditId"] = this.securityAuditId;
        data["securityId"] = this.securityId;
        data["description"] = this.description;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["security"] = this.security ? this.security.toJSON() : undefined as any;
        return data;
    }
}

export interface ISecurityAudit {
    securityAuditId?: number;
    securityId?: number;
    description: string;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    security?: Security;
}

export class SecurityAuditHistoryResponse implements ISecurityAuditHistoryResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    security?: SecurityResponseWithNestedObjectsAuditable;
    description?: string | undefined;

    constructor(data?: ISecurityAuditHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.security = _data["security"] ? SecurityResponseWithNestedObjectsAuditable.fromJS(_data["security"]) : undefined as any;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SecurityAuditHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityAuditHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["security"] = this.security ? this.security.toJSON() : undefined as any;
        data["description"] = this.description;
        return data;
    }
}

export interface ISecurityAuditHistoryResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    security?: SecurityResponseWithNestedObjectsAuditable;
    description?: string | undefined;
}

/** OData response message structure */
export class SecurityAuditHistoryResponseODataWithMetadataResponse implements ISecurityAuditHistoryResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: SecurityAuditHistoryResponse[] | undefined;

    constructor(data?: ISecurityAuditHistoryResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(SecurityAuditHistoryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurityAuditHistoryResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityAuditHistoryResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ISecurityAuditHistoryResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: SecurityAuditHistoryResponse[] | undefined;
}

export class SecurityByIdResponseWithNestedObjectsAuditable implements ISecurityByIdResponseWithNestedObjectsAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    securityId?: number;
    generalRateEntityTypeId?: number | undefined;
    generalRateEntityType?: EntityTypeNestedObjectResponse;
    entity?: EntityResponseWithNestedObjectsAuditable;
    investmentJurisdiction?: NestedInvestmentJurisdictionShortResponse;
    transactionType?: TransactionTypeNestedResponse;
    securityType?: SecurityTypeNestedObjectResponse;
    securityStatus?: SecurityStatusNestedObjectResponse;
    securityTaxResultItems?: SecurityTaxResultItemNestedObjectResponse[] | undefined;
    name?: string | undefined;
    approved?: Date | undefined;
    approvedByNavigation?: NestedUserResponse;
    comment?: string | undefined;
    description?: string | undefined;
    ownership?: number | undefined;
    isinCusip?: string | undefined;
    acquisitionDate?: Date | undefined;
    dispositionDate?: Date | undefined;
    isActive?: boolean;
    adminComment?: string | undefined;
    adminCommentModifiedBy?: string | undefined;
    adminCommentModifiedDate?: Date | undefined;
    securityQuestionAnswers?: SecurityQuestionAnswerResponse[] | undefined;

    constructor(data?: ISecurityByIdResponseWithNestedObjectsAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.securityId = _data["securityId"];
            this.generalRateEntityTypeId = _data["generalRateEntityTypeId"];
            this.generalRateEntityType = _data["generalRateEntityType"] ? EntityTypeNestedObjectResponse.fromJS(_data["generalRateEntityType"]) : undefined as any;
            this.entity = _data["entity"] ? EntityResponseWithNestedObjectsAuditable.fromJS(_data["entity"]) : undefined as any;
            this.investmentJurisdiction = _data["investmentJurisdiction"] ? NestedInvestmentJurisdictionShortResponse.fromJS(_data["investmentJurisdiction"]) : undefined as any;
            this.transactionType = _data["transactionType"] ? TransactionTypeNestedResponse.fromJS(_data["transactionType"]) : undefined as any;
            this.securityType = _data["securityType"] ? SecurityTypeNestedObjectResponse.fromJS(_data["securityType"]) : undefined as any;
            this.securityStatus = _data["securityStatus"] ? SecurityStatusNestedObjectResponse.fromJS(_data["securityStatus"]) : undefined as any;
            if (Array.isArray(_data["securityTaxResultItems"])) {
                this.securityTaxResultItems = [] as any;
                for (let item of _data["securityTaxResultItems"])
                    this.securityTaxResultItems!.push(SecurityTaxResultItemNestedObjectResponse.fromJS(item));
            }
            this.name = _data["name"];
            this.approved = _data["approved"] ? new Date(_data["approved"].toString()) : undefined as any;
            this.approvedByNavigation = _data["approvedByNavigation"] ? NestedUserResponse.fromJS(_data["approvedByNavigation"]) : undefined as any;
            this.comment = _data["comment"];
            this.description = _data["description"];
            this.ownership = _data["ownership"];
            this.isinCusip = _data["isinCusip"];
            this.acquisitionDate = _data["acquisitionDate"] ? new Date(_data["acquisitionDate"].toString()) : undefined as any;
            this.dispositionDate = _data["dispositionDate"] ? new Date(_data["dispositionDate"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.adminComment = _data["adminComment"];
            this.adminCommentModifiedBy = _data["adminCommentModifiedBy"];
            this.adminCommentModifiedDate = _data["adminCommentModifiedDate"] ? new Date(_data["adminCommentModifiedDate"].toString()) : undefined as any;
            if (Array.isArray(_data["securityQuestionAnswers"])) {
                this.securityQuestionAnswers = [] as any;
                for (let item of _data["securityQuestionAnswers"])
                    this.securityQuestionAnswers!.push(SecurityQuestionAnswerResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurityByIdResponseWithNestedObjectsAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityByIdResponseWithNestedObjectsAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["securityId"] = this.securityId;
        data["generalRateEntityTypeId"] = this.generalRateEntityTypeId;
        data["generalRateEntityType"] = this.generalRateEntityType ? this.generalRateEntityType.toJSON() : undefined as any;
        data["entity"] = this.entity ? this.entity.toJSON() : undefined as any;
        data["investmentJurisdiction"] = this.investmentJurisdiction ? this.investmentJurisdiction.toJSON() : undefined as any;
        data["transactionType"] = this.transactionType ? this.transactionType.toJSON() : undefined as any;
        data["securityType"] = this.securityType ? this.securityType.toJSON() : undefined as any;
        data["securityStatus"] = this.securityStatus ? this.securityStatus.toJSON() : undefined as any;
        if (Array.isArray(this.securityTaxResultItems)) {
            data["securityTaxResultItems"] = [];
            for (let item of this.securityTaxResultItems)
                data["securityTaxResultItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["name"] = this.name;
        data["approved"] = this.approved ? this.approved.toISOString() : undefined as any;
        data["approvedByNavigation"] = this.approvedByNavigation ? this.approvedByNavigation.toJSON() : undefined as any;
        data["comment"] = this.comment;
        data["description"] = this.description;
        data["ownership"] = this.ownership;
        data["isinCusip"] = this.isinCusip;
        data["acquisitionDate"] = this.acquisitionDate ? this.acquisitionDate.toISOString() : undefined as any;
        data["dispositionDate"] = this.dispositionDate ? this.dispositionDate.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["adminComment"] = this.adminComment;
        data["adminCommentModifiedBy"] = this.adminCommentModifiedBy;
        data["adminCommentModifiedDate"] = this.adminCommentModifiedDate ? this.adminCommentModifiedDate.toISOString() : undefined as any;
        if (Array.isArray(this.securityQuestionAnswers)) {
            data["securityQuestionAnswers"] = [];
            for (let item of this.securityQuestionAnswers)
                data["securityQuestionAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISecurityByIdResponseWithNestedObjectsAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    securityId?: number;
    generalRateEntityTypeId?: number | undefined;
    generalRateEntityType?: EntityTypeNestedObjectResponse;
    entity?: EntityResponseWithNestedObjectsAuditable;
    investmentJurisdiction?: NestedInvestmentJurisdictionShortResponse;
    transactionType?: TransactionTypeNestedResponse;
    securityType?: SecurityTypeNestedObjectResponse;
    securityStatus?: SecurityStatusNestedObjectResponse;
    securityTaxResultItems?: SecurityTaxResultItemNestedObjectResponse[] | undefined;
    name?: string | undefined;
    approved?: Date | undefined;
    approvedByNavigation?: NestedUserResponse;
    comment?: string | undefined;
    description?: string | undefined;
    ownership?: number | undefined;
    isinCusip?: string | undefined;
    acquisitionDate?: Date | undefined;
    dispositionDate?: Date | undefined;
    isActive?: boolean;
    adminComment?: string | undefined;
    adminCommentModifiedBy?: string | undefined;
    adminCommentModifiedDate?: Date | undefined;
    securityQuestionAnswers?: SecurityQuestionAnswerResponse[] | undefined;
}

export class SecurityEvaluationRequest implements ISecurityEvaluationRequest {
    transactionTypeId?: number;
    acquisitionDate?: Date | undefined;
    dispositionDate?: Date | undefined;

    constructor(data?: ISecurityEvaluationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionTypeId = _data["transactionTypeId"];
            this.acquisitionDate = _data["acquisitionDate"] ? new Date(_data["acquisitionDate"].toString()) : undefined as any;
            this.dispositionDate = _data["dispositionDate"] ? new Date(_data["dispositionDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SecurityEvaluationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityEvaluationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionTypeId"] = this.transactionTypeId;
        data["acquisitionDate"] = this.acquisitionDate ? this.acquisitionDate.toISOString() : undefined as any;
        data["dispositionDate"] = this.dispositionDate ? this.dispositionDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ISecurityEvaluationRequest {
    transactionTypeId?: number;
    acquisitionDate?: Date | undefined;
    dispositionDate?: Date | undefined;
}

export class SecurityFileImport implements ISecurityFileImport {
    securityFileImportId?: number;
    clientId?: number | undefined;
    fileImportStatusId?: number;
    dueDate?: Date | undefined;
    fileName!: string;
    history?: string | undefined;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    client?: Client;
    fileImportStatus?: FileImportStatus;

    constructor(data?: ISecurityFileImport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityFileImportId = _data["securityFileImportId"];
            this.clientId = _data["clientId"];
            this.fileImportStatusId = _data["fileImportStatusId"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.fileName = _data["fileName"];
            this.history = _data["history"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : undefined as any;
            this.fileImportStatus = _data["fileImportStatus"] ? FileImportStatus.fromJS(_data["fileImportStatus"]) : undefined as any;
        }
    }

    static fromJS(data: any): SecurityFileImport {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityFileImport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityFileImportId"] = this.securityFileImportId;
        data["clientId"] = this.clientId;
        data["fileImportStatusId"] = this.fileImportStatusId;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["fileName"] = this.fileName;
        data["history"] = this.history;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["fileImportStatus"] = this.fileImportStatus ? this.fileImportStatus.toJSON() : undefined as any;
        return data;
    }
}

export interface ISecurityFileImport {
    securityFileImportId?: number;
    clientId?: number | undefined;
    fileImportStatusId?: number;
    dueDate?: Date | undefined;
    fileName: string;
    history?: string | undefined;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    client?: Client;
    fileImportStatus?: FileImportStatus;
}

export class SecurityFileImportResponse implements ISecurityFileImportResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    securityFileImportId?: number;
    clientId?: number;
    fileName?: string | undefined;
    history?: string | undefined;
    fileImportStatus?: FileImportStatusResponse;

    constructor(data?: ISecurityFileImportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.securityFileImportId = _data["securityFileImportId"];
            this.clientId = _data["clientId"];
            this.fileName = _data["fileName"];
            this.history = _data["history"];
            this.fileImportStatus = _data["fileImportStatus"] ? FileImportStatusResponse.fromJS(_data["fileImportStatus"]) : undefined as any;
        }
    }

    static fromJS(data: any): SecurityFileImportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityFileImportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["securityFileImportId"] = this.securityFileImportId;
        data["clientId"] = this.clientId;
        data["fileName"] = this.fileName;
        data["history"] = this.history;
        data["fileImportStatus"] = this.fileImportStatus ? this.fileImportStatus.toJSON() : undefined as any;
        return data;
    }
}

export interface ISecurityFileImportResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    securityFileImportId?: number;
    clientId?: number;
    fileName?: string | undefined;
    history?: string | undefined;
    fileImportStatus?: FileImportStatusResponse;
}

/** OData response message structure */
export class SecurityFileImportResponseODataWithMetadataResponse implements ISecurityFileImportResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: SecurityFileImportResponse[] | undefined;

    constructor(data?: ISecurityFileImportResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(SecurityFileImportResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurityFileImportResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityFileImportResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ISecurityFileImportResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: SecurityFileImportResponse[] | undefined;
}

export class SecurityFilterRequest implements ISecurityFilterRequest {
    entityId?: number | undefined;
    entityTypeId?: number | undefined;
    investmentJurisdictionId?: number | undefined;
    transactionTypeId?: number | undefined;
    securityTypeId?: number | undefined;
    securityStatusId?: number | undefined;
    nameDescription?: string | undefined;
    acquisitionDateFrom?: Date | undefined;
    acquisitionDateTo?: Date | undefined;
    dispositionDateFrom?: Date | undefined;
    dispositionDateTo?: Date | undefined;
    withholdingTaxFrom?: number | undefined;
    withholdingTaxTo?: number | undefined;
    capitalGainsFrom?: number | undefined;
    capitalGainsTo?: number | undefined;

    constructor(data?: ISecurityFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.entityTypeId = _data["entityTypeId"];
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
            this.transactionTypeId = _data["transactionTypeId"];
            this.securityTypeId = _data["securityTypeId"];
            this.securityStatusId = _data["securityStatusId"];
            this.nameDescription = _data["nameDescription"];
            this.acquisitionDateFrom = _data["acquisitionDateFrom"] ? new Date(_data["acquisitionDateFrom"].toString()) : undefined as any;
            this.acquisitionDateTo = _data["acquisitionDateTo"] ? new Date(_data["acquisitionDateTo"].toString()) : undefined as any;
            this.dispositionDateFrom = _data["dispositionDateFrom"] ? new Date(_data["dispositionDateFrom"].toString()) : undefined as any;
            this.dispositionDateTo = _data["dispositionDateTo"] ? new Date(_data["dispositionDateTo"].toString()) : undefined as any;
            this.withholdingTaxFrom = _data["withholdingTaxFrom"];
            this.withholdingTaxTo = _data["withholdingTaxTo"];
            this.capitalGainsFrom = _data["capitalGainsFrom"];
            this.capitalGainsTo = _data["capitalGainsTo"];
        }
    }

    static fromJS(data: any): SecurityFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["entityTypeId"] = this.entityTypeId;
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        data["transactionTypeId"] = this.transactionTypeId;
        data["securityTypeId"] = this.securityTypeId;
        data["securityStatusId"] = this.securityStatusId;
        data["nameDescription"] = this.nameDescription;
        data["acquisitionDateFrom"] = this.acquisitionDateFrom ? this.acquisitionDateFrom.toISOString() : undefined as any;
        data["acquisitionDateTo"] = this.acquisitionDateTo ? this.acquisitionDateTo.toISOString() : undefined as any;
        data["dispositionDateFrom"] = this.dispositionDateFrom ? this.dispositionDateFrom.toISOString() : undefined as any;
        data["dispositionDateTo"] = this.dispositionDateTo ? this.dispositionDateTo.toISOString() : undefined as any;
        data["withholdingTaxFrom"] = this.withholdingTaxFrom;
        data["withholdingTaxTo"] = this.withholdingTaxTo;
        data["capitalGainsFrom"] = this.capitalGainsFrom;
        data["capitalGainsTo"] = this.capitalGainsTo;
        return data;
    }
}

export interface ISecurityFilterRequest {
    entityId?: number | undefined;
    entityTypeId?: number | undefined;
    investmentJurisdictionId?: number | undefined;
    transactionTypeId?: number | undefined;
    securityTypeId?: number | undefined;
    securityStatusId?: number | undefined;
    nameDescription?: string | undefined;
    acquisitionDateFrom?: Date | undefined;
    acquisitionDateTo?: Date | undefined;
    dispositionDateFrom?: Date | undefined;
    dispositionDateTo?: Date | undefined;
    withholdingTaxFrom?: number | undefined;
    withholdingTaxTo?: number | undefined;
    capitalGainsFrom?: number | undefined;
    capitalGainsTo?: number | undefined;
}

export class SecurityNotification implements ISecurityNotification {
    securityNotificationId?: number;
    securityId?: number;
    userId!: string;
    securityNotificationTypeId?: number;
    isNotified?: boolean;
    description!: string;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    security?: Security;
    securityNotificationType?: SecurityNotificationType;
    user?: AspNetUser;

    constructor(data?: ISecurityNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityNotificationId = _data["securityNotificationId"];
            this.securityId = _data["securityId"];
            this.userId = _data["userId"];
            this.securityNotificationTypeId = _data["securityNotificationTypeId"];
            this.isNotified = _data["isNotified"];
            this.description = _data["description"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.security = _data["security"] ? Security.fromJS(_data["security"]) : undefined as any;
            this.securityNotificationType = _data["securityNotificationType"] ? SecurityNotificationType.fromJS(_data["securityNotificationType"]) : undefined as any;
            this.user = _data["user"] ? AspNetUser.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): SecurityNotification {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityNotificationId"] = this.securityNotificationId;
        data["securityId"] = this.securityId;
        data["userId"] = this.userId;
        data["securityNotificationTypeId"] = this.securityNotificationTypeId;
        data["isNotified"] = this.isNotified;
        data["description"] = this.description;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["security"] = this.security ? this.security.toJSON() : undefined as any;
        data["securityNotificationType"] = this.securityNotificationType ? this.securityNotificationType.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface ISecurityNotification {
    securityNotificationId?: number;
    securityId?: number;
    userId: string;
    securityNotificationTypeId?: number;
    isNotified?: boolean;
    description: string;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    security?: Security;
    securityNotificationType?: SecurityNotificationType;
    user?: AspNetUser;
}

export class SecurityNotificationType implements ISecurityNotificationType {
    securityNotificationTypeId?: number;
    name!: string;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    securityNotifications?: SecurityNotification[] | undefined;

    constructor(data?: ISecurityNotificationType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityNotificationTypeId = _data["securityNotificationTypeId"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["securityNotifications"])) {
                this.securityNotifications = [] as any;
                for (let item of _data["securityNotifications"])
                    this.securityNotifications!.push(SecurityNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurityNotificationType {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityNotificationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityNotificationTypeId"] = this.securityNotificationTypeId;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.securityNotifications)) {
            data["securityNotifications"] = [];
            for (let item of this.securityNotifications)
                data["securityNotifications"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISecurityNotificationType {
    securityNotificationTypeId?: number;
    name: string;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    securityNotifications?: SecurityNotification[] | undefined;
}

export class SecurityNotificationTypeResponse implements ISecurityNotificationTypeResponse {
    securityNotificationTypeId?: number;
    name?: string | undefined;

    constructor(data?: ISecurityNotificationTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityNotificationTypeId = _data["securityNotificationTypeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SecurityNotificationTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityNotificationTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityNotificationTypeId"] = this.securityNotificationTypeId;
        data["name"] = this.name;
        return data;
    }
}

export interface ISecurityNotificationTypeResponse {
    securityNotificationTypeId?: number;
    name?: string | undefined;
}

export class SecurityNotifictionResponseAuditable implements ISecurityNotifictionResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    securityNotificationId?: number;
    security?: SecurityResponseWithNestedObjectsAuditable;
    userId?: string | undefined;
    securityNotificationType?: SecurityNotificationTypeResponse;
    isNotified?: boolean;
    description?: string | undefined;

    constructor(data?: ISecurityNotifictionResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.securityNotificationId = _data["securityNotificationId"];
            this.security = _data["security"] ? SecurityResponseWithNestedObjectsAuditable.fromJS(_data["security"]) : undefined as any;
            this.userId = _data["userId"];
            this.securityNotificationType = _data["securityNotificationType"] ? SecurityNotificationTypeResponse.fromJS(_data["securityNotificationType"]) : undefined as any;
            this.isNotified = _data["isNotified"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SecurityNotifictionResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityNotifictionResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["securityNotificationId"] = this.securityNotificationId;
        data["security"] = this.security ? this.security.toJSON() : undefined as any;
        data["userId"] = this.userId;
        data["securityNotificationType"] = this.securityNotificationType ? this.securityNotificationType.toJSON() : undefined as any;
        data["isNotified"] = this.isNotified;
        data["description"] = this.description;
        return data;
    }
}

export interface ISecurityNotifictionResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    securityNotificationId?: number;
    security?: SecurityResponseWithNestedObjectsAuditable;
    userId?: string | undefined;
    securityNotificationType?: SecurityNotificationTypeResponse;
    isNotified?: boolean;
    description?: string | undefined;
}

/** OData response message structure */
export class SecurityNotifictionResponseAuditableODataWithMetadataResponse implements ISecurityNotifictionResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: SecurityNotifictionResponseAuditable[] | undefined;

    constructor(data?: ISecurityNotifictionResponseAuditableODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(SecurityNotifictionResponseAuditable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurityNotifictionResponseAuditableODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityNotifictionResponseAuditableODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ISecurityNotifictionResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: SecurityNotifictionResponseAuditable[] | undefined;
}

export class SecurityQuestionAnswer implements ISecurityQuestionAnswer {
    securityQuestionAnswerId?: number;
    taxPolicyId?: number;
    taxRuleId?: number;
    questionId?: number;
    securityId?: number;
    text!: string;
    comment?: string | undefined;
    unsureAnswer?: boolean;
    isActive!: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    question?: Question;
    security?: Security;
    taxPolicy?: TaxPolicy;
    taxRule?: TaxRule;

    constructor(data?: ISecurityQuestionAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityQuestionAnswerId = _data["securityQuestionAnswerId"];
            this.taxPolicyId = _data["taxPolicyId"];
            this.taxRuleId = _data["taxRuleId"];
            this.questionId = _data["questionId"];
            this.securityId = _data["securityId"];
            this.text = _data["text"];
            this.comment = _data["comment"];
            this.unsureAnswer = _data["unsureAnswer"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.question = _data["question"] ? Question.fromJS(_data["question"]) : undefined as any;
            this.security = _data["security"] ? Security.fromJS(_data["security"]) : undefined as any;
            this.taxPolicy = _data["taxPolicy"] ? TaxPolicy.fromJS(_data["taxPolicy"]) : undefined as any;
            this.taxRule = _data["taxRule"] ? TaxRule.fromJS(_data["taxRule"]) : undefined as any;
        }
    }

    static fromJS(data: any): SecurityQuestionAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityQuestionAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityQuestionAnswerId"] = this.securityQuestionAnswerId;
        data["taxPolicyId"] = this.taxPolicyId;
        data["taxRuleId"] = this.taxRuleId;
        data["questionId"] = this.questionId;
        data["securityId"] = this.securityId;
        data["text"] = this.text;
        data["comment"] = this.comment;
        data["unsureAnswer"] = this.unsureAnswer;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["question"] = this.question ? this.question.toJSON() : undefined as any;
        data["security"] = this.security ? this.security.toJSON() : undefined as any;
        data["taxPolicy"] = this.taxPolicy ? this.taxPolicy.toJSON() : undefined as any;
        data["taxRule"] = this.taxRule ? this.taxRule.toJSON() : undefined as any;
        return data;
    }
}

export interface ISecurityQuestionAnswer {
    securityQuestionAnswerId?: number;
    taxPolicyId?: number;
    taxRuleId?: number;
    questionId?: number;
    securityId?: number;
    text: string;
    comment?: string | undefined;
    unsureAnswer?: boolean;
    isActive: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    question?: Question;
    security?: Security;
    taxPolicy?: TaxPolicy;
    taxRule?: TaxRule;
}

export class SecurityQuestionAnswerAuditableResponse implements ISecurityQuestionAnswerAuditableResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    question?: QuestionForSecurityReviewResponse;
    taxPolicy?: TaxPolicyForSecurityReviewResponse;
    taxRuleId?: number;
    text?: string | undefined;
    comment?: string | undefined;
    unsureAnswer?: boolean;
    isActive?: boolean | undefined;

    constructor(data?: ISecurityQuestionAnswerAuditableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.question = _data["question"] ? QuestionForSecurityReviewResponse.fromJS(_data["question"]) : undefined as any;
            this.taxPolicy = _data["taxPolicy"] ? TaxPolicyForSecurityReviewResponse.fromJS(_data["taxPolicy"]) : undefined as any;
            this.taxRuleId = _data["taxRuleId"];
            this.text = _data["text"];
            this.comment = _data["comment"];
            this.unsureAnswer = _data["unsureAnswer"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SecurityQuestionAnswerAuditableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityQuestionAnswerAuditableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["question"] = this.question ? this.question.toJSON() : undefined as any;
        data["taxPolicy"] = this.taxPolicy ? this.taxPolicy.toJSON() : undefined as any;
        data["taxRuleId"] = this.taxRuleId;
        data["text"] = this.text;
        data["comment"] = this.comment;
        data["unsureAnswer"] = this.unsureAnswer;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISecurityQuestionAnswerAuditableResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    question?: QuestionForSecurityReviewResponse;
    taxPolicy?: TaxPolicyForSecurityReviewResponse;
    taxRuleId?: number;
    text?: string | undefined;
    comment?: string | undefined;
    unsureAnswer?: boolean;
    isActive?: boolean | undefined;
}

export class SecurityQuestionAnswerResponse implements ISecurityQuestionAnswerResponse {
    securityQuestionAnswerId?: number;
    questionId?: number;
    taxPolicyId?: number;
    taxRuleId?: number;
    text?: string | undefined;
    comment?: string | undefined;
    unsureAnswer?: boolean;
    isActive?: boolean | undefined;

    constructor(data?: ISecurityQuestionAnswerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityQuestionAnswerId = _data["securityQuestionAnswerId"];
            this.questionId = _data["questionId"];
            this.taxPolicyId = _data["taxPolicyId"];
            this.taxRuleId = _data["taxRuleId"];
            this.text = _data["text"];
            this.comment = _data["comment"];
            this.unsureAnswer = _data["unsureAnswer"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SecurityQuestionAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityQuestionAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityQuestionAnswerId"] = this.securityQuestionAnswerId;
        data["questionId"] = this.questionId;
        data["taxPolicyId"] = this.taxPolicyId;
        data["taxRuleId"] = this.taxRuleId;
        data["text"] = this.text;
        data["comment"] = this.comment;
        data["unsureAnswer"] = this.unsureAnswer;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISecurityQuestionAnswerResponse {
    securityQuestionAnswerId?: number;
    questionId?: number;
    taxPolicyId?: number;
    taxRuleId?: number;
    text?: string | undefined;
    comment?: string | undefined;
    unsureAnswer?: boolean;
    isActive?: boolean | undefined;
}

export class SecurityQuestionAnswerWithNestedObjectsResponse implements ISecurityQuestionAnswerWithNestedObjectsResponse {
    securityId?: number;
    question?: QuestionResponseWithNestedObjectsResponseAuditable;
    text?: string | undefined;
    comment?: string | undefined;
    unsureAnswer?: boolean;
    isActive?: boolean | undefined;
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;

    constructor(data?: ISecurityQuestionAnswerWithNestedObjectsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityId = _data["securityId"];
            this.question = _data["question"] ? QuestionResponseWithNestedObjectsResponseAuditable.fromJS(_data["question"]) : undefined as any;
            this.text = _data["text"];
            this.comment = _data["comment"];
            this.unsureAnswer = _data["unsureAnswer"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): SecurityQuestionAnswerWithNestedObjectsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityQuestionAnswerWithNestedObjectsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityId"] = this.securityId;
        data["question"] = this.question ? this.question.toJSON() : undefined as any;
        data["text"] = this.text;
        data["comment"] = this.comment;
        data["unsureAnswer"] = this.unsureAnswer;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface ISecurityQuestionAnswerWithNestedObjectsResponse {
    securityId?: number;
    question?: QuestionResponseWithNestedObjectsResponseAuditable;
    text?: string | undefined;
    comment?: string | undefined;
    unsureAnswer?: boolean;
    isActive?: boolean | undefined;
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
}

/** OData response message structure */
export class SecurityQuestionAnswerWithNestedObjectsResponseODataWithMetadataResponse implements ISecurityQuestionAnswerWithNestedObjectsResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: SecurityQuestionAnswerWithNestedObjectsResponse[] | undefined;

    constructor(data?: ISecurityQuestionAnswerWithNestedObjectsResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(SecurityQuestionAnswerWithNestedObjectsResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurityQuestionAnswerWithNestedObjectsResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityQuestionAnswerWithNestedObjectsResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ISecurityQuestionAnswerWithNestedObjectsResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: SecurityQuestionAnswerWithNestedObjectsResponse[] | undefined;
}

export class SecurityResponseAuditable implements ISecurityResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    securityId?: number;
    entityId?: number;
    generalRateEntityTypeId?: number | undefined;
    investmentJurisdictionId?: number;
    transactionTypeId?: number;
    securityTypeId?: number;
    securityStatusId?: number;
    name?: string | undefined;
    description?: string | undefined;
    ownership?: number | undefined;
    isinCusip?: string | undefined;
    acquisitionDate?: Date | undefined;
    dispositionDate?: Date | undefined;
    isActive?: boolean;
    adminComment?: string | undefined;
    adminCommentModifiedBy?: string | undefined;
    adminCommentModifiedDate?: Date | undefined;

    constructor(data?: ISecurityResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.securityId = _data["securityId"];
            this.entityId = _data["entityId"];
            this.generalRateEntityTypeId = _data["generalRateEntityTypeId"];
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
            this.transactionTypeId = _data["transactionTypeId"];
            this.securityTypeId = _data["securityTypeId"];
            this.securityStatusId = _data["securityStatusId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.ownership = _data["ownership"];
            this.isinCusip = _data["isinCusip"];
            this.acquisitionDate = _data["acquisitionDate"] ? new Date(_data["acquisitionDate"].toString()) : undefined as any;
            this.dispositionDate = _data["dispositionDate"] ? new Date(_data["dispositionDate"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.adminComment = _data["adminComment"];
            this.adminCommentModifiedBy = _data["adminCommentModifiedBy"];
            this.adminCommentModifiedDate = _data["adminCommentModifiedDate"] ? new Date(_data["adminCommentModifiedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SecurityResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["securityId"] = this.securityId;
        data["entityId"] = this.entityId;
        data["generalRateEntityTypeId"] = this.generalRateEntityTypeId;
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        data["transactionTypeId"] = this.transactionTypeId;
        data["securityTypeId"] = this.securityTypeId;
        data["securityStatusId"] = this.securityStatusId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["ownership"] = this.ownership;
        data["isinCusip"] = this.isinCusip;
        data["acquisitionDate"] = this.acquisitionDate ? this.acquisitionDate.toISOString() : undefined as any;
        data["dispositionDate"] = this.dispositionDate ? this.dispositionDate.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["adminComment"] = this.adminComment;
        data["adminCommentModifiedBy"] = this.adminCommentModifiedBy;
        data["adminCommentModifiedDate"] = this.adminCommentModifiedDate ? this.adminCommentModifiedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ISecurityResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    securityId?: number;
    entityId?: number;
    generalRateEntityTypeId?: number | undefined;
    investmentJurisdictionId?: number;
    transactionTypeId?: number;
    securityTypeId?: number;
    securityStatusId?: number;
    name?: string | undefined;
    description?: string | undefined;
    ownership?: number | undefined;
    isinCusip?: string | undefined;
    acquisitionDate?: Date | undefined;
    dispositionDate?: Date | undefined;
    isActive?: boolean;
    adminComment?: string | undefined;
    adminCommentModifiedBy?: string | undefined;
    adminCommentModifiedDate?: Date | undefined;
}

export class SecurityResponseWithNestedObjectsAuditable implements ISecurityResponseWithNestedObjectsAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    securityId?: number;
    generalRateEntityTypeId?: number | undefined;
    generalRateEntityType?: EntityTypeNestedObjectResponse;
    entity?: EntityResponseWithNestedObjectsAuditable;
    investmentJurisdiction?: NestedInvestmentJurisdictionShortResponse;
    transactionType?: TransactionTypeNestedResponse;
    securityType?: SecurityTypeNestedObjectResponse;
    securityStatus?: SecurityStatusNestedObjectResponse;
    securityTaxResultItems?: SecurityTaxResultItemNestedObjectResponse[] | undefined;
    name?: string | undefined;
    approved?: Date | undefined;
    approvedByNavigation?: NestedUserResponse;
    comment?: string | undefined;
    description?: string | undefined;
    ownership?: number | undefined;
    isinCusip?: string | undefined;
    acquisitionDate?: Date | undefined;
    dispositionDate?: Date | undefined;
    isActive?: boolean;
    adminComment?: string | undefined;
    adminCommentModifiedBy?: string | undefined;
    adminCommentModifiedDate?: Date | undefined;

    constructor(data?: ISecurityResponseWithNestedObjectsAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.securityId = _data["securityId"];
            this.generalRateEntityTypeId = _data["generalRateEntityTypeId"];
            this.generalRateEntityType = _data["generalRateEntityType"] ? EntityTypeNestedObjectResponse.fromJS(_data["generalRateEntityType"]) : undefined as any;
            this.entity = _data["entity"] ? EntityResponseWithNestedObjectsAuditable.fromJS(_data["entity"]) : undefined as any;
            this.investmentJurisdiction = _data["investmentJurisdiction"] ? NestedInvestmentJurisdictionShortResponse.fromJS(_data["investmentJurisdiction"]) : undefined as any;
            this.transactionType = _data["transactionType"] ? TransactionTypeNestedResponse.fromJS(_data["transactionType"]) : undefined as any;
            this.securityType = _data["securityType"] ? SecurityTypeNestedObjectResponse.fromJS(_data["securityType"]) : undefined as any;
            this.securityStatus = _data["securityStatus"] ? SecurityStatusNestedObjectResponse.fromJS(_data["securityStatus"]) : undefined as any;
            if (Array.isArray(_data["securityTaxResultItems"])) {
                this.securityTaxResultItems = [] as any;
                for (let item of _data["securityTaxResultItems"])
                    this.securityTaxResultItems!.push(SecurityTaxResultItemNestedObjectResponse.fromJS(item));
            }
            this.name = _data["name"];
            this.approved = _data["approved"] ? new Date(_data["approved"].toString()) : undefined as any;
            this.approvedByNavigation = _data["approvedByNavigation"] ? NestedUserResponse.fromJS(_data["approvedByNavigation"]) : undefined as any;
            this.comment = _data["comment"];
            this.description = _data["description"];
            this.ownership = _data["ownership"];
            this.isinCusip = _data["isinCusip"];
            this.acquisitionDate = _data["acquisitionDate"] ? new Date(_data["acquisitionDate"].toString()) : undefined as any;
            this.dispositionDate = _data["dispositionDate"] ? new Date(_data["dispositionDate"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.adminComment = _data["adminComment"];
            this.adminCommentModifiedBy = _data["adminCommentModifiedBy"];
            this.adminCommentModifiedDate = _data["adminCommentModifiedDate"] ? new Date(_data["adminCommentModifiedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SecurityResponseWithNestedObjectsAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityResponseWithNestedObjectsAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["securityId"] = this.securityId;
        data["generalRateEntityTypeId"] = this.generalRateEntityTypeId;
        data["generalRateEntityType"] = this.generalRateEntityType ? this.generalRateEntityType.toJSON() : undefined as any;
        data["entity"] = this.entity ? this.entity.toJSON() : undefined as any;
        data["investmentJurisdiction"] = this.investmentJurisdiction ? this.investmentJurisdiction.toJSON() : undefined as any;
        data["transactionType"] = this.transactionType ? this.transactionType.toJSON() : undefined as any;
        data["securityType"] = this.securityType ? this.securityType.toJSON() : undefined as any;
        data["securityStatus"] = this.securityStatus ? this.securityStatus.toJSON() : undefined as any;
        if (Array.isArray(this.securityTaxResultItems)) {
            data["securityTaxResultItems"] = [];
            for (let item of this.securityTaxResultItems)
                data["securityTaxResultItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["name"] = this.name;
        data["approved"] = this.approved ? this.approved.toISOString() : undefined as any;
        data["approvedByNavigation"] = this.approvedByNavigation ? this.approvedByNavigation.toJSON() : undefined as any;
        data["comment"] = this.comment;
        data["description"] = this.description;
        data["ownership"] = this.ownership;
        data["isinCusip"] = this.isinCusip;
        data["acquisitionDate"] = this.acquisitionDate ? this.acquisitionDate.toISOString() : undefined as any;
        data["dispositionDate"] = this.dispositionDate ? this.dispositionDate.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["adminComment"] = this.adminComment;
        data["adminCommentModifiedBy"] = this.adminCommentModifiedBy;
        data["adminCommentModifiedDate"] = this.adminCommentModifiedDate ? this.adminCommentModifiedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ISecurityResponseWithNestedObjectsAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    securityId?: number;
    generalRateEntityTypeId?: number | undefined;
    generalRateEntityType?: EntityTypeNestedObjectResponse;
    entity?: EntityResponseWithNestedObjectsAuditable;
    investmentJurisdiction?: NestedInvestmentJurisdictionShortResponse;
    transactionType?: TransactionTypeNestedResponse;
    securityType?: SecurityTypeNestedObjectResponse;
    securityStatus?: SecurityStatusNestedObjectResponse;
    securityTaxResultItems?: SecurityTaxResultItemNestedObjectResponse[] | undefined;
    name?: string | undefined;
    approved?: Date | undefined;
    approvedByNavigation?: NestedUserResponse;
    comment?: string | undefined;
    description?: string | undefined;
    ownership?: number | undefined;
    isinCusip?: string | undefined;
    acquisitionDate?: Date | undefined;
    dispositionDate?: Date | undefined;
    isActive?: boolean;
    adminComment?: string | undefined;
    adminCommentModifiedBy?: string | undefined;
    adminCommentModifiedDate?: Date | undefined;
}

/** OData response message structure */
export class SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse implements ISecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: SecurityResponseWithNestedObjectsAuditable[] | undefined;

    constructor(data?: ISecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(SecurityResponseWithNestedObjectsAuditable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ISecurityResponseWithNestedObjectsAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: SecurityResponseWithNestedObjectsAuditable[] | undefined;
}

export class SecurityReviewResponseWithAnswersAndNestedObjects implements ISecurityReviewResponseWithAnswersAndNestedObjects {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    securityId?: number;
    generalRateEntityTypeId?: number | undefined;
    generalRateEntityType?: EntityTypeNestedObjectResponse;
    entity?: EntityResponseWithNestedObjectsAuditable;
    investmentJurisdiction?: NestedInvestmentJurisdictionShortResponse;
    transactionType?: TransactionTypeNestedResponse;
    securityType?: SecurityTypeNestedObjectResponse;
    securityStatus?: SecurityStatusNestedObjectResponse;
    securityTaxResultItems?: SecurityReviewTaxResultItemNestedObjectResponse[] | undefined;
    name?: string | undefined;
    comment?: string | undefined;
    description?: string | undefined;
    ownership?: number | undefined;
    isinCusip?: string | undefined;
    acquisitionDate?: Date | undefined;
    dispositionDate?: Date | undefined;
    isActive?: boolean;
    adminComment?: string | undefined;
    adminCommentModifiedBy?: string | undefined;
    adminCommentModifiedDate?: Date | undefined;
    securityQuestionAnswers?: SecurityQuestionAnswerAuditableResponse[] | undefined;

    constructor(data?: ISecurityReviewResponseWithAnswersAndNestedObjects) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.securityId = _data["securityId"];
            this.generalRateEntityTypeId = _data["generalRateEntityTypeId"];
            this.generalRateEntityType = _data["generalRateEntityType"] ? EntityTypeNestedObjectResponse.fromJS(_data["generalRateEntityType"]) : undefined as any;
            this.entity = _data["entity"] ? EntityResponseWithNestedObjectsAuditable.fromJS(_data["entity"]) : undefined as any;
            this.investmentJurisdiction = _data["investmentJurisdiction"] ? NestedInvestmentJurisdictionShortResponse.fromJS(_data["investmentJurisdiction"]) : undefined as any;
            this.transactionType = _data["transactionType"] ? TransactionTypeNestedResponse.fromJS(_data["transactionType"]) : undefined as any;
            this.securityType = _data["securityType"] ? SecurityTypeNestedObjectResponse.fromJS(_data["securityType"]) : undefined as any;
            this.securityStatus = _data["securityStatus"] ? SecurityStatusNestedObjectResponse.fromJS(_data["securityStatus"]) : undefined as any;
            if (Array.isArray(_data["securityTaxResultItems"])) {
                this.securityTaxResultItems = [] as any;
                for (let item of _data["securityTaxResultItems"])
                    this.securityTaxResultItems!.push(SecurityReviewTaxResultItemNestedObjectResponse.fromJS(item));
            }
            this.name = _data["name"];
            this.comment = _data["comment"];
            this.description = _data["description"];
            this.ownership = _data["ownership"];
            this.isinCusip = _data["isinCusip"];
            this.acquisitionDate = _data["acquisitionDate"] ? new Date(_data["acquisitionDate"].toString()) : undefined as any;
            this.dispositionDate = _data["dispositionDate"] ? new Date(_data["dispositionDate"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.adminComment = _data["adminComment"];
            this.adminCommentModifiedBy = _data["adminCommentModifiedBy"];
            this.adminCommentModifiedDate = _data["adminCommentModifiedDate"] ? new Date(_data["adminCommentModifiedDate"].toString()) : undefined as any;
            if (Array.isArray(_data["securityQuestionAnswers"])) {
                this.securityQuestionAnswers = [] as any;
                for (let item of _data["securityQuestionAnswers"])
                    this.securityQuestionAnswers!.push(SecurityQuestionAnswerAuditableResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurityReviewResponseWithAnswersAndNestedObjects {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityReviewResponseWithAnswersAndNestedObjects();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["securityId"] = this.securityId;
        data["generalRateEntityTypeId"] = this.generalRateEntityTypeId;
        data["generalRateEntityType"] = this.generalRateEntityType ? this.generalRateEntityType.toJSON() : undefined as any;
        data["entity"] = this.entity ? this.entity.toJSON() : undefined as any;
        data["investmentJurisdiction"] = this.investmentJurisdiction ? this.investmentJurisdiction.toJSON() : undefined as any;
        data["transactionType"] = this.transactionType ? this.transactionType.toJSON() : undefined as any;
        data["securityType"] = this.securityType ? this.securityType.toJSON() : undefined as any;
        data["securityStatus"] = this.securityStatus ? this.securityStatus.toJSON() : undefined as any;
        if (Array.isArray(this.securityTaxResultItems)) {
            data["securityTaxResultItems"] = [];
            for (let item of this.securityTaxResultItems)
                data["securityTaxResultItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["description"] = this.description;
        data["ownership"] = this.ownership;
        data["isinCusip"] = this.isinCusip;
        data["acquisitionDate"] = this.acquisitionDate ? this.acquisitionDate.toISOString() : undefined as any;
        data["dispositionDate"] = this.dispositionDate ? this.dispositionDate.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["adminComment"] = this.adminComment;
        data["adminCommentModifiedBy"] = this.adminCommentModifiedBy;
        data["adminCommentModifiedDate"] = this.adminCommentModifiedDate ? this.adminCommentModifiedDate.toISOString() : undefined as any;
        if (Array.isArray(this.securityQuestionAnswers)) {
            data["securityQuestionAnswers"] = [];
            for (let item of this.securityQuestionAnswers)
                data["securityQuestionAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISecurityReviewResponseWithAnswersAndNestedObjects {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    securityId?: number;
    generalRateEntityTypeId?: number | undefined;
    generalRateEntityType?: EntityTypeNestedObjectResponse;
    entity?: EntityResponseWithNestedObjectsAuditable;
    investmentJurisdiction?: NestedInvestmentJurisdictionShortResponse;
    transactionType?: TransactionTypeNestedResponse;
    securityType?: SecurityTypeNestedObjectResponse;
    securityStatus?: SecurityStatusNestedObjectResponse;
    securityTaxResultItems?: SecurityReviewTaxResultItemNestedObjectResponse[] | undefined;
    name?: string | undefined;
    comment?: string | undefined;
    description?: string | undefined;
    ownership?: number | undefined;
    isinCusip?: string | undefined;
    acquisitionDate?: Date | undefined;
    dispositionDate?: Date | undefined;
    isActive?: boolean;
    adminComment?: string | undefined;
    adminCommentModifiedBy?: string | undefined;
    adminCommentModifiedDate?: Date | undefined;
    securityQuestionAnswers?: SecurityQuestionAnswerAuditableResponse[] | undefined;
}

/** OData response message structure */
export class SecurityReviewResponseWithAnswersAndNestedObjectsODataWithMetadataResponse implements ISecurityReviewResponseWithAnswersAndNestedObjectsODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: SecurityReviewResponseWithAnswersAndNestedObjects[] | undefined;

    constructor(data?: ISecurityReviewResponseWithAnswersAndNestedObjectsODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(SecurityReviewResponseWithAnswersAndNestedObjects.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurityReviewResponseWithAnswersAndNestedObjectsODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityReviewResponseWithAnswersAndNestedObjectsODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ISecurityReviewResponseWithAnswersAndNestedObjectsODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: SecurityReviewResponseWithAnswersAndNestedObjects[] | undefined;
}

export class SecurityReviewResponseWithNestedObjectsAuditable implements ISecurityReviewResponseWithNestedObjectsAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    securityId?: number;
    generalRateEntityTypeId?: number | undefined;
    generalRateEntityType?: EntityTypeNestedObjectResponse;
    entity?: EntityResponseWithNestedObjectsAuditable;
    investmentJurisdiction?: NestedInvestmentJurisdictionShortResponse;
    transactionType?: TransactionTypeNestedResponse;
    securityType?: SecurityTypeNestedObjectResponse;
    securityStatus?: SecurityStatusNestedObjectResponse;
    securityTaxResultItems?: SecurityReviewTaxResultItemNestedObjectResponse[] | undefined;
    name?: string | undefined;
    comment?: string | undefined;
    description?: string | undefined;
    ownership?: number | undefined;
    isinCusip?: string | undefined;
    acquisitionDate?: Date | undefined;
    dispositionDate?: Date | undefined;
    isActive?: boolean;
    adminComment?: string | undefined;
    adminCommentModifiedBy?: string | undefined;
    adminCommentModifiedDate?: Date | undefined;

    constructor(data?: ISecurityReviewResponseWithNestedObjectsAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.securityId = _data["securityId"];
            this.generalRateEntityTypeId = _data["generalRateEntityTypeId"];
            this.generalRateEntityType = _data["generalRateEntityType"] ? EntityTypeNestedObjectResponse.fromJS(_data["generalRateEntityType"]) : undefined as any;
            this.entity = _data["entity"] ? EntityResponseWithNestedObjectsAuditable.fromJS(_data["entity"]) : undefined as any;
            this.investmentJurisdiction = _data["investmentJurisdiction"] ? NestedInvestmentJurisdictionShortResponse.fromJS(_data["investmentJurisdiction"]) : undefined as any;
            this.transactionType = _data["transactionType"] ? TransactionTypeNestedResponse.fromJS(_data["transactionType"]) : undefined as any;
            this.securityType = _data["securityType"] ? SecurityTypeNestedObjectResponse.fromJS(_data["securityType"]) : undefined as any;
            this.securityStatus = _data["securityStatus"] ? SecurityStatusNestedObjectResponse.fromJS(_data["securityStatus"]) : undefined as any;
            if (Array.isArray(_data["securityTaxResultItems"])) {
                this.securityTaxResultItems = [] as any;
                for (let item of _data["securityTaxResultItems"])
                    this.securityTaxResultItems!.push(SecurityReviewTaxResultItemNestedObjectResponse.fromJS(item));
            }
            this.name = _data["name"];
            this.comment = _data["comment"];
            this.description = _data["description"];
            this.ownership = _data["ownership"];
            this.isinCusip = _data["isinCusip"];
            this.acquisitionDate = _data["acquisitionDate"] ? new Date(_data["acquisitionDate"].toString()) : undefined as any;
            this.dispositionDate = _data["dispositionDate"] ? new Date(_data["dispositionDate"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.adminComment = _data["adminComment"];
            this.adminCommentModifiedBy = _data["adminCommentModifiedBy"];
            this.adminCommentModifiedDate = _data["adminCommentModifiedDate"] ? new Date(_data["adminCommentModifiedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SecurityReviewResponseWithNestedObjectsAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityReviewResponseWithNestedObjectsAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["securityId"] = this.securityId;
        data["generalRateEntityTypeId"] = this.generalRateEntityTypeId;
        data["generalRateEntityType"] = this.generalRateEntityType ? this.generalRateEntityType.toJSON() : undefined as any;
        data["entity"] = this.entity ? this.entity.toJSON() : undefined as any;
        data["investmentJurisdiction"] = this.investmentJurisdiction ? this.investmentJurisdiction.toJSON() : undefined as any;
        data["transactionType"] = this.transactionType ? this.transactionType.toJSON() : undefined as any;
        data["securityType"] = this.securityType ? this.securityType.toJSON() : undefined as any;
        data["securityStatus"] = this.securityStatus ? this.securityStatus.toJSON() : undefined as any;
        if (Array.isArray(this.securityTaxResultItems)) {
            data["securityTaxResultItems"] = [];
            for (let item of this.securityTaxResultItems)
                data["securityTaxResultItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["description"] = this.description;
        data["ownership"] = this.ownership;
        data["isinCusip"] = this.isinCusip;
        data["acquisitionDate"] = this.acquisitionDate ? this.acquisitionDate.toISOString() : undefined as any;
        data["dispositionDate"] = this.dispositionDate ? this.dispositionDate.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["adminComment"] = this.adminComment;
        data["adminCommentModifiedBy"] = this.adminCommentModifiedBy;
        data["adminCommentModifiedDate"] = this.adminCommentModifiedDate ? this.adminCommentModifiedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ISecurityReviewResponseWithNestedObjectsAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    securityId?: number;
    generalRateEntityTypeId?: number | undefined;
    generalRateEntityType?: EntityTypeNestedObjectResponse;
    entity?: EntityResponseWithNestedObjectsAuditable;
    investmentJurisdiction?: NestedInvestmentJurisdictionShortResponse;
    transactionType?: TransactionTypeNestedResponse;
    securityType?: SecurityTypeNestedObjectResponse;
    securityStatus?: SecurityStatusNestedObjectResponse;
    securityTaxResultItems?: SecurityReviewTaxResultItemNestedObjectResponse[] | undefined;
    name?: string | undefined;
    comment?: string | undefined;
    description?: string | undefined;
    ownership?: number | undefined;
    isinCusip?: string | undefined;
    acquisitionDate?: Date | undefined;
    dispositionDate?: Date | undefined;
    isActive?: boolean;
    adminComment?: string | undefined;
    adminCommentModifiedBy?: string | undefined;
    adminCommentModifiedDate?: Date | undefined;
}

/** OData response message structure */
export class SecurityReviewResponseWithNestedObjectsAuditableODataWithMetadataResponse implements ISecurityReviewResponseWithNestedObjectsAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: SecurityReviewResponseWithNestedObjectsAuditable[] | undefined;

    constructor(data?: ISecurityReviewResponseWithNestedObjectsAuditableODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(SecurityReviewResponseWithNestedObjectsAuditable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurityReviewResponseWithNestedObjectsAuditableODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityReviewResponseWithNestedObjectsAuditableODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ISecurityReviewResponseWithNestedObjectsAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: SecurityReviewResponseWithNestedObjectsAuditable[] | undefined;
}

export class SecurityReviewTaxResultItemNestedObjectResponse implements ISecurityReviewTaxResultItemNestedObjectResponse {
    securityTaxResultItemId?: number;
    taxResultItemType?: TaxResultItemTypeNestedObjectResponse;
    taxResultItem?: TaxResultItemNestedObjectResponse;
    rate?: number | undefined;
    description?: string | undefined;
    isActive?: boolean;
    taxPolicyId?: number;
    taxRuleId?: number;

    constructor(data?: ISecurityReviewTaxResultItemNestedObjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityTaxResultItemId = _data["securityTaxResultItemId"];
            this.taxResultItemType = _data["taxResultItemType"] ? TaxResultItemTypeNestedObjectResponse.fromJS(_data["taxResultItemType"]) : undefined as any;
            this.taxResultItem = _data["taxResultItem"] ? TaxResultItemNestedObjectResponse.fromJS(_data["taxResultItem"]) : undefined as any;
            this.rate = _data["rate"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.taxPolicyId = _data["taxPolicyId"];
            this.taxRuleId = _data["taxRuleId"];
        }
    }

    static fromJS(data: any): SecurityReviewTaxResultItemNestedObjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityReviewTaxResultItemNestedObjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityTaxResultItemId"] = this.securityTaxResultItemId;
        data["taxResultItemType"] = this.taxResultItemType ? this.taxResultItemType.toJSON() : undefined as any;
        data["taxResultItem"] = this.taxResultItem ? this.taxResultItem.toJSON() : undefined as any;
        data["rate"] = this.rate;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["taxPolicyId"] = this.taxPolicyId;
        data["taxRuleId"] = this.taxRuleId;
        return data;
    }
}

export interface ISecurityReviewTaxResultItemNestedObjectResponse {
    securityTaxResultItemId?: number;
    taxResultItemType?: TaxResultItemTypeNestedObjectResponse;
    taxResultItem?: TaxResultItemNestedObjectResponse;
    rate?: number | undefined;
    description?: string | undefined;
    isActive?: boolean;
    taxPolicyId?: number;
    taxRuleId?: number;
}

export class SecurityStatus implements ISecurityStatus {
    securityStatusId?: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    securities?: Security[] | undefined;

    constructor(data?: ISecurityStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityStatusId = _data["securityStatusId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["securities"])) {
                this.securities = [] as any;
                for (let item of _data["securities"])
                    this.securities!.push(Security.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityStatusId"] = this.securityStatusId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.securities)) {
            data["securities"] = [];
            for (let item of this.securities)
                data["securities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISecurityStatus {
    securityStatusId?: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    securities?: Security[] | undefined;
}

export class SecurityStatusNestedObjectResponse implements ISecurityStatusNestedObjectResponse {
    securityStatusId?: number;
    name?: string | undefined;

    constructor(data?: ISecurityStatusNestedObjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityStatusId = _data["securityStatusId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SecurityStatusNestedObjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityStatusNestedObjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityStatusId"] = this.securityStatusId;
        data["name"] = this.name;
        return data;
    }
}

export interface ISecurityStatusNestedObjectResponse {
    securityStatusId?: number;
    name?: string | undefined;
}

export class SecurityStatusResponse implements ISecurityStatusResponse {
    securityStatusId?: number;
    name?: string | undefined;

    constructor(data?: ISecurityStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityStatusId = _data["securityStatusId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SecurityStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityStatusId"] = this.securityStatusId;
        data["name"] = this.name;
        return data;
    }
}

export interface ISecurityStatusResponse {
    securityStatusId?: number;
    name?: string | undefined;
}

export class SecurityTaxResultItem implements ISecurityTaxResultItem {
    securityTaxResultItemId?: number;
    securityId?: number;
    taxPolicyId?: number | undefined;
    taxRuleId?: number | undefined;
    taxResultItemId?: number | undefined;
    taxResultItemTypeId?: number;
    rate?: number | undefined;
    description?: string | undefined;
    isActive!: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    security?: Security;
    taxPolicy?: TaxPolicy;
    taxResultItem?: TaxResultItem;
    taxResultItemType?: TaxResultItemType;
    taxRule?: TaxRule;

    constructor(data?: ISecurityTaxResultItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityTaxResultItemId = _data["securityTaxResultItemId"];
            this.securityId = _data["securityId"];
            this.taxPolicyId = _data["taxPolicyId"];
            this.taxRuleId = _data["taxRuleId"];
            this.taxResultItemId = _data["taxResultItemId"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.rate = _data["rate"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.security = _data["security"] ? Security.fromJS(_data["security"]) : undefined as any;
            this.taxPolicy = _data["taxPolicy"] ? TaxPolicy.fromJS(_data["taxPolicy"]) : undefined as any;
            this.taxResultItem = _data["taxResultItem"] ? TaxResultItem.fromJS(_data["taxResultItem"]) : undefined as any;
            this.taxResultItemType = _data["taxResultItemType"] ? TaxResultItemType.fromJS(_data["taxResultItemType"]) : undefined as any;
            this.taxRule = _data["taxRule"] ? TaxRule.fromJS(_data["taxRule"]) : undefined as any;
        }
    }

    static fromJS(data: any): SecurityTaxResultItem {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityTaxResultItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityTaxResultItemId"] = this.securityTaxResultItemId;
        data["securityId"] = this.securityId;
        data["taxPolicyId"] = this.taxPolicyId;
        data["taxRuleId"] = this.taxRuleId;
        data["taxResultItemId"] = this.taxResultItemId;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["rate"] = this.rate;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["security"] = this.security ? this.security.toJSON() : undefined as any;
        data["taxPolicy"] = this.taxPolicy ? this.taxPolicy.toJSON() : undefined as any;
        data["taxResultItem"] = this.taxResultItem ? this.taxResultItem.toJSON() : undefined as any;
        data["taxResultItemType"] = this.taxResultItemType ? this.taxResultItemType.toJSON() : undefined as any;
        data["taxRule"] = this.taxRule ? this.taxRule.toJSON() : undefined as any;
        return data;
    }
}

export interface ISecurityTaxResultItem {
    securityTaxResultItemId?: number;
    securityId?: number;
    taxPolicyId?: number | undefined;
    taxRuleId?: number | undefined;
    taxResultItemId?: number | undefined;
    taxResultItemTypeId?: number;
    rate?: number | undefined;
    description?: string | undefined;
    isActive: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    security?: Security;
    taxPolicy?: TaxPolicy;
    taxResultItem?: TaxResultItem;
    taxResultItemType?: TaxResultItemType;
    taxRule?: TaxRule;
}

export class SecurityTaxResultItemHistoryResponse implements ISecurityTaxResultItemHistoryResponse {
    securityTaxResultItemId?: number;
    taxResultItemTypeId?: number;
    rate?: number | undefined;
    description?: string | undefined;
    isActive?: boolean;

    constructor(data?: ISecurityTaxResultItemHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityTaxResultItemId = _data["securityTaxResultItemId"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.rate = _data["rate"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SecurityTaxResultItemHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityTaxResultItemHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityTaxResultItemId"] = this.securityTaxResultItemId;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["rate"] = this.rate;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISecurityTaxResultItemHistoryResponse {
    securityTaxResultItemId?: number;
    taxResultItemTypeId?: number;
    rate?: number | undefined;
    description?: string | undefined;
    isActive?: boolean;
}

/** OData response message structure */
export class SecurityTaxResultItemHistoryResponseODataWithMetadataResponse implements ISecurityTaxResultItemHistoryResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: SecurityTaxResultItemHistoryResponse[] | undefined;

    constructor(data?: ISecurityTaxResultItemHistoryResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(SecurityTaxResultItemHistoryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurityTaxResultItemHistoryResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityTaxResultItemHistoryResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ISecurityTaxResultItemHistoryResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: SecurityTaxResultItemHistoryResponse[] | undefined;
}

export class SecurityTaxResultItemNestedObjectResponse implements ISecurityTaxResultItemNestedObjectResponse {
    securityTaxResultItemId?: number;
    taxResultItemType?: TaxResultItemTypeNestedObjectResponse;
    rate?: number | undefined;
    description?: string | undefined;
    isActive?: boolean;
    taxPolicyId?: number | undefined;
    taxRuleId?: number | undefined;
    taxResultItemId?: number | undefined;

    constructor(data?: ISecurityTaxResultItemNestedObjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityTaxResultItemId = _data["securityTaxResultItemId"];
            this.taxResultItemType = _data["taxResultItemType"] ? TaxResultItemTypeNestedObjectResponse.fromJS(_data["taxResultItemType"]) : undefined as any;
            this.rate = _data["rate"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.taxPolicyId = _data["taxPolicyId"];
            this.taxRuleId = _data["taxRuleId"];
            this.taxResultItemId = _data["taxResultItemId"];
        }
    }

    static fromJS(data: any): SecurityTaxResultItemNestedObjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityTaxResultItemNestedObjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityTaxResultItemId"] = this.securityTaxResultItemId;
        data["taxResultItemType"] = this.taxResultItemType ? this.taxResultItemType.toJSON() : undefined as any;
        data["rate"] = this.rate;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["taxPolicyId"] = this.taxPolicyId;
        data["taxRuleId"] = this.taxRuleId;
        data["taxResultItemId"] = this.taxResultItemId;
        return data;
    }
}

export interface ISecurityTaxResultItemNestedObjectResponse {
    securityTaxResultItemId?: number;
    taxResultItemType?: TaxResultItemTypeNestedObjectResponse;
    rate?: number | undefined;
    description?: string | undefined;
    isActive?: boolean;
    taxPolicyId?: number | undefined;
    taxRuleId?: number | undefined;
    taxResultItemId?: number | undefined;
}

export class SecurityType implements ISecurityType {
    securityTypeId?: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    isVisible!: boolean;
    isDefault?: boolean;
    isParent?: boolean;
    parentSecurityTypeId?: number | undefined;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    inverseParentSecurityType?: SecurityType[] | undefined;
    parentSecurityType?: SecurityType;
    securities?: Security[] | undefined;
    generalRateRulesEditors?: GeneralRateRulesEditor[] | undefined;
    securityTypeTaxResultItemTypes?: SecurityTypeTaxResultItemType[] | undefined;
    taxPolicies?: TaxPolicy[] | undefined;

    constructor(data?: ISecurityType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityTypeId = _data["securityTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isVisible = _data["isVisible"];
            this.isDefault = _data["isDefault"];
            this.isParent = _data["isParent"];
            this.parentSecurityTypeId = _data["parentSecurityTypeId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["inverseParentSecurityType"])) {
                this.inverseParentSecurityType = [] as any;
                for (let item of _data["inverseParentSecurityType"])
                    this.inverseParentSecurityType!.push(SecurityType.fromJS(item));
            }
            this.parentSecurityType = _data["parentSecurityType"] ? SecurityType.fromJS(_data["parentSecurityType"]) : undefined as any;
            if (Array.isArray(_data["securities"])) {
                this.securities = [] as any;
                for (let item of _data["securities"])
                    this.securities!.push(Security.fromJS(item));
            }
            if (Array.isArray(_data["generalRateRulesEditors"])) {
                this.generalRateRulesEditors = [] as any;
                for (let item of _data["generalRateRulesEditors"])
                    this.generalRateRulesEditors!.push(GeneralRateRulesEditor.fromJS(item));
            }
            if (Array.isArray(_data["securityTypeTaxResultItemTypes"])) {
                this.securityTypeTaxResultItemTypes = [] as any;
                for (let item of _data["securityTypeTaxResultItemTypes"])
                    this.securityTypeTaxResultItemTypes!.push(SecurityTypeTaxResultItemType.fromJS(item));
            }
            if (Array.isArray(_data["taxPolicies"])) {
                this.taxPolicies = [] as any;
                for (let item of _data["taxPolicies"])
                    this.taxPolicies!.push(TaxPolicy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurityType {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityTypeId"] = this.securityTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isVisible"] = this.isVisible;
        data["isDefault"] = this.isDefault;
        data["isParent"] = this.isParent;
        data["parentSecurityTypeId"] = this.parentSecurityTypeId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.inverseParentSecurityType)) {
            data["inverseParentSecurityType"] = [];
            for (let item of this.inverseParentSecurityType)
                data["inverseParentSecurityType"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentSecurityType"] = this.parentSecurityType ? this.parentSecurityType.toJSON() : undefined as any;
        if (Array.isArray(this.securities)) {
            data["securities"] = [];
            for (let item of this.securities)
                data["securities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generalRateRulesEditors)) {
            data["generalRateRulesEditors"] = [];
            for (let item of this.generalRateRulesEditors)
                data["generalRateRulesEditors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.securityTypeTaxResultItemTypes)) {
            data["securityTypeTaxResultItemTypes"] = [];
            for (let item of this.securityTypeTaxResultItemTypes)
                data["securityTypeTaxResultItemTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.taxPolicies)) {
            data["taxPolicies"] = [];
            for (let item of this.taxPolicies)
                data["taxPolicies"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISecurityType {
    securityTypeId?: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    isVisible: boolean;
    isDefault?: boolean;
    isParent?: boolean;
    parentSecurityTypeId?: number | undefined;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    inverseParentSecurityType?: SecurityType[] | undefined;
    parentSecurityType?: SecurityType;
    securities?: Security[] | undefined;
    generalRateRulesEditors?: GeneralRateRulesEditor[] | undefined;
    securityTypeTaxResultItemTypes?: SecurityTypeTaxResultItemType[] | undefined;
    taxPolicies?: TaxPolicy[] | undefined;
}

export class SecurityTypeNestedObjectResponse implements ISecurityTypeNestedObjectResponse {
    securityTypeId?: number;
    name?: string | undefined;

    constructor(data?: ISecurityTypeNestedObjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityTypeId = _data["securityTypeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SecurityTypeNestedObjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityTypeNestedObjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityTypeId"] = this.securityTypeId;
        data["name"] = this.name;
        return data;
    }
}

export interface ISecurityTypeNestedObjectResponse {
    securityTypeId?: number;
    name?: string | undefined;
}

export class SecurityTypeResponseAuditable implements ISecurityTypeResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    securityTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    isVisible?: boolean;
    isDefault?: boolean;
    isParent?: boolean;
    parentSecurityType?: SecurityTypeNestedObjectResponse;

    constructor(data?: ISecurityTypeResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.securityTypeId = _data["securityTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isVisible = _data["isVisible"];
            this.isDefault = _data["isDefault"];
            this.isParent = _data["isParent"];
            this.parentSecurityType = _data["parentSecurityType"] ? SecurityTypeNestedObjectResponse.fromJS(_data["parentSecurityType"]) : undefined as any;
        }
    }

    static fromJS(data: any): SecurityTypeResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityTypeResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["securityTypeId"] = this.securityTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isVisible"] = this.isVisible;
        data["isDefault"] = this.isDefault;
        data["isParent"] = this.isParent;
        data["parentSecurityType"] = this.parentSecurityType ? this.parentSecurityType.toJSON() : undefined as any;
        return data;
    }
}

export interface ISecurityTypeResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    securityTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    isVisible?: boolean;
    isDefault?: boolean;
    isParent?: boolean;
    parentSecurityType?: SecurityTypeNestedObjectResponse;
}

/** OData response message structure */
export class SecurityTypeResponseAuditableODataWithMetadataResponse implements ISecurityTypeResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: SecurityTypeResponseAuditable[] | undefined;

    constructor(data?: ISecurityTypeResponseAuditableODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(SecurityTypeResponseAuditable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurityTypeResponseAuditableODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityTypeResponseAuditableODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ISecurityTypeResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: SecurityTypeResponseAuditable[] | undefined;
}

export class SecurityTypeTaxResultItemType implements ISecurityTypeTaxResultItemType {
    securityTypeTaxResultItemTypeId?: number;
    securityTypeId?: number;
    taxResultItemTypeId?: number;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    securityType?: SecurityType;
    taxResultItemType?: TaxResultItemType;

    constructor(data?: ISecurityTypeTaxResultItemType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityTypeTaxResultItemTypeId = _data["securityTypeTaxResultItemTypeId"];
            this.securityTypeId = _data["securityTypeId"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.securityType = _data["securityType"] ? SecurityType.fromJS(_data["securityType"]) : undefined as any;
            this.taxResultItemType = _data["taxResultItemType"] ? TaxResultItemType.fromJS(_data["taxResultItemType"]) : undefined as any;
        }
    }

    static fromJS(data: any): SecurityTypeTaxResultItemType {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityTypeTaxResultItemType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityTypeTaxResultItemTypeId"] = this.securityTypeTaxResultItemTypeId;
        data["securityTypeId"] = this.securityTypeId;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["securityType"] = this.securityType ? this.securityType.toJSON() : undefined as any;
        data["taxResultItemType"] = this.taxResultItemType ? this.taxResultItemType.toJSON() : undefined as any;
        return data;
    }
}

export interface ISecurityTypeTaxResultItemType {
    securityTypeTaxResultItemTypeId?: number;
    securityTypeId?: number;
    taxResultItemTypeId?: number;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    securityType?: SecurityType;
    taxResultItemType?: TaxResultItemType;
}

export class SecurityTypeTaxResultItemTypeResponse implements ISecurityTypeTaxResultItemTypeResponse {
    securityTypeId?: number;
    name?: string | undefined;
    taxResultItemTypes?: TaxResultItemTypeNestedObjectResponse[] | undefined;

    constructor(data?: ISecurityTypeTaxResultItemTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityTypeId = _data["securityTypeId"];
            this.name = _data["name"];
            if (Array.isArray(_data["taxResultItemTypes"])) {
                this.taxResultItemTypes = [] as any;
                for (let item of _data["taxResultItemTypes"])
                    this.taxResultItemTypes!.push(TaxResultItemTypeNestedObjectResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurityTypeTaxResultItemTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityTypeTaxResultItemTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityTypeId"] = this.securityTypeId;
        data["name"] = this.name;
        if (Array.isArray(this.taxResultItemTypes)) {
            data["taxResultItemTypes"] = [];
            for (let item of this.taxResultItemTypes)
                data["taxResultItemTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISecurityTypeTaxResultItemTypeResponse {
    securityTypeId?: number;
    name?: string | undefined;
    taxResultItemTypes?: TaxResultItemTypeNestedObjectResponse[] | undefined;
}

/** OData response message structure */
export class SecurityTypeTaxResultItemTypeResponseODataWithMetadataResponse implements ISecurityTypeTaxResultItemTypeResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: SecurityTypeTaxResultItemTypeResponse[] | undefined;

    constructor(data?: ISecurityTypeTaxResultItemTypeResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(SecurityTypeTaxResultItemTypeResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurityTypeTaxResultItemTypeResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityTypeTaxResultItemTypeResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ISecurityTypeTaxResultItemTypeResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: SecurityTypeTaxResultItemTypeResponse[] | undefined;
}

export class StringIdentityUserClaim implements IStringIdentityUserClaim {
    id?: number;
    userId?: string | undefined;
    claimType?: string | undefined;
    claimValue?: string | undefined;

    constructor(data?: IStringIdentityUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
        }
    }

    static fromJS(data: any): StringIdentityUserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new StringIdentityUserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        return data;
    }
}

export interface IStringIdentityUserClaim {
    id?: number;
    userId?: string | undefined;
    claimType?: string | undefined;
    claimValue?: string | undefined;
}

export class TargetEntityTypeResponse implements ITargetEntityTypeResponse {
    entityTypeId?: number;
    name?: string | undefined;
    isDefault?: boolean;

    constructor(data?: ITargetEntityTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityTypeId = _data["entityTypeId"];
            this.name = _data["name"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): TargetEntityTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TargetEntityTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityTypeId"] = this.entityTypeId;
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface ITargetEntityTypeResponse {
    entityTypeId?: number;
    name?: string | undefined;
    isDefault?: boolean;
}

export class TaxByJurisdictionRequest implements ITaxByJurisdictionRequest {
    clientId?: number | undefined;
    transactionTypeId?: number | undefined;
    taxResultItemTypeId?: number | undefined;

    constructor(data?: ITaxByJurisdictionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.transactionTypeId = _data["transactionTypeId"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
        }
    }

    static fromJS(data: any): TaxByJurisdictionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaxByJurisdictionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["transactionTypeId"] = this.transactionTypeId;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        return data;
    }
}

export interface ITaxByJurisdictionRequest {
    clientId?: number | undefined;
    transactionTypeId?: number | undefined;
    taxResultItemTypeId?: number | undefined;
}

export class TaxByJurisdictionResponse implements ITaxByJurisdictionResponse {
    countryId?: number;
    code?: string | undefined;
    countryName?: string | undefined;
    value?: number;

    constructor(data?: ITaxByJurisdictionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.code = _data["code"];
            this.countryName = _data["countryName"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TaxByJurisdictionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxByJurisdictionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["code"] = this.code;
        data["countryName"] = this.countryName;
        data["value"] = this.value;
        return data;
    }
}

export interface ITaxByJurisdictionResponse {
    countryId?: number;
    code?: string | undefined;
    countryName?: string | undefined;
    value?: number;
}

export class TaxPolicy implements ITaxPolicy {
    taxPolicyId?: number;
    investmentJurisdictionId?: number;
    residencyJurisdictionId?: number | undefined;
    securityTypeId?: number;
    entityTypeId?: number | undefined;
    generalRateEntityTypeId?: number | undefined;
    generalRate?: boolean | undefined;
    taxRuleId?: number | undefined;
    taxPolicyStatusId?: number;
    sourceTaxPolicyId?: number | undefined;
    taxResultItemTypeId?: number;
    name!: string;
    isActive?: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    entityType?: EntityType;
    generalRateEntityType?: EntityType;
    inverseSourceTaxPolicy?: TaxPolicy[] | undefined;
    investmentJurisdiction?: InvestmentJurisdiction;
    questions?: Question[] | undefined;
    residencyJurisdiction?: ResidencyJurisdiction;
    securityQuestionAnswers?: SecurityQuestionAnswer[] | undefined;
    securityTaxResultItems?: SecurityTaxResultItem[] | undefined;
    securityType?: SecurityType;
    sourceTaxPolicy?: TaxPolicy;
    taxPolicyStatus?: TaxPolicyStatus;
    taxResultItemType?: TaxResultItemType;
    taxResults?: TaxResult[] | undefined;
    taxRule?: TaxRule;
    taxRules?: TaxRule[] | undefined;

    constructor(data?: ITaxPolicy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxPolicyId = _data["taxPolicyId"];
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
            this.residencyJurisdictionId = _data["residencyJurisdictionId"];
            this.securityTypeId = _data["securityTypeId"];
            this.entityTypeId = _data["entityTypeId"];
            this.generalRateEntityTypeId = _data["generalRateEntityTypeId"];
            this.generalRate = _data["generalRate"];
            this.taxRuleId = _data["taxRuleId"];
            this.taxPolicyStatusId = _data["taxPolicyStatusId"];
            this.sourceTaxPolicyId = _data["sourceTaxPolicyId"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.entityType = _data["entityType"] ? EntityType.fromJS(_data["entityType"]) : undefined as any;
            this.generalRateEntityType = _data["generalRateEntityType"] ? EntityType.fromJS(_data["generalRateEntityType"]) : undefined as any;
            if (Array.isArray(_data["inverseSourceTaxPolicy"])) {
                this.inverseSourceTaxPolicy = [] as any;
                for (let item of _data["inverseSourceTaxPolicy"])
                    this.inverseSourceTaxPolicy!.push(TaxPolicy.fromJS(item));
            }
            this.investmentJurisdiction = _data["investmentJurisdiction"] ? InvestmentJurisdiction.fromJS(_data["investmentJurisdiction"]) : undefined as any;
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(Question.fromJS(item));
            }
            this.residencyJurisdiction = _data["residencyJurisdiction"] ? ResidencyJurisdiction.fromJS(_data["residencyJurisdiction"]) : undefined as any;
            if (Array.isArray(_data["securityQuestionAnswers"])) {
                this.securityQuestionAnswers = [] as any;
                for (let item of _data["securityQuestionAnswers"])
                    this.securityQuestionAnswers!.push(SecurityQuestionAnswer.fromJS(item));
            }
            if (Array.isArray(_data["securityTaxResultItems"])) {
                this.securityTaxResultItems = [] as any;
                for (let item of _data["securityTaxResultItems"])
                    this.securityTaxResultItems!.push(SecurityTaxResultItem.fromJS(item));
            }
            this.securityType = _data["securityType"] ? SecurityType.fromJS(_data["securityType"]) : undefined as any;
            this.sourceTaxPolicy = _data["sourceTaxPolicy"] ? TaxPolicy.fromJS(_data["sourceTaxPolicy"]) : undefined as any;
            this.taxPolicyStatus = _data["taxPolicyStatus"] ? TaxPolicyStatus.fromJS(_data["taxPolicyStatus"]) : undefined as any;
            this.taxResultItemType = _data["taxResultItemType"] ? TaxResultItemType.fromJS(_data["taxResultItemType"]) : undefined as any;
            if (Array.isArray(_data["taxResults"])) {
                this.taxResults = [] as any;
                for (let item of _data["taxResults"])
                    this.taxResults!.push(TaxResult.fromJS(item));
            }
            this.taxRule = _data["taxRule"] ? TaxRule.fromJS(_data["taxRule"]) : undefined as any;
            if (Array.isArray(_data["taxRules"])) {
                this.taxRules = [] as any;
                for (let item of _data["taxRules"])
                    this.taxRules!.push(TaxRule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxPolicy {
        data = typeof data === 'object' ? data : {};
        let result = new TaxPolicy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxPolicyId"] = this.taxPolicyId;
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        data["residencyJurisdictionId"] = this.residencyJurisdictionId;
        data["securityTypeId"] = this.securityTypeId;
        data["entityTypeId"] = this.entityTypeId;
        data["generalRateEntityTypeId"] = this.generalRateEntityTypeId;
        data["generalRate"] = this.generalRate;
        data["taxRuleId"] = this.taxRuleId;
        data["taxPolicyStatusId"] = this.taxPolicyStatusId;
        data["sourceTaxPolicyId"] = this.sourceTaxPolicyId;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["entityType"] = this.entityType ? this.entityType.toJSON() : undefined as any;
        data["generalRateEntityType"] = this.generalRateEntityType ? this.generalRateEntityType.toJSON() : undefined as any;
        if (Array.isArray(this.inverseSourceTaxPolicy)) {
            data["inverseSourceTaxPolicy"] = [];
            for (let item of this.inverseSourceTaxPolicy)
                data["inverseSourceTaxPolicy"].push(item ? item.toJSON() : undefined as any);
        }
        data["investmentJurisdiction"] = this.investmentJurisdiction ? this.investmentJurisdiction.toJSON() : undefined as any;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        data["residencyJurisdiction"] = this.residencyJurisdiction ? this.residencyJurisdiction.toJSON() : undefined as any;
        if (Array.isArray(this.securityQuestionAnswers)) {
            data["securityQuestionAnswers"] = [];
            for (let item of this.securityQuestionAnswers)
                data["securityQuestionAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.securityTaxResultItems)) {
            data["securityTaxResultItems"] = [];
            for (let item of this.securityTaxResultItems)
                data["securityTaxResultItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["securityType"] = this.securityType ? this.securityType.toJSON() : undefined as any;
        data["sourceTaxPolicy"] = this.sourceTaxPolicy ? this.sourceTaxPolicy.toJSON() : undefined as any;
        data["taxPolicyStatus"] = this.taxPolicyStatus ? this.taxPolicyStatus.toJSON() : undefined as any;
        data["taxResultItemType"] = this.taxResultItemType ? this.taxResultItemType.toJSON() : undefined as any;
        if (Array.isArray(this.taxResults)) {
            data["taxResults"] = [];
            for (let item of this.taxResults)
                data["taxResults"].push(item ? item.toJSON() : undefined as any);
        }
        data["taxRule"] = this.taxRule ? this.taxRule.toJSON() : undefined as any;
        if (Array.isArray(this.taxRules)) {
            data["taxRules"] = [];
            for (let item of this.taxRules)
                data["taxRules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaxPolicy {
    taxPolicyId?: number;
    investmentJurisdictionId?: number;
    residencyJurisdictionId?: number | undefined;
    securityTypeId?: number;
    entityTypeId?: number | undefined;
    generalRateEntityTypeId?: number | undefined;
    generalRate?: boolean | undefined;
    taxRuleId?: number | undefined;
    taxPolicyStatusId?: number;
    sourceTaxPolicyId?: number | undefined;
    taxResultItemTypeId?: number;
    name: string;
    isActive?: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    entityType?: EntityType;
    generalRateEntityType?: EntityType;
    inverseSourceTaxPolicy?: TaxPolicy[] | undefined;
    investmentJurisdiction?: InvestmentJurisdiction;
    questions?: Question[] | undefined;
    residencyJurisdiction?: ResidencyJurisdiction;
    securityQuestionAnswers?: SecurityQuestionAnswer[] | undefined;
    securityTaxResultItems?: SecurityTaxResultItem[] | undefined;
    securityType?: SecurityType;
    sourceTaxPolicy?: TaxPolicy;
    taxPolicyStatus?: TaxPolicyStatus;
    taxResultItemType?: TaxResultItemType;
    taxResults?: TaxResult[] | undefined;
    taxRule?: TaxRule;
    taxRules?: TaxRule[] | undefined;
}

export class TaxPolicyForSecurityReviewResponse implements ITaxPolicyForSecurityReviewResponse {
    taxPolicyId?: number;
    name?: string | undefined;
    isActive?: boolean;
    taxResultItemType?: TaxResultItemTypeNestedObjectResponse;

    constructor(data?: ITaxPolicyForSecurityReviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxPolicyId = _data["taxPolicyId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.taxResultItemType = _data["taxResultItemType"] ? TaxResultItemTypeNestedObjectResponse.fromJS(_data["taxResultItemType"]) : undefined as any;
        }
    }

    static fromJS(data: any): TaxPolicyForSecurityReviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxPolicyForSecurityReviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxPolicyId"] = this.taxPolicyId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["taxResultItemType"] = this.taxResultItemType ? this.taxResultItemType.toJSON() : undefined as any;
        return data;
    }
}

export interface ITaxPolicyForSecurityReviewResponse {
    taxPolicyId?: number;
    name?: string | undefined;
    isActive?: boolean;
    taxResultItemType?: TaxResultItemTypeNestedObjectResponse;
}

export class TaxPolicyHistoryResponseAuditable implements ITaxPolicyHistoryResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxPolicyId?: number;
    investmentJurisdictionId?: number;
    residencyJurisdictionId?: number | undefined;
    securityTypeId?: number;
    entityTypeId?: number | undefined;
    generalRateEntityTypeId?: number | undefined;
    generalRate?: boolean | undefined;
    taxRuleId?: number | undefined;
    taxPolicyStatusId?: number;
    taxResultItemTypeId?: number;
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: ITaxPolicyHistoryResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.taxPolicyId = _data["taxPolicyId"];
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
            this.residencyJurisdictionId = _data["residencyJurisdictionId"];
            this.securityTypeId = _data["securityTypeId"];
            this.entityTypeId = _data["entityTypeId"];
            this.generalRateEntityTypeId = _data["generalRateEntityTypeId"];
            this.generalRate = _data["generalRate"];
            this.taxRuleId = _data["taxRuleId"];
            this.taxPolicyStatusId = _data["taxPolicyStatusId"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TaxPolicyHistoryResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new TaxPolicyHistoryResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["taxPolicyId"] = this.taxPolicyId;
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        data["residencyJurisdictionId"] = this.residencyJurisdictionId;
        data["securityTypeId"] = this.securityTypeId;
        data["entityTypeId"] = this.entityTypeId;
        data["generalRateEntityTypeId"] = this.generalRateEntityTypeId;
        data["generalRate"] = this.generalRate;
        data["taxRuleId"] = this.taxRuleId;
        data["taxPolicyStatusId"] = this.taxPolicyStatusId;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITaxPolicyHistoryResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxPolicyId?: number;
    investmentJurisdictionId?: number;
    residencyJurisdictionId?: number | undefined;
    securityTypeId?: number;
    entityTypeId?: number | undefined;
    generalRateEntityTypeId?: number | undefined;
    generalRate?: boolean | undefined;
    taxRuleId?: number | undefined;
    taxPolicyStatusId?: number;
    taxResultItemTypeId?: number;
    name?: string | undefined;
    isActive?: boolean;
}

/** OData response message structure */
export class TaxPolicyHistoryResponseAuditableODataWithMetadataResponse implements ITaxPolicyHistoryResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: TaxPolicyHistoryResponseAuditable[] | undefined;

    constructor(data?: ITaxPolicyHistoryResponseAuditableODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(TaxPolicyHistoryResponseAuditable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxPolicyHistoryResponseAuditableODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxPolicyHistoryResponseAuditableODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ITaxPolicyHistoryResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: TaxPolicyHistoryResponseAuditable[] | undefined;
}

export class TaxPolicyResponse implements ITaxPolicyResponse {
    taxPolicyId?: number;
    investmentJurisdictionId?: number;
    residencyJurisdictionId?: number | undefined;
    securityTypeId?: number;
    entityTypeId?: number | undefined;
    generalRateEntityTypeId?: number | undefined;
    generalRate?: boolean | undefined;
    taxRuleId?: number | undefined;
    taxPolicyStatusId?: number;
    taxResultItemTypeId?: number;
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: ITaxPolicyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxPolicyId = _data["taxPolicyId"];
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
            this.residencyJurisdictionId = _data["residencyJurisdictionId"];
            this.securityTypeId = _data["securityTypeId"];
            this.entityTypeId = _data["entityTypeId"];
            this.generalRateEntityTypeId = _data["generalRateEntityTypeId"];
            this.generalRate = _data["generalRate"];
            this.taxRuleId = _data["taxRuleId"];
            this.taxPolicyStatusId = _data["taxPolicyStatusId"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TaxPolicyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxPolicyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxPolicyId"] = this.taxPolicyId;
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        data["residencyJurisdictionId"] = this.residencyJurisdictionId;
        data["securityTypeId"] = this.securityTypeId;
        data["entityTypeId"] = this.entityTypeId;
        data["generalRateEntityTypeId"] = this.generalRateEntityTypeId;
        data["generalRate"] = this.generalRate;
        data["taxRuleId"] = this.taxRuleId;
        data["taxPolicyStatusId"] = this.taxPolicyStatusId;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITaxPolicyResponse {
    taxPolicyId?: number;
    investmentJurisdictionId?: number;
    residencyJurisdictionId?: number | undefined;
    securityTypeId?: number;
    entityTypeId?: number | undefined;
    generalRateEntityTypeId?: number | undefined;
    generalRate?: boolean | undefined;
    taxRuleId?: number | undefined;
    taxPolicyStatusId?: number;
    taxResultItemTypeId?: number;
    name?: string | undefined;
    isActive?: boolean;
}

export class TaxPolicyStatus implements ITaxPolicyStatus {
    taxPolicyStatusId?: number;
    name!: string;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    taxPolicies?: TaxPolicy[] | undefined;

    constructor(data?: ITaxPolicyStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxPolicyStatusId = _data["taxPolicyStatusId"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["taxPolicies"])) {
                this.taxPolicies = [] as any;
                for (let item of _data["taxPolicies"])
                    this.taxPolicies!.push(TaxPolicy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxPolicyStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TaxPolicyStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxPolicyStatusId"] = this.taxPolicyStatusId;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.taxPolicies)) {
            data["taxPolicies"] = [];
            for (let item of this.taxPolicies)
                data["taxPolicies"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaxPolicyStatus {
    taxPolicyStatusId?: number;
    name: string;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    taxPolicies?: TaxPolicy[] | undefined;
}

export class TaxPolicyStatusResponse implements ITaxPolicyStatusResponse {
    taxPolicyStatusId?: number;
    name?: string | undefined;

    constructor(data?: ITaxPolicyStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxPolicyStatusId = _data["taxPolicyStatusId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TaxPolicyStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxPolicyStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxPolicyStatusId"] = this.taxPolicyStatusId;
        data["name"] = this.name;
        return data;
    }
}

export interface ITaxPolicyStatusResponse {
    taxPolicyStatusId?: number;
    name?: string | undefined;
}

/** OData response message structure */
export class TaxPolicyStatusResponseODataWithMetadataResponse implements ITaxPolicyStatusResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: TaxPolicyStatusResponse[] | undefined;

    constructor(data?: ITaxPolicyStatusResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(TaxPolicyStatusResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxPolicyStatusResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxPolicyStatusResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ITaxPolicyStatusResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: TaxPolicyStatusResponse[] | undefined;
}

export class TaxPolicyWithNestedObjectResponseAuditable implements ITaxPolicyWithNestedObjectResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxPolicyId?: number;
    investmentJurisdiction?: NestedInvestmentJurisdictionShortResponse;
    residencyJurisdiction?: NestedResidencyJurisdictionShortResponse;
    entityType?: EntityTypeNestedObjectResponse;
    generalRateEntityTypeId?: number | undefined;
    generalRateEntityType?: EntityTypeNestedObjectResponse;
    securityType?: SecurityTypeNestedObjectResponse;
    generalRate?: boolean | undefined;
    taxRule?: TaxRuleShortResponse;
    taxPolicyStatus?: TaxPolicyStatusResponse;
    taxResultItemType?: TaxResultItemTypeNestedObjectResponse;
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: ITaxPolicyWithNestedObjectResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.taxPolicyId = _data["taxPolicyId"];
            this.investmentJurisdiction = _data["investmentJurisdiction"] ? NestedInvestmentJurisdictionShortResponse.fromJS(_data["investmentJurisdiction"]) : undefined as any;
            this.residencyJurisdiction = _data["residencyJurisdiction"] ? NestedResidencyJurisdictionShortResponse.fromJS(_data["residencyJurisdiction"]) : undefined as any;
            this.entityType = _data["entityType"] ? EntityTypeNestedObjectResponse.fromJS(_data["entityType"]) : undefined as any;
            this.generalRateEntityTypeId = _data["generalRateEntityTypeId"];
            this.generalRateEntityType = _data["generalRateEntityType"] ? EntityTypeNestedObjectResponse.fromJS(_data["generalRateEntityType"]) : undefined as any;
            this.securityType = _data["securityType"] ? SecurityTypeNestedObjectResponse.fromJS(_data["securityType"]) : undefined as any;
            this.generalRate = _data["generalRate"];
            this.taxRule = _data["taxRule"] ? TaxRuleShortResponse.fromJS(_data["taxRule"]) : undefined as any;
            this.taxPolicyStatus = _data["taxPolicyStatus"] ? TaxPolicyStatusResponse.fromJS(_data["taxPolicyStatus"]) : undefined as any;
            this.taxResultItemType = _data["taxResultItemType"] ? TaxResultItemTypeNestedObjectResponse.fromJS(_data["taxResultItemType"]) : undefined as any;
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TaxPolicyWithNestedObjectResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new TaxPolicyWithNestedObjectResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["taxPolicyId"] = this.taxPolicyId;
        data["investmentJurisdiction"] = this.investmentJurisdiction ? this.investmentJurisdiction.toJSON() : undefined as any;
        data["residencyJurisdiction"] = this.residencyJurisdiction ? this.residencyJurisdiction.toJSON() : undefined as any;
        data["entityType"] = this.entityType ? this.entityType.toJSON() : undefined as any;
        data["generalRateEntityTypeId"] = this.generalRateEntityTypeId;
        data["generalRateEntityType"] = this.generalRateEntityType ? this.generalRateEntityType.toJSON() : undefined as any;
        data["securityType"] = this.securityType ? this.securityType.toJSON() : undefined as any;
        data["generalRate"] = this.generalRate;
        data["taxRule"] = this.taxRule ? this.taxRule.toJSON() : undefined as any;
        data["taxPolicyStatus"] = this.taxPolicyStatus ? this.taxPolicyStatus.toJSON() : undefined as any;
        data["taxResultItemType"] = this.taxResultItemType ? this.taxResultItemType.toJSON() : undefined as any;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITaxPolicyWithNestedObjectResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxPolicyId?: number;
    investmentJurisdiction?: NestedInvestmentJurisdictionShortResponse;
    residencyJurisdiction?: NestedResidencyJurisdictionShortResponse;
    entityType?: EntityTypeNestedObjectResponse;
    generalRateEntityTypeId?: number | undefined;
    generalRateEntityType?: EntityTypeNestedObjectResponse;
    securityType?: SecurityTypeNestedObjectResponse;
    generalRate?: boolean | undefined;
    taxRule?: TaxRuleShortResponse;
    taxPolicyStatus?: TaxPolicyStatusResponse;
    taxResultItemType?: TaxResultItemTypeNestedObjectResponse;
    name?: string | undefined;
    isActive?: boolean;
}

/** OData response message structure */
export class TaxPolicyWithNestedObjectResponseAuditableODataWithMetadataResponse implements ITaxPolicyWithNestedObjectResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: TaxPolicyWithNestedObjectResponseAuditable[] | undefined;

    constructor(data?: ITaxPolicyWithNestedObjectResponseAuditableODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(TaxPolicyWithNestedObjectResponseAuditable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxPolicyWithNestedObjectResponseAuditableODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxPolicyWithNestedObjectResponseAuditableODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ITaxPolicyWithNestedObjectResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: TaxPolicyWithNestedObjectResponseAuditable[] | undefined;
}

export class TaxPolicyWithNestedObjectShortResponse implements ITaxPolicyWithNestedObjectShortResponse {
    taxPolicyId?: number;
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: ITaxPolicyWithNestedObjectShortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxPolicyId = _data["taxPolicyId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TaxPolicyWithNestedObjectShortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxPolicyWithNestedObjectShortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxPolicyId"] = this.taxPolicyId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITaxPolicyWithNestedObjectShortResponse {
    taxPolicyId?: number;
    name?: string | undefined;
    isActive?: boolean;
}

export class TaxRateSummary implements ITaxRateSummary {
    taxRateSummaryId?: number;
    taxSummaryId?: number;
    rate?: number;
    description!: string;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    taxSummary?: TaxSummary;

    constructor(data?: ITaxRateSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxRateSummaryId = _data["taxRateSummaryId"];
            this.taxSummaryId = _data["taxSummaryId"];
            this.rate = _data["rate"];
            this.description = _data["description"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.taxSummary = _data["taxSummary"] ? TaxSummary.fromJS(_data["taxSummary"]) : undefined as any;
        }
    }

    static fromJS(data: any): TaxRateSummary {
        data = typeof data === 'object' ? data : {};
        let result = new TaxRateSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxRateSummaryId"] = this.taxRateSummaryId;
        data["taxSummaryId"] = this.taxSummaryId;
        data["rate"] = this.rate;
        data["description"] = this.description;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["taxSummary"] = this.taxSummary ? this.taxSummary.toJSON() : undefined as any;
        return data;
    }
}

export interface ITaxRateSummary {
    taxRateSummaryId?: number;
    taxSummaryId?: number;
    rate?: number;
    description: string;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    taxSummary?: TaxSummary;
}

export class TaxRateSummaryResponse implements ITaxRateSummaryResponse {
    taxRateSummaryId?: number;
    taxSummaryId?: number;
    rate?: number;
    description?: string | undefined;

    constructor(data?: ITaxRateSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxRateSummaryId = _data["taxRateSummaryId"];
            this.taxSummaryId = _data["taxSummaryId"];
            this.rate = _data["rate"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TaxRateSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxRateSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxRateSummaryId"] = this.taxRateSummaryId;
        data["taxSummaryId"] = this.taxSummaryId;
        data["rate"] = this.rate;
        data["description"] = this.description;
        return data;
    }
}

export interface ITaxRateSummaryResponse {
    taxRateSummaryId?: number;
    taxSummaryId?: number;
    rate?: number;
    description?: string | undefined;
}

export class TaxRateSummaryWithNestedObjectResponse implements ITaxRateSummaryWithNestedObjectResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxRateSummaryId?: number;
    taxSummary?: TaxSummary;
    rate?: number;
    description?: string | undefined;

    constructor(data?: ITaxRateSummaryWithNestedObjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.taxRateSummaryId = _data["taxRateSummaryId"];
            this.taxSummary = _data["taxSummary"] ? TaxSummary.fromJS(_data["taxSummary"]) : undefined as any;
            this.rate = _data["rate"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TaxRateSummaryWithNestedObjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxRateSummaryWithNestedObjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["taxRateSummaryId"] = this.taxRateSummaryId;
        data["taxSummary"] = this.taxSummary ? this.taxSummary.toJSON() : undefined as any;
        data["rate"] = this.rate;
        data["description"] = this.description;
        return data;
    }
}

export interface ITaxRateSummaryWithNestedObjectResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxRateSummaryId?: number;
    taxSummary?: TaxSummary;
    rate?: number;
    description?: string | undefined;
}

/** OData response message structure */
export class TaxRateSummaryWithNestedObjectResponseODataWithMetadataResponse implements ITaxRateSummaryWithNestedObjectResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: TaxRateSummaryWithNestedObjectResponse[] | undefined;

    constructor(data?: ITaxRateSummaryWithNestedObjectResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(TaxRateSummaryWithNestedObjectResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxRateSummaryWithNestedObjectResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxRateSummaryWithNestedObjectResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ITaxRateSummaryWithNestedObjectResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: TaxRateSummaryWithNestedObjectResponse[] | undefined;
}

export class TaxResult implements ITaxResult {
    taxResultId?: number;
    taxPolicyId?: number | undefined;
    taxResultTypeId?: number;
    name!: string;
    isActive?: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    taxPolicy?: TaxPolicy;
    taxResultItems?: TaxResultItem[] | undefined;
    taxResultType?: TaxResultType;

    constructor(data?: ITaxResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxResultId = _data["taxResultId"];
            this.taxPolicyId = _data["taxPolicyId"];
            this.taxResultTypeId = _data["taxResultTypeId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.taxPolicy = _data["taxPolicy"] ? TaxPolicy.fromJS(_data["taxPolicy"]) : undefined as any;
            if (Array.isArray(_data["taxResultItems"])) {
                this.taxResultItems = [] as any;
                for (let item of _data["taxResultItems"])
                    this.taxResultItems!.push(TaxResultItem.fromJS(item));
            }
            this.taxResultType = _data["taxResultType"] ? TaxResultType.fromJS(_data["taxResultType"]) : undefined as any;
        }
    }

    static fromJS(data: any): TaxResult {
        data = typeof data === 'object' ? data : {};
        let result = new TaxResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxResultId"] = this.taxResultId;
        data["taxPolicyId"] = this.taxPolicyId;
        data["taxResultTypeId"] = this.taxResultTypeId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["taxPolicy"] = this.taxPolicy ? this.taxPolicy.toJSON() : undefined as any;
        if (Array.isArray(this.taxResultItems)) {
            data["taxResultItems"] = [];
            for (let item of this.taxResultItems)
                data["taxResultItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["taxResultType"] = this.taxResultType ? this.taxResultType.toJSON() : undefined as any;
        return data;
    }
}

export interface ITaxResult {
    taxResultId?: number;
    taxPolicyId?: number | undefined;
    taxResultTypeId?: number;
    name: string;
    isActive?: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    taxPolicy?: TaxPolicy;
    taxResultItems?: TaxResultItem[] | undefined;
    taxResultType?: TaxResultType;
}

export class TaxResultEvaluationResponse implements ITaxResultEvaluationResponse {
    taxResultItemTypeId?: number;
    taxResultItemId?: number;
    taxResultItemTypeName?: string | undefined;
    rate?: number | undefined;
    description?: string | undefined;

    constructor(data?: ITaxResultEvaluationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.taxResultItemId = _data["taxResultItemId"];
            this.taxResultItemTypeName = _data["taxResultItemTypeName"];
            this.rate = _data["rate"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TaxResultEvaluationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxResultEvaluationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["taxResultItemId"] = this.taxResultItemId;
        data["taxResultItemTypeName"] = this.taxResultItemTypeName;
        data["rate"] = this.rate;
        data["description"] = this.description;
        return data;
    }
}

export interface ITaxResultEvaluationResponse {
    taxResultItemTypeId?: number;
    taxResultItemId?: number;
    taxResultItemTypeName?: string | undefined;
    rate?: number | undefined;
    description?: string | undefined;
}

export class TaxResultHistoryResponseAuditable implements ITaxResultHistoryResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxResultId?: number;
    taxPolicyId?: number | undefined;
    taxResultTypeId?: number;
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: ITaxResultHistoryResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.taxResultId = _data["taxResultId"];
            this.taxPolicyId = _data["taxPolicyId"];
            this.taxResultTypeId = _data["taxResultTypeId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TaxResultHistoryResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new TaxResultHistoryResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["taxResultId"] = this.taxResultId;
        data["taxPolicyId"] = this.taxPolicyId;
        data["taxResultTypeId"] = this.taxResultTypeId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITaxResultHistoryResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxResultId?: number;
    taxPolicyId?: number | undefined;
    taxResultTypeId?: number;
    name?: string | undefined;
    isActive?: boolean;
}

/** OData response message structure */
export class TaxResultHistoryResponseAuditableODataWithMetadataResponse implements ITaxResultHistoryResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: TaxResultHistoryResponseAuditable[] | undefined;

    constructor(data?: ITaxResultHistoryResponseAuditableODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(TaxResultHistoryResponseAuditable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxResultHistoryResponseAuditableODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxResultHistoryResponseAuditableODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ITaxResultHistoryResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: TaxResultHistoryResponseAuditable[] | undefined;
}

export class TaxResultItem implements ITaxResultItem {
    taxResultItemId?: number;
    taxResultId?: number;
    taxResultItemTypeId?: number;
    rate?: number | undefined;
    description?: string | undefined;
    isActive!: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    securityTaxResultItems?: SecurityTaxResultItem[] | undefined;
    taxResult?: TaxResult;
    taxResultItemType?: TaxResultItemType;

    constructor(data?: ITaxResultItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxResultItemId = _data["taxResultItemId"];
            this.taxResultId = _data["taxResultId"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.rate = _data["rate"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["securityTaxResultItems"])) {
                this.securityTaxResultItems = [] as any;
                for (let item of _data["securityTaxResultItems"])
                    this.securityTaxResultItems!.push(SecurityTaxResultItem.fromJS(item));
            }
            this.taxResult = _data["taxResult"] ? TaxResult.fromJS(_data["taxResult"]) : undefined as any;
            this.taxResultItemType = _data["taxResultItemType"] ? TaxResultItemType.fromJS(_data["taxResultItemType"]) : undefined as any;
        }
    }

    static fromJS(data: any): TaxResultItem {
        data = typeof data === 'object' ? data : {};
        let result = new TaxResultItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxResultItemId"] = this.taxResultItemId;
        data["taxResultId"] = this.taxResultId;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["rate"] = this.rate;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.securityTaxResultItems)) {
            data["securityTaxResultItems"] = [];
            for (let item of this.securityTaxResultItems)
                data["securityTaxResultItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["taxResult"] = this.taxResult ? this.taxResult.toJSON() : undefined as any;
        data["taxResultItemType"] = this.taxResultItemType ? this.taxResultItemType.toJSON() : undefined as any;
        return data;
    }
}

export interface ITaxResultItem {
    taxResultItemId?: number;
    taxResultId?: number;
    taxResultItemTypeId?: number;
    rate?: number | undefined;
    description?: string | undefined;
    isActive: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    securityTaxResultItems?: SecurityTaxResultItem[] | undefined;
    taxResult?: TaxResult;
    taxResultItemType?: TaxResultItemType;
}

export class TaxResultItemNestedObjectResponse implements ITaxResultItemNestedObjectResponse {
    taxResultItemId?: number;
    taxResultItemType?: TaxResultItemTypeNestedObjectResponse;
    rate?: number | undefined;
    description?: string | undefined;
    isActive?: boolean;

    constructor(data?: ITaxResultItemNestedObjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxResultItemId = _data["taxResultItemId"];
            this.taxResultItemType = _data["taxResultItemType"] ? TaxResultItemTypeNestedObjectResponse.fromJS(_data["taxResultItemType"]) : undefined as any;
            this.rate = _data["rate"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TaxResultItemNestedObjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxResultItemNestedObjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxResultItemId"] = this.taxResultItemId;
        data["taxResultItemType"] = this.taxResultItemType ? this.taxResultItemType.toJSON() : undefined as any;
        data["rate"] = this.rate;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITaxResultItemNestedObjectResponse {
    taxResultItemId?: number;
    taxResultItemType?: TaxResultItemTypeNestedObjectResponse;
    rate?: number | undefined;
    description?: string | undefined;
    isActive?: boolean;
}

/** OData response message structure */
export class TaxResultItemNestedObjectResponseODataWithMetadataResponse implements ITaxResultItemNestedObjectResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: TaxResultItemNestedObjectResponse[] | undefined;

    constructor(data?: ITaxResultItemNestedObjectResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(TaxResultItemNestedObjectResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxResultItemNestedObjectResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxResultItemNestedObjectResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ITaxResultItemNestedObjectResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: TaxResultItemNestedObjectResponse[] | undefined;
}

export class TaxResultItemResponse implements ITaxResultItemResponse {
    taxResultItemId?: number;
    taxResultId?: number;
    taxResultItemTypeId?: number;
    rate?: number | undefined;
    description?: string | undefined;
    isActive?: boolean;

    constructor(data?: ITaxResultItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxResultItemId = _data["taxResultItemId"];
            this.taxResultId = _data["taxResultId"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.rate = _data["rate"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TaxResultItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxResultItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxResultItemId"] = this.taxResultItemId;
        data["taxResultId"] = this.taxResultId;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["rate"] = this.rate;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITaxResultItemResponse {
    taxResultItemId?: number;
    taxResultId?: number;
    taxResultItemTypeId?: number;
    rate?: number | undefined;
    description?: string | undefined;
    isActive?: boolean;
}

export class TaxResultItemType implements ITaxResultItemType {
    taxResultItemTypeId?: number;
    name!: string;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    generalRateRulesEditors?: GeneralRateRulesEditor[] | undefined;
    securityTaxResultItems?: SecurityTaxResultItem[] | undefined;
    securityTypeTaxResultItemTypes?: SecurityTypeTaxResultItemType[] | undefined;
    taxPolicies?: TaxPolicy[] | undefined;
    taxResultItems?: TaxResultItem[] | undefined;

    constructor(data?: ITaxResultItemType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["generalRateRulesEditors"])) {
                this.generalRateRulesEditors = [] as any;
                for (let item of _data["generalRateRulesEditors"])
                    this.generalRateRulesEditors!.push(GeneralRateRulesEditor.fromJS(item));
            }
            if (Array.isArray(_data["securityTaxResultItems"])) {
                this.securityTaxResultItems = [] as any;
                for (let item of _data["securityTaxResultItems"])
                    this.securityTaxResultItems!.push(SecurityTaxResultItem.fromJS(item));
            }
            if (Array.isArray(_data["securityTypeTaxResultItemTypes"])) {
                this.securityTypeTaxResultItemTypes = [] as any;
                for (let item of _data["securityTypeTaxResultItemTypes"])
                    this.securityTypeTaxResultItemTypes!.push(SecurityTypeTaxResultItemType.fromJS(item));
            }
            if (Array.isArray(_data["taxPolicies"])) {
                this.taxPolicies = [] as any;
                for (let item of _data["taxPolicies"])
                    this.taxPolicies!.push(TaxPolicy.fromJS(item));
            }
            if (Array.isArray(_data["taxResultItems"])) {
                this.taxResultItems = [] as any;
                for (let item of _data["taxResultItems"])
                    this.taxResultItems!.push(TaxResultItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxResultItemType {
        data = typeof data === 'object' ? data : {};
        let result = new TaxResultItemType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.generalRateRulesEditors)) {
            data["generalRateRulesEditors"] = [];
            for (let item of this.generalRateRulesEditors)
                data["generalRateRulesEditors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.securityTaxResultItems)) {
            data["securityTaxResultItems"] = [];
            for (let item of this.securityTaxResultItems)
                data["securityTaxResultItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.securityTypeTaxResultItemTypes)) {
            data["securityTypeTaxResultItemTypes"] = [];
            for (let item of this.securityTypeTaxResultItemTypes)
                data["securityTypeTaxResultItemTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.taxPolicies)) {
            data["taxPolicies"] = [];
            for (let item of this.taxPolicies)
                data["taxPolicies"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.taxResultItems)) {
            data["taxResultItems"] = [];
            for (let item of this.taxResultItems)
                data["taxResultItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaxResultItemType {
    taxResultItemTypeId?: number;
    name: string;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    generalRateRulesEditors?: GeneralRateRulesEditor[] | undefined;
    securityTaxResultItems?: SecurityTaxResultItem[] | undefined;
    securityTypeTaxResultItemTypes?: SecurityTypeTaxResultItemType[] | undefined;
    taxPolicies?: TaxPolicy[] | undefined;
    taxResultItems?: TaxResultItem[] | undefined;
}

export class TaxResultItemTypeNestedObjectResponse implements ITaxResultItemTypeNestedObjectResponse {
    taxResultItemTypeId?: number;
    name?: string | undefined;

    constructor(data?: ITaxResultItemTypeNestedObjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TaxResultItemTypeNestedObjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxResultItemTypeNestedObjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["name"] = this.name;
        return data;
    }
}

export interface ITaxResultItemTypeNestedObjectResponse {
    taxResultItemTypeId?: number;
    name?: string | undefined;
}

/** OData response message structure */
export class TaxResultItemTypeNestedObjectResponseODataWithMetadataResponse implements ITaxResultItemTypeNestedObjectResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: TaxResultItemTypeNestedObjectResponse[] | undefined;

    constructor(data?: ITaxResultItemTypeNestedObjectResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(TaxResultItemTypeNestedObjectResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxResultItemTypeNestedObjectResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxResultItemTypeNestedObjectResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ITaxResultItemTypeNestedObjectResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: TaxResultItemTypeNestedObjectResponse[] | undefined;
}

export class TaxResultItemTypeResponseAuditable implements ITaxResultItemTypeResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxResultItemTypeId?: number;
    name?: string | undefined;

    constructor(data?: ITaxResultItemTypeResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TaxResultItemTypeResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new TaxResultItemTypeResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["name"] = this.name;
        return data;
    }
}

export interface ITaxResultItemTypeResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxResultItemTypeId?: number;
    name?: string | undefined;
}

export class TaxResultResponse implements ITaxResultResponse {
    taxResultId?: number;
    taxPolicyId?: number | undefined;
    taxResultTypeId?: number;
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: ITaxResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxResultId = _data["taxResultId"];
            this.taxPolicyId = _data["taxPolicyId"];
            this.taxResultTypeId = _data["taxResultTypeId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TaxResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxResultId"] = this.taxResultId;
        data["taxPolicyId"] = this.taxPolicyId;
        data["taxResultTypeId"] = this.taxResultTypeId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITaxResultResponse {
    taxResultId?: number;
    taxPolicyId?: number | undefined;
    taxResultTypeId?: number;
    name?: string | undefined;
    isActive?: boolean;
}

export class TaxResultType implements ITaxResultType {
    taxResultTypeId?: number;
    name!: string;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    taxResults?: TaxResult[] | undefined;

    constructor(data?: ITaxResultType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxResultTypeId = _data["taxResultTypeId"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["taxResults"])) {
                this.taxResults = [] as any;
                for (let item of _data["taxResults"])
                    this.taxResults!.push(TaxResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxResultType {
        data = typeof data === 'object' ? data : {};
        let result = new TaxResultType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxResultTypeId"] = this.taxResultTypeId;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.taxResults)) {
            data["taxResults"] = [];
            for (let item of this.taxResults)
                data["taxResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaxResultType {
    taxResultTypeId?: number;
    name: string;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    taxResults?: TaxResult[] | undefined;
}

export class TaxResultTypeNestedObjectResponse implements ITaxResultTypeNestedObjectResponse {
    taxResultTypeId?: number;
    name?: string | undefined;

    constructor(data?: ITaxResultTypeNestedObjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxResultTypeId = _data["taxResultTypeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TaxResultTypeNestedObjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxResultTypeNestedObjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxResultTypeId"] = this.taxResultTypeId;
        data["name"] = this.name;
        return data;
    }
}

export interface ITaxResultTypeNestedObjectResponse {
    taxResultTypeId?: number;
    name?: string | undefined;
}

export class TaxResultTypeResponse implements ITaxResultTypeResponse {
    taxResultTypeId?: number;
    name?: string | undefined;

    constructor(data?: ITaxResultTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxResultTypeId = _data["taxResultTypeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TaxResultTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxResultTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxResultTypeId"] = this.taxResultTypeId;
        data["name"] = this.name;
        return data;
    }
}

export interface ITaxResultTypeResponse {
    taxResultTypeId?: number;
    name?: string | undefined;
}

/** OData response message structure */
export class TaxResultTypeResponseODataWithMetadataResponse implements ITaxResultTypeResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: TaxResultTypeResponse[] | undefined;

    constructor(data?: ITaxResultTypeResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(TaxResultTypeResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxResultTypeResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxResultTypeResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ITaxResultTypeResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: TaxResultTypeResponse[] | undefined;
}

export class TaxResultWithNestedObjectsResponseAuditable implements ITaxResultWithNestedObjectsResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxResultId?: number;
    taxPolicy?: TaxPolicyWithNestedObjectShortResponse;
    taxResultType?: TaxResultTypeNestedObjectResponse;
    taxResultItems?: TaxResultItemNestedObjectResponse[] | undefined;
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: ITaxResultWithNestedObjectsResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.taxResultId = _data["taxResultId"];
            this.taxPolicy = _data["taxPolicy"] ? TaxPolicyWithNestedObjectShortResponse.fromJS(_data["taxPolicy"]) : undefined as any;
            this.taxResultType = _data["taxResultType"] ? TaxResultTypeNestedObjectResponse.fromJS(_data["taxResultType"]) : undefined as any;
            if (Array.isArray(_data["taxResultItems"])) {
                this.taxResultItems = [] as any;
                for (let item of _data["taxResultItems"])
                    this.taxResultItems!.push(TaxResultItemNestedObjectResponse.fromJS(item));
            }
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TaxResultWithNestedObjectsResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new TaxResultWithNestedObjectsResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["taxResultId"] = this.taxResultId;
        data["taxPolicy"] = this.taxPolicy ? this.taxPolicy.toJSON() : undefined as any;
        data["taxResultType"] = this.taxResultType ? this.taxResultType.toJSON() : undefined as any;
        if (Array.isArray(this.taxResultItems)) {
            data["taxResultItems"] = [];
            for (let item of this.taxResultItems)
                data["taxResultItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITaxResultWithNestedObjectsResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxResultId?: number;
    taxPolicy?: TaxPolicyWithNestedObjectShortResponse;
    taxResultType?: TaxResultTypeNestedObjectResponse;
    taxResultItems?: TaxResultItemNestedObjectResponse[] | undefined;
    name?: string | undefined;
    isActive?: boolean;
}

/** OData response message structure */
export class TaxResultWithNestedObjectsResponseAuditableODataWithMetadataResponse implements ITaxResultWithNestedObjectsResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: TaxResultWithNestedObjectsResponseAuditable[] | undefined;

    constructor(data?: ITaxResultWithNestedObjectsResponseAuditableODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(TaxResultWithNestedObjectsResponseAuditable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxResultWithNestedObjectsResponseAuditableODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxResultWithNestedObjectsResponseAuditableODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ITaxResultWithNestedObjectsResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: TaxResultWithNestedObjectsResponseAuditable[] | undefined;
}

export class TaxRule implements ITaxRule {
    taxRuleId?: number;
    taxPolicyId?: number;
    name!: string;
    rule!: string;
    isActive!: boolean;
    obsolete?: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    securityQuestionAnswers?: SecurityQuestionAnswer[] | undefined;
    securityTaxResultItems?: SecurityTaxResultItem[] | undefined;
    taxPolicies?: TaxPolicy[] | undefined;
    taxPolicy?: TaxPolicy;

    constructor(data?: ITaxRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxRuleId = _data["taxRuleId"];
            this.taxPolicyId = _data["taxPolicyId"];
            this.name = _data["name"];
            this.rule = _data["rule"];
            this.isActive = _data["isActive"];
            this.obsolete = _data["obsolete"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["securityQuestionAnswers"])) {
                this.securityQuestionAnswers = [] as any;
                for (let item of _data["securityQuestionAnswers"])
                    this.securityQuestionAnswers!.push(SecurityQuestionAnswer.fromJS(item));
            }
            if (Array.isArray(_data["securityTaxResultItems"])) {
                this.securityTaxResultItems = [] as any;
                for (let item of _data["securityTaxResultItems"])
                    this.securityTaxResultItems!.push(SecurityTaxResultItem.fromJS(item));
            }
            if (Array.isArray(_data["taxPolicies"])) {
                this.taxPolicies = [] as any;
                for (let item of _data["taxPolicies"])
                    this.taxPolicies!.push(TaxPolicy.fromJS(item));
            }
            this.taxPolicy = _data["taxPolicy"] ? TaxPolicy.fromJS(_data["taxPolicy"]) : undefined as any;
        }
    }

    static fromJS(data: any): TaxRule {
        data = typeof data === 'object' ? data : {};
        let result = new TaxRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxRuleId"] = this.taxRuleId;
        data["taxPolicyId"] = this.taxPolicyId;
        data["name"] = this.name;
        data["rule"] = this.rule;
        data["isActive"] = this.isActive;
        data["obsolete"] = this.obsolete;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.securityQuestionAnswers)) {
            data["securityQuestionAnswers"] = [];
            for (let item of this.securityQuestionAnswers)
                data["securityQuestionAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.securityTaxResultItems)) {
            data["securityTaxResultItems"] = [];
            for (let item of this.securityTaxResultItems)
                data["securityTaxResultItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.taxPolicies)) {
            data["taxPolicies"] = [];
            for (let item of this.taxPolicies)
                data["taxPolicies"].push(item ? item.toJSON() : undefined as any);
        }
        data["taxPolicy"] = this.taxPolicy ? this.taxPolicy.toJSON() : undefined as any;
        return data;
    }
}

export interface ITaxRule {
    taxRuleId?: number;
    taxPolicyId?: number;
    name: string;
    rule: string;
    isActive: boolean;
    obsolete?: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    securityQuestionAnswers?: SecurityQuestionAnswer[] | undefined;
    securityTaxResultItems?: SecurityTaxResultItem[] | undefined;
    taxPolicies?: TaxPolicy[] | undefined;
    taxPolicy?: TaxPolicy;
}

export class TaxRuleHistoryResponseAuditable implements ITaxRuleHistoryResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxRuleId?: number;
    taxPolicyId?: number;
    name?: string | undefined;
    rule?: string | undefined;
    isActive?: boolean;
    obsolete?: boolean;

    constructor(data?: ITaxRuleHistoryResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.taxRuleId = _data["taxRuleId"];
            this.taxPolicyId = _data["taxPolicyId"];
            this.name = _data["name"];
            this.rule = _data["rule"];
            this.isActive = _data["isActive"];
            this.obsolete = _data["obsolete"];
        }
    }

    static fromJS(data: any): TaxRuleHistoryResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new TaxRuleHistoryResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["taxRuleId"] = this.taxRuleId;
        data["taxPolicyId"] = this.taxPolicyId;
        data["name"] = this.name;
        data["rule"] = this.rule;
        data["isActive"] = this.isActive;
        data["obsolete"] = this.obsolete;
        return data;
    }
}

export interface ITaxRuleHistoryResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxRuleId?: number;
    taxPolicyId?: number;
    name?: string | undefined;
    rule?: string | undefined;
    isActive?: boolean;
    obsolete?: boolean;
}

/** OData response message structure */
export class TaxRuleHistoryResponseAuditableODataWithMetadataResponse implements ITaxRuleHistoryResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: TaxRuleHistoryResponseAuditable[] | undefined;

    constructor(data?: ITaxRuleHistoryResponseAuditableODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(TaxRuleHistoryResponseAuditable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxRuleHistoryResponseAuditableODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxRuleHistoryResponseAuditableODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ITaxRuleHistoryResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: TaxRuleHistoryResponseAuditable[] | undefined;
}

export class TaxRuleResponse implements ITaxRuleResponse {
    taxRuleId?: number;
    taxPolicyId?: number;
    name?: string | undefined;
    rule?: string | undefined;
    isActive?: boolean;
    obsolete?: boolean;

    constructor(data?: ITaxRuleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxRuleId = _data["taxRuleId"];
            this.taxPolicyId = _data["taxPolicyId"];
            this.name = _data["name"];
            this.rule = _data["rule"];
            this.isActive = _data["isActive"];
            this.obsolete = _data["obsolete"];
        }
    }

    static fromJS(data: any): TaxRuleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxRuleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxRuleId"] = this.taxRuleId;
        data["taxPolicyId"] = this.taxPolicyId;
        data["name"] = this.name;
        data["rule"] = this.rule;
        data["isActive"] = this.isActive;
        data["obsolete"] = this.obsolete;
        return data;
    }
}

export interface ITaxRuleResponse {
    taxRuleId?: number;
    taxPolicyId?: number;
    name?: string | undefined;
    rule?: string | undefined;
    isActive?: boolean;
    obsolete?: boolean;
}

export class TaxRuleShortResponse implements ITaxRuleShortResponse {
    taxRuleId?: number;
    name?: string | undefined;
    isActive?: boolean;
    obsolete?: boolean;

    constructor(data?: ITaxRuleShortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxRuleId = _data["taxRuleId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.obsolete = _data["obsolete"];
        }
    }

    static fromJS(data: any): TaxRuleShortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxRuleShortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxRuleId"] = this.taxRuleId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["obsolete"] = this.obsolete;
        return data;
    }
}

export interface ITaxRuleShortResponse {
    taxRuleId?: number;
    name?: string | undefined;
    isActive?: boolean;
    obsolete?: boolean;
}

export class TaxRuleWithNestedObjectResponseAuditable implements ITaxRuleWithNestedObjectResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxRuleId?: number;
    taxPolicy?: TaxPolicyWithNestedObjectShortResponse;
    name?: string | undefined;
    rule?: string | undefined;
    isActive?: boolean;
    obsolete?: boolean;

    constructor(data?: ITaxRuleWithNestedObjectResponseAuditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.taxRuleId = _data["taxRuleId"];
            this.taxPolicy = _data["taxPolicy"] ? TaxPolicyWithNestedObjectShortResponse.fromJS(_data["taxPolicy"]) : undefined as any;
            this.name = _data["name"];
            this.rule = _data["rule"];
            this.isActive = _data["isActive"];
            this.obsolete = _data["obsolete"];
        }
    }

    static fromJS(data: any): TaxRuleWithNestedObjectResponseAuditable {
        data = typeof data === 'object' ? data : {};
        let result = new TaxRuleWithNestedObjectResponseAuditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["taxRuleId"] = this.taxRuleId;
        data["taxPolicy"] = this.taxPolicy ? this.taxPolicy.toJSON() : undefined as any;
        data["name"] = this.name;
        data["rule"] = this.rule;
        data["isActive"] = this.isActive;
        data["obsolete"] = this.obsolete;
        return data;
    }
}

export interface ITaxRuleWithNestedObjectResponseAuditable {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxRuleId?: number;
    taxPolicy?: TaxPolicyWithNestedObjectShortResponse;
    name?: string | undefined;
    rule?: string | undefined;
    isActive?: boolean;
    obsolete?: boolean;
}

/** OData response message structure */
export class TaxRuleWithNestedObjectResponseAuditableODataWithMetadataResponse implements ITaxRuleWithNestedObjectResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: TaxRuleWithNestedObjectResponseAuditable[] | undefined;

    constructor(data?: ITaxRuleWithNestedObjectResponseAuditableODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(TaxRuleWithNestedObjectResponseAuditable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxRuleWithNestedObjectResponseAuditableODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxRuleWithNestedObjectResponseAuditableODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ITaxRuleWithNestedObjectResponseAuditableODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: TaxRuleWithNestedObjectResponseAuditable[] | undefined;
}

export class TaxSummary implements ITaxSummary {
    taxSummaryId?: number;
    countryId?: number;
    taxSummaryTypeId?: number;
    description!: string;
    isActive?: boolean;
    isApproved?: boolean;
    actualFrom?: Date;
    reviewDate?: Date | undefined;
    approvedOn?: Date | undefined;
    approvedBy?: string | undefined;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    country?: Country;
    taxRateSummaries?: TaxRateSummary[] | undefined;
    taxSummaryType?: TaxSummaryType;

    constructor(data?: ITaxSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxSummaryId = _data["taxSummaryId"];
            this.countryId = _data["countryId"];
            this.taxSummaryTypeId = _data["taxSummaryTypeId"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isApproved = _data["isApproved"];
            this.actualFrom = _data["actualFrom"] ? new Date(_data["actualFrom"].toString()) : undefined as any;
            this.reviewDate = _data["reviewDate"] ? new Date(_data["reviewDate"].toString()) : undefined as any;
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : undefined as any;
            this.approvedBy = _data["approvedBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : undefined as any;
            if (Array.isArray(_data["taxRateSummaries"])) {
                this.taxRateSummaries = [] as any;
                for (let item of _data["taxRateSummaries"])
                    this.taxRateSummaries!.push(TaxRateSummary.fromJS(item));
            }
            this.taxSummaryType = _data["taxSummaryType"] ? TaxSummaryType.fromJS(_data["taxSummaryType"]) : undefined as any;
        }
    }

    static fromJS(data: any): TaxSummary {
        data = typeof data === 'object' ? data : {};
        let result = new TaxSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxSummaryId"] = this.taxSummaryId;
        data["countryId"] = this.countryId;
        data["taxSummaryTypeId"] = this.taxSummaryTypeId;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isApproved"] = this.isApproved;
        data["actualFrom"] = this.actualFrom ? this.actualFrom.toISOString() : undefined as any;
        data["reviewDate"] = this.reviewDate ? this.reviewDate.toISOString() : undefined as any;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : undefined as any;
        data["approvedBy"] = this.approvedBy;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        if (Array.isArray(this.taxRateSummaries)) {
            data["taxRateSummaries"] = [];
            for (let item of this.taxRateSummaries)
                data["taxRateSummaries"].push(item ? item.toJSON() : undefined as any);
        }
        data["taxSummaryType"] = this.taxSummaryType ? this.taxSummaryType.toJSON() : undefined as any;
        return data;
    }
}

export interface ITaxSummary {
    taxSummaryId?: number;
    countryId?: number;
    taxSummaryTypeId?: number;
    description: string;
    isActive?: boolean;
    isApproved?: boolean;
    actualFrom?: Date;
    reviewDate?: Date | undefined;
    approvedOn?: Date | undefined;
    approvedBy?: string | undefined;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    country?: Country;
    taxRateSummaries?: TaxRateSummary[] | undefined;
    taxSummaryType?: TaxSummaryType;
}

export class TaxSummaryHeaderType implements ITaxSummaryHeaderType {
    taxSummaryHeaderTypeId?: number;
    name!: string;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    taxSummaryTypes?: TaxSummaryType[] | undefined;

    constructor(data?: ITaxSummaryHeaderType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxSummaryHeaderTypeId = _data["taxSummaryHeaderTypeId"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["taxSummaryTypes"])) {
                this.taxSummaryTypes = [] as any;
                for (let item of _data["taxSummaryTypes"])
                    this.taxSummaryTypes!.push(TaxSummaryType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxSummaryHeaderType {
        data = typeof data === 'object' ? data : {};
        let result = new TaxSummaryHeaderType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxSummaryHeaderTypeId"] = this.taxSummaryHeaderTypeId;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.taxSummaryTypes)) {
            data["taxSummaryTypes"] = [];
            for (let item of this.taxSummaryTypes)
                data["taxSummaryTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaxSummaryHeaderType {
    taxSummaryHeaderTypeId?: number;
    name: string;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    taxSummaryTypes?: TaxSummaryType[] | undefined;
}

export class TaxSummaryHeaderTypeResponse implements ITaxSummaryHeaderTypeResponse {
    taxSummaryHeaderTypeId?: number;
    name?: string | undefined;

    constructor(data?: ITaxSummaryHeaderTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxSummaryHeaderTypeId = _data["taxSummaryHeaderTypeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TaxSummaryHeaderTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxSummaryHeaderTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxSummaryHeaderTypeId"] = this.taxSummaryHeaderTypeId;
        data["name"] = this.name;
        return data;
    }
}

export interface ITaxSummaryHeaderTypeResponse {
    taxSummaryHeaderTypeId?: number;
    name?: string | undefined;
}

/** OData response message structure */
export class TaxSummaryHeaderTypeResponseODataWithMetadataResponse implements ITaxSummaryHeaderTypeResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: TaxSummaryHeaderTypeResponse[] | undefined;

    constructor(data?: ITaxSummaryHeaderTypeResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(TaxSummaryHeaderTypeResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxSummaryHeaderTypeResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxSummaryHeaderTypeResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ITaxSummaryHeaderTypeResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: TaxSummaryHeaderTypeResponse[] | undefined;
}

export class TaxSummaryResponse implements ITaxSummaryResponse {
    taxSummaryId?: number;
    countryId?: number;
    taxSummaryTypeId?: number;
    description?: string | undefined;
    isActive?: boolean;
    isApproved?: boolean;
    actualFrom?: Date;
    reviewDate?: Date | undefined;
    approvedOn?: Date | undefined;
    approvedBy?: string | undefined;

    constructor(data?: ITaxSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxSummaryId = _data["taxSummaryId"];
            this.countryId = _data["countryId"];
            this.taxSummaryTypeId = _data["taxSummaryTypeId"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isApproved = _data["isApproved"];
            this.actualFrom = _data["actualFrom"] ? new Date(_data["actualFrom"].toString()) : undefined as any;
            this.reviewDate = _data["reviewDate"] ? new Date(_data["reviewDate"].toString()) : undefined as any;
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : undefined as any;
            this.approvedBy = _data["approvedBy"];
        }
    }

    static fromJS(data: any): TaxSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxSummaryId"] = this.taxSummaryId;
        data["countryId"] = this.countryId;
        data["taxSummaryTypeId"] = this.taxSummaryTypeId;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isApproved"] = this.isApproved;
        data["actualFrom"] = this.actualFrom ? this.actualFrom.toISOString() : undefined as any;
        data["reviewDate"] = this.reviewDate ? this.reviewDate.toISOString() : undefined as any;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : undefined as any;
        data["approvedBy"] = this.approvedBy;
        return data;
    }
}

export interface ITaxSummaryResponse {
    taxSummaryId?: number;
    countryId?: number;
    taxSummaryTypeId?: number;
    description?: string | undefined;
    isActive?: boolean;
    isApproved?: boolean;
    actualFrom?: Date;
    reviewDate?: Date | undefined;
    approvedOn?: Date | undefined;
    approvedBy?: string | undefined;
}

export class TaxSummaryType implements ITaxSummaryType {
    taxSummaryTypeId?: number;
    name!: string;
    taxSummaryHeaderTypeId?: number | undefined;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    taxSummaries?: TaxSummary[] | undefined;
    taxSummaryHeaderType?: TaxSummaryHeaderType;

    constructor(data?: ITaxSummaryType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxSummaryTypeId = _data["taxSummaryTypeId"];
            this.name = _data["name"];
            this.taxSummaryHeaderTypeId = _data["taxSummaryHeaderTypeId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["taxSummaries"])) {
                this.taxSummaries = [] as any;
                for (let item of _data["taxSummaries"])
                    this.taxSummaries!.push(TaxSummary.fromJS(item));
            }
            this.taxSummaryHeaderType = _data["taxSummaryHeaderType"] ? TaxSummaryHeaderType.fromJS(_data["taxSummaryHeaderType"]) : undefined as any;
        }
    }

    static fromJS(data: any): TaxSummaryType {
        data = typeof data === 'object' ? data : {};
        let result = new TaxSummaryType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxSummaryTypeId"] = this.taxSummaryTypeId;
        data["name"] = this.name;
        data["taxSummaryHeaderTypeId"] = this.taxSummaryHeaderTypeId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.taxSummaries)) {
            data["taxSummaries"] = [];
            for (let item of this.taxSummaries)
                data["taxSummaries"].push(item ? item.toJSON() : undefined as any);
        }
        data["taxSummaryHeaderType"] = this.taxSummaryHeaderType ? this.taxSummaryHeaderType.toJSON() : undefined as any;
        return data;
    }
}

export interface ITaxSummaryType {
    taxSummaryTypeId?: number;
    name: string;
    taxSummaryHeaderTypeId?: number | undefined;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    taxSummaries?: TaxSummary[] | undefined;
    taxSummaryHeaderType?: TaxSummaryHeaderType;
}

export class TaxSummaryTypeResponse implements ITaxSummaryTypeResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxSummaryTypeId?: number;
    name?: string | undefined;
    taxSummaryHeaderTypeId?: number | undefined;

    constructor(data?: ITaxSummaryTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.taxSummaryTypeId = _data["taxSummaryTypeId"];
            this.name = _data["name"];
            this.taxSummaryHeaderTypeId = _data["taxSummaryHeaderTypeId"];
        }
    }

    static fromJS(data: any): TaxSummaryTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxSummaryTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["taxSummaryTypeId"] = this.taxSummaryTypeId;
        data["name"] = this.name;
        data["taxSummaryHeaderTypeId"] = this.taxSummaryHeaderTypeId;
        return data;
    }
}

export interface ITaxSummaryTypeResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxSummaryTypeId?: number;
    name?: string | undefined;
    taxSummaryHeaderTypeId?: number | undefined;
}

export class TaxSummaryTypeWithNestedObjectResponse implements ITaxSummaryTypeWithNestedObjectResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxSummaryTypeId?: number;
    name?: string | undefined;
    taxSummaryHeaderType?: TaxSummaryHeaderTypeResponse;

    constructor(data?: ITaxSummaryTypeWithNestedObjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.taxSummaryTypeId = _data["taxSummaryTypeId"];
            this.name = _data["name"];
            this.taxSummaryHeaderType = _data["taxSummaryHeaderType"] ? TaxSummaryHeaderTypeResponse.fromJS(_data["taxSummaryHeaderType"]) : undefined as any;
        }
    }

    static fromJS(data: any): TaxSummaryTypeWithNestedObjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxSummaryTypeWithNestedObjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["taxSummaryTypeId"] = this.taxSummaryTypeId;
        data["name"] = this.name;
        data["taxSummaryHeaderType"] = this.taxSummaryHeaderType ? this.taxSummaryHeaderType.toJSON() : undefined as any;
        return data;
    }
}

export interface ITaxSummaryTypeWithNestedObjectResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxSummaryTypeId?: number;
    name?: string | undefined;
    taxSummaryHeaderType?: TaxSummaryHeaderTypeResponse;
}

/** OData response message structure */
export class TaxSummaryTypeWithNestedObjectResponseODataWithMetadataResponse implements ITaxSummaryTypeWithNestedObjectResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: TaxSummaryTypeWithNestedObjectResponse[] | undefined;

    constructor(data?: ITaxSummaryTypeWithNestedObjectResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(TaxSummaryTypeWithNestedObjectResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxSummaryTypeWithNestedObjectResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxSummaryTypeWithNestedObjectResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ITaxSummaryTypeWithNestedObjectResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: TaxSummaryTypeWithNestedObjectResponse[] | undefined;
}

export class TaxSummaryWithNestedObjectsResponse implements ITaxSummaryWithNestedObjectsResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxSummaryId?: number;
    countryId?: number;
    taxSummaryType?: TaxSummaryTypeWithNestedObjectResponse;
    taxRateSummaries?: TaxRateSummary[] | undefined;
    description?: string | undefined;
    isActive?: boolean;
    isApproved?: boolean;
    actualFrom?: Date;
    reviewDate?: Date | undefined;
    approvedOn?: Date | undefined;
    approvedBy?: string | undefined;

    constructor(data?: ITaxSummaryWithNestedObjectsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.taxSummaryId = _data["taxSummaryId"];
            this.countryId = _data["countryId"];
            this.taxSummaryType = _data["taxSummaryType"] ? TaxSummaryTypeWithNestedObjectResponse.fromJS(_data["taxSummaryType"]) : undefined as any;
            if (Array.isArray(_data["taxRateSummaries"])) {
                this.taxRateSummaries = [] as any;
                for (let item of _data["taxRateSummaries"])
                    this.taxRateSummaries!.push(TaxRateSummary.fromJS(item));
            }
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isApproved = _data["isApproved"];
            this.actualFrom = _data["actualFrom"] ? new Date(_data["actualFrom"].toString()) : undefined as any;
            this.reviewDate = _data["reviewDate"] ? new Date(_data["reviewDate"].toString()) : undefined as any;
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : undefined as any;
            this.approvedBy = _data["approvedBy"];
        }
    }

    static fromJS(data: any): TaxSummaryWithNestedObjectsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxSummaryWithNestedObjectsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["taxSummaryId"] = this.taxSummaryId;
        data["countryId"] = this.countryId;
        data["taxSummaryType"] = this.taxSummaryType ? this.taxSummaryType.toJSON() : undefined as any;
        if (Array.isArray(this.taxRateSummaries)) {
            data["taxRateSummaries"] = [];
            for (let item of this.taxRateSummaries)
                data["taxRateSummaries"].push(item ? item.toJSON() : undefined as any);
        }
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isApproved"] = this.isApproved;
        data["actualFrom"] = this.actualFrom ? this.actualFrom.toISOString() : undefined as any;
        data["reviewDate"] = this.reviewDate ? this.reviewDate.toISOString() : undefined as any;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : undefined as any;
        data["approvedBy"] = this.approvedBy;
        return data;
    }
}

export interface ITaxSummaryWithNestedObjectsResponse {
    created?: Date;
    createdBy?: string | undefined;
    modified?: Date;
    modifiedBy?: string | undefined;
    taxSummaryId?: number;
    countryId?: number;
    taxSummaryType?: TaxSummaryTypeWithNestedObjectResponse;
    taxRateSummaries?: TaxRateSummary[] | undefined;
    description?: string | undefined;
    isActive?: boolean;
    isApproved?: boolean;
    actualFrom?: Date;
    reviewDate?: Date | undefined;
    approvedOn?: Date | undefined;
    approvedBy?: string | undefined;
}

/** OData response message structure */
export class TaxSummaryWithNestedObjectsResponseODataWithMetadataResponse implements ITaxSummaryWithNestedObjectsResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: TaxSummaryWithNestedObjectsResponse[] | undefined;

    constructor(data?: ITaxSummaryWithNestedObjectsResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(TaxSummaryWithNestedObjectsResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxSummaryWithNestedObjectsResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxSummaryWithNestedObjectsResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ITaxSummaryWithNestedObjectsResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: TaxSummaryWithNestedObjectsResponse[] | undefined;
}

export class TransactionType implements ITransactionType {
    transactionTypeId?: number;
    name!: string;
    description?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    securities?: Security[] | undefined;

    constructor(data?: ITransactionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionTypeId = _data["transactionTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["securities"])) {
                this.securities = [] as any;
                for (let item of _data["securities"])
                    this.securities!.push(Security.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransactionType {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionTypeId"] = this.transactionTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.securities)) {
            data["securities"] = [];
            for (let item of this.securities)
                data["securities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITransactionType {
    transactionTypeId?: number;
    name: string;
    description?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    securities?: Security[] | undefined;
}

export enum TransactionTypeEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class TransactionTypeNestedResponse implements ITransactionTypeNestedResponse {
    transactionTypeId?: number;
    name?: string | undefined;

    constructor(data?: ITransactionTypeNestedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionTypeId = _data["transactionTypeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TransactionTypeNestedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionTypeNestedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionTypeId"] = this.transactionTypeId;
        data["name"] = this.name;
        return data;
    }
}

export interface ITransactionTypeNestedResponse {
    transactionTypeId?: number;
    name?: string | undefined;
}

export class TransactionTypeResponse implements ITransactionTypeResponse {
    transactionTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;

    constructor(data?: ITransactionTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionTypeId = _data["transactionTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TransactionTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionTypeId"] = this.transactionTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITransactionTypeResponse {
    transactionTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
}

/** OData response message structure */
export class TransactionTypeResponseODataWithMetadataResponse implements ITransactionTypeResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: TransactionTypeResponse[] | undefined;

    constructor(data?: ITransactionTypeResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(TransactionTypeResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransactionTypeResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionTypeResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface ITransactionTypeResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: TransactionTypeResponse[] | undefined;
}

export class UpdateApplicationNotificationRequest implements IUpdateApplicationNotificationRequest {
    title!: string;
    description?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    applicationNotificationId?: number;
    isActive?: boolean;

    constructor(data?: IUpdateApplicationNotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined as any;
            this.applicationNotificationId = _data["applicationNotificationId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateApplicationNotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateApplicationNotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        data["applicationNotificationId"] = this.applicationNotificationId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateApplicationNotificationRequest {
    title: string;
    description?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    applicationNotificationId?: number;
    isActive?: boolean;
}

export class UpdateClientAssignmentRequest implements IUpdateClientAssignmentRequest {
    clientId!: number;
    userId!: string;
    isActive!: boolean;
    clientAssignmentId!: number;

    constructor(data?: IUpdateClientAssignmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.userId = _data["userId"];
            this.isActive = _data["isActive"];
            this.clientAssignmentId = _data["clientAssignmentId"];
        }
    }

    static fromJS(data: any): UpdateClientAssignmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientAssignmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["userId"] = this.userId;
        data["isActive"] = this.isActive;
        data["clientAssignmentId"] = this.clientAssignmentId;
        return data;
    }
}

export interface IUpdateClientAssignmentRequest {
    clientId: number;
    userId: string;
    isActive: boolean;
    clientAssignmentId: number;
}

export class UpdateClientConfigurationRequest implements IUpdateClientConfigurationRequest {
    clientId!: number;
    key!: string;
    value?: string | undefined;
    clientConfigurationId!: number;

    constructor(data?: IUpdateClientConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.key = _data["key"];
            this.value = _data["value"];
            this.clientConfigurationId = _data["clientConfigurationId"];
        }
    }

    static fromJS(data: any): UpdateClientConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["key"] = this.key;
        data["value"] = this.value;
        data["clientConfigurationId"] = this.clientConfigurationId;
        return data;
    }
}

export interface IUpdateClientConfigurationRequest {
    clientId: number;
    key: string;
    value?: string | undefined;
    clientConfigurationId: number;
}

export class UpdateClientRequest implements IUpdateClientRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    clientId!: number;

    constructor(data?: IUpdateClientRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): UpdateClientRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IUpdateClientRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
    clientId: number;
}

export class UpdateCountryMaterialRequest implements IUpdateCountryMaterialRequest {
    clientId?: number;
    countryId?: number;
    isActive?: boolean;
    countryMaterialId?: number;

    constructor(data?: IUpdateCountryMaterialRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.countryId = _data["countryId"];
            this.isActive = _data["isActive"];
            this.countryMaterialId = _data["countryMaterialId"];
        }
    }

    static fromJS(data: any): UpdateCountryMaterialRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCountryMaterialRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["countryId"] = this.countryId;
        data["isActive"] = this.isActive;
        data["countryMaterialId"] = this.countryMaterialId;
        return data;
    }
}

export interface IUpdateCountryMaterialRequest {
    clientId?: number;
    countryId?: number;
    isActive?: boolean;
    countryMaterialId?: number;
}

export class UpdateCountryRequest implements IUpdateCountryRequest {
    regionId!: number;
    name!: string;
    isActive!: boolean;
    countryId!: number;

    constructor(data?: IUpdateCountryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regionId = _data["regionId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): UpdateCountryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCountryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface IUpdateCountryRequest {
    regionId: number;
    name: string;
    isActive: boolean;
    countryId: number;
}

export class UpdateCountryTaxNewsRequest implements IUpdateCountryTaxNewsRequest {
    name!: string;
    description!: string;
    newsDate!: Date;
    countryIds!: number[];
    isActive?: boolean;
    countryTaxNewsId!: number;

    constructor(data?: IUpdateCountryTaxNewsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.countryIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.newsDate = _data["newsDate"] ? new Date(_data["newsDate"].toString()) : undefined as any;
            if (Array.isArray(_data["countryIds"])) {
                this.countryIds = [] as any;
                for (let item of _data["countryIds"])
                    this.countryIds!.push(item);
            }
            this.isActive = _data["isActive"];
            this.countryTaxNewsId = _data["countryTaxNewsId"];
        }
    }

    static fromJS(data: any): UpdateCountryTaxNewsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCountryTaxNewsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["newsDate"] = this.newsDate ? this.newsDate.toISOString() : undefined as any;
        if (Array.isArray(this.countryIds)) {
            data["countryIds"] = [];
            for (let item of this.countryIds)
                data["countryIds"].push(item);
        }
        data["isActive"] = this.isActive;
        data["countryTaxNewsId"] = this.countryTaxNewsId;
        return data;
    }
}

export interface IUpdateCountryTaxNewsRequest {
    name: string;
    description: string;
    newsDate: Date;
    countryIds: number[];
    isActive?: boolean;
    countryTaxNewsId: number;
}

export class UpdateDispositionDateSecurityRequest implements IUpdateDispositionDateSecurityRequest {
    dispositionDate?: Date | undefined;

    constructor(data?: IUpdateDispositionDateSecurityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dispositionDate = _data["dispositionDate"] ? new Date(_data["dispositionDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateDispositionDateSecurityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDispositionDateSecurityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dispositionDate"] = this.dispositionDate ? this.dispositionDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IUpdateDispositionDateSecurityRequest {
    dispositionDate?: Date | undefined;
}

export class UpdateEntityRequest implements IUpdateEntityRequest {
    clientId?: number;
    residencyJurisdictionId?: number;
    entityTypeId?: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    entityId!: number;

    constructor(data?: IUpdateEntityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.residencyJurisdictionId = _data["residencyJurisdictionId"];
            this.entityTypeId = _data["entityTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.entityId = _data["entityId"];
        }
    }

    static fromJS(data: any): UpdateEntityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEntityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["residencyJurisdictionId"] = this.residencyJurisdictionId;
        data["entityTypeId"] = this.entityTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["entityId"] = this.entityId;
        return data;
    }
}

export interface IUpdateEntityRequest {
    clientId?: number;
    residencyJurisdictionId?: number;
    entityTypeId?: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    entityId: number;
}

export class UpdateEntityTypeRequest implements IUpdateEntityTypeRequest {
    countryId?: number | undefined;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    entityTypeInvestmentJurisdiction?: CreateEntityTypeTargetInvestmentJurisdictionRequest[] | undefined;
    entityTypeId!: number;

    constructor(data?: IUpdateEntityTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["entityTypeInvestmentJurisdiction"])) {
                this.entityTypeInvestmentJurisdiction = [] as any;
                for (let item of _data["entityTypeInvestmentJurisdiction"])
                    this.entityTypeInvestmentJurisdiction!.push(CreateEntityTypeTargetInvestmentJurisdictionRequest.fromJS(item));
            }
            this.entityTypeId = _data["entityTypeId"];
        }
    }

    static fromJS(data: any): UpdateEntityTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEntityTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.entityTypeInvestmentJurisdiction)) {
            data["entityTypeInvestmentJurisdiction"] = [];
            for (let item of this.entityTypeInvestmentJurisdiction)
                data["entityTypeInvestmentJurisdiction"].push(item ? item.toJSON() : undefined as any);
        }
        data["entityTypeId"] = this.entityTypeId;
        return data;
    }
}

export interface IUpdateEntityTypeRequest {
    countryId?: number | undefined;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    entityTypeInvestmentJurisdiction?: CreateEntityTypeTargetInvestmentJurisdictionRequest[] | undefined;
    entityTypeId: number;
}

export class UpdateExternalSystemRequest implements IUpdateExternalSystemRequest {
    name!: string;
    externalSystemId!: number;

    constructor(data?: IUpdateExternalSystemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.externalSystemId = _data["externalSystemId"];
        }
    }

    static fromJS(data: any): UpdateExternalSystemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExternalSystemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["externalSystemId"] = this.externalSystemId;
        return data;
    }
}

export interface IUpdateExternalSystemRequest {
    name: string;
    externalSystemId: number;
}

export class UpdateExternalUserRequest implements IUpdateExternalUserRequest {
    email!: string;
    firstName!: string;
    lastName!: string;
    organization!: string;
    territory!: string;
    isActive!: boolean;
    termsAndPrivacyAccepted!: boolean;
    id!: string;

    constructor(data?: IUpdateExternalUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.organization = _data["organization"];
            this.territory = _data["territory"];
            this.isActive = _data["isActive"];
            this.termsAndPrivacyAccepted = _data["termsAndPrivacyAccepted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateExternalUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExternalUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["organization"] = this.organization;
        data["territory"] = this.territory;
        data["isActive"] = this.isActive;
        data["termsAndPrivacyAccepted"] = this.termsAndPrivacyAccepted;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateExternalUserRequest {
    email: string;
    firstName: string;
    lastName: string;
    organization: string;
    territory: string;
    isActive: boolean;
    termsAndPrivacyAccepted: boolean;
    id: string;
}

export class UpdateGeneralCountryInformationRequest implements IUpdateGeneralCountryInformationRequest {
    countryId!: number;
    generalCountryInformationTypeId!: number;
    description!: string;
    isActive!: boolean;
    isApproved?: boolean;
    approvedBy?: string | undefined;
    approvedOn?: Date;
    actualFrom!: Date;
    reviewDate?: Date;
    generalCountryInformationId!: number;

    constructor(data?: IUpdateGeneralCountryInformationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.generalCountryInformationTypeId = _data["generalCountryInformationTypeId"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isApproved = _data["isApproved"];
            this.approvedBy = _data["approvedBy"];
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : undefined as any;
            this.actualFrom = _data["actualFrom"] ? new Date(_data["actualFrom"].toString()) : undefined as any;
            this.reviewDate = _data["reviewDate"] ? new Date(_data["reviewDate"].toString()) : undefined as any;
            this.generalCountryInformationId = _data["generalCountryInformationId"];
        }
    }

    static fromJS(data: any): UpdateGeneralCountryInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeneralCountryInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["generalCountryInformationTypeId"] = this.generalCountryInformationTypeId;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isApproved"] = this.isApproved;
        data["approvedBy"] = this.approvedBy;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : undefined as any;
        data["actualFrom"] = this.actualFrom ? this.actualFrom.toISOString() : undefined as any;
        data["reviewDate"] = this.reviewDate ? this.reviewDate.toISOString() : undefined as any;
        data["generalCountryInformationId"] = this.generalCountryInformationId;
        return data;
    }
}

export interface IUpdateGeneralCountryInformationRequest {
    countryId: number;
    generalCountryInformationTypeId: number;
    description: string;
    isActive: boolean;
    isApproved?: boolean;
    approvedBy?: string | undefined;
    approvedOn?: Date;
    actualFrom: Date;
    reviewDate?: Date;
    generalCountryInformationId: number;
}

export class UpdateGeneralRateRulesEditorRateRequest implements IUpdateGeneralRateRulesEditorRateRequest {
    generalRateRulesEditorRateId?: number | undefined;
    rate?: number;

    constructor(data?: IUpdateGeneralRateRulesEditorRateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generalRateRulesEditorRateId = _data["generalRateRulesEditorRateId"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): UpdateGeneralRateRulesEditorRateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeneralRateRulesEditorRateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalRateRulesEditorRateId"] = this.generalRateRulesEditorRateId;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IUpdateGeneralRateRulesEditorRateRequest {
    generalRateRulesEditorRateId?: number | undefined;
    rate?: number;
}

export class UpdateGeneralRateRulesEditorRequest implements IUpdateGeneralRateRulesEditorRequest {
    generalRateRulesEditorId?: number;
    description?: string | undefined;
    generalRateRulesEditorRates!: UpdateGeneralRateRulesEditorRateRequest[];

    constructor(data?: IUpdateGeneralRateRulesEditorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.generalRateRulesEditorRates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generalRateRulesEditorId = _data["generalRateRulesEditorId"];
            this.description = _data["description"];
            if (Array.isArray(_data["generalRateRulesEditorRates"])) {
                this.generalRateRulesEditorRates = [] as any;
                for (let item of _data["generalRateRulesEditorRates"])
                    this.generalRateRulesEditorRates!.push(UpdateGeneralRateRulesEditorRateRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateGeneralRateRulesEditorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeneralRateRulesEditorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalRateRulesEditorId"] = this.generalRateRulesEditorId;
        data["description"] = this.description;
        if (Array.isArray(this.generalRateRulesEditorRates)) {
            data["generalRateRulesEditorRates"] = [];
            for (let item of this.generalRateRulesEditorRates)
                data["generalRateRulesEditorRates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateGeneralRateRulesEditorRequest {
    generalRateRulesEditorId?: number;
    description?: string | undefined;
    generalRateRulesEditorRates: UpdateGeneralRateRulesEditorRateRequest[];
}

export class UpdateInternalUserRequest implements IUpdateInternalUserRequest {
    email!: string;
    firstName!: string;
    lastName!: string;
    isActive!: boolean;
    termsAndPrivacyAccepted!: boolean;
    id!: string;

    constructor(data?: IUpdateInternalUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isActive = _data["isActive"];
            this.termsAndPrivacyAccepted = _data["termsAndPrivacyAccepted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateInternalUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInternalUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isActive"] = this.isActive;
        data["termsAndPrivacyAccepted"] = this.termsAndPrivacyAccepted;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateInternalUserRequest {
    email: string;
    firstName: string;
    lastName: string;
    isActive: boolean;
    termsAndPrivacyAccepted: boolean;
    id: string;
}

export class UpdateInvestmentJurisdictionRequest implements IUpdateInvestmentJurisdictionRequest {
    countryId!: number;
    isActive!: boolean;
    isDisplay!: boolean;
    investmentJurisdictionId!: number;

    constructor(data?: IUpdateInvestmentJurisdictionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.isActive = _data["isActive"];
            this.isDisplay = _data["isDisplay"];
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
        }
    }

    static fromJS(data: any): UpdateInvestmentJurisdictionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvestmentJurisdictionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["isActive"] = this.isActive;
        data["isDisplay"] = this.isDisplay;
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        return data;
    }
}

export interface IUpdateInvestmentJurisdictionRequest {
    countryId: number;
    isActive: boolean;
    isDisplay: boolean;
    investmentJurisdictionId: number;
}

export class UpdateQuestionRequest implements IUpdateQuestionRequest {
    text?: string | undefined;
    countryList?: string | undefined;
    isActive!: boolean;
    questionId?: number;

    constructor(data?: IUpdateQuestionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.countryList = _data["countryList"];
            this.isActive = _data["isActive"];
            this.questionId = _data["questionId"];
        }
    }

    static fromJS(data: any): UpdateQuestionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuestionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["countryList"] = this.countryList;
        data["isActive"] = this.isActive;
        data["questionId"] = this.questionId;
        return data;
    }
}

export interface IUpdateQuestionRequest {
    text?: string | undefined;
    countryList?: string | undefined;
    isActive: boolean;
    questionId?: number;
}

export class UpdateRegionRequest implements IUpdateRegionRequest {
    name!: string;
    isActive!: boolean;
    regionId!: number;

    constructor(data?: IUpdateRegionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.regionId = _data["regionId"];
        }
    }

    static fromJS(data: any): UpdateRegionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRegionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["regionId"] = this.regionId;
        return data;
    }
}

export interface IUpdateRegionRequest {
    name: string;
    isActive: boolean;
    regionId: number;
}

export class UpdateResidencyJurisdictionRequest implements IUpdateResidencyJurisdictionRequest {
    countryId!: number;
    isActive!: boolean;
    residencyJurisdictionId!: number;

    constructor(data?: IUpdateResidencyJurisdictionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.isActive = _data["isActive"];
            this.residencyJurisdictionId = _data["residencyJurisdictionId"];
        }
    }

    static fromJS(data: any): UpdateResidencyJurisdictionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateResidencyJurisdictionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["isActive"] = this.isActive;
        data["residencyJurisdictionId"] = this.residencyJurisdictionId;
        return data;
    }
}

export interface IUpdateResidencyJurisdictionRequest {
    countryId: number;
    isActive: boolean;
    residencyJurisdictionId: number;
}

export class UpdateSecurityNotificationRequest implements IUpdateSecurityNotificationRequest {
    securityId!: number;
    userId!: string;
    securityNotificationTypeId?: number;
    isNotified!: boolean;
    description!: string;
    securityNotificationId!: number;

    constructor(data?: IUpdateSecurityNotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityId = _data["securityId"];
            this.userId = _data["userId"];
            this.securityNotificationTypeId = _data["securityNotificationTypeId"];
            this.isNotified = _data["isNotified"];
            this.description = _data["description"];
            this.securityNotificationId = _data["securityNotificationId"];
        }
    }

    static fromJS(data: any): UpdateSecurityNotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSecurityNotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityId"] = this.securityId;
        data["userId"] = this.userId;
        data["securityNotificationTypeId"] = this.securityNotificationTypeId;
        data["isNotified"] = this.isNotified;
        data["description"] = this.description;
        data["securityNotificationId"] = this.securityNotificationId;
        return data;
    }
}

export interface IUpdateSecurityNotificationRequest {
    securityId: number;
    userId: string;
    securityNotificationTypeId?: number;
    isNotified: boolean;
    description: string;
    securityNotificationId: number;
}

export class UpdateSecurityQuestionAnswerRequest implements IUpdateSecurityQuestionAnswerRequest {
    questionId?: number;
    answer?: string | undefined;
    comment?: string | undefined;
    unsureAnswer?: boolean;
    taxPolicyId?: number;
    taxRuleId?: number;
    isActive?: boolean;
    securityQuestionAnswerId?: number;

    constructor(data?: IUpdateSecurityQuestionAnswerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.answer = _data["answer"];
            this.comment = _data["comment"];
            this.unsureAnswer = _data["unsureAnswer"];
            this.taxPolicyId = _data["taxPolicyId"];
            this.taxRuleId = _data["taxRuleId"];
            this.isActive = _data["isActive"];
            this.securityQuestionAnswerId = _data["securityQuestionAnswerId"];
        }
    }

    static fromJS(data: any): UpdateSecurityQuestionAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSecurityQuestionAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["answer"] = this.answer;
        data["comment"] = this.comment;
        data["unsureAnswer"] = this.unsureAnswer;
        data["taxPolicyId"] = this.taxPolicyId;
        data["taxRuleId"] = this.taxRuleId;
        data["isActive"] = this.isActive;
        data["securityQuestionAnswerId"] = this.securityQuestionAnswerId;
        return data;
    }
}

export interface IUpdateSecurityQuestionAnswerRequest {
    questionId?: number;
    answer?: string | undefined;
    comment?: string | undefined;
    unsureAnswer?: boolean;
    taxPolicyId?: number;
    taxRuleId?: number;
    isActive?: boolean;
    securityQuestionAnswerId?: number;
}

export class UpdateSecurityRequest implements IUpdateSecurityRequest {
    entityId?: number;
    clientId?: number | undefined;
    generalRateEntityTypeId?: number | undefined;
    investmentJurisdictionId?: number;
    transactionTypeId?: number;
    securityTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    ownership?: number | undefined;
    isinCusip?: string | undefined;
    acquisitionDate?: Date | undefined;
    dispositionDate?: Date | undefined;
    taxRates?: UpdateSecurityTaxRateRequest[] | undefined;
    questionAnswers?: UpdateSecurityQuestionAnswerRequest[] | undefined;
    securityId?: number;
    comment?: string | undefined;
    adminComment?: string | undefined;
    skipNotification?: boolean;

    constructor(data?: IUpdateSecurityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.clientId = _data["clientId"];
            this.generalRateEntityTypeId = _data["generalRateEntityTypeId"];
            this.investmentJurisdictionId = _data["investmentJurisdictionId"];
            this.transactionTypeId = _data["transactionTypeId"];
            this.securityTypeId = _data["securityTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.ownership = _data["ownership"];
            this.isinCusip = _data["isinCusip"];
            this.acquisitionDate = _data["acquisitionDate"] ? new Date(_data["acquisitionDate"].toString()) : undefined as any;
            this.dispositionDate = _data["dispositionDate"] ? new Date(_data["dispositionDate"].toString()) : undefined as any;
            if (Array.isArray(_data["taxRates"])) {
                this.taxRates = [] as any;
                for (let item of _data["taxRates"])
                    this.taxRates!.push(UpdateSecurityTaxRateRequest.fromJS(item));
            }
            if (Array.isArray(_data["questionAnswers"])) {
                this.questionAnswers = [] as any;
                for (let item of _data["questionAnswers"])
                    this.questionAnswers!.push(UpdateSecurityQuestionAnswerRequest.fromJS(item));
            }
            this.securityId = _data["securityId"];
            this.comment = _data["comment"];
            this.adminComment = _data["adminComment"];
            this.skipNotification = _data["skipNotification"];
        }
    }

    static fromJS(data: any): UpdateSecurityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSecurityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["clientId"] = this.clientId;
        data["generalRateEntityTypeId"] = this.generalRateEntityTypeId;
        data["investmentJurisdictionId"] = this.investmentJurisdictionId;
        data["transactionTypeId"] = this.transactionTypeId;
        data["securityTypeId"] = this.securityTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["ownership"] = this.ownership;
        data["isinCusip"] = this.isinCusip;
        data["acquisitionDate"] = this.acquisitionDate ? this.acquisitionDate.toISOString() : undefined as any;
        data["dispositionDate"] = this.dispositionDate ? this.dispositionDate.toISOString() : undefined as any;
        if (Array.isArray(this.taxRates)) {
            data["taxRates"] = [];
            for (let item of this.taxRates)
                data["taxRates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.questionAnswers)) {
            data["questionAnswers"] = [];
            for (let item of this.questionAnswers)
                data["questionAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        data["securityId"] = this.securityId;
        data["comment"] = this.comment;
        data["adminComment"] = this.adminComment;
        data["skipNotification"] = this.skipNotification;
        return data;
    }
}

export interface IUpdateSecurityRequest {
    entityId?: number;
    clientId?: number | undefined;
    generalRateEntityTypeId?: number | undefined;
    investmentJurisdictionId?: number;
    transactionTypeId?: number;
    securityTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    ownership?: number | undefined;
    isinCusip?: string | undefined;
    acquisitionDate?: Date | undefined;
    dispositionDate?: Date | undefined;
    taxRates?: UpdateSecurityTaxRateRequest[] | undefined;
    questionAnswers?: UpdateSecurityQuestionAnswerRequest[] | undefined;
    securityId?: number;
    comment?: string | undefined;
    adminComment?: string | undefined;
    skipNotification?: boolean;
}

export class UpdateSecurityTaxRateRequest implements IUpdateSecurityTaxRateRequest {
    taxPolicyId?: number | undefined;
    taxRuleId?: number | undefined;
    taxResultItemId?: number | undefined;
    taxResultItemTypeId?: number;
    rate?: number | undefined;
    description?: string | undefined;
    isActive?: boolean;
    securityTaxResultItemId?: number;

    constructor(data?: IUpdateSecurityTaxRateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxPolicyId = _data["taxPolicyId"];
            this.taxRuleId = _data["taxRuleId"];
            this.taxResultItemId = _data["taxResultItemId"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.rate = _data["rate"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.securityTaxResultItemId = _data["securityTaxResultItemId"];
        }
    }

    static fromJS(data: any): UpdateSecurityTaxRateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSecurityTaxRateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxPolicyId"] = this.taxPolicyId;
        data["taxRuleId"] = this.taxRuleId;
        data["taxResultItemId"] = this.taxResultItemId;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["rate"] = this.rate;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["securityTaxResultItemId"] = this.securityTaxResultItemId;
        return data;
    }
}

export interface IUpdateSecurityTaxRateRequest {
    taxPolicyId?: number | undefined;
    taxRuleId?: number | undefined;
    taxResultItemId?: number | undefined;
    taxResultItemTypeId?: number;
    rate?: number | undefined;
    description?: string | undefined;
    isActive?: boolean;
    securityTaxResultItemId?: number;
}

export class UpdateSecurityTransactionTypeRequest implements IUpdateSecurityTransactionTypeRequest {
    securityId?: number;
    transactionTypeId?: number;
    generalRateEntityTypeId?: number | undefined;
    acquisitionDate?: Date | undefined;

    constructor(data?: IUpdateSecurityTransactionTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityId = _data["securityId"];
            this.transactionTypeId = _data["transactionTypeId"];
            this.generalRateEntityTypeId = _data["generalRateEntityTypeId"];
            this.acquisitionDate = _data["acquisitionDate"] ? new Date(_data["acquisitionDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateSecurityTransactionTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSecurityTransactionTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityId"] = this.securityId;
        data["transactionTypeId"] = this.transactionTypeId;
        data["generalRateEntityTypeId"] = this.generalRateEntityTypeId;
        data["acquisitionDate"] = this.acquisitionDate ? this.acquisitionDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IUpdateSecurityTransactionTypeRequest {
    securityId?: number;
    transactionTypeId?: number;
    generalRateEntityTypeId?: number | undefined;
    acquisitionDate?: Date | undefined;
}

export class UpdateSecurityTypeRequest implements IUpdateSecurityTypeRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    isVisible?: boolean;
    isDefault?: boolean;
    isParent?: boolean;
    parentSecurityTypeId?: number | undefined;
    securityTypeId?: number;

    constructor(data?: IUpdateSecurityTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isVisible = _data["isVisible"];
            this.isDefault = _data["isDefault"];
            this.isParent = _data["isParent"];
            this.parentSecurityTypeId = _data["parentSecurityTypeId"];
            this.securityTypeId = _data["securityTypeId"];
        }
    }

    static fromJS(data: any): UpdateSecurityTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSecurityTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isVisible"] = this.isVisible;
        data["isDefault"] = this.isDefault;
        data["isParent"] = this.isParent;
        data["parentSecurityTypeId"] = this.parentSecurityTypeId;
        data["securityTypeId"] = this.securityTypeId;
        return data;
    }
}

export interface IUpdateSecurityTypeRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
    isVisible?: boolean;
    isDefault?: boolean;
    isParent?: boolean;
    parentSecurityTypeId?: number | undefined;
    securityTypeId?: number;
}

export class UpdateTaxPolicyRequest implements IUpdateTaxPolicyRequest {
    taxPolicyId?: number;
    taxRuleId?: number;
    isActive!: boolean;
    taxPolicyStatusId?: number;
    taxResultItemTypeId?: number;

    constructor(data?: IUpdateTaxPolicyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxPolicyId = _data["taxPolicyId"];
            this.taxRuleId = _data["taxRuleId"];
            this.isActive = _data["isActive"];
            this.taxPolicyStatusId = _data["taxPolicyStatusId"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
        }
    }

    static fromJS(data: any): UpdateTaxPolicyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaxPolicyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxPolicyId"] = this.taxPolicyId;
        data["taxRuleId"] = this.taxRuleId;
        data["isActive"] = this.isActive;
        data["taxPolicyStatusId"] = this.taxPolicyStatusId;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        return data;
    }
}

export interface IUpdateTaxPolicyRequest {
    taxPolicyId?: number;
    taxRuleId?: number;
    isActive: boolean;
    taxPolicyStatusId?: number;
    taxResultItemTypeId?: number;
}

export class UpdateTaxRateSummaryRequest implements IUpdateTaxRateSummaryRequest {
    taxSummaryId!: number;
    rate!: number;
    description!: string;
    taxRateSummaryId!: number;

    constructor(data?: IUpdateTaxRateSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxSummaryId = _data["taxSummaryId"];
            this.rate = _data["rate"];
            this.description = _data["description"];
            this.taxRateSummaryId = _data["taxRateSummaryId"];
        }
    }

    static fromJS(data: any): UpdateTaxRateSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaxRateSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxSummaryId"] = this.taxSummaryId;
        data["rate"] = this.rate;
        data["description"] = this.description;
        data["taxRateSummaryId"] = this.taxRateSummaryId;
        return data;
    }
}

export interface IUpdateTaxRateSummaryRequest {
    taxSummaryId: number;
    rate: number;
    description: string;
    taxRateSummaryId: number;
}

export class UpdateTaxResultItemRequest implements IUpdateTaxResultItemRequest {
    taxResultId?: number;
    taxResultItemTypeId?: number;
    rate?: number | undefined;
    description?: string | undefined;
    isActive?: boolean;
    taxResultItemId?: number;

    constructor(data?: IUpdateTaxResultItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxResultId = _data["taxResultId"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
            this.rate = _data["rate"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.taxResultItemId = _data["taxResultItemId"];
        }
    }

    static fromJS(data: any): UpdateTaxResultItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaxResultItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxResultId"] = this.taxResultId;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        data["rate"] = this.rate;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["taxResultItemId"] = this.taxResultItemId;
        return data;
    }
}

export interface IUpdateTaxResultItemRequest {
    taxResultId?: number;
    taxResultItemTypeId?: number;
    rate?: number | undefined;
    description?: string | undefined;
    isActive?: boolean;
    taxResultItemId?: number;
}

export class UpdateTaxResultItemTypeRequest implements IUpdateTaxResultItemTypeRequest {
    name!: string;
    taxResultItemTypeId?: number;

    constructor(data?: IUpdateTaxResultItemTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.taxResultItemTypeId = _data["taxResultItemTypeId"];
        }
    }

    static fromJS(data: any): UpdateTaxResultItemTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaxResultItemTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["taxResultItemTypeId"] = this.taxResultItemTypeId;
        return data;
    }
}

export interface IUpdateTaxResultItemTypeRequest {
    name: string;
    taxResultItemTypeId?: number;
}

export class UpdateTaxResultRequest implements IUpdateTaxResultRequest {
    taxResultTypeId?: number;
    isActive!: boolean;
    taxResultId?: number;

    constructor(data?: IUpdateTaxResultRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxResultTypeId = _data["taxResultTypeId"];
            this.isActive = _data["isActive"];
            this.taxResultId = _data["taxResultId"];
        }
    }

    static fromJS(data: any): UpdateTaxResultRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaxResultRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxResultTypeId"] = this.taxResultTypeId;
        data["isActive"] = this.isActive;
        data["taxResultId"] = this.taxResultId;
        return data;
    }
}

export interface IUpdateTaxResultRequest {
    taxResultTypeId?: number;
    isActive: boolean;
    taxResultId?: number;
}

export class UpdateTaxRuleRequest implements IUpdateTaxRuleRequest {
    taxRuleId?: number;
    taxPolicyId?: number;
    rule?: string | undefined;
    isActive!: boolean;
    obsolete?: boolean;

    constructor(data?: IUpdateTaxRuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxRuleId = _data["taxRuleId"];
            this.taxPolicyId = _data["taxPolicyId"];
            this.rule = _data["rule"];
            this.isActive = _data["isActive"];
            this.obsolete = _data["obsolete"];
        }
    }

    static fromJS(data: any): UpdateTaxRuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaxRuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxRuleId"] = this.taxRuleId;
        data["taxPolicyId"] = this.taxPolicyId;
        data["rule"] = this.rule;
        data["isActive"] = this.isActive;
        data["obsolete"] = this.obsolete;
        return data;
    }
}

export interface IUpdateTaxRuleRequest {
    taxRuleId?: number;
    taxPolicyId?: number;
    rule?: string | undefined;
    isActive: boolean;
    obsolete?: boolean;
}

export class UpdateTaxSummaryHeaderTypeRequest implements IUpdateTaxSummaryHeaderTypeRequest {
    name!: string;
    taxSummaryHeaderTypeId!: number;

    constructor(data?: IUpdateTaxSummaryHeaderTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.taxSummaryHeaderTypeId = _data["taxSummaryHeaderTypeId"];
        }
    }

    static fromJS(data: any): UpdateTaxSummaryHeaderTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaxSummaryHeaderTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["taxSummaryHeaderTypeId"] = this.taxSummaryHeaderTypeId;
        return data;
    }
}

export interface IUpdateTaxSummaryHeaderTypeRequest {
    name: string;
    taxSummaryHeaderTypeId: number;
}

export class UpdateTaxSummaryRequest implements IUpdateTaxSummaryRequest {
    countryId!: number;
    taxSummaryTypeId!: number;
    description!: string;
    isActive!: boolean;
    isApproved!: boolean;
    actualFrom!: Date;
    reviewDate?: Date | undefined;
    approvedOn?: Date | undefined;
    approvedBy!: string;
    taxSummaryId!: number;

    constructor(data?: IUpdateTaxSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.taxSummaryTypeId = _data["taxSummaryTypeId"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isApproved = _data["isApproved"];
            this.actualFrom = _data["actualFrom"] ? new Date(_data["actualFrom"].toString()) : undefined as any;
            this.reviewDate = _data["reviewDate"] ? new Date(_data["reviewDate"].toString()) : undefined as any;
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : undefined as any;
            this.approvedBy = _data["approvedBy"];
            this.taxSummaryId = _data["taxSummaryId"];
        }
    }

    static fromJS(data: any): UpdateTaxSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaxSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["taxSummaryTypeId"] = this.taxSummaryTypeId;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isApproved"] = this.isApproved;
        data["actualFrom"] = this.actualFrom ? this.actualFrom.toISOString() : undefined as any;
        data["reviewDate"] = this.reviewDate ? this.reviewDate.toISOString() : undefined as any;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : undefined as any;
        data["approvedBy"] = this.approvedBy;
        data["taxSummaryId"] = this.taxSummaryId;
        return data;
    }
}

export interface IUpdateTaxSummaryRequest {
    countryId: number;
    taxSummaryTypeId: number;
    description: string;
    isActive: boolean;
    isApproved: boolean;
    actualFrom: Date;
    reviewDate?: Date | undefined;
    approvedOn?: Date | undefined;
    approvedBy: string;
    taxSummaryId: number;
}

export class UpdateTaxSummaryTypeRequest implements IUpdateTaxSummaryTypeRequest {
    name!: string;
    taxSummaryHeaderTypeId?: number | undefined;
    taxSummaryTypeId!: number;

    constructor(data?: IUpdateTaxSummaryTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.taxSummaryHeaderTypeId = _data["taxSummaryHeaderTypeId"];
            this.taxSummaryTypeId = _data["taxSummaryTypeId"];
        }
    }

    static fromJS(data: any): UpdateTaxSummaryTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaxSummaryTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["taxSummaryHeaderTypeId"] = this.taxSummaryHeaderTypeId;
        data["taxSummaryTypeId"] = this.taxSummaryTypeId;
        return data;
    }
}

export interface IUpdateTaxSummaryTypeRequest {
    name: string;
    taxSummaryHeaderTypeId?: number | undefined;
    taxSummaryTypeId: number;
}

export class UpdateTransactionTypeRequest implements IUpdateTransactionTypeRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    transactionTypeId!: number;

    constructor(data?: IUpdateTransactionTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.transactionTypeId = _data["transactionTypeId"];
        }
    }

    static fromJS(data: any): UpdateTransactionTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTransactionTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["transactionTypeId"] = this.transactionTypeId;
        return data;
    }
}

export interface IUpdateTransactionTypeRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
    transactionTypeId: number;
}

export class UserEmailNotificationSettingsRequest implements IUserEmailNotificationSettingsRequest {
    userId?: string | undefined;
    notificationEmailsEnabled?: boolean;

    constructor(data?: IUserEmailNotificationSettingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.notificationEmailsEnabled = _data["notificationEmailsEnabled"];
        }
    }

    static fromJS(data: any): UserEmailNotificationSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserEmailNotificationSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["notificationEmailsEnabled"] = this.notificationEmailsEnabled;
        return data;
    }
}

export interface IUserEmailNotificationSettingsRequest {
    userId?: string | undefined;
    notificationEmailsEnabled?: boolean;
}

export class UserEmailNotificationSettingsResponse implements IUserEmailNotificationSettingsResponse {
    userId?: string | undefined;
    notificationEmailsEnabled?: boolean;

    constructor(data?: IUserEmailNotificationSettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.notificationEmailsEnabled = _data["notificationEmailsEnabled"];
        }
    }

    static fromJS(data: any): UserEmailNotificationSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserEmailNotificationSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["notificationEmailsEnabled"] = this.notificationEmailsEnabled;
        return data;
    }
}

export interface IUserEmailNotificationSettingsResponse {
    userId?: string | undefined;
    notificationEmailsEnabled?: boolean;
}

export class UserNotification implements IUserNotification {
    userNotificationId?: number;
    requestedUserId!: string;
    title!: string;
    notificationText!: string;
    isRead?: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    requestedUser?: AspNetUser;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNotificationId = _data["userNotificationId"];
            this.requestedUserId = _data["requestedUserId"];
            this.title = _data["title"];
            this.notificationText = _data["notificationText"];
            this.isRead = _data["isRead"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.requestedUser = _data["requestedUser"] ? AspNetUser.fromJS(_data["requestedUser"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNotificationId"] = this.userNotificationId;
        data["requestedUserId"] = this.requestedUserId;
        data["title"] = this.title;
        data["notificationText"] = this.notificationText;
        data["isRead"] = this.isRead;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["requestedUser"] = this.requestedUser ? this.requestedUser.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserNotification {
    userNotificationId?: number;
    requestedUserId: string;
    title: string;
    notificationText: string;
    isRead?: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    requestedUser?: AspNetUser;
}

export class UserNotificationResponse implements IUserNotificationResponse {
    userNotificationId?: number;
    requestedUserId?: string | undefined;
    title?: string | undefined;
    notificationText?: string | undefined;
    isRead?: boolean;

    constructor(data?: IUserNotificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNotificationId = _data["userNotificationId"];
            this.requestedUserId = _data["requestedUserId"];
            this.title = _data["title"];
            this.notificationText = _data["notificationText"];
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): UserNotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNotificationId"] = this.userNotificationId;
        data["requestedUserId"] = this.requestedUserId;
        data["title"] = this.title;
        data["notificationText"] = this.notificationText;
        data["isRead"] = this.isRead;
        return data;
    }
}

export interface IUserNotificationResponse {
    userNotificationId?: number;
    requestedUserId?: string | undefined;
    title?: string | undefined;
    notificationText?: string | undefined;
    isRead?: boolean;
}

/** OData response message structure */
export class UserNotificationResponseODataWithMetadataResponse implements IUserNotificationResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: UserNotificationResponse[] | undefined;

    constructor(data?: IUserNotificationResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(UserNotificationResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserNotificationResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IUserNotificationResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: UserNotificationResponse[] | undefined;
}

export class UserResponse implements IUserResponse {
    id?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    organization?: string | undefined;
    territory?: string | undefined;
    isActive?: boolean;
    isExternal?: boolean;
    termsAndPrivacyAccepted?: boolean;
    lastLogin?: Date | undefined;
    created?: Date | undefined;
    modified?: Date | undefined;

    constructor(data?: IUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.organization = _data["organization"];
            this.territory = _data["territory"];
            this.isActive = _data["isActive"];
            this.isExternal = _data["isExternal"];
            this.termsAndPrivacyAccepted = _data["termsAndPrivacyAccepted"];
            this.lastLogin = _data["lastLogin"] ? new Date(_data["lastLogin"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["organization"] = this.organization;
        data["territory"] = this.territory;
        data["isActive"] = this.isActive;
        data["isExternal"] = this.isExternal;
        data["termsAndPrivacyAccepted"] = this.termsAndPrivacyAccepted;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        return data;
    }
}

export interface IUserResponse {
    id?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    organization?: string | undefined;
    territory?: string | undefined;
    isActive?: boolean;
    isExternal?: boolean;
    termsAndPrivacyAccepted?: boolean;
    lastLogin?: Date | undefined;
    created?: Date | undefined;
    modified?: Date | undefined;
}

/** OData response message structure */
export class UserResponseODataWithMetadataResponse implements IUserResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: UserResponse[] | undefined;

    constructor(data?: IUserResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(UserResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IUserResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: UserResponse[] | undefined;
}

export class UserRoleCountryResponse implements IUserRoleCountryResponse {
  countryId?: number | undefined;
  countryName?: string | undefined;

  constructor(data?: IUserRoleCountryResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.countryId = _data['countryId'];
      this.countryName = _data['countryName'];
    }
  }

  static fromJS(data: any): UserRoleCountryResponse {
    data = typeof data === 'object' ? data : {};
    let result = new UserRoleCountryResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['countryId'] = this.countryId;
    data['countryName'] = this.countryName;
    return data;
  }
}

export interface IUserRoleCountryResponse {
  countryId?: number | undefined;
  countryName?: string | undefined;
}

export class UserRoleResponse implements IUserRoleResponse {
  userId?: string | undefined;
  email?: string | undefined;
  roleId?: string | undefined;
  roleName?: string | undefined;
  countryId?: number | undefined;
  countryName?: string | undefined;
  countries?: UserRoleCountryResponse[] | undefined;

    constructor(data?: IUserRoleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      this.email = _data['email'];
      this.roleId = _data['roleId'];
      this.roleName = _data['roleName'];
      this.countryId = _data['countryId'];
      this.countryName = _data['countryName'];
      if (Array.isArray(_data['countries'])) {
        this.countries = [];
        for (let item of _data['countries']) {
          this.countries.push(UserRoleCountryResponse.fromJS(item));
        }
      }
    }
  }

    static fromJS(data: any): UserRoleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleResponse();
        result.init(data);
        return result;
    }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['email'] = this.email;
    data['roleId'] = this.roleId;
    data['roleName'] = this.roleName;
    data['countryId'] = this.countryId;
    data['countryName'] = this.countryName;
    if (Array.isArray(this.countries)) {
      data['countries'] = [];
      for (let item of this.countries) data['countries'].push(item.toJSON());
    }
    return data;
  }
}

export interface IUserRoleResponse {
  userId?: string | undefined;
  email?: string | undefined;
  roleId?: string | undefined;
  roleName?: string | undefined;
  countryId?: number | undefined;
  countryName?: string | undefined;
  countries?: UserRoleCountryResponse[] | undefined;
}

/** OData response message structure */
export class UserRoleResponseODataWithMetadataResponse implements IUserRoleResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: UserRoleResponse[] | undefined;

    constructor(data?: IUserRoleResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(UserRoleResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserRoleResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IUserRoleResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: UserRoleResponse[] | undefined;
}

export class UserSetting implements IUserSetting {
    userSettingsId?: number;
    userId!: string;
    notificationEmailsEnabled?: boolean;
    created?: Date;
    createdBy!: string;
    modified?: Date;
    modifiedBy!: string;
    user?: AspNetUser;

    constructor(data?: IUserSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userSettingsId = _data["userSettingsId"];
            this.userId = _data["userId"];
            this.notificationEmailsEnabled = _data["notificationEmailsEnabled"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.user = _data["user"] ? AspNetUser.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSettingsId"] = this.userSettingsId;
        data["userId"] = this.userId;
        data["notificationEmailsEnabled"] = this.notificationEmailsEnabled;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserSetting {
    userSettingsId?: number;
    userId: string;
    notificationEmailsEnabled?: boolean;
    created?: Date;
    createdBy: string;
    modified?: Date;
    modifiedBy: string;
    user?: AspNetUser;
}

export class UserSettingResponse implements IUserSettingResponse {
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IUserSettingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UserSettingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IUserSettingResponse {
    key?: string | undefined;
    value?: string | undefined;
}

/** OData response message structure */
export class UserSettingResponseODataWithMetadataResponse implements IUserSettingResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    readonly value?: UserSettingResponse[] | undefined;

    constructor(data?: IUserSettingResponseODataWithMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(UserSettingResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserSettingResponseODataWithMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingResponseODataWithMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** OData response message structure */
export interface IUserSettingResponseODataWithMetadataResponse {
    odataCount?: number | undefined;
    value?: UserSettingResponse[] | undefined;
}

export class ValidationProblemDetails implements IValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = (this.errors as any)[key];
            }
        }
        return data;
    }
}

export interface IValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;
}

export class Body implements IBody {
    code?: string;
    state?: string;
    error?: string;
    error_description?: string;

    [key: string]: any;

    constructor(data?: IBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.code = _data["code"];
            this.state = _data["state"];
            this.error = _data["error"];
            this.error_description = _data["error_description"];
        }
    }

    static fromJS(data: any): Body {
        data = typeof data === 'object' ? data : {};
        let result = new Body();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["code"] = this.code;
        data["state"] = this.state;
        data["error"] = this.error;
        data["error_description"] = this.error_description;
        return data;
    }
}

export interface IBody {
    code?: string;
    state?: string;
    error?: string;
    error_description?: string;

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}